// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"94XF7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hub", ()=>(0, _indexMjs.Hub));
parcelHelpers.export(exports, "decodeJWT", ()=>(0, _indexMjs1.decodeJWT));
parcelHelpers.export(exports, "Amplify", ()=>(0, _amplifyMjs.Amplify));
parcelHelpers.export(exports, "AmplifyClassV6", ()=>(0, _amplifyMjs.AmplifyClass));
parcelHelpers.export(exports, "fetchAuthSession", ()=>(0, _fetchAuthSessionMjs.fetchAuthSession));
parcelHelpers.export(exports, "clearCredentials", ()=>(0, _clearCredentialsMjs.clearCredentials));
parcelHelpers.export(exports, "createGetCredentialsForIdentityClient", ()=>(0, _createGetCredentialsForIdentityClientMjs.createGetCredentialsForIdentityClient));
parcelHelpers.export(exports, "createGetIdClient", ()=>(0, _createGetIdClientMjs.createGetIdClient));
parcelHelpers.export(exports, "cognitoIdentityPoolEndpointResolver", ()=>(0, _cognitoIdentityPoolEndpointResolverMjs.cognitoIdentityPoolEndpointResolver));
parcelHelpers.export(exports, "defaultStorage", ()=>(0, _indexMjs2.defaultStorage));
parcelHelpers.export(exports, "sessionStorage", ()=>(0, _indexMjs2.sessionStorage));
parcelHelpers.export(exports, "sharedInMemoryStorage", ()=>(0, _indexMjs2.sharedInMemoryStorage));
parcelHelpers.export(exports, "syncSessionStorage", ()=>(0, _indexMjs2.syncSessionStorage));
parcelHelpers.export(exports, "Cache", ()=>(0, _indexMjs3.Cache));
parcelHelpers.export(exports, "I18n", ()=>(0, _indexMjs4.I18n));
parcelHelpers.export(exports, "ConsoleLogger", ()=>(0, _consoleLoggerMjs.ConsoleLogger));
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _serviceWorkerMjs.ServiceWorkerClass));
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _cookieStorageMjs.CookieStorage));
var _indexMjs = require("./Hub/index.mjs");
var _indexMjs1 = require("./singleton/Auth/utils/index.mjs");
var _amplifyMjs = require("./singleton/Amplify.mjs");
var _fetchAuthSessionMjs = require("./singleton/apis/fetchAuthSession.mjs");
var _clearCredentialsMjs = require("./singleton/apis/clearCredentials.mjs");
var _createGetCredentialsForIdentityClientMjs = require("./foundation/factories/serviceClients/cognitoIdentity/createGetCredentialsForIdentityClient.mjs");
var _createGetIdClientMjs = require("./foundation/factories/serviceClients/cognitoIdentity/createGetIdClient.mjs");
var _cognitoIdentityPoolEndpointResolverMjs = require("./foundation/factories/serviceClients/cognitoIdentity/cognitoIdentityPoolEndpointResolver.mjs");
var _indexMjs2 = require("./storage/index.mjs");
var _indexMjs3 = require("./Cache/index.mjs");
var _indexMjs4 = require("./I18n/index.mjs");
var _consoleLoggerMjs = require("./Logger/ConsoleLogger.mjs");
var _serviceWorkerMjs = require("./ServiceWorker/ServiceWorker.mjs");
var _cookieStorageMjs = require("./storage/CookieStorage.mjs");

},{"./Hub/index.mjs":"hkdby","./singleton/Auth/utils/index.mjs":"57gzf","./singleton/Amplify.mjs":"3ZpqK","./singleton/apis/fetchAuthSession.mjs":"ecuoW","./singleton/apis/clearCredentials.mjs":"dMTIk","./foundation/factories/serviceClients/cognitoIdentity/createGetCredentialsForIdentityClient.mjs":"9BciP","./foundation/factories/serviceClients/cognitoIdentity/createGetIdClient.mjs":"lNTH7","./foundation/factories/serviceClients/cognitoIdentity/cognitoIdentityPoolEndpointResolver.mjs":"fDu4p","./storage/index.mjs":"cXhBO","./Cache/index.mjs":"jU1bK","./I18n/index.mjs":"845dP","./Logger/ConsoleLogger.mjs":"6OFOw","./ServiceWorker/ServiceWorker.mjs":"4kMAx","./storage/CookieStorage.mjs":"ghdeH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hkdby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
parcelHelpers.export(exports, "Hub", ()=>Hub);
parcelHelpers.export(exports, "HubClass", ()=>HubClass);
parcelHelpers.export(exports, "HubInternal", ()=>HubInternal);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
var _constantsMjs = require("../constants.mjs");
var _amplifyErrorMjs = require("../errors/AmplifyError.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' ? Symbol('amplify_default') : '@@amplify_default';
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('Hub');
class HubClass {
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === 'string' && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === AMPLIFY_SYMBOL;
            if (!hasAccess) logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel,
            payload: (0, _objectSpread._)({}, payload),
            source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            logger.error(e);
        }
    }
    listen(channel, callback, listenerName = 'noname') {
        let cb;
        if (typeof callback !== 'function') throw new (0, _amplifyErrorMjs.AmplifyError)({
            name: (0, _constantsMjs.NO_HUBCALLBACK_PROVIDED_EXCEPTION),
            message: 'No callback supplied to Hub'
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel, payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                logger.error(e);
            }
        });
    }
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'ui',
            'xr'
        ];
        this.name = name;
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const Hub = new HubClass('__default__');
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const HubInternal = new HubClass('internal-hub');

},{"@swc/helpers/_/_object_spread":"PGIdx","../Logger/ConsoleLogger.mjs":"6OFOw","../constants.mjs":"1d7L6","../errors/AmplifyError.mjs":"9LcuL","../types/errors.mjs":"2tN68","../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6OFOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsoleLogger", ()=>ConsoleLogger);
var _constantsMjs = require("../constants.mjs");
var _typesMjs = require("./types.mjs");
/* eslint-disable no-console */ // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class ConsoleLogger {
    _padding(n) {
        return n < 10 ? '0' + n : '' + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if (ConsoleLogger.LOG_LEVEL) loggerLevelName = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = LOG_LEVELS[loggerLevelName];
        const typeLevel = LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, _typesMjs.LogType).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, _typesMjs.LogType).WARN && console.warn) log = console.warn.bind(console);
        if (ConsoleLogger.BIND_ALL_LOG_LEVELS) {
            if (type === (0, _typesMjs.LogType).INFO && console.info) log = console.info.bind(console);
            if (type === (0, _typesMjs.LogType).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = '';
        if (msg.length === 1 && typeof msg[0] === 'string') {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === 'string') {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, _typesMjs.LogType).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, _typesMjs.LogType).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, _typesMjs.LogType).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, _typesMjs.LogType).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, _typesMjs.LogType).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, _typesMjs.LogType).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, _constantsMjs.AWS_CLOUDWATCH_CATEGORY)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, _typesMjs.LogType).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
}
ConsoleLogger.LOG_LEVEL = null;
ConsoleLogger.BIND_ALL_LOG_LEVELS = false;

},{"../constants.mjs":"1d7L6","./types.mjs":"hRlwk","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1d7L6":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>AWS_CLOUDWATCH_CATEGORY);
parcelHelpers.export(exports, "NO_HUBCALLBACK_PROVIDED_EXCEPTION", ()=>NO_HUBCALLBACK_PROVIDED_EXCEPTION);
parcelHelpers.export(exports, "USER_AGENT_HEADER", ()=>USER_AGENT_HEADER);
const AWS_CLOUDWATCH_CATEGORY = 'Logging';
const USER_AGENT_HEADER = 'x-amz-user-agent';
// Error exception code constants
const NO_HUBCALLBACK_PROVIDED_EXCEPTION = 'NoHubcallbackProvidedException';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hRlwk":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogType", ()=>LogType);
var LogType;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})(LogType || (LogType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9LcuL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyError", ()=>AmplifyError);
class AmplifyError extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message, name, recoverySuggestion, underlyingError, metadata }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        if (metadata) {
            // If metadata exists, explicitly only record the following properties.
            const { extendedRequestId, httpStatusCode, requestId } = metadata;
            this.metadata = {
                extendedRequestId,
                httpStatusCode,
                requestId
            };
        }
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = AmplifyError;
        Object.setPrototypeOf(this, AmplifyError.prototype);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2tN68":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyErrorCode", ()=>AmplifyErrorCode);
var AmplifyErrorCode;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})(AmplifyErrorCode || (AmplifyErrorCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fvR3Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
var _errorsMjs = require("../types/errors.mjs");
var _createAssertionFunctionMjs = require("./createAssertionFunction.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const amplifyErrorMap = {
    [(0, _errorsMjs.AmplifyErrorCode).NoEndpointId]: {
        message: 'Endpoint ID was not found and was unable to be created.'
    },
    [(0, _errorsMjs.AmplifyErrorCode).PlatformNotSupported]: {
        message: 'Function not supported on current platform.'
    },
    [(0, _errorsMjs.AmplifyErrorCode).Unknown]: {
        message: 'An unknown error occurred.'
    },
    [(0, _errorsMjs.AmplifyErrorCode).NetworkError]: {
        message: 'A network error has occurred.'
    }
};
const assert = (0, _createAssertionFunctionMjs.createAssertionFunction)(amplifyErrorMap);

},{"../types/errors.mjs":"2tN68","./createAssertionFunction.mjs":"lBq8c","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lBq8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAssertionFunction", ()=>createAssertionFunction);
var _amplifyErrorMjs = require("./AmplifyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createAssertionFunction = (errorMap, AssertionError = (0, _amplifyErrorMjs.AmplifyError))=>(assertion, name, additionalContext)=>{
        const { message, recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion
        });
    };

},{"./AmplifyError.mjs":"9LcuL","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"57gzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertIdentityPoolIdConfig", ()=>assertIdentityPoolIdConfig);
parcelHelpers.export(exports, "assertOAuthConfig", ()=>assertOAuthConfig);
parcelHelpers.export(exports, "assertTokenProviderConfig", ()=>assertTokenProviderConfig);
parcelHelpers.export(exports, "decodeJWT", ()=>decodeJWT);
var _base64DecoderMjs = require("../../../utils/convert/base64/base64Decoder.mjs");
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _errorHelpersMjs1 = require("./errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function assertTokenProviderConfig(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, _errorHelpersMjs1.assert)(assertionValid, (0, _errorHelpersMjs1.AuthConfigurationErrorCode).AuthUserPoolException);
}
function assertOAuthConfig(cognitoConfig) {
    var _cognitoConfig_loginWith_oauth, _cognitoConfig_loginWith, _cognitoConfig_loginWith_oauth1, _cognitoConfig_loginWith1, _cognitoConfig_loginWith_oauth2, _cognitoConfig_loginWith2, _cognitoConfig_loginWith_oauth3, _cognitoConfig_loginWith3;
    const validOAuthConfig = !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth = _cognitoConfig_loginWith.oauth) === null || _cognitoConfig_loginWith_oauth === void 0 ? void 0 : _cognitoConfig_loginWith_oauth.domain) && !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith1 = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith1 === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth1 = _cognitoConfig_loginWith1.oauth) === null || _cognitoConfig_loginWith_oauth1 === void 0 ? void 0 : _cognitoConfig_loginWith_oauth1.redirectSignOut) && !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith2 = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith2 === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth2 = _cognitoConfig_loginWith2.oauth) === null || _cognitoConfig_loginWith_oauth2 === void 0 ? void 0 : _cognitoConfig_loginWith_oauth2.redirectSignIn) && !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith3 = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith3 === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth3 = _cognitoConfig_loginWith3.oauth) === null || _cognitoConfig_loginWith_oauth3 === void 0 ? void 0 : _cognitoConfig_loginWith_oauth3.responseType);
    (0, _errorHelpersMjs1.assert)(validOAuthConfig, (0, _errorHelpersMjs1.AuthConfigurationErrorCode).OAuthNotConfigureException);
}
function assertIdentityPoolIdConfig(cognitoConfig) {
    const validConfig = !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : cognitoConfig.identityPoolId);
    (0, _errorHelpersMjs1.assert)(validConfig, (0, _errorHelpersMjs1.AuthConfigurationErrorCode).InvalidIdentityPoolIdException);
}
/**
 * Decodes payload of JWT token
 *
 * @param {String} token A string representing a token to be decoded
 * @throws {@link Error} - Throws error when token is invalid or payload malformed.
 */ function decodeJWT(token) {
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) throw new Error('Invalid token');
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, '+').replace(/_/g, '/');
        const jsonStr = decodeURIComponent((0, _base64DecoderMjs.base64Decoder).convert(base64).split('').map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload
        };
    } catch (err) {
        throw new Error('Invalid token payload');
    }
}

},{"../../../utils/convert/base64/base64Decoder.mjs":"58oTM","../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","./errorHelpers.mjs":"cz6fR","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"58oTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base64Decoder", ()=>base64Decoder);
var _indexMjs = require("../../globalHelpers/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const base64Decoder = {
    convert (input, options) {
        let inputStr = input;
        // urlSafe character replacement options conform to the base64 url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#page-7
        if (options === null || options === void 0 ? void 0 : options.urlSafe) inputStr = inputStr.replace(/-/g, '+').replace(/_/g, '/');
        return (0, _indexMjs.getAtob)()(inputStr);
    }
};

},{"../../globalHelpers/index.mjs":"5JDaI","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5JDaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAtob", ()=>getAtob);
parcelHelpers.export(exports, "getBtoa", ()=>getBtoa);
parcelHelpers.export(exports, "getCrypto", ()=>getCrypto);
var _amplifyErrorMjs = require("../../errors/AmplifyError.mjs");
var _errorsMjs = require("../../types/errors.mjs");
var _errorHelpersMjs = require("../../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getCrypto = ()=>{
    if (typeof window === 'object' && typeof window.crypto === 'object') return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === 'object') return crypto;
    throw new (0, _amplifyErrorMjs.AmplifyError)({
        name: 'MissingPolyfill',
        message: 'Cannot resolve the `crypto` function from the environment.'
    });
};
const getBtoa = ()=>{
    // browser
    if (typeof window !== 'undefined' && typeof window.btoa === 'function') return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === 'function') return btoa;
    throw new (0, _amplifyErrorMjs.AmplifyError)({
        name: 'Base64EncoderError',
        message: 'Cannot resolve the `btoa` function from the environment.'
    });
};
const getAtob = ()=>{
    // browser
    if (typeof window !== 'undefined' && typeof window.atob === 'function') return window.atob;
    // Next.js global polyfill
    if (typeof atob === 'function') return atob;
    throw new (0, _amplifyErrorMjs.AmplifyError)({
        name: 'Base64EncoderError',
        message: 'Cannot resolve the `atob` function from the environment.'
    });
};

},{"../../errors/AmplifyError.mjs":"9LcuL","../../types/errors.mjs":"2tN68","../../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cz6fR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthConfigurationErrorCode", ()=>AuthConfigurationErrorCode);
parcelHelpers.export(exports, "assert", ()=>assert);
var _createAssertionFunctionMjs = require("../../../errors/createAssertionFunction.mjs");
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var AuthConfigurationErrorCode;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})(AuthConfigurationErrorCode || (AuthConfigurationErrorCode = {}));
const authConfigurationErrorMap = {
    [AuthConfigurationErrorCode.AuthTokenConfigException]: {
        message: 'Auth Token Provider not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure in your app.'
    },
    [AuthConfigurationErrorCode.AuthUserPoolAndIdentityPoolException]: {
        message: 'Auth UserPool or IdentityPool not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId.'
    },
    [AuthConfigurationErrorCode.AuthUserPoolException]: {
        message: 'Auth UserPool not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId.'
    },
    [AuthConfigurationErrorCode.InvalidIdentityPoolIdException]: {
        message: 'Invalid identity pool id provided.',
        recoverySuggestion: 'Make sure a valid identityPoolId is given in the config.'
    },
    [AuthConfigurationErrorCode.OAuthNotConfigureException]: {
        message: 'oauth param not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure with oauth parameter in your app.'
    }
};
const assert = (0, _createAssertionFunctionMjs.createAssertionFunction)(authConfigurationErrorMap);

},{"../../../errors/createAssertionFunction.mjs":"lBq8c","../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3ZpqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", ()=>Amplify);
parcelHelpers.export(exports, "AmplifyClass", ()=>AmplifyClass);
var _indexMjs = require("../Hub/index.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../utils/retry/retry.mjs");
var _deepFreezeMjs = require("../utils/deepFreeze.mjs");
var _parseAWSExportsMjs = require("../parseAWSExports.mjs");
var _constantsMjs = require("./constants.mjs");
var _uuid = require("uuid");
var _parseAmplifyConfigMjs = require("../utils/parseAmplifyConfig.mjs");
var _errorHelpersMjs1 = require("./Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs1 = require("../Platform/index.mjs");
var _typesMjs = require("../Platform/types.mjs");
var _typesMjs1 = require("../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../Reachability/Reachability.mjs");
var _indexMjs2 = require("../utils/sessionListener/index.mjs");
var _indexMjs3 = require("./Auth/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class AmplifyClass {
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        var _this_resourcesConfig_Analytics, _this_resourcesConfig_Notifications_InAppMessaging, _this_resourcesConfig_Notifications, _this_resourcesConfig_Notifications_PushNotification, _this_resourcesConfig_Notifications1;
        const resolvedResourceConfig = (0, _parseAmplifyConfigMjs.parseAmplifyConfig)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, _deepFreezeMjs.deepFreeze)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        // Warn if Pinpoint is configured
        if (((_this_resourcesConfig_Analytics = this.resourcesConfig.Analytics) === null || _this_resourcesConfig_Analytics === void 0 ? void 0 : _this_resourcesConfig_Analytics.Pinpoint) || ((_this_resourcesConfig_Notifications = this.resourcesConfig.Notifications) === null || _this_resourcesConfig_Notifications === void 0 ? void 0 : (_this_resourcesConfig_Notifications_InAppMessaging = _this_resourcesConfig_Notifications.InAppMessaging) === null || _this_resourcesConfig_Notifications_InAppMessaging === void 0 ? void 0 : _this_resourcesConfig_Notifications_InAppMessaging.Pinpoint) || ((_this_resourcesConfig_Notifications1 = this.resourcesConfig.Notifications) === null || _this_resourcesConfig_Notifications1 === void 0 ? void 0 : (_this_resourcesConfig_Notifications_PushNotification = _this_resourcesConfig_Notifications1.PushNotification) === null || _this_resourcesConfig_Notifications_PushNotification === void 0 ? void 0 : _this_resourcesConfig_Notifications_PushNotification.Pinpoint)) // eslint-disable-next-line no-console
        console.warn("AWS will end support for Amazon Pinpoint on October 30, 2026. The guidance is to use AWS End User Messaging for push notifications and SMS, Amazon Simple Email Service for sending emails, Amazon Connect for campaigns, journeys, endpoints, and engagement analytics. Pinpoint recommends Amazon Kinesis for event collection and mobile analytics.");
        (0, _indexMjs.Hub).dispatch('core', {
            event: 'configure',
            data: this.resourcesConfig
        }, 'Configure', (0, _indexMjs.AMPLIFY_SYMBOL));
        this.notifyOAuthListener();
        this.isConfigured = true;
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        if (!this.isConfigured) // eslint-disable-next-line no-console
        console.warn(`Amplify has not been configured. Please call Amplify.configure() before using this service.`);
        return this.resourcesConfig;
    }
    /** @internal */ [(0, _constantsMjs.ADD_OAUTH_LISTENER)](listener) {
        var _this_resourcesConfig_Auth_Cognito_loginWith, _this_resourcesConfig_Auth, _this_resourcesConfig_Auth1;
        if ((_this_resourcesConfig_Auth = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth === void 0 ? void 0 : (_this_resourcesConfig_Auth_Cognito_loginWith = _this_resourcesConfig_Auth.Cognito.loginWith) === null || _this_resourcesConfig_Auth_Cognito_loginWith === void 0 ? void 0 : _this_resourcesConfig_Auth_Cognito_loginWith.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener((_this_resourcesConfig_Auth1 = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth1 === void 0 ? void 0 : _this_resourcesConfig_Auth1.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        var _this_resourcesConfig_Auth_Cognito_loginWith, _this_resourcesConfig_Auth, _this_resourcesConfig_Auth1;
        if (!((_this_resourcesConfig_Auth = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth === void 0 ? void 0 : (_this_resourcesConfig_Auth_Cognito_loginWith = _this_resourcesConfig_Auth.Cognito.loginWith) === null || _this_resourcesConfig_Auth_Cognito_loginWith === void 0 ? void 0 : _this_resourcesConfig_Auth_Cognito_loginWith.oauth) || !this.oAuthListener) return;
        this.oAuthListener((_this_resourcesConfig_Auth1 = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth1 === void 0 ? void 0 : _this_resourcesConfig_Auth1.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
    constructor(){
        this.oAuthListener = undefined;
        this.isConfigured = false;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, _indexMjs3.AuthClass)();
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const Amplify = new AmplifyClass();

},{"../Hub/index.mjs":"hkdby","../types/errors.mjs":"2tN68","../errors/errorHelpers.mjs":"fvR3Q","../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../utils/retry/retry.mjs":"eFvhH","../utils/deepFreeze.mjs":"iBLBL","../parseAWSExports.mjs":"4w5h9","./constants.mjs":"f5Lch","uuid":"5L12c","../utils/parseAmplifyConfig.mjs":"5uPpw","./Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../Platform/index.mjs":"34W7w","../Platform/types.mjs":"8YCjz","../BackgroundProcessManager/types.mjs":"3gmMQ","../Reachability/Reachability.mjs":"1EGHg","../utils/sessionListener/index.mjs":"4uBhf","./Auth/index.mjs":"aMUHt","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gMIbI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClientInfo", ()=>getClientInfo);
var _consoleLoggerMjs = require("../../Logger/ConsoleLogger.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('getClientInfo');
function getClientInfo() {
    if (typeof window === 'undefined') return {};
    return browserClientInfo();
}
function browserClientInfo() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return {};
    }
    const nav = window.navigator;
    if (!nav) {
        logger.warn('No navigator object available to get browser client info');
        return {};
    }
    const { platform, product, vendor, userAgent, language } = nav;
    const type = getBrowserType(userAgent);
    const timezone = browserTimezone();
    return {
        platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join('/'),
        language,
        timezone
    };
}
function browserTimezone() {
    const tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function getBrowserType(userAgent) {
    // The latest user agents for Opera: https://www.whatismybrowser.com/guides/the-latest-user-agent/opera
    const operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    // The latest user agents for Edge: https://www.whatismybrowser.com/guides/the-latest-user-agent/edge
    const ieMatch = /.+(Trident|Edge|Edg|EdgA|EdgiOS)\/([0-9.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    // The latest user agents for web browsers on Firefox and Chrome
    // https://www.whatismybrowser.com/guides/the-latest-user-agent/firefox
    // https://www.whatismybrowser.com/guides/the-latest-user-agent/chrome
    const cfMatch = /.+(Chrome|CriOS|Firefox|FxiOS)\/([0-9.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    // The latest user agents for Safari: https://www.whatismybrowser.com/guides/the-latest-user-agent/safari
    const sMatch = /.+(Safari)\/([0-9.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    const awkMatch = /.+(AppleWebKit)\/([0-9.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    const anyMatch = /.*([A-Z]+)\/([0-9.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: '',
        version: ''
    };
}

},{"../../Logger/ConsoleLogger.mjs":"6OFOw","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eFvhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retry", ()=>retry);
var _consoleLoggerMjs = require("../../Logger/ConsoleLogger.mjs");
var _isNonRetryableErrorMjs = require("./isNonRetryableError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('retryUtil');
/**
 * @private
 * Internal use of Amplify only
 */ async function retry(functionToRetry, args, delayFn, onTerminate) {
    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
    // TODO(eslint): remove this linter suppression with refactoring.
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject)=>{
        let attempt = 0;
        let terminated = false;
        let timeout;
        let wakeUp = ()=>{
        // no-op
        }; // will be replaced with a resolver()
        // used after the loop if terminated while waiting for a timer.
        let lastError;
        onTerminate && onTerminate.then(()=>{
            // signal not to try anymore.
            terminated = true;
            // stop sleeping if we're sleeping.
            clearTimeout(timeout);
            wakeUp();
        });
        // TODO(eslint): remove this linter suppression with refactoring.
        // eslint-disable-next-line no-unmodified-loop-condition
        while(!terminated){
            attempt++;
            logger.debug(`${functionToRetry.name} attempt #${attempt} with this vars: ${JSON.stringify(args)}`);
            try {
                resolve(await functionToRetry(...args));
                return;
            } catch (err) {
                lastError = err;
                logger.debug(`error on ${functionToRetry.name}`, err);
                if ((0, _isNonRetryableErrorMjs.isNonRetryableError)(err)) {
                    logger.debug(`${functionToRetry.name} non retryable error`, err);
                    reject(err);
                    return;
                }
                const retryIn = delayFn(attempt, args, err);
                logger.debug(`${functionToRetry.name} retrying in ${retryIn} ms`);
                // we check `terminated` again here because it could have flipped
                // in the time it took `functionToRetry` to return.
                if (retryIn === false || terminated) {
                    reject(err);
                    return;
                } else await new Promise((_resolve)=>{
                    wakeUp = _resolve; // export wakeUp for onTerminate handling
                    timeout = setTimeout(wakeUp, retryIn);
                });
            }
        }
        // reached if terminated while waiting for a timer.
        reject(lastError);
    });
}

},{"../../Logger/ConsoleLogger.mjs":"6OFOw","./isNonRetryableError.mjs":"kyGTP","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kyGTP":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNonRetryableError", ()=>isNonRetryableError);
const isNonRetryableError = (obj)=>{
    const key = 'nonRetryable';
    return obj && obj[key];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iBLBL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepFreeze", ()=>deepFreeze);
const deepFreeze = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === 'object' || typeof value === 'function') deepFreeze(value);
    }
    return Object.freeze(object);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4w5h9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAWSExports", ()=>parseAWSExports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _consoleLoggerMjs = require("./Logger/ConsoleLogger.mjs");
var _amplifyErrorMjs = require("./errors/AmplifyError.mjs");
var _errorsMjs = require("./types/errors.mjs");
var _errorHelpersMjs = require("./errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('parseAWSExports');
const authTypeMapping = {
    API_KEY: 'apiKey',
    AWS_IAM: 'iam',
    AMAZON_COGNITO_USER_POOLS: 'userPool',
    OPENID_CONNECT: 'oidc',
    NONE: 'none',
    AWS_LAMBDA: 'lambda',
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: 'lambda'
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const parseAWSExports = (config = {})=>{
    var _aws_cognito_password_protection_settings_passwordPolicyCharacters, _aws_cognito_password_protection_settings_passwordPolicyCharacters1, _aws_cognito_password_protection_settings_passwordPolicyCharacters2, _aws_cognito_password_protection_settings_passwordPolicyCharacters3;
    if (!Object.prototype.hasOwnProperty.call(config, 'aws_project_region')) throw new (0, _amplifyErrorMjs.AmplifyError)({
        name: 'InvalidParameterException',
        message: 'Invalid config parameter.',
        recoverySuggestion: 'Ensure passing the config object imported from  `amplifyconfiguration.json`.'
    });
    const { aws_appsync_apiKey, aws_appsync_authenticationType, aws_appsync_graphqlEndpoint, aws_appsync_region, aws_bots_config, aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration, aws_cognito_mfa_types, aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms, aws_cognito_signup_attributes, aws_cognito_social_providers, aws_cognito_username_attributes, aws_mandatory_sign_in, aws_mobile_analytics_app_id, aws_mobile_analytics_app_region, aws_user_files_s3_bucket, aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id, aws_user_pools_web_client_id, geo, oauth, predictions, aws_cloud_logic_custom, Notifications, modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging, Push } = Notifications !== null && Notifications !== void 0 ? Notifications : {};
    if ((InAppMessaging === null || InAppMessaging === void 0 ? void 0 : InAppMessaging.AWSPinpoint) || (Push === null || Push === void 0 ? void 0 : Push.AWSPinpoint)) {
        if (InAppMessaging === null || InAppMessaging === void 0 ? void 0 : InAppMessaging.AWSPinpoint) {
            const { appId, region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId,
                        region
                    }
                }
            };
        }
        if (Push === null || Push === void 0 ? void 0 : Push.AWSPinpoint) {
            const { appId, region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = (0, _objectSpreadProps._)((0, _objectSpread._)({}, amplifyConfig.Notifications), {
                PushNotification: {
                    Pinpoint: {
                        appId,
                        region
                    }
                }
            });
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode !== null && defaultAuthMode !== void 0 ? defaultAuthMode : 'iam'
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    var _aws_cognito_mfa_types_includes, _aws_cognito_mfa_types_includes1;
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: (_aws_cognito_mfa_types_includes = aws_cognito_mfa_types === null || aws_cognito_mfa_types === void 0 ? void 0 : aws_cognito_mfa_types.includes('TOTP')) !== null && _aws_cognito_mfa_types_includes !== void 0 ? _aws_cognito_mfa_types_includes : false,
        smsEnabled: (_aws_cognito_mfa_types_includes1 = aws_cognito_mfa_types === null || aws_cognito_mfa_types === void 0 ? void 0 : aws_cognito_mfa_types.includes('SMS')) !== null && _aws_cognito_mfa_types_includes1 !== void 0 ? _aws_cognito_mfa_types_includes1 : false
    } : undefined;
    var _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes, _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1, _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2, _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes = (_aws_cognito_password_protection_settings_passwordPolicyCharacters = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters.includes('REQUIRES_LOWERCASE')) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes : false,
        requireUppercase: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1 = (_aws_cognito_password_protection_settings_passwordPolicyCharacters1 = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters1 === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters1.includes('REQUIRES_UPPERCASE')) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1 !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1 : false,
        requireNumbers: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2 = (_aws_cognito_password_protection_settings_passwordPolicyCharacters2 = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters2 === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters2.includes('REQUIRES_NUMBERS')) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2 !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2 : false,
        requireSpecialCharacters: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3 = (_aws_cognito_password_protection_settings_passwordPolicyCharacters3 = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters3 === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters3.includes('REQUIRES_SYMBOLS')) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3 !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3 : false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms !== null && aws_cognito_verification_mechanisms !== void 0 ? aws_cognito_verification_mechanisms : [],
        ...aws_cognito_signup_attributes !== null && aws_cognito_signup_attributes !== void 0 ? aws_cognito_signup_attributes : []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    var _aws_cognito_username_attributes_includes;
    const loginWithEmailEnabled = (_aws_cognito_username_attributes_includes = aws_cognito_username_attributes === null || aws_cognito_username_attributes === void 0 ? void 0 : aws_cognito_username_attributes.includes('EMAIL')) !== null && _aws_cognito_username_attributes_includes !== void 0 ? _aws_cognito_username_attributes_includes : false;
    var _aws_cognito_username_attributes_includes1;
    const loginWithPhoneEnabled = (_aws_cognito_username_attributes_includes1 = aws_cognito_username_attributes === null || aws_cognito_username_attributes === void 0 ? void 0 : aws_cognito_username_attributes.includes('PHONE_NUMBER')) !== null && _aws_cognito_username_attributes_includes1 !== void 0 ? _aws_cognito_username_attributes_includes1 : false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== 'enable',
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = (0, _objectSpreadProps._)((0, _objectSpread._)({}, amplifyConfig.Auth.Cognito.loginWith), {
        oauth: (0, _objectSpread._)({}, getOAuthConfig(oauth), hasSocialProviderConfig && {
            providers: parseSocialProviders(aws_cognito_social_providers)
        })
    });
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = (0, _objectSpreadProps._)((0, _objectSpread._)({}, amplifyConfig.API), {
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name, endpoint, region, service } = api;
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [name]: (0, _objectSpread._)({
                    endpoint
                }, service ? {
                    service
                } : undefined, region ? {
                    region
                } : undefined)
            });
        }, {})
    });
    // Predictions
    if (predictions) {
        var _predictions_convert_speechGenerator, _predictions_convert;
        var _predictions_convert_speechGenerator_defaults;
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = (_predictions_convert_speechGenerator_defaults = predictions === null || predictions === void 0 ? void 0 : (_predictions_convert = predictions.convert) === null || _predictions_convert === void 0 ? void 0 : (_predictions_convert_speechGenerator = _predictions_convert.speechGenerator) === null || _predictions_convert_speechGenerator === void 0 ? void 0 : _predictions_convert_speechGenerator.defaults) !== null && _predictions_convert_speechGenerator_defaults !== void 0 ? _predictions_convert_speechGenerator_defaults : {};
        amplifyConfig.Predictions = voiceId ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, predictions), {
            convert: (0, _objectSpreadProps._)((0, _objectSpread._)({}, predictions.convert), {
                speechGenerator: (0, _objectSpreadProps._)((0, _objectSpread._)({}, predictions.convert.speechGenerator), {
                    defaults: {
                        voiceId
                    }
                })
            })
        }) : predictions;
    }
    return amplifyConfig;
};
const getRedirectUrl = (redirectStr)=>{
    var _redirectStr_split;
    return (_redirectStr_split = redirectStr === null || redirectStr === void 0 ? void 0 : redirectStr.split(',')) !== null && _redirectStr_split !== void 0 ? _redirectStr_split : [];
};
const getOAuthConfig = ({ domain, scope, redirectSignIn, redirectSignOut, responseType })=>({
        domain,
        scopes: scope,
        redirectSignIn: getRedirectUrl(redirectSignIn),
        redirectSignOut: getRedirectUrl(redirectSignOut),
        responseType
    });
const parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","./Logger/ConsoleLogger.mjs":"6OFOw","./errors/AmplifyError.mjs":"9LcuL","./types/errors.mjs":"2tN68","./errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"f5Lch":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADD_OAUTH_LISTENER", ()=>ADD_OAUTH_LISTENER);
const ADD_OAUTH_LISTENER = Symbol('oauth-listener');

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5L12c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v1ToV6", ()=>(0, _v1ToV6JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "v6", ()=>(0, _v6JsDefault.default));
parcelHelpers.export(exports, "v6ToV1", ()=>(0, _v6ToV1JsDefault.default));
parcelHelpers.export(exports, "v7", ()=>(0, _v7JsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v1ToV6Js = require("./v1ToV6.js");
var _v1ToV6JsDefault = parcelHelpers.interopDefault(_v1ToV6Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _v6Js = require("./v6.js");
var _v6JsDefault = parcelHelpers.interopDefault(_v6Js);
var _v6ToV1Js = require("./v6ToV1.js");
var _v6ToV1JsDefault = parcelHelpers.interopDefault(_v6ToV1Js);
var _v7Js = require("./v7.js");
var _v7JsDefault = parcelHelpers.interopDefault(_v7Js);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);

},{"./max.js":"kILD5","./nil.js":"7qSLS","./parse.js":"keTbS","./stringify.js":"ap3TH","./v1.js":"l5HQw","./v1ToV6.js":"3OXu5","./v3.js":"h48lj","./v4.js":"cIlHW","./v5.js":"aevA7","./v6.js":"jC6eY","./v6ToV1.js":"aCXkk","./v7.js":"ihk6u","./validate.js":"c7JCc","./version.js":"2sc8m","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kILD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = 'ffffffff-ffff-ffff-ffff-ffffffffffff';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7qSLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '00000000-0000-0000-0000-000000000000';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"keTbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function parse(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    let v;
    return Uint8Array.of((v = parseInt(uuid.slice(0, 8), 16)) >>> 24, v >>> 16 & 0xff, v >>> 8 & 0xff, v & 0xff, (v = parseInt(uuid.slice(9, 13), 16)) >>> 8, v & 0xff, (v = parseInt(uuid.slice(14, 18), 16)) >>> 8, v & 0xff, (v = parseInt(uuid.slice(19, 23), 16)) >>> 8, v & 0xff, (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff, v / 0x100000000 & 0xff, v >>> 24 & 0xff, v >>> 16 & 0xff, v >>> 8 & 0xff, v & 0xff);
}
exports.default = parse;

},{"./validate.js":"c7JCc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"c7JCc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"eM0Mt","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eM0Mt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ap3TH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset);
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"c7JCc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"l5HQw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateV1State", ()=>updateV1State);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
const _state = {};
function v1(options, buf, offset) {
    var _options_rng;
    let bytes;
    var _options__v6;
    const isV6 = (_options__v6 = options === null || options === void 0 ? void 0 : options._v6) !== null && _options__v6 !== void 0 ? _options__v6 : false;
    if (options) {
        const optionsKeys = Object.keys(options);
        if (optionsKeys.length === 1 && optionsKeys[0] === '_v6') options = undefined;
    }
    var _options_random, _ref;
    if (options) bytes = v1Bytes((_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, _rngJsDefault.default)(), options.msecs, options.nsecs, options.clockseq, options.node, buf, offset);
    else {
        const now = Date.now();
        const rnds = (0, _rngJsDefault.default)();
        updateV1State(_state, now, rnds);
        bytes = v1Bytes(rnds, _state.msecs, _state.nsecs, isV6 ? undefined : _state.clockseq, isV6 ? undefined : _state.node, buf, offset);
    }
    return buf !== null && buf !== void 0 ? buf : (0, _stringifyJs.unsafeStringify)(bytes);
}
function updateV1State(state, now, rnds) {
    var _state, _state1;
    var _msecs;
    (_msecs = (_state = state).msecs) !== null && _msecs !== void 0 ? _msecs : _state.msecs = -Infinity;
    var _nsecs;
    (_nsecs = (_state1 = state).nsecs) !== null && _nsecs !== void 0 ? _nsecs : _state1.nsecs = 0;
    if (now === state.msecs) {
        state.nsecs++;
        if (state.nsecs >= 10000) {
            state.node = undefined;
            state.nsecs = 0;
        }
    } else if (now > state.msecs) state.nsecs = 0;
    else if (now < state.msecs) state.node = undefined;
    if (!state.node) {
        state.node = rnds.slice(10, 16);
        state.node[0] |= 0x01;
        state.clockseq = (rnds[8] << 8 | rnds[9]) & 0x3fff;
    }
    state.msecs = now;
    return state;
}
function v1Bytes(rnds, msecs, nsecs, clockseq, node, buf, offset = 0) {
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    if (!buf) {
        buf = new Uint8Array(16);
        offset = 0;
    } else {
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
    }
    msecs !== null && msecs !== void 0 ? msecs : msecs = Date.now();
    nsecs !== null && nsecs !== void 0 ? nsecs : nsecs = 0;
    clockseq !== null && clockseq !== void 0 ? clockseq : clockseq = (rnds[8] << 8 | rnds[9]) & 0x3fff;
    node !== null && node !== void 0 ? node : node = rnds.slice(10, 16);
    msecs += 12219292800000;
    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    buf[offset++] = tl >>> 24 & 0xff;
    buf[offset++] = tl >>> 16 & 0xff;
    buf[offset++] = tl >>> 8 & 0xff;
    buf[offset++] = tl & 0xff;
    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    buf[offset++] = tmh >>> 8 & 0xff;
    buf[offset++] = tmh & 0xff;
    buf[offset++] = tmh >>> 24 & 0xf | 0x10;
    buf[offset++] = tmh >>> 16 & 0xff;
    buf[offset++] = clockseq >>> 8 | 0x80;
    buf[offset++] = clockseq & 0xff;
    for(let n = 0; n < 6; ++n)buf[offset++] = node[n];
    return buf;
}
exports.default = v1;

},{"./rng.js":"iSRC5","./stringify.js":"ap3TH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iSRC5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3OXu5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>v1ToV6);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
function v1ToV6(uuid) {
    const v1Bytes = typeof uuid === 'string' ? (0, _parseJsDefault.default)(uuid) : uuid;
    const v6Bytes = _v1ToV6(v1Bytes);
    return typeof uuid === 'string' ? (0, _stringifyJs.unsafeStringify)(v6Bytes) : v6Bytes;
}
function _v1ToV6(v1Bytes) {
    return Uint8Array.of((v1Bytes[6] & 0x0f) << 4 | v1Bytes[7] >> 4 & 0x0f, (v1Bytes[7] & 0x0f) << 4 | (v1Bytes[4] & 0xf0) >> 4, (v1Bytes[4] & 0x0f) << 4 | (v1Bytes[5] & 0xf0) >> 4, (v1Bytes[5] & 0x0f) << 4 | (v1Bytes[0] & 0xf0) >> 4, (v1Bytes[0] & 0x0f) << 4 | (v1Bytes[1] & 0xf0) >> 4, (v1Bytes[1] & 0x0f) << 4 | (v1Bytes[2] & 0xf0) >> 4, 0x60 | v1Bytes[2] & 0x0f, v1Bytes[3], v1Bytes[8], v1Bytes[9], v1Bytes[10], v1Bytes[11], v1Bytes[12], v1Bytes[13], v1Bytes[14], v1Bytes[15]);
}

},{"./parse.js":"keTbS","./stringify.js":"ap3TH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"h48lj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", ()=>(0, _v35Js.DNS));
parcelHelpers.export(exports, "URL", ()=>(0, _v35Js.URL));
var _md5Js = require("./md5.js");
var _md5JsDefault = parcelHelpers.interopDefault(_md5Js);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
function v3(value, namespace, buf, offset) {
    return (0, _v35JsDefault.default)(0x30, (0, _md5JsDefault.default), value, namespace, buf, offset);
}
v3.DNS = (0, _v35Js.DNS);
v3.URL = (0, _v35Js.URL);
exports.default = v3;

},{"./md5.js":"mox20","./v35.js":"f4tPk","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"mox20":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function md5(bytes) {
    const words = uint8ToUint32(bytes);
    const md5Bytes = wordsToMd5(words, bytes.length * 8);
    return uint32ToUint8(md5Bytes);
}
function uint32ToUint8(input) {
    const bytes = new Uint8Array(input.length * 4);
    for(let i = 0; i < input.length * 4; i++)bytes[i] = input[i >> 2] >>> i % 4 * 8 & 0xff;
    return bytes;
}
function getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x, len) {
    const xpad = new Uint32Array(getOutputLength(len)).fill(0);
    xpad.set(x);
    xpad[len >> 5] |= 0x80 << len % 32;
    xpad[xpad.length - 1] = len;
    x = xpad;
    let a = 1732584193;
    let b = -271733879;
    let c = -1732584194;
    let d = 271733878;
    for(let i = 0; i < x.length; i += 16){
        const olda = a;
        const oldb = b;
        const oldc = c;
        const oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return Uint32Array.of(a, b, c, d);
}
function uint8ToUint32(input) {
    if (input.length === 0) return new Uint32Array();
    const output = new Uint32Array(getOutputLength(input.length * 8)).fill(0);
    for(let i = 0; i < input.length; i++)output[i >> 2] |= (input[i] & 0xff) << i % 4 * 8;
    return output;
}
function safeAdd(x, y) {
    const lsw = (x & 0xffff) + (y & 0xffff);
    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
exports.default = md5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"f4tPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringToBytes", ()=>stringToBytes);
parcelHelpers.export(exports, "DNS", ()=>DNS);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "default", ()=>v35);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str));
    const bytes = new Uint8Array(str.length);
    for(let i = 0; i < str.length; ++i)bytes[i] = str.charCodeAt(i);
    return bytes;
}
const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(version, hash, value, namespace, buf, offset) {
    const valueBytes = typeof value === 'string' ? stringToBytes(value) : value;
    const namespaceBytes = typeof namespace === 'string' ? (0, _parseJsDefault.default)(namespace) : namespace;
    if (typeof namespace === 'string') namespace = (0, _parseJsDefault.default)(namespace);
    if ((namespace === null || namespace === void 0 ? void 0 : namespace.length) !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    let bytes = new Uint8Array(16 + valueBytes.length);
    bytes.set(namespaceBytes);
    bytes.set(valueBytes, namespaceBytes.length);
    bytes = hash(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(bytes);
}

},{"./parse.js":"keTbS","./stringify.js":"ap3TH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cIlHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    var _options_rng;
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var _options_random, _ref;
    const rnds = (_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, _rngJsDefault.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"j8DWy","./rng.js":"iSRC5","./stringify.js":"ap3TH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"j8DWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aevA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", ()=>(0, _v35Js.DNS));
parcelHelpers.export(exports, "URL", ()=>(0, _v35Js.URL));
var _sha1Js = require("./sha1.js");
var _sha1JsDefault = parcelHelpers.interopDefault(_sha1Js);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
function v5(value, namespace, buf, offset) {
    return (0, _v35JsDefault.default)(0x50, (0, _sha1JsDefault.default), value, namespace, buf, offset);
}
v5.DNS = (0, _v35Js.DNS);
v5.URL = (0, _v35Js.URL);
exports.default = v5;

},{"./sha1.js":"aZUqF","./v35.js":"f4tPk","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aZUqF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    const K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    const H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    const newBytes = new Uint8Array(bytes.length + 1);
    newBytes.set(bytes);
    newBytes[bytes.length] = 0x80;
    bytes = newBytes;
    const l = bytes.length / 4 + 2;
    const N = Math.ceil(l / 16);
    const M = new Array(N);
    for(let i = 0; i < N; ++i){
        const arr = new Uint32Array(16);
        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
        M[i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(let i = 0; i < N; ++i){
        const W = new Uint32Array(80);
        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
        for(let t = 16; t < 80; ++t)W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
        let a = H[0];
        let b = H[1];
        let c = H[2];
        let d = H[3];
        let e = H[4];
        for(let t = 0; t < 80; ++t){
            const s = Math.floor(t / 20);
            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return Uint8Array.of(H[0] >> 24, H[0] >> 16, H[0] >> 8, H[0], H[1] >> 24, H[1] >> 16, H[1] >> 8, H[1], H[2] >> 24, H[2] >> 16, H[2] >> 8, H[2], H[3] >> 24, H[3] >> 16, H[3] >> 8, H[3], H[4] >> 24, H[4] >> 16, H[4] >> 8, H[4]);
}
exports.default = sha1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jC6eY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _stringifyJs = require("./stringify.js");
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v1ToV6Js = require("./v1ToV6.js");
var _v1ToV6JsDefault = parcelHelpers.interopDefault(_v1ToV6Js);
function v6(options, buf, offset) {
    options !== null && options !== void 0 ? options : options = {};
    offset !== null && offset !== void 0 ? offset : offset = 0;
    let bytes = (0, _v1JsDefault.default)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        _v6: true
    }), new Uint8Array(16));
    bytes = (0, _v1ToV6JsDefault.default)(bytes);
    if (buf) {
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; i++)buf[offset + i] = bytes[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(bytes);
}
exports.default = v6;

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","./stringify.js":"ap3TH","./v1.js":"l5HQw","./v1ToV6.js":"3OXu5","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aCXkk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>v6ToV1);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
function v6ToV1(uuid) {
    const v6Bytes = typeof uuid === 'string' ? (0, _parseJsDefault.default)(uuid) : uuid;
    const v1Bytes = _v6ToV1(v6Bytes);
    return typeof uuid === 'string' ? (0, _stringifyJs.unsafeStringify)(v1Bytes) : v1Bytes;
}
function _v6ToV1(v6Bytes) {
    return Uint8Array.of((v6Bytes[3] & 0x0f) << 4 | v6Bytes[4] >> 4 & 0x0f, (v6Bytes[4] & 0x0f) << 4 | (v6Bytes[5] & 0xf0) >> 4, (v6Bytes[5] & 0x0f) << 4 | v6Bytes[6] & 0x0f, v6Bytes[7], (v6Bytes[1] & 0x0f) << 4 | (v6Bytes[2] & 0xf0) >> 4, (v6Bytes[2] & 0x0f) << 4 | (v6Bytes[3] & 0xf0) >> 4, 0x10 | (v6Bytes[0] & 0xf0) >> 4, (v6Bytes[0] & 0x0f) << 4 | (v6Bytes[1] & 0xf0) >> 4, v6Bytes[8], v6Bytes[9], v6Bytes[10], v6Bytes[11], v6Bytes[12], v6Bytes[13], v6Bytes[14], v6Bytes[15]);
}

},{"./parse.js":"keTbS","./stringify.js":"ap3TH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ihk6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateV7State", ()=>updateV7State);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
const _state = {};
function v7(options, buf, offset) {
    var _options_rng;
    let bytes;
    var _options_random, _ref;
    if (options) bytes = v7Bytes((_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, _rngJsDefault.default)(), options.msecs, options.seq, buf, offset);
    else {
        const now = Date.now();
        const rnds = (0, _rngJsDefault.default)();
        updateV7State(_state, now, rnds);
        bytes = v7Bytes(rnds, _state.msecs, _state.seq, buf, offset);
    }
    return buf !== null && buf !== void 0 ? buf : (0, _stringifyJs.unsafeStringify)(bytes);
}
function updateV7State(state, now, rnds) {
    var _state, _state1;
    var _msecs;
    (_msecs = (_state = state).msecs) !== null && _msecs !== void 0 ? _msecs : _state.msecs = -Infinity;
    var _seq;
    (_seq = (_state1 = state).seq) !== null && _seq !== void 0 ? _seq : _state1.seq = 0;
    if (now > state.msecs) {
        state.seq = rnds[6] << 23 | rnds[7] << 16 | rnds[8] << 8 | rnds[9];
        state.msecs = now;
    } else {
        state.seq = state.seq + 1 | 0;
        if (state.seq === 0) state.msecs++;
    }
    return state;
}
function v7Bytes(rnds, msecs, seq, buf, offset = 0) {
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    if (!buf) {
        buf = new Uint8Array(16);
        offset = 0;
    } else {
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
    }
    msecs !== null && msecs !== void 0 ? msecs : msecs = Date.now();
    seq !== null && seq !== void 0 ? seq : seq = rnds[6] * 0x7f << 24 | rnds[7] << 16 | rnds[8] << 8 | rnds[9];
    buf[offset++] = msecs / 0x10000000000 & 0xff;
    buf[offset++] = msecs / 0x100000000 & 0xff;
    buf[offset++] = msecs / 0x1000000 & 0xff;
    buf[offset++] = msecs / 0x10000 & 0xff;
    buf[offset++] = msecs / 0x100 & 0xff;
    buf[offset++] = msecs & 0xff;
    buf[offset++] = 0x70 | seq >>> 28 & 0x0f;
    buf[offset++] = seq >>> 20 & 0xff;
    buf[offset++] = 0x80 | seq >>> 14 & 0x3f;
    buf[offset++] = seq >>> 6 & 0xff;
    buf[offset++] = seq << 2 & 0xff | rnds[10] & 0x03;
    buf[offset++] = rnds[11];
    buf[offset++] = rnds[12];
    buf[offset++] = rnds[13];
    buf[offset++] = rnds[14];
    buf[offset++] = rnds[15];
    return buf;
}
exports.default = v7;

},{"./rng.js":"iSRC5","./stringify.js":"ap3TH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2sc8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function version(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    return parseInt(uuid.slice(14, 15), 16);
}
exports.default = version;

},{"./validate.js":"c7JCc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5uPpw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAmplifyConfig", ()=>parseAmplifyConfig);
var _parseAWSExportsMjs = require("../parseAWSExports.mjs");
var _parseAmplifyOutputsMjs = require("../parseAmplifyOutputs.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const parseAmplifyConfig = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith('aws_'))) return (0, _parseAWSExportsMjs.parseAWSExports)(amplifyConfig);
    else if ((0, _parseAmplifyOutputsMjs.isAmplifyOutputs)(amplifyConfig)) return (0, _parseAmplifyOutputsMjs.parseAmplifyOutputs)(amplifyConfig);
    else return amplifyConfig;
};

},{"../parseAWSExports.mjs":"4w5h9","../parseAmplifyOutputs.mjs":"iA5kP","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iA5kP":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAmplifyOutputs", ()=>isAmplifyOutputs);
parcelHelpers.export(exports, "parseAmplifyOutputs", ()=>parseAmplifyOutputs);
parcelHelpers.export(exports, "parseAnalytics", ()=>parseAnalytics);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
function isAmplifyOutputs(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version } = config;
    if (!version) return false;
    return version.startsWith('1');
}
function parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name, aws_region, buckets } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region,
            buckets: buckets && createBucketInfoMap(buckets)
        }
    };
}
function parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id, user_pool_client_id, identity_pool_id, password_policy, mfa_configuration, mfa_methods, unauthenticated_identities_enabled, oauth, username_attributes, standard_required_attributes, groups, passwordless } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id,
            groups
        }
    };
    if (identity_pool_id) authConfig.Cognito = (0, _objectSpreadProps._)((0, _objectSpread._)({}, authConfig.Cognito), {
        identityPoolId: identity_pool_id
    });
    var _password_policy_min_length;
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: (_password_policy_min_length = password_policy.min_length) !== null && _password_policy_min_length !== void 0 ? _password_policy_min_length : 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods === null || mfa_methods === void 0 ? void 0 : mfa_methods.includes('SMS'),
        totpEnabled: mfa_methods === null || mfa_methods === void 0 ? void 0 : mfa_methods.includes('TOTP')
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === 'token' ? 'token' : 'code',
            scopes: oauth.scopes,
            providers: getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = (0, _objectSpreadProps._)((0, _objectSpread._)({}, authConfig.Cognito.loginWith), {
        email: username_attributes.includes('email'),
        phone: username_attributes.includes('phone_number'),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes('username')
    });
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
            [curr]: {
                required: true
            }
        }), {});
    if (passwordless) authConfig.Cognito.passwordless = {
        emailOtpEnabled: passwordless.email_otp_enabled,
        smsOtpEnabled: passwordless.sms_otp_enabled,
        webAuthn: passwordless.web_authn ? {
            relyingPartyId: passwordless.web_authn.relying_party_id,
            userVerification: passwordless.web_authn.user_verification
        } : undefined,
        preferredChallenge: passwordless.preferred_challenge
    };
    return authConfig;
}
function parseAnalytics(amplifyOutputsAnalyticsProperties) {
    if (!(amplifyOutputsAnalyticsProperties === null || amplifyOutputsAnalyticsProperties === void 0 ? void 0 : amplifyOutputsAnalyticsProperties.amazon_pinpoint)) return undefined;
    const { amazon_pinpoint } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region, geofence_collections, maps, search_indices } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps
        }
    };
}
function parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region, default_authorization_type, url, api_key, model_introspection } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL
    };
}
function parseCustom(amplifyOutputsCustomProperties) {
    if (!(amplifyOutputsCustomProperties === null || amplifyOutputsCustomProperties === void 0 ? void 0 : amplifyOutputsCustomProperties.events)) return undefined;
    const { url, aws_region, api_key, default_authorization_type } = amplifyOutputsCustomProperties.events;
    const Events = {
        endpoint: url,
        defaultAuthMode: getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key
    };
    return {
        Events
    };
}
function parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region, channels, amazon_pinpoint_app_id } = amplifyOutputsNotificationsProperties;
    const hasInAppMessaging = channels.includes('IN_APP_MESSAGING');
    const hasPushNotification = channels.includes('APNS') || channels.includes('FCM');
    if (!(hasInAppMessaging || hasPushNotification)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    if (hasPushNotification) notificationsConfig.PushNotification = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    return notificationsConfig;
}
function parseAmplifyOutputs(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = parseAnalytics(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = parseData(amplifyOutputs.data);
    if (amplifyOutputs.custom) {
        const customConfig = parseCustom(amplifyOutputs.custom);
        if (customConfig && 'Events' in customConfig) resourcesConfig.API = (0, _objectSpread._)({}, resourcesConfig.API, customConfig);
    }
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const authModeNames = {
    AMAZON_COGNITO_USER_POOLS: 'userPool',
    API_KEY: 'apiKey',
    AWS_IAM: 'iam',
    AWS_LAMBDA: 'lambda',
    OPENID_CONNECT: 'oidc'
};
function getGraphQLAuthMode(authType) {
    return authModeNames[authType];
}
const providerNames = {
    GOOGLE: 'Google',
    LOGIN_WITH_AMAZON: 'Amazon',
    FACEBOOK: 'Facebook',
    SIGN_IN_WITH_APPLE: 'Apple'
};
function getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if (providerNames[provider] !== undefined) oAuthProviders.push(providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === 'OPTIONAL') return 'optional';
    if (mfaConfiguration === 'REQUIRED') return 'on';
    return 'off';
}
function createBucketInfoMap(buckets) {
    const mappedBuckets = {};
    buckets.forEach(({ name, bucket_name: bucketName, aws_region: region, paths })=>{
        if (name in mappedBuckets) throw new Error(`Duplicate friendly name found: ${name}. Name must be unique.`);
        const sanitizedPaths = paths ? Object.entries(paths).reduce((acc, [key, value])=>{
            if (value !== undefined) acc[key] = value;
            return acc;
        }, {}) : undefined;
        mappedBuckets[name] = {
            bucketName,
            region,
            paths: sanitizedPaths
        };
    });
    return mappedBuckets;
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5A0J7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsSha256 = require("./jsSha256");
parcelHelpers.exportAll(_jsSha256, exports);

},{"./jsSha256":"b47Hg","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"b47Hg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sha256", ()=>Sha256);
var _tslib = require("tslib");
var _constants = require("./constants");
var _rawSha256 = require("./RawSha256");
var _util = require("@aws-crypto/util");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, _rawSha256.RawSha256)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, _util.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, _util.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, _rawSha256.RawSha256)();
        if (this.secret) {
            this.outer = new (0, _rawSha256.RawSha256)();
            var inner = bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, _constants.BLOCK_SIZE));
            outer.set(inner);
            for(var i = 0; i < (0, _constants.BLOCK_SIZE); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function bufferFromSecret(secret) {
    var input = (0, _util.convertToBuffer)(secret);
    if (input.byteLength > (0, _constants.BLOCK_SIZE)) {
        var bufferHash = new (0, _rawSha256.RawSha256)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, _constants.BLOCK_SIZE));
    buffer.set(input);
    return buffer;
}

},{"tslib":"h1Nlh","./constants":"h32rA","./RawSha256":"tMWCZ","@aws-crypto/util":"fhR4v","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"h1Nlh":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"h32rA":[function(require,module,exports,__globalThis) {
/**
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLOCK_SIZE", ()=>BLOCK_SIZE);
parcelHelpers.export(exports, "DIGEST_LENGTH", ()=>DIGEST_LENGTH);
parcelHelpers.export(exports, "KEY", ()=>KEY);
parcelHelpers.export(exports, "INIT", ()=>INIT);
parcelHelpers.export(exports, "MAX_HASHABLE_LENGTH", ()=>MAX_HASHABLE_LENGTH);
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 32;
var KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"tMWCZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RawSha256", ()=>RawSha256);
var _constants = require("./constants");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, _constants.INIT));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, _constants.MAX_HASHABLE_LENGTH)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, _constants.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, _constants.BLOCK_SIZE) >= (0, _constants.BLOCK_SIZE) - 8) {
                for(var i = this.bufferLength; i < (0, _constants.BLOCK_SIZE); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, _constants.BLOCK_SIZE) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, _constants.BLOCK_SIZE) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, _constants.BLOCK_SIZE) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, _constants.DIGEST_LENGTH));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, _constants.BLOCK_SIZE); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, _constants.KEY)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();

},{"./constants":"h32rA","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fhR4v":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToBuffer", ()=>(0, _convertToBuffer.convertToBuffer));
parcelHelpers.export(exports, "isEmptyData", ()=>(0, _isEmptyData.isEmptyData));
parcelHelpers.export(exports, "numToUint8", ()=>(0, _numToUint8.numToUint8));
parcelHelpers.export(exports, "uint32ArrayFrom", ()=>(0, _uint32ArrayFrom.uint32ArrayFrom));
var _convertToBuffer = require("./convertToBuffer");
var _isEmptyData = require("./isEmptyData");
var _numToUint8 = require("./numToUint8");
var _uint32ArrayFrom = require("./uint32ArrayFrom");

},{"./convertToBuffer":"g1mA2","./isEmptyData":"1nSW7","./numToUint8":"kwH2s","./uint32ArrayFrom":"7G85v","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"g1mA2":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToBuffer", ()=>convertToBuffer);
var _utilUtf8 = require("@smithy/util-utf8");
var Buffer = require("1373df1d6c1e369e").Buffer;
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : (0, _utilUtf8.fromUtf8);
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"1373df1d6c1e369e":"bzMHD","@smithy/util-utf8":"56m7B","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bzMHD":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayLike(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"9dgvu","aceacb6a4531a9d2":"6l3tO"}],"9dgvu":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6l3tO":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"56m7B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fromUtf8 = require("./fromUtf8");
parcelHelpers.exportAll(_fromUtf8, exports);
var _toUint8Array = require("./toUint8Array");
parcelHelpers.exportAll(_toUint8Array, exports);
var _toUtf8 = require("./toUtf8");
parcelHelpers.exportAll(_toUtf8, exports);

},{"./fromUtf8":"3z9ID","./toUint8Array":"Qdju3","./toUtf8":"8OJ9b","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3z9ID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
const fromUtf8 = (input)=>new TextEncoder().encode(input);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"Qdju3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toUint8Array", ()=>toUint8Array);
var _fromUtf8 = require("./fromUtf8");
const toUint8Array = (data)=>{
    if (typeof data === "string") return (0, _fromUtf8.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

},{"./fromUtf8":"3z9ID","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8OJ9b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
const toUtf8 = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1nSW7":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyData", ()=>isEmptyData);
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kwH2s":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numToUint8", ()=>numToUint8);
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7G85v":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uint32ArrayFrom", ()=>uint32ArrayFrom);
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ghBtt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
const SHORT_TO_HEX = {};
const HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function toHex(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"34W7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>getAmplifyUserAgent);
parcelHelpers.export(exports, "getAmplifyUserAgentObject", ()=>getAmplifyUserAgentObject);
parcelHelpers.export(exports, "sanitizeAmplifyVersion", ()=>sanitizeAmplifyVersion);
var _typesMjs = require("./types.mjs");
var _versionMjs = require("./version.mjs");
var _detectFrameworkMjs = require("./detectFramework.mjs");
var _customUserAgentMjs = require("./customUserAgent.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const BASE_USER_AGENT = `aws-amplify`;
/** Sanitize Amplify version string be removing special character + and character post the special character  */ const sanitizeAmplifyVersion = (amplifyVersion)=>amplifyVersion.replace(/\+.*/, '');
class PlatformBuilder {
    get framework() {
        return (0, _detectFrameworkMjs.detectFramework)();
    }
    get isReactNative() {
        return this.framework === (0, _typesMjs.Framework).ReactNative || this.framework === (0, _typesMjs.Framework).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, _detectFrameworkMjs.observeFrameworkChanges)(fcn);
    }
    constructor(){
        this.userAgent = `${BASE_USER_AGENT}/${sanitizeAmplifyVersion((0, _versionMjs.version))}`;
    }
}
const Platform = new PlatformBuilder();
const getAmplifyUserAgentObject = ({ category, action } = {})=>{
    const userAgent = [
        [
            BASE_USER_AGENT,
            sanitizeAmplifyVersion((0, _versionMjs.version))
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        'framework',
        (0, _detectFrameworkMjs.detectFramework)()
    ]);
    if (category && action) {
        const customState = (0, _customUserAgentMjs.getCustomUserAgent)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const getAmplifyUserAgent = (customUserAgentDetails)=>{
    const userAgent = getAmplifyUserAgentObject(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(' ');
    return userAgentString;
};

},{"./types.mjs":"8YCjz","./version.mjs":"83ucX","./detectFramework.mjs":"ild5k","./customUserAgent.mjs":"9MkrV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8YCjz":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AiAction", ()=>AiAction);
parcelHelpers.export(exports, "AnalyticsAction", ()=>AnalyticsAction);
parcelHelpers.export(exports, "ApiAction", ()=>ApiAction);
parcelHelpers.export(exports, "AuthAction", ()=>AuthAction);
parcelHelpers.export(exports, "Category", ()=>Category);
parcelHelpers.export(exports, "DataStoreAction", ()=>DataStoreAction);
parcelHelpers.export(exports, "Framework", ()=>Framework);
parcelHelpers.export(exports, "GeoAction", ()=>GeoAction);
parcelHelpers.export(exports, "InAppMessagingAction", ()=>InAppMessagingAction);
parcelHelpers.export(exports, "InteractionsAction", ()=>InteractionsAction);
parcelHelpers.export(exports, "PredictionsAction", ()=>PredictionsAction);
parcelHelpers.export(exports, "PubSubAction", ()=>PubSubAction);
parcelHelpers.export(exports, "PushNotificationAction", ()=>PushNotificationAction);
parcelHelpers.export(exports, "StorageAction", ()=>StorageAction);
var Framework;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})(Framework || (Framework = {}));
var Category;
(function(Category) {
    Category["AI"] = "ai";
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})(Category || (Category = {}));
var AiAction;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnMessage"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})(AiAction || (AiAction = {}));
var AnalyticsAction;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})(AnalyticsAction || (AnalyticsAction = {}));
var ApiAction;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})(ApiAction || (ApiAction = {}));
var AuthAction;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
    AuthAction["StartWebAuthnRegistration"] = "37";
    AuthAction["CompleteWebAuthnRegistration"] = "38";
    AuthAction["ListWebAuthnCredentials"] = "39";
    AuthAction["DeleteWebAuthnCredential"] = "40";
})(AuthAction || (AuthAction = {}));
var DataStoreAction;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})(DataStoreAction || (DataStoreAction = {}));
var GeoAction;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})(GeoAction || (GeoAction = {}));
var InAppMessagingAction;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})(InAppMessagingAction || (InAppMessagingAction = {}));
var InteractionsAction;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})(InteractionsAction || (InteractionsAction = {}));
var PredictionsAction;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})(PredictionsAction || (PredictionsAction = {}));
var PubSubAction;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})(PubSubAction || (PubSubAction = {}));
var PushNotificationAction;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})(PushNotificationAction || (PushNotificationAction = {}));
var StorageAction;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
    StorageAction["GetDataAccess"] = "8";
    StorageAction["ListCallerAccessGrants"] = "9";
})(StorageAction || (StorageAction = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"83ucX":[function(require,module,exports,__globalThis) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = '6.17.0';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ild5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearCache", ()=>clearCache);
parcelHelpers.export(exports, "detectFramework", ()=>detectFramework);
parcelHelpers.export(exports, "frameworkChangeObservers", ()=>frameworkChangeObservers);
parcelHelpers.export(exports, "observeFrameworkChanges", ()=>observeFrameworkChanges);
var _typesMjs = require("./types.mjs");
var _indexMjs = require("./detection/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let frameworkCache;
const frameworkChangeObservers = [];
// Setup the detection reset tracking / timeout delays
let resetTriggered = false;
const SSR_RESET_TIMEOUT = 10; // ms
const WEB_RESET_TIMEOUT = 10; // ms
const PRIME_FRAMEWORK_DELAY = 1000; // ms
const detectFramework = ()=>{
    if (!frameworkCache) {
        var _frameworkChangeObservers_pop;
        frameworkCache = (0, _indexMjs.detect)();
        if (resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while(frameworkChangeObservers.length)(_frameworkChangeObservers_pop = frameworkChangeObservers.pop()) === null || _frameworkChangeObservers_pop === void 0 ? void 0 : _frameworkChangeObservers_pop();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        frameworkChangeObservers.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        resetTimeout((0, _typesMjs.Framework).ServerSideUnknown, SSR_RESET_TIMEOUT);
        resetTimeout((0, _typesMjs.Framework).WebUnknown, WEB_RESET_TIMEOUT);
    }
    return frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const observeFrameworkChanges = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if (resetTriggered) return;
    frameworkChangeObservers.push(fcn);
};
function clearCache() {
    frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function resetTimeout(framework, delay) {
    if (frameworkCache === framework && !resetTriggered) setTimeout(()=>{
        clearCache();
        resetTriggered = true;
        setTimeout(detectFramework, PRIME_FRAMEWORK_DELAY);
    }, delay);
}

},{"./types.mjs":"8YCjz","./detection/index.mjs":"5WC8z","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5WC8z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detect", ()=>detect);
var _typesMjs = require("../types.mjs");
var _reactMjs = require("./React.mjs");
var _vueMjs = require("./Vue.mjs");
var _svelteMjs = require("./Svelte.mjs");
var _nextMjs = require("./Next.mjs");
var _nuxtMjs = require("./Nuxt.mjs");
var _angularMjs = require("./Angular.mjs");
var _reactNativeMjs = require("./ReactNative.mjs");
var _expoMjs = require("./Expo.mjs");
var _webMjs = require("./Web.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const detectionMap = [
    // First, detect mobile
    {
        platform: (0, _typesMjs.Framework).Expo,
        detectionMethod: (0, _expoMjs.expoDetect)
    },
    {
        platform: (0, _typesMjs.Framework).ReactNative,
        detectionMethod: (0, _reactNativeMjs.reactNativeDetect)
    },
    // Next, detect web frameworks
    {
        platform: (0, _typesMjs.Framework).NextJs,
        detectionMethod: (0, _nextMjs.nextWebDetect)
    },
    {
        platform: (0, _typesMjs.Framework).Nuxt,
        detectionMethod: (0, _nuxtMjs.nuxtWebDetect)
    },
    {
        platform: (0, _typesMjs.Framework).Angular,
        detectionMethod: (0, _angularMjs.angularWebDetect)
    },
    {
        platform: (0, _typesMjs.Framework).React,
        detectionMethod: (0, _reactMjs.reactWebDetect)
    },
    {
        platform: (0, _typesMjs.Framework).VueJs,
        detectionMethod: (0, _vueMjs.vueWebDetect)
    },
    {
        platform: (0, _typesMjs.Framework).Svelte,
        detectionMethod: (0, _svelteMjs.svelteWebDetect)
    },
    {
        platform: (0, _typesMjs.Framework).WebUnknown,
        detectionMethod: (0, _webMjs.webDetect)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, _typesMjs.Framework).NextJsSSR,
        detectionMethod: (0, _nextMjs.nextSSRDetect)
    },
    {
        platform: (0, _typesMjs.Framework).NuxtSSR,
        detectionMethod: (0, _nuxtMjs.nuxtSSRDetect)
    },
    {
        platform: (0, _typesMjs.Framework).ReactSSR,
        detectionMethod: (0, _reactMjs.reactSSRDetect)
    },
    {
        platform: (0, _typesMjs.Framework).VueJsSSR,
        detectionMethod: (0, _vueMjs.vueSSRDetect)
    },
    {
        platform: (0, _typesMjs.Framework).AngularSSR,
        detectionMethod: (0, _angularMjs.angularSSRDetect)
    },
    {
        platform: (0, _typesMjs.Framework).SvelteSSR,
        detectionMethod: (0, _svelteMjs.svelteSSRDetect)
    }
];
function detect() {
    var _detectionMap_find;
    return ((_detectionMap_find = detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())) === null || _detectionMap_find === void 0 ? void 0 : _detectionMap_find.platform) || (0, _typesMjs.Framework).ServerSideUnknown;
}

},{"../types.mjs":"8YCjz","./React.mjs":"jRMBd","./Vue.mjs":"17yEV","./Svelte.mjs":"1qcaE","./Next.mjs":"kKbWR","./Nuxt.mjs":"5RmAE","./Angular.mjs":"iO6ws","./ReactNative.mjs":"chdmv","./Expo.mjs":"enebG","./Web.mjs":"lAXKO","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jRMBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// use the some
parcelHelpers.export(exports, "reactSSRDetect", ()=>reactSSRDetect);
parcelHelpers.export(exports, "reactWebDetect", ()=>reactWebDetect);
var _helpersMjs = require("./helpers.mjs");
var process = require("7f97f5f6eaa3ffdf");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function reactWebDetect() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith('_react') || key.startsWith('__react');
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll('[id]'));
    return (0, _helpersMjs.documentExists)() && allElementsWithId().some(elementIsReactEnabled);
}
function reactSSRDetect() {
    return (0, _helpersMjs.processExists)() && typeof process.env !== 'undefined' && !!Object.keys(process.env).find((key)=>key.includes('react'));
}

},{"7f97f5f6eaa3ffdf":"bcIy3","./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bcIy3":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"bp52h":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "documentExists", ()=>documentExists);
parcelHelpers.export(exports, "globalExists", ()=>globalExists);
parcelHelpers.export(exports, "globalThisExists", ()=>globalThisExists);
parcelHelpers.export(exports, "keyPrefixMatch", ()=>keyPrefixMatch);
parcelHelpers.export(exports, "processExists", ()=>processExists);
parcelHelpers.export(exports, "windowExists", ()=>windowExists);
var global = arguments[3];
const globalExists = ()=>{
    return typeof global !== 'undefined';
};
const globalThisExists = ()=>{
    return typeof globalThis !== 'undefined';
};
const windowExists = ()=>{
    return typeof window !== 'undefined';
};
const documentExists = ()=>{
    return typeof document !== 'undefined';
};
const processExists = ()=>{
    return false;
};
const keyPrefixMatch = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"17yEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vueSSRDetect", ()=>vueSSRDetect);
parcelHelpers.export(exports, "vueWebDetect", ()=>vueWebDetect);
var _helpersMjs = require("./helpers.mjs");
var global = arguments[3];
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function vueWebDetect() {
    return (0, _helpersMjs.windowExists)() && (0, _helpersMjs.keyPrefixMatch)(window, '__VUE');
}
function vueSSRDetect() {
    return (0, _helpersMjs.globalExists)() && (0, _helpersMjs.keyPrefixMatch)(global, '__VUE');
}

},{"./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1qcaE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "svelteSSRDetect", ()=>svelteSSRDetect);
parcelHelpers.export(exports, "svelteWebDetect", ()=>svelteWebDetect);
var _helpersMjs = require("./helpers.mjs");
var process = require("bf0b6ee27f41cfab");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function svelteWebDetect() {
    return (0, _helpersMjs.windowExists)() && (0, _helpersMjs.keyPrefixMatch)(window, '__SVELTE');
}
function svelteSSRDetect() {
    return (0, _helpersMjs.processExists)() && typeof process.env !== 'undefined' && !!Object.keys(process.env).find((key)=>key.includes('svelte'));
}

},{"bf0b6ee27f41cfab":"bcIy3","./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kKbWR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nextSSRDetect", ()=>nextSSRDetect);
parcelHelpers.export(exports, "nextWebDetect", ()=>nextWebDetect);
var _helpersMjs = require("./helpers.mjs");
var global = arguments[3];
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function nextWebDetect() {
    return (0, _helpersMjs.windowExists)() && window.next && typeof window.next === 'object';
}
function nextSSRDetect() {
    return (0, _helpersMjs.globalExists)() && ((0, _helpersMjs.keyPrefixMatch)(global, '__next') || (0, _helpersMjs.keyPrefixMatch)(global, '__NEXT'));
}

},{"./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5RmAE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nuxtSSRDetect", ()=>nuxtSSRDetect);
parcelHelpers.export(exports, "nuxtWebDetect", ()=>nuxtWebDetect);
var _helpersMjs = require("./helpers.mjs");
var global = arguments[3];
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function nuxtWebDetect() {
    return (0, _helpersMjs.windowExists)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function nuxtSSRDetect() {
    return (0, _helpersMjs.globalExists)() && typeof global.__NUXT_PATHS__ !== 'undefined';
}

},{"./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iO6ws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "angularSSRDetect", ()=>angularSSRDetect);
parcelHelpers.export(exports, "angularWebDetect", ()=>angularWebDetect);
var _helpersMjs = require("./helpers.mjs");
var process = require("3d5a82adcc718a18");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function angularWebDetect() {
    const angularVersionSetInDocument = Boolean((0, _helpersMjs.documentExists)() && document.querySelector('[ng-version]'));
    const angularContentSetInWindow = Boolean((0, _helpersMjs.windowExists)() && typeof window.ng !== 'undefined');
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function angularSSRDetect() {
    var _undefined;
    return (0, _helpersMjs.processExists)() && typeof process.env === 'object' && ((_undefined = undefined) === null || _undefined === void 0 ? void 0 : _undefined.startsWith('ng ')) || false;
}

},{"3d5a82adcc718a18":"bcIy3","./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"chdmv":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactNativeDetect", ()=>reactNativeDetect);
function reactNativeDetect() {
    return typeof navigator !== 'undefined' && typeof navigator.product !== 'undefined' && navigator.product === 'ReactNative';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"enebG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expoDetect", ()=>expoDetect);
var _helpersMjs = require("./helpers.mjs");
var global = arguments[3];
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function expoDetect() {
    return (0, _helpersMjs.globalExists)() && typeof global.expo !== 'undefined';
}

},{"./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lAXKO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webDetect", ()=>webDetect);
var _helpersMjs = require("./helpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function webDetect() {
    return (0, _helpersMjs.windowExists)();
}

},{"./helpers.mjs":"bp52h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9MkrV":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCustomUserAgent", ()=>getCustomUserAgent);
parcelHelpers.export(exports, "setCustomUserAgent", ()=>setCustomUserAgent);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
const customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const setCustomUserAgent = (input)=>{
    var _customUserAgentState_input_category;
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    customUserAgentState[input.category] = input.apis.reduce((acc, api)=>{
        var _acc_api;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
            [api]: {
                refCount: ((_acc_api = acc[api]) === null || _acc_api === void 0 ? void 0 : _acc_api.refCount) ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        });
    }, (_customUserAgentState_input_category = customUserAgentState[input.category]) !== null && _customUserAgentState_input_category !== void 0 ? _customUserAgentState_input_category : {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys(customUserAgentState[input.category]).length) delete customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const getCustomUserAgent = (category, api)=>{
    var _customUserAgentState_category_api, _customUserAgentState_category;
    return (_customUserAgentState_category = customUserAgentState[category]) === null || _customUserAgentState_category === void 0 ? void 0 : (_customUserAgentState_category_api = _customUserAgentState_category[api]) === null || _customUserAgentState_category_api === void 0 ? void 0 : _customUserAgentState_category_api.additionalDetails;
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3gmMQ":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * All possible states a `BackgroundProcessManager` instance can be in.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>BackgroundProcessManagerState);
var BackgroundProcessManagerState;
(function(BackgroundProcessManagerState) {
    /**
     * Accepting new jobs.
     */ BackgroundProcessManagerState["Open"] = "Open";
    /**
     * Not accepting new jobs. Waiting for submitted jobs to complete.
     */ BackgroundProcessManagerState["Closing"] = "Closing";
    /**
     * Not accepting new jobs. All submitted jobs are complete.
     */ BackgroundProcessManagerState["Closed"] = "Closed";
})(BackgroundProcessManagerState || (BackgroundProcessManagerState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1EGHg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reachability", ()=>Reachability);
var _rxjs = require("rxjs");
var _errorsMjs = require("../types/errors.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../utils/getClientInfo/getClientInfo.mjs");
var _isWebWorkerMjs = require("../utils/isWebWorker.mjs");
var _retryMjs = require("../utils/retry/retry.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class Reachability {
    networkMonitor(_) {
        const globalObj = (0, _isWebWorkerMjs.isWebWorker)() ? self : typeof window !== 'undefined' && window;
        if (!globalObj) return (0, _rxjs.from)([
            {
                online: true
            }
        ]);
        return new (0, _rxjs.Observable)((observer)=>{
            observer.next({
                online: globalObj.navigator.onLine
            });
            const notifyOnline = ()=>{
                observer.next({
                    online: true
                });
            };
            const notifyOffline = ()=>{
                observer.next({
                    online: false
                });
            };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            Reachability._observers.push(observer);
            return ()=>{
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                Reachability._observers = Reachability._observers.filter((_observer)=>_observer !== observer);
            };
        });
    }
    // expose observers to simulate offline mode for integration testing
    static _observerOverride(status) {
        for (const observer of this._observers){
            if (observer.closed) {
                this._observers = this._observers.filter((_observer)=>_observer !== observer);
                continue;
            }
            (observer === null || observer === void 0 ? void 0 : observer.next) && observer.next(status);
        }
    }
}
Reachability._observers = [];

},{"rxjs":"7iDG5","../types/errors.mjs":"2tN68","../errors/errorHelpers.mjs":"fvR3Q","../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../utils/isWebWorker.mjs":"iXFzc","../utils/retry/retry.mjs":"eFvhH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7iDG5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "animationFrames", ()=>(0, _animationFrames.animationFrames));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "lastValueFrom", ()=>(0, _lastValueFrom.lastValueFrom));
parcelHelpers.export(exports, "firstValueFrom", ()=>(0, _firstValueFrom.firstValueFrom));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "NotFoundError", ()=>(0, _notFoundError.NotFoundError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "SequenceError", ()=>(0, _sequenceError.SequenceError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeout.TimeoutError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "connectable", ()=>(0, _connectable.connectable));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatestAll", ()=>(0, _combineLatestAll.combineLatestAll));
parcelHelpers.export(exports, "combineLatestWith", ()=>(0, _combineLatestWith.combineLatestWith));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "concatWith", ()=>(0, _concatWith.concatWith));
parcelHelpers.export(exports, "connect", ()=>(0, _connect.connect));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustAll", ()=>(0, _exhaustAll.exhaustAll));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "flatMap", ()=>(0, _flatMap.flatMap));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWith.mergeWith));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNextWith", ()=>(0, _onErrorResumeNextWith.onErrorResumeNextWith));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "raceWith", ()=>(0, _raceWith.raceWith));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "switchScan", ()=>(0, _switchScan.switchScan));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWith.zipWith));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _observable1 = require("./internal/symbol/observable");
var _animationFrames = require("./internal/observable/dom/animationFrames");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _lastValueFrom = require("./internal/lastValueFrom");
var _firstValueFrom = require("./internal/firstValueFrom");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _notFoundError = require("./internal/util/NotFoundError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _sequenceError = require("./internal/util/SequenceError");
var _timeout = require("./internal/operators/timeout");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _connectable = require("./internal/observable/connectable");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _types = require("./internal/types");
parcelHelpers.exportAll(_types, exports);
var _config = require("./internal/config");
var _audit = require("./internal/operators/audit");
var _auditTime = require("./internal/operators/auditTime");
var _buffer = require("./internal/operators/buffer");
var _bufferCount = require("./internal/operators/bufferCount");
var _bufferTime = require("./internal/operators/bufferTime");
var _bufferToggle = require("./internal/operators/bufferToggle");
var _bufferWhen = require("./internal/operators/bufferWhen");
var _catchError = require("./internal/operators/catchError");
var _combineAll = require("./internal/operators/combineAll");
var _combineLatestAll = require("./internal/operators/combineLatestAll");
var _combineLatestWith = require("./internal/operators/combineLatestWith");
var _concatAll = require("./internal/operators/concatAll");
var _concatMap = require("./internal/operators/concatMap");
var _concatMapTo = require("./internal/operators/concatMapTo");
var _concatWith = require("./internal/operators/concatWith");
var _connect = require("./internal/operators/connect");
var _count = require("./internal/operators/count");
var _debounce = require("./internal/operators/debounce");
var _debounceTime = require("./internal/operators/debounceTime");
var _defaultIfEmpty = require("./internal/operators/defaultIfEmpty");
var _delay = require("./internal/operators/delay");
var _delayWhen = require("./internal/operators/delayWhen");
var _dematerialize = require("./internal/operators/dematerialize");
var _distinct = require("./internal/operators/distinct");
var _distinctUntilChanged = require("./internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("./internal/operators/distinctUntilKeyChanged");
var _elementAt = require("./internal/operators/elementAt");
var _endWith = require("./internal/operators/endWith");
var _every = require("./internal/operators/every");
var _exhaust = require("./internal/operators/exhaust");
var _exhaustAll = require("./internal/operators/exhaustAll");
var _exhaustMap = require("./internal/operators/exhaustMap");
var _expand = require("./internal/operators/expand");
var _filter = require("./internal/operators/filter");
var _finalize = require("./internal/operators/finalize");
var _find = require("./internal/operators/find");
var _findIndex = require("./internal/operators/findIndex");
var _first = require("./internal/operators/first");
var _groupBy = require("./internal/operators/groupBy");
var _ignoreElements = require("./internal/operators/ignoreElements");
var _isEmpty = require("./internal/operators/isEmpty");
var _last = require("./internal/operators/last");
var _map = require("./internal/operators/map");
var _mapTo = require("./internal/operators/mapTo");
var _materialize = require("./internal/operators/materialize");
var _max = require("./internal/operators/max");
var _mergeAll = require("./internal/operators/mergeAll");
var _flatMap = require("./internal/operators/flatMap");
var _mergeMap = require("./internal/operators/mergeMap");
var _mergeMapTo = require("./internal/operators/mergeMapTo");
var _mergeScan = require("./internal/operators/mergeScan");
var _mergeWith = require("./internal/operators/mergeWith");
var _min = require("./internal/operators/min");
var _multicast = require("./internal/operators/multicast");
var _observeOn = require("./internal/operators/observeOn");
var _onErrorResumeNextWith = require("./internal/operators/onErrorResumeNextWith");
var _pairwise = require("./internal/operators/pairwise");
var _pluck = require("./internal/operators/pluck");
var _publish = require("./internal/operators/publish");
var _publishBehavior = require("./internal/operators/publishBehavior");
var _publishLast = require("./internal/operators/publishLast");
var _publishReplay = require("./internal/operators/publishReplay");
var _raceWith = require("./internal/operators/raceWith");
var _reduce = require("./internal/operators/reduce");
var _repeat = require("./internal/operators/repeat");
var _repeatWhen = require("./internal/operators/repeatWhen");
var _retry = require("./internal/operators/retry");
var _retryWhen = require("./internal/operators/retryWhen");
var _refCount = require("./internal/operators/refCount");
var _sample = require("./internal/operators/sample");
var _sampleTime = require("./internal/operators/sampleTime");
var _scan = require("./internal/operators/scan");
var _sequenceEqual = require("./internal/operators/sequenceEqual");
var _share = require("./internal/operators/share");
var _shareReplay = require("./internal/operators/shareReplay");
var _single = require("./internal/operators/single");
var _skip = require("./internal/operators/skip");
var _skipLast = require("./internal/operators/skipLast");
var _skipUntil = require("./internal/operators/skipUntil");
var _skipWhile = require("./internal/operators/skipWhile");
var _startWith = require("./internal/operators/startWith");
var _subscribeOn = require("./internal/operators/subscribeOn");
var _switchAll = require("./internal/operators/switchAll");
var _switchMap = require("./internal/operators/switchMap");
var _switchMapTo = require("./internal/operators/switchMapTo");
var _switchScan = require("./internal/operators/switchScan");
var _take = require("./internal/operators/take");
var _takeLast = require("./internal/operators/takeLast");
var _takeUntil = require("./internal/operators/takeUntil");
var _takeWhile = require("./internal/operators/takeWhile");
var _tap = require("./internal/operators/tap");
var _throttle = require("./internal/operators/throttle");
var _throttleTime = require("./internal/operators/throttleTime");
var _throwIfEmpty = require("./internal/operators/throwIfEmpty");
var _timeInterval = require("./internal/operators/timeInterval");
var _timeoutWith = require("./internal/operators/timeoutWith");
var _timestamp = require("./internal/operators/timestamp");
var _toArray = require("./internal/operators/toArray");
var _window = require("./internal/operators/window");
var _windowCount = require("./internal/operators/windowCount");
var _windowTime = require("./internal/operators/windowTime");
var _windowToggle = require("./internal/operators/windowToggle");
var _windowWhen = require("./internal/operators/windowWhen");
var _withLatestFrom = require("./internal/operators/withLatestFrom");
var _zipAll = require("./internal/operators/zipAll");
var _zipWith = require("./internal/operators/zipWith");

},{"./internal/Observable":"cmjzh","./internal/observable/ConnectableObservable":"ayC9d","./internal/symbol/observable":"cSqR4","./internal/observable/dom/animationFrames":"cJLFj","./internal/Subject":"kOvhz","./internal/BehaviorSubject":"8riRa","./internal/ReplaySubject":"dz1Gz","./internal/AsyncSubject":"g4Qg0","./internal/scheduler/asap":"bbwxq","./internal/scheduler/async":"3m7bL","./internal/scheduler/queue":"dlkAj","./internal/scheduler/animationFrame":"3pXwd","./internal/scheduler/VirtualTimeScheduler":"kyF7E","./internal/Scheduler":"2JSrA","./internal/Subscription":"jB6sM","./internal/Subscriber":"4uu7P","./internal/Notification":"1XSSK","./internal/util/pipe":"7GPyh","./internal/util/noop":"eBCM1","./internal/util/identity":"3R9K0","./internal/util/isObservable":"biXW2","./internal/lastValueFrom":"1vfSX","./internal/firstValueFrom":"iqwkH","./internal/util/ArgumentOutOfRangeError":"aKRd9","./internal/util/EmptyError":"ikj9E","./internal/util/NotFoundError":"cRrIH","./internal/util/ObjectUnsubscribedError":"fkwCx","./internal/util/SequenceError":"7MxXm","./internal/operators/timeout":"33AiV","./internal/util/UnsubscriptionError":"ZttQE","./internal/observable/bindCallback":"4aRvH","./internal/observable/bindNodeCallback":"fK7p6","./internal/observable/combineLatest":"gEX6r","./internal/observable/concat":"jgH4Y","./internal/observable/connectable":"1b5GA","./internal/observable/defer":"9FTON","./internal/observable/empty":"lbDEn","./internal/observable/forkJoin":"99HSs","./internal/observable/from":"ir8Cr","./internal/observable/fromEvent":"hqoat","./internal/observable/fromEventPattern":"apt9I","./internal/observable/generate":"hhU34","./internal/observable/iif":"eG8ee","./internal/observable/interval":"bYViF","./internal/observable/merge":"1TYJk","./internal/observable/never":"f6KgZ","./internal/observable/of":"gx45o","./internal/observable/onErrorResumeNext":"eMPOL","./internal/observable/pairs":"9j6CW","./internal/observable/partition":"cS9Ey","./internal/observable/race":"6cMD5","./internal/observable/range":"afzb5","./internal/observable/throwError":"SKmw6","./internal/observable/timer":"8Uhl1","./internal/observable/using":"bKeEF","./internal/observable/zip":"9zyDM","./internal/scheduled/scheduled":"c3mP7","./internal/types":"gdwXG","./internal/config":"d4EOS","./internal/operators/audit":"by7Z5","./internal/operators/auditTime":"psoPL","./internal/operators/buffer":"9A7yb","./internal/operators/bufferCount":"e5ENZ","./internal/operators/bufferTime":"cSGPo","./internal/operators/bufferToggle":"aARRB","./internal/operators/bufferWhen":"eadh9","./internal/operators/catchError":"78nD5","./internal/operators/combineAll":"llZTb","./internal/operators/combineLatestAll":"3GtTR","./internal/operators/combineLatestWith":"j1Twf","./internal/operators/concatAll":"78ztJ","./internal/operators/concatMap":"az0GZ","./internal/operators/concatMapTo":"jfHN2","./internal/operators/concatWith":"b9TyJ","./internal/operators/connect":"jM60D","./internal/operators/count":"8Eey7","./internal/operators/debounce":"7SkeI","./internal/operators/debounceTime":"dD9nD","./internal/operators/defaultIfEmpty":"8NhEc","./internal/operators/delay":"izLke","./internal/operators/delayWhen":"lJfeU","./internal/operators/dematerialize":"8pj1g","./internal/operators/distinct":"jMIBy","./internal/operators/distinctUntilChanged":"kO2be","./internal/operators/distinctUntilKeyChanged":"lV5ed","./internal/operators/elementAt":"jPnAj","./internal/operators/endWith":"eavh3","./internal/operators/every":"1Itrm","./internal/operators/exhaust":"bUsbZ","./internal/operators/exhaustAll":"aQzG3","./internal/operators/exhaustMap":"jdu2B","./internal/operators/expand":"3ISEJ","./internal/operators/filter":"kk9Ge","./internal/operators/finalize":"3sDHB","./internal/operators/find":"3SGAc","./internal/operators/findIndex":"3GiEY","./internal/operators/first":"8YZIh","./internal/operators/groupBy":"gnE9r","./internal/operators/ignoreElements":"bgzSn","./internal/operators/isEmpty":"eKwbQ","./internal/operators/last":"je9YS","./internal/operators/map":"aLYgu","./internal/operators/mapTo":"8xbwH","./internal/operators/materialize":"pf3ll","./internal/operators/max":"54Hke","./internal/operators/mergeAll":"eGWmm","./internal/operators/flatMap":"idJOb","./internal/operators/mergeMap":"3P4JK","./internal/operators/mergeMapTo":"5WctF","./internal/operators/mergeScan":"3SsGI","./internal/operators/mergeWith":"3tsSO","./internal/operators/min":"cQ9iK","./internal/operators/multicast":"lYmDp","./internal/operators/observeOn":"kfOpK","./internal/operators/onErrorResumeNextWith":"3EdOT","./internal/operators/pairwise":"hEN0p","./internal/operators/pluck":"exVUn","./internal/operators/publish":"WzriD","./internal/operators/publishBehavior":"jFZVF","./internal/operators/publishLast":"lVnyF","./internal/operators/publishReplay":"k5PlD","./internal/operators/raceWith":"iRXzm","./internal/operators/reduce":"lcFGM","./internal/operators/repeat":"1JzhN","./internal/operators/repeatWhen":"9ihhe","./internal/operators/retry":"elWVe","./internal/operators/retryWhen":"dvAD7","./internal/operators/refCount":"7rPtV","./internal/operators/sample":"ed9y7","./internal/operators/sampleTime":"7XqCe","./internal/operators/scan":"lbX4B","./internal/operators/sequenceEqual":"1V9Fe","./internal/operators/share":"cARo8","./internal/operators/shareReplay":"22B8X","./internal/operators/single":"c17as","./internal/operators/skip":"ihqWk","./internal/operators/skipLast":"9CGPG","./internal/operators/skipUntil":"iYiSJ","./internal/operators/skipWhile":"cvBXb","./internal/operators/startWith":"lm6WM","./internal/operators/subscribeOn":"e4zP2","./internal/operators/switchAll":"6XryD","./internal/operators/switchMap":"bjPkB","./internal/operators/switchMapTo":"55Cae","./internal/operators/switchScan":"ehD6Z","./internal/operators/take":"jkc4U","./internal/operators/takeLast":"glYcy","./internal/operators/takeUntil":"7tR5N","./internal/operators/takeWhile":"9Q7X7","./internal/operators/tap":"lDW82","./internal/operators/throttle":"fyMKZ","./internal/operators/throttleTime":"bnY8X","./internal/operators/throwIfEmpty":"67JYe","./internal/operators/timeInterval":"iqEjH","./internal/operators/timeoutWith":"lHItB","./internal/operators/timestamp":"lqzQV","./internal/operators/toArray":"31L3f","./internal/operators/window":"aFS6K","./internal/operators/windowCount":"1BnOI","./internal/operators/windowTime":"dBf9p","./internal/operators/windowToggle":"hheJM","./internal/operators/windowWhen":"cjHLA","./internal/operators/withLatestFrom":"efgsf","./internal/operators/zipAll":"67Mcf","./internal/operators/zipWith":"1rkRO","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cmjzh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var _isFunction = require("./util/isFunction");
var _errorContext = require("./util/errorContext");
var Observable = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new (0, _subscriber.SafeSubscriber)(observerOrNext, error, complete);
        (0, _errorContext.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, _subscriber.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, _config.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && (0, _isFunction.isFunction)(value.next) && (0, _isFunction.isFunction)(value.error) && (0, _isFunction.isFunction)(value.complete);
}
function isSubscriber(value) {
    return value && value instanceof (0, _subscriber.Subscriber) || isObserver(value) && (0, _subscription.isSubscription)(value);
}

},{"./Subscriber":"4uu7P","./Subscription":"jB6sM","./symbol/observable":"cSqR4","./util/pipe":"7GPyh","./config":"d4EOS","./util/isFunction":"2Pp4R","./util/errorContext":"5a5o4","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4uu7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
parcelHelpers.export(exports, "EMPTY_OBSERVER", ()=>EMPTY_OBSERVER);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _subscription = require("./Subscription");
var _config = require("./config");
var _reportUnhandledError = require("./util/reportUnhandledError");
var _noop = require("./util/noop");
var _notificationFactories = require("./NotificationFactories");
var _timeoutProvider = require("./scheduler/timeoutProvider");
var _errorContext = require("./util/errorContext");
var Subscriber = function(_super) {
    (0, _tslib.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, _subscription.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = EMPTY_OBSERVER;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, _subscription.Subscription));
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            handleUnhandledError(error);
        }
        else handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var SafeSubscriber = function(_super) {
    (0, _tslib.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, _isFunction.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, _config.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber);
function handleUnhandledError(error) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) (0, _errorContext.captureError)(error);
    else (0, _reportUnhandledError.reportUnhandledError)(error);
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, _config.config).onStoppedNotification;
    onStoppedNotification && (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: (0, _noop.noop),
    error: defaultErrorHandler,
    complete: (0, _noop.noop)
};

},{"tslib":"h1Nlh","./util/isFunction":"2Pp4R","./Subscription":"jB6sM","./config":"d4EOS","./util/reportUnhandledError":"dXqPm","./util/noop":"eBCM1","./NotificationFactories":"9G8D9","./scheduler/timeoutProvider":"1dfqV","./util/errorContext":"5a5o4","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2Pp4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(value) {
    return typeof value === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jB6sM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
parcelHelpers.export(exports, "EMPTY_SUBSCRIPTION", ()=>EMPTY_SUBSCRIPTION);
parcelHelpers.export(exports, "isSubscription", ()=>isSubscription);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var _arrRemove = require("./util/arrRemove");
var Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, _tslib.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, _isFunction.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, _tslib.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(errors)), (0, _tslib.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, _arrRemove.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, _arrRemove.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return value instanceof Subscription || value && 'closed' in value && (0, _isFunction.isFunction)(value.remove) && (0, _isFunction.isFunction)(value.add) && (0, _isFunction.isFunction)(value.unsubscribe);
}
function execFinalizer(finalizer) {
    if ((0, _isFunction.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

},{"tslib":"h1Nlh","./util/isFunction":"2Pp4R","./util/UnsubscriptionError":"ZttQE","./util/arrRemove":"1R6w9","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ZttQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var _createErrorClass = require("./createErrorClass");
var UnsubscriptionError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

},{"./createErrorClass":"1zvAf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1zvAf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createErrorClass", ()=>createErrorClass);
function createErrorClass(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1R6w9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrRemove", ()=>arrRemove);
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"d4EOS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dXqPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportUnhandledError", ()=>reportUnhandledError);
var _config = require("../config");
var _timeoutProvider = require("../scheduler/timeoutProvider");
function reportUnhandledError(err) {
    (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, _config.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

},{"../config":"d4EOS","../scheduler/timeoutProvider":"1dfqV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1dfqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutProvider", ()=>timeoutProvider);
var _tslib = require("tslib");
var timeoutProvider = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setTimeout.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

},{"tslib":"h1Nlh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eBCM1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9G8D9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPLETE_NOTIFICATION", ()=>COMPLETE_NOTIFICATION);
parcelHelpers.export(exports, "errorNotification", ()=>errorNotification);
parcelHelpers.export(exports, "nextNotification", ()=>nextNotification);
parcelHelpers.export(exports, "createNotification", ()=>createNotification);
var COMPLETE_NOTIFICATION = function() {
    return createNotification('C', undefined, undefined);
}();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5a5o4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorContext", ()=>errorContext);
parcelHelpers.export(exports, "captureError", ()=>captureError);
var _config = require("../config");
var context = null;
function errorContext(cb) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function captureError(err) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}

},{"../config":"d4EOS","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cSqR4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7GPyh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3R9K0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ayC9d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectableObservable", ()=>ConnectableObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _refCount = require("../operators/refCount");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _lift = require("../util/lift");
var ConnectableObservable = function(_super) {
    (0, _tslib.__extends)(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if ((0, _lift.hasLift)(source)) _this.lift = source.lift;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 || _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new (0, _subscription.Subscription)();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subject_1, undefined, function() {
                _this._teardown();
                subject_1.complete();
            }, function(err) {
                _this._teardown();
                subject_1.error(err);
            }, function() {
                return _this._teardown();
            })));
            if (connection.closed) {
                this._connection = null;
                connection = (0, _subscription.Subscription).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, _refCount.refCount)()(this);
    };
    return ConnectableObservable;
}((0, _observable.Observable));

},{"tslib":"h1Nlh","../Observable":"cmjzh","../Subscription":"jB6sM","../operators/refCount":"7rPtV","../operators/OperatorSubscriber":"6STW8","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7rPtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refCount", ()=>refCount);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function refCount() {
    return (0, _lift.operate)(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, undefined, function() {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) sharedConnection.unsubscribe();
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) connection = source.connect();
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"d9IaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasLift", ()=>hasLift);
parcelHelpers.export(exports, "operate", ()=>operate);
var _isFunction = require("./isFunction");
function hasLift(source) {
    return (0, _isFunction.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function(source) {
        if (hasLift(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

},{"./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6STW8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOperatorSubscriber", ()=>createOperatorSubscriber);
parcelHelpers.export(exports, "OperatorSubscriber", ()=>OperatorSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
    (0, _tslib.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"h1Nlh","../Subscriber":"4uu7P","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cJLFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrames", ()=>animationFrames);
var _observable = require("../../Observable");
var _performanceTimestampProvider = require("../../scheduler/performanceTimestampProvider");
var _animationFrameProvider = require("../../scheduler/animationFrameProvider");
function animationFrames(timestampProvider) {
    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
}
function animationFramesFactory(timestampProvider) {
    return new (0, _observable.Observable)(function(subscriber) {
        var provider = timestampProvider || (0, _performanceTimestampProvider.performanceTimestampProvider);
        var start = provider.now();
        var id = 0;
        var run = function() {
            if (!subscriber.closed) id = (0, _animationFrameProvider.animationFrameProvider).requestAnimationFrame(function(timestamp) {
                id = 0;
                var now = provider.now();
                subscriber.next({
                    timestamp: timestampProvider ? now : timestamp,
                    elapsed: now - start
                });
                run();
            });
        };
        run();
        return function() {
            if (id) (0, _animationFrameProvider.animationFrameProvider).cancelAnimationFrame(id);
        };
    });
}
var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();

},{"../../Observable":"cmjzh","../../scheduler/performanceTimestampProvider":"q7EPy","../../scheduler/animationFrameProvider":"fZSzi","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"q7EPy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "performanceTimestampProvider", ()=>performanceTimestampProvider);
var performanceTimestampProvider = {
    now: function() {
        return (performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fZSzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameProvider", ()=>animationFrameProvider);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var animationFrameProvider = {
    schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = animationFrameProvider.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new (0, _subscription.Subscription)(function() {
            return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
    },
    requestAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)));
    },
    cancelAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)));
    },
    delegate: undefined
};

},{"tslib":"h1Nlh","../Subscription":"jB6sM","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kOvhz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _arrRemove = require("./util/arrRemove");
var _errorContext = require("./util/errorContext");
var Subject = function(_super) {
    (0, _tslib.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, _tslib.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, _subscription.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, _subscription.Subscription)(function() {
            _this.currentObservers = null;
            (0, _arrRemove.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = function(_super) {
    (0, _tslib.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, _subscription.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"h1Nlh","./Observable":"cmjzh","./Subscription":"jB6sM","./util/ObjectUnsubscribedError":"fkwCx","./util/arrRemove":"1R6w9","./util/errorContext":"5a5o4","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fkwCx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var _createErrorClass = require("./createErrorClass");
var ObjectUnsubscribedError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

},{"./createErrorClass":"1zvAf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8riRa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var BehaviorSubject = function(_super) {
    (0, _tslib.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"h1Nlh","./Subject":"kOvhz","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dz1Gz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var ReplaySubject = function(_super) {
    (0, _tslib.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, _dateTimestampProvider.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, _subject.Subject));

},{"tslib":"h1Nlh","./Subject":"kOvhz","./scheduler/dateTimestampProvider":"84pzX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"84pzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampProvider", ()=>dateTimestampProvider);
var dateTimestampProvider = {
    now: function() {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"g4Qg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncSubject", ()=>AsyncSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var AsyncSubject = function(_super) {
    (0, _tslib.__extends)(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped || _isComplete) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function() {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}((0, _subject.Subject));

},{"tslib":"h1Nlh","./Subject":"kOvhz","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bbwxq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"lHyC5","./AsapScheduler":"1O2VU","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lHyC5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _immediateProvider = require("./immediateProvider");
var AsapAction = function(_super) {
    (0, _tslib.__extends)(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, _immediateProvider.immediateProvider).setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, _immediateProvider.immediateProvider).clearImmediate(id);
            if (scheduler._scheduled === id) scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"h1Nlh","./AsyncAction":"hDLz1","./immediateProvider":"6FAfI","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hDLz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var _intervalProvider = require("./intervalProvider");
var _arrRemove = require("../util/arrRemove");
var AsyncAction = function(_super) {
    (0, _tslib.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, _intervalProvider.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, _intervalProvider.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, _arrRemove.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"h1Nlh","./Action":"8uV2u","./intervalProvider":"3JJCu","../util/arrRemove":"1R6w9","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8uV2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = function(_super) {
    (0, _tslib.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"h1Nlh","../Subscription":"jB6sM","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3JJCu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intervalProvider", ()=>intervalProvider);
var _tslib = require("tslib");
var intervalProvider = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setInterval.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

},{"tslib":"h1Nlh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6FAfI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "immediateProvider", ()=>immediateProvider);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var setImmediate = (0, _immediate.Immediate).setImmediate, clearImmediate = (0, _immediate.Immediate).clearImmediate;
var immediateProvider = {
    setImmediate: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)));
    },
    clearImmediate: function(handle) {
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
    },
    delegate: undefined
};

},{"tslib":"h1Nlh","../util/Immediate":"1g2Dz","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1g2Dz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) resolved = Promise.resolve();
        resolved.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1O2VU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = function(_super) {
    (0, _tslib.__extends)(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"h1Nlh","./AsyncScheduler":"7Ckm8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7Ckm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = function(_super) {
    (0, _tslib.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"h1Nlh","../Scheduler":"2JSrA","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2JSrA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, _dateTimestampProvider.dateTimestampProvider).now;
    return Scheduler;
}();

},{"./scheduler/dateTimestampProvider":"84pzX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3m7bL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"hDLz1","./AsyncScheduler":"7Ckm8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dlkAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"1weCh","./QueueScheduler":"1lz20","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1weCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = function(_super) {
    (0, _tslib.__extends)(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && delay > 0 || delay == null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.flush(this);
        return 0;
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"h1Nlh","./AsyncAction":"hDLz1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1lz20":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = function(_super) {
    (0, _tslib.__extends)(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"h1Nlh","./AsyncScheduler":"7Ckm8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3pXwd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameScheduler", ()=>animationFrameScheduler);
parcelHelpers.export(exports, "animationFrame", ()=>animationFrame);
var _animationFrameAction = require("./AnimationFrameAction");
var _animationFrameScheduler = require("./AnimationFrameScheduler");
var animationFrameScheduler = new (0, _animationFrameScheduler.AnimationFrameScheduler)((0, _animationFrameAction.AnimationFrameAction));
var animationFrame = animationFrameScheduler;

},{"./AnimationFrameAction":"1b7li","./AnimationFrameScheduler":"4Zd5T","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1b7li":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameAction", ()=>AnimationFrameAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _animationFrameProvider = require("./animationFrameProvider");
var AnimationFrameAction = function(_super) {
    (0, _tslib.__extends)(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, _animationFrameProvider.animationFrameProvider).requestAnimationFrame(function() {
            return scheduler.flush(undefined);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && id === scheduler._scheduled && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, _animationFrameProvider.animationFrameProvider).cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"h1Nlh","./AsyncAction":"hDLz1","./animationFrameProvider":"fZSzi","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4Zd5T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameScheduler", ()=>AnimationFrameScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AnimationFrameScheduler = function(_super) {
    (0, _tslib.__extends)(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId;
        if (action) flushId = action.id;
        else {
            flushId = this._scheduled;
            this._scheduled = undefined;
        }
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"h1Nlh","./AsyncScheduler":"7Ckm8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kyF7E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>VirtualTimeScheduler);
parcelHelpers.export(exports, "VirtualAction", ()=>VirtualAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _subscription = require("../Subscription");
var _asyncScheduler = require("./AsyncScheduler");
var VirtualTimeScheduler = function(_super) {
    (0, _tslib.__extends)(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) schedulerActionCtor = VirtualAction;
        if (maxFrames === void 0) maxFrames = Infinity;
        var _this = _super.call(this, schedulerActionCtor, function() {
            return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while((action = actions[0]) && action.delay <= maxFrames){
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}((0, _asyncScheduler.AsyncScheduler));
var VirtualAction = function(_super) {
    (0, _tslib.__extends)(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (Number.isFinite(delay)) {
            if (!this.id) return _super.prototype.schedule.call(this, state, delay);
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        } else return (0, _subscription.Subscription).EMPTY;
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return 1;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"h1Nlh","./AsyncAction":"hDLz1","../Subscription":"jB6sM","./AsyncScheduler":"7Ckm8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1XSSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
parcelHelpers.export(exports, "observeNotification", ()=>observeNotification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var _isFunction = require("./util/isFunction");
var NotificationKind;
(function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function(observer) {
        return observeNotification(this, observer);
    };
    Notification.prototype.do = function(nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        var _a;
        return (0, _isFunction.isFunction)((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N' ? (0, _of.of)(value) : kind === 'E' ? (0, _throwError.throwError)(function() {
            return error;
        }) : kind === 'C' ? (0, _empty.EMPTY) : 0;
        if (!result) throw new TypeError("Unexpected notification kind " + kind);
        return result;
    };
    Notification.createNext = function(value) {
        return new Notification('N', value);
    };
    Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}();
function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') throw new TypeError('Invalid notification, missing "kind"');
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 || _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 || _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
}

},{"./observable/empty":"lbDEn","./observable/of":"gx45o","./observable/throwError":"SKmw6","./util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lbDEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"cmjzh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gx45o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _args = require("../util/args");
var _from = require("./from");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    return (0, _from.from)(args, scheduler);
}

},{"../util/args":"1ipMv","./from":"ir8Cr","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1ipMv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popResultSelector", ()=>popResultSelector);
parcelHelpers.export(exports, "popScheduler", ()=>popScheduler);
parcelHelpers.export(exports, "popNumber", ()=>popNumber);
var _isFunction = require("./isFunction");
var _isScheduler = require("./isScheduler");
function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return (0, _isFunction.isFunction)(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return (0, _isScheduler.isScheduler)(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
}

},{"./isFunction":"2Pp4R","./isScheduler":"bosUI","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bosUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
var _isFunction = require("./isFunction");
function isScheduler(value) {
    return value && (0, _isFunction.isFunction)(value.schedule);
}

},{"./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ir8Cr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _scheduled = require("../scheduled/scheduled");
var _innerFrom = require("./innerFrom");
function from(input, scheduler) {
    return scheduler ? (0, _scheduled.scheduled)(input, scheduler) : (0, _innerFrom.innerFrom)(input);
}

},{"../scheduled/scheduled":"c3mP7","./innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"c3mP7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _scheduleReadableStreamLike = require("./scheduleReadableStreamLike");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return (0, _scheduleAsyncIterable.scheduleAsyncIterable)(input, scheduler);
        if ((0, _isIterable.isIterable)(input)) return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return (0, _scheduleReadableStreamLike.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}

},{"./scheduleObservable":"2BALv","./schedulePromise":"6z8Gg","./scheduleArray":"4fRqC","./scheduleIterable":"3RBUg","./scheduleAsyncIterable":"WZ4Pt","../util/isInteropObservable":"58gt2","../util/isPromise":"35OyD","../util/isArrayLike":"5lbMS","../util/isIterable":"i7o5X","../util/isAsyncIterable":"jzZdy","../util/throwUnobservableError":"hPGCl","../util/isReadableStreamLike":"gfSAG","./scheduleReadableStreamLike":"eR55F","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2BALv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function scheduleObservable(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"hQbM7","../operators/observeOn":"kfOpK","../operators/subscribeOn":"e4zP2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hQbM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "innerFrom", ()=>innerFrom);
parcelHelpers.export(exports, "fromInteropObservable", ()=>fromInteropObservable);
parcelHelpers.export(exports, "fromArrayLike", ()=>fromArrayLike);
parcelHelpers.export(exports, "fromPromise", ()=>fromPromise);
parcelHelpers.export(exports, "fromIterable", ()=>fromIterable);
parcelHelpers.export(exports, "fromAsyncIterable", ()=>fromAsyncIterable);
parcelHelpers.export(exports, "fromReadableStreamLike", ()=>fromReadableStreamLike);
var _tslib = require("tslib");
var _isArrayLike = require("../util/isArrayLike");
var _isPromise = require("../util/isPromise");
var _observable = require("../Observable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isIterable = require("../util/isIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _isFunction = require("../util/isFunction");
var _reportUnhandledError = require("../util/reportUnhandledError");
var _observable1 = require("../symbol/observable");
function innerFrom(input) {
    if (input instanceof (0, _observable.Observable)) return input;
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return fromInteropObservable(input);
        if ((0, _isArrayLike.isArrayLike)(input)) return fromArrayLike(input);
        if ((0, _isPromise.isPromise)(input)) return fromPromise(input);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return fromAsyncIterable(input);
        if ((0, _isIterable.isIterable)(input)) return fromIterable(input);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return fromReadableStreamLike(input);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}
function fromInteropObservable(obj) {
    return new (0, _observable.Observable)(function(subscriber) {
        var obs = obj[0, _observable1.observable]();
        if ((0, _isFunction.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new (0, _observable.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new (0, _observable.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _reportUnhandledError.reportUnhandledError));
    });
}
function fromIterable(iterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, _tslib.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, _tslib.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

},{"tslib":"h1Nlh","../util/isArrayLike":"5lbMS","../util/isPromise":"35OyD","../Observable":"cmjzh","../util/isInteropObservable":"58gt2","../util/isAsyncIterable":"jzZdy","../util/throwUnobservableError":"hPGCl","../util/isIterable":"i7o5X","../util/isReadableStreamLike":"gfSAG","../util/isFunction":"2Pp4R","../util/reportUnhandledError":"dXqPm","../symbol/observable":"cSqR4","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5lbMS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"35OyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
var _isFunction = require("./isFunction");
function isPromise(value) {
    return (0, _isFunction.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

},{"./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"58gt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
var _isFunction = require("./isFunction");
function isInteropObservable(input) {
    return (0, _isFunction.isFunction)(input[0, _observable.observable]);
}

},{"../symbol/observable":"cSqR4","./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jzZdy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
var _isFunction = require("./isFunction");
function isAsyncIterable(obj) {
    return Symbol.asyncIterator && (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

},{"./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hPGCl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidObservableTypeError", ()=>createInvalidObservableTypeError);
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"i7o5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
var _isFunction = require("./isFunction");
function isIterable(input) {
    return (0, _isFunction.isFunction)(input === null || input === void 0 ? void 0 : input[0, _iterator.iterator]);
}

},{"../symbol/iterator":"fFCCo","./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fFCCo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gfSAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamLikeToAsyncGenerator", ()=>readableStreamLikeToAsyncGenerator);
parcelHelpers.export(exports, "isReadableStreamLike", ()=>isReadableStreamLike);
var _tslib = require("tslib");
var _isFunction = require("./isFunction");
function readableStreamLikeToAsyncGenerator(readableStream) {
    return (0, _tslib.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, _tslib.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, _tslib.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, _tslib.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

},{"tslib":"h1Nlh","./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kfOpK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
var _executeSchedule = require("../util/executeSchedule");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

},{"../util/executeSchedule":"fQYkB","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fQYkB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "executeSchedule", ()=>executeSchedule);
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"e4zP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _lift = require("../util/lift");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

},{"../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6z8Gg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function schedulePromise(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"hQbM7","../operators/observeOn":"kfOpK","../operators/subscribeOn":"e4zP2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4fRqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

},{"../Observable":"cmjzh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3RBUg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _iterator = require("../symbol/iterator");
var _isFunction = require("../util/isFunction");
var _executeSchedule = require("../util/executeSchedule");
function scheduleIterable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var iterator;
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, _iterator.iterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, _isFunction.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

},{"../Observable":"cmjzh","../symbol/iterator":"fFCCo","../util/isFunction":"2Pp4R","../util/executeSchedule":"fQYkB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"WZ4Pt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleAsyncIterable", ()=>scheduleAsyncIterable);
var _observable = require("../Observable");
var _executeSchedule = require("../util/executeSchedule");
function scheduleAsyncIterable(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, _observable.Observable)(function(subscriber) {
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

},{"../Observable":"cmjzh","../util/executeSchedule":"fQYkB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eR55F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleReadableStreamLike", ()=>scheduleReadableStreamLike);
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
function scheduleReadableStreamLike(input, scheduler) {
    return (0, _scheduleAsyncIterable.scheduleAsyncIterable)((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

},{"./scheduleAsyncIterable":"WZ4Pt","../util/isReadableStreamLike":"gfSAG","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"SKmw6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
var _isFunction = require("../util/isFunction");
function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, _isFunction.isFunction)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, _observable.Observable)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}

},{"../Observable":"cmjzh","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"biXW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObservable", ()=>isObservable);
var _observable = require("../Observable");
var _isFunction = require("./isFunction");
function isObservable(obj) {
    return !!obj && (obj instanceof (0, _observable.Observable) || (0, _isFunction.isFunction)(obj.lift) && (0, _isFunction.isFunction)(obj.subscribe));
}

},{"../Observable":"cmjzh","./isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1vfSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lastValueFrom", ()=>lastValueFrom);
var _emptyError = require("./util/EmptyError");
function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function(value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function() {
                if (_hasValue) resolve(_value);
                else if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, _emptyError.EmptyError)());
            }
        });
    });
}

},{"./util/EmptyError":"ikj9E","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ikj9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyError", ()=>EmptyError);
var _createErrorClass = require("./createErrorClass");
var EmptyError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

},{"./createErrorClass":"1zvAf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iqwkH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "firstValueFrom", ()=>firstValueFrom);
var _emptyError = require("./util/EmptyError");
var _subscriber = require("./Subscriber");
function firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, _subscriber.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, _emptyError.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

},{"./util/EmptyError":"ikj9E","./Subscriber":"4uu7P","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aKRd9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>ArgumentOutOfRangeError);
var _createErrorClass = require("./createErrorClass");
var ArgumentOutOfRangeError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = 'ArgumentOutOfRangeError';
        this.message = 'argument out of range';
    };
});

},{"./createErrorClass":"1zvAf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cRrIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFoundError", ()=>NotFoundError);
var _createErrorClass = require("./createErrorClass");
var NotFoundError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = 'NotFoundError';
        this.message = message;
    };
});

},{"./createErrorClass":"1zvAf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7MxXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SequenceError", ()=>SequenceError);
var _createErrorClass = require("./createErrorClass");
var SequenceError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = 'SequenceError';
        this.message = message;
    };
});

},{"./createErrorClass":"1zvAf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"33AiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
parcelHelpers.export(exports, "timeout", ()=>timeout);
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _createErrorClass = require("../util/createErrorClass");
var _operatorSubscriber = require("./OperatorSubscriber");
var _executeSchedule = require("../util/executeSchedule");
var TimeoutError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = (0, _isDate.isValidDate)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, _async.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, _lift.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, _innerFrom.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
}

},{"../scheduler/async":"3m7bL","../util/isDate":"gGR6h","../util/lift":"d9IaV","../observable/innerFrom":"hQbM7","../util/createErrorClass":"1zvAf","./OperatorSubscriber":"6STW8","../util/executeSchedule":"fQYkB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gGR6h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidDate", ()=>isValidDate);
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4aRvH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallback", ()=>bindCallback);
var _bindCallbackInternals = require("./bindCallbackInternals");
function bindCallback(callbackFunc, resultSelector, scheduler) {
    return (0, _bindCallbackInternals.bindCallbackInternals)(false, callbackFunc, resultSelector, scheduler);
}

},{"./bindCallbackInternals":"2YvFA","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2YvFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallbackInternals", ()=>bindCallbackInternals);
var _tslib = require("tslib");
var _isScheduler = require("../util/isScheduler");
var _observable = require("../Observable");
var _subscribeOn = require("../operators/subscribeOn");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _observeOn = require("../operators/observeOn");
var _asyncSubject = require("../AsyncSubject");
function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler).apply(this, args).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
        };
    }
    if (scheduler) return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return bindCallbackInternals(isNodeStyle, callbackFunc).apply(this, args).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
    };
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var subject = new (0, _asyncSubject.AsyncSubject)();
        var uninitialized = true;
        return new (0, _observable.Observable)(function(subscriber) {
            var subs = subject.subscribe(subscriber);
            if (uninitialized) {
                uninitialized = false;
                var isAsync_1 = false;
                var isComplete_1 = false;
                callbackFunc.apply(_this, (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)), [
                    function() {
                        var results = [];
                        for(var _i = 0; _i < arguments.length; _i++)results[_i] = arguments[_i];
                        if (isNodeStyle) {
                            var err = results.shift();
                            if (err != null) {
                                subject.error(err);
                                return;
                            }
                        }
                        subject.next(1 < results.length ? results : results[0]);
                        isComplete_1 = true;
                        if (isAsync_1) subject.complete();
                    }
                ]));
                if (isComplete_1) subject.complete();
                isAsync_1 = true;
            }
            return subs;
        });
    };
}

},{"tslib":"h1Nlh","../util/isScheduler":"bosUI","../Observable":"cmjzh","../operators/subscribeOn":"e4zP2","../util/mapOneOrManyArgs":"76yj6","../operators/observeOn":"kfOpK","../AsyncSubject":"g4Qg0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"76yj6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapOneOrManyArgs", ()=>mapOneOrManyArgs);
var _tslib = require("tslib");
var _map = require("../operators/map");
var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return (0, _map.map)(function(args) {
        return callOrApply(fn, args);
    });
}

},{"tslib":"h1Nlh","../operators/map":"aLYgu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aLYgu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function map(project, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fK7p6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindNodeCallback", ()=>bindNodeCallback);
var _bindCallbackInternals = require("./bindCallbackInternals");
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return (0, _bindCallbackInternals.bindCallbackInternals)(true, callbackFunc, resultSelector, scheduler);
}

},{"./bindCallbackInternals":"2YvFA","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gEX6r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
parcelHelpers.export(exports, "combineLatestInit", ()=>combineLatestInit);
var _observable = require("../Observable");
var _argsArgArrayOrObject = require("../util/argsArgArrayOrObject");
var _from = require("./from");
var _identity = require("../util/identity");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _args = require("../util/args");
var _createObject = require("../util/createObject");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _executeSchedule = require("../util/executeSchedule");
function combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var resultSelector = (0, _args.popResultSelector)(args);
    var _a = (0, _argsArgArrayOrObject.argsArgArrayOrObject)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, _from.from)([], scheduler);
    var result = new (0, _observable.Observable)(combineLatestInit(observables, scheduler, keys ? function(values) {
        return (0, _createObject.createObject)(keys, values);
    } : (0, _identity.identity)));
    return resultSelector ? result.pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : result;
}
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, _identity.identity);
    return function(subscriber) {
        maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                maybeSchedule(scheduler, function() {
                    var source = (0, _from.from)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, _executeSchedule.executeSchedule)(subscription, scheduler, execute);
    else execute();
}

},{"../Observable":"cmjzh","../util/argsArgArrayOrObject":"ftJmD","./from":"ir8Cr","../util/identity":"3R9K0","../util/mapOneOrManyArgs":"76yj6","../util/args":"1ipMv","../util/createObject":"kisxp","../operators/OperatorSubscriber":"6STW8","../util/executeSchedule":"fQYkB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ftJmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsArgArrayOrObject", ()=>argsArgArrayOrObject);
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kisxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createObject", ()=>createObject);
function createObject(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jgH4Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _concatAll = require("../operators/concatAll");
var _args = require("../util/args");
var _from = require("./from");
function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _from.from)(args, (0, _args.popScheduler)(args)));
}

},{"../operators/concatAll":"78ztJ","../util/args":"1ipMv","./from":"ir8Cr","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"78ztJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", ()=>concatAll);
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"eGWmm","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eGWmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"3P4JK","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3P4JK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
var _map = require("./map");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
var _isFunction = require("../util/isFunction");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, _isFunction.isFunction)(resultSelector)) return mergeMap(function(a, i) {
        return (0, _map.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, _innerFrom.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, _lift.operate)(function(source, subscriber) {
        return (0, _mergeInternals.mergeInternals)(source, subscriber, project, concurrent);
    });
}

},{"./map":"aLYgu","../observable/innerFrom":"hQbM7","../util/lift":"d9IaV","./mergeInternals":"6f2Fi","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6f2Fi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeInternals", ()=>mergeInternals);
var _innerFrom = require("../observable/innerFrom");
var _executeSchedule = require("../util/executeSchedule");
var _operatorSubscriber = require("./OperatorSubscriber");
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, _innerFrom.innerFrom)(project(value, index++)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, _executeSchedule.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

},{"../observable/innerFrom":"hQbM7","../util/executeSchedule":"fQYkB","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1b5GA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "connectable", ()=>connectable);
var _subject = require("../Subject");
var _observable = require("../Observable");
var _defer = require("./defer");
var DEFAULT_CONFIG = {
    connector: function() {
        return new (0, _subject.Subject)();
    },
    resetOnDisconnect: true
};
function connectable(source, config) {
    if (config === void 0) config = DEFAULT_CONFIG;
    var connection = null;
    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new (0, _observable.Observable)(function(subscriber) {
        return subject.subscribe(subscriber);
    });
    result.connect = function() {
        if (!connection || connection.closed) {
            connection = (0, _defer.defer)(function() {
                return source;
            }).subscribe(subject);
            if (resetOnDisconnect) connection.add(function() {
                return subject = connector();
            });
        }
        return connection;
    };
    return result;
}

},{"../Subject":"kOvhz","../Observable":"cmjzh","./defer":"9FTON","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9FTON":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defer", ()=>defer);
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
function defer(observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        (0, _innerFrom.innerFrom)(observableFactory()).subscribe(subscriber);
    });
}

},{"../Observable":"cmjzh","./innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"99HSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forkJoin", ()=>forkJoin);
var _observable = require("../Observable");
var _argsArgArrayOrObject = require("../util/argsArgArrayOrObject");
var _innerFrom = require("./innerFrom");
var _args = require("../util/args");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _createObject = require("../util/createObject");
function forkJoin() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, _args.popResultSelector)(args);
    var _a = (0, _argsArgArrayOrObject.argsArgArrayOrObject)(args), sources = _a.args, keys = _a.keys;
    var result = new (0, _observable.Observable)(function(subscriber) {
        var length = sources.length;
        if (!length) {
            subscriber.complete();
            return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function(sourceIndex) {
            var hasValue = false;
            (0, _innerFrom.innerFrom)(sources[sourceIndex]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                if (!hasValue) {
                    hasValue = true;
                    remainingEmissions--;
                }
                values[sourceIndex] = value;
            }, function() {
                return remainingCompletions--;
            }, undefined, function() {
                if (!remainingCompletions || !hasValue) {
                    if (!remainingEmissions) subscriber.next(keys ? (0, _createObject.createObject)(keys, values) : values);
                    subscriber.complete();
                }
            }));
        };
        for(var sourceIndex = 0; sourceIndex < length; sourceIndex++)_loop_1(sourceIndex);
    });
    return resultSelector ? result.pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : result;
}

},{"../Observable":"cmjzh","../util/argsArgArrayOrObject":"ftJmD","./innerFrom":"hQbM7","../util/args":"1ipMv","../operators/OperatorSubscriber":"6STW8","../util/mapOneOrManyArgs":"76yj6","../util/createObject":"kisxp","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hqoat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _observable = require("../Observable");
var _mergeMap = require("../operators/mergeMap");
var _isArrayLike = require("../util/isArrayLike");
var _isFunction = require("../util/isFunction");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var jqueryMethods = [
    'on',
    'off'
];
function fromEvent(target, eventName, options, resultSelector) {
    if ((0, _isFunction.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return fromEvent(target, eventName, options).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
    var _a = (0, _tslib.__read)(isEventTarget(target) ? eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, _isArrayLike.isArrayLike)(target)) return (0, _mergeMap.mergeMap)(function(subTarget) {
            return fromEvent(subTarget, eventName, options);
        })((0, _innerFrom.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function isNodeStyleEventEmitter(target) {
    return (0, _isFunction.isFunction)(target.addListener) && (0, _isFunction.isFunction)(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return (0, _isFunction.isFunction)(target.on) && (0, _isFunction.isFunction)(target.off);
}
function isEventTarget(target) {
    return (0, _isFunction.isFunction)(target.addEventListener) && (0, _isFunction.isFunction)(target.removeEventListener);
}

},{"tslib":"h1Nlh","../observable/innerFrom":"hQbM7","../Observable":"cmjzh","../operators/mergeMap":"3P4JK","../util/isArrayLike":"5lbMS","../util/isFunction":"2Pp4R","../util/mapOneOrManyArgs":"76yj6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"apt9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEventPattern", ()=>fromEventPattern);
var _observable = require("../Observable");
var _isFunction = require("../util/isFunction");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return fromEventPattern(addHandler, removeHandler).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, _isFunction.isFunction)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}

},{"../Observable":"cmjzh","../util/isFunction":"2Pp4R","../util/mapOneOrManyArgs":"76yj6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hhU34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>generate);
var _tslib = require("tslib");
var _identity = require("../util/identity");
var _isScheduler = require("../util/isScheduler");
var _defer = require("./defer");
var _scheduleIterable = require("../scheduled/scheduleIterable");
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) _a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? (0, _identity.identity) : _b, scheduler = _a.scheduler;
    else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || (0, _isScheduler.isScheduler)(resultSelectorOrScheduler)) {
            resultSelector = (0, _identity.identity);
            scheduler = resultSelectorOrScheduler;
        } else resultSelector = resultSelectorOrScheduler;
    }
    function gen() {
        var state;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    state = initialState;
                    _a.label = 1;
                case 1:
                    if (!(!condition || condition(state))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        resultSelector(state)
                    ];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    state = iterate(state);
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }
    return (0, _defer.defer)(scheduler ? function() {
        return (0, _scheduleIterable.scheduleIterable)(gen(), scheduler);
    } : gen);
}

},{"tslib":"h1Nlh","../util/identity":"3R9K0","../util/isScheduler":"bosUI","./defer":"9FTON","../scheduled/scheduleIterable":"3RBUg","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eG8ee":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iif", ()=>iif);
var _defer = require("./defer");
function iif(condition, trueResult, falseResult) {
    return (0, _defer.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

},{"./defer":"9FTON","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bYViF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interval", ()=>interval);
var _async = require("../scheduler/async");
var _timer = require("./timer");
function interval(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    if (period < 0) period = 0;
    return (0, _timer.timer)(period, period, scheduler);
}

},{"../scheduler/async":"3m7bL","./timer":"8Uhl1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8Uhl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isScheduler = require("../util/isScheduler");
var _isDate = require("../util/isDate");
function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, _isScheduler.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isDate.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

},{"../Observable":"cmjzh","../scheduler/async":"3m7bL","../util/isScheduler":"bosUI","../util/isDate":"gGR6h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1TYJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _mergeAll = require("../operators/mergeAll");
var _innerFrom = require("./innerFrom");
var _empty = require("./empty");
var _args = require("../util/args");
var _from = require("./from");
function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var concurrent = (0, _args.popNumber)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, _empty.EMPTY) : sources.length === 1 ? (0, _innerFrom.innerFrom)(sources[0]) : (0, _mergeAll.mergeAll)(concurrent)((0, _from.from)(sources, scheduler));
}

},{"../operators/mergeAll":"eGWmm","./innerFrom":"hQbM7","./empty":"lbDEn","../util/args":"1ipMv","./from":"ir8Cr","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"f6KgZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "never", ()=>never);
var _observable = require("../Observable");
var _noop = require("../util/noop");
var NEVER = new (0, _observable.Observable)((0, _noop.noop));
function never() {
    return NEVER;
}

},{"../Observable":"cmjzh","../util/noop":"eBCM1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eMPOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _observable = require("../Observable");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _noop = require("../util/noop");
var _innerFrom = require("./innerFrom");
function onErrorResumeNext() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = (0, _argsOrArgArray.argsOrArgArray)(sources);
    return new (0, _observable.Observable)(function(subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function() {
            if (sourceIndex < nextSources.length) {
                var nextSource = void 0;
                try {
                    nextSource = (0, _innerFrom.innerFrom)(nextSources[sourceIndex++]);
                } catch (err) {
                    subscribeNext();
                    return;
                }
                var innerSubscriber = new (0, _operatorSubscriber.OperatorSubscriber)(subscriber, undefined, (0, _noop.noop), (0, _noop.noop));
                nextSource.subscribe(innerSubscriber);
                innerSubscriber.add(subscribeNext);
            } else subscriber.complete();
        };
        subscribeNext();
    });
}

},{"../Observable":"cmjzh","../util/argsOrArgArray":"3cobE","../operators/OperatorSubscriber":"6STW8","../util/noop":"eBCM1","./innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3cobE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsOrArgArray", ()=>argsOrArgArray);
var isArray = Array.isArray;
function argsOrArgArray(args) {
    return args.length === 1 && isArray(args[0]) ? args[0] : args;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9j6CW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairs", ()=>pairs);
var _from = require("./from");
function pairs(obj, scheduler) {
    return (0, _from.from)(Object.entries(obj), scheduler);
}

},{"./from":"ir8Cr","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cS9Ey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _filter = require("../operators/filter");
var _innerFrom = require("./innerFrom");
function partition(source, predicate, thisArg) {
    return [
        (0, _filter.filter)(predicate, thisArg)((0, _innerFrom.innerFrom)(source)),
        (0, _filter.filter)((0, _not.not)(predicate, thisArg))((0, _innerFrom.innerFrom)(source))
    ];
}

},{"../util/not":"4uJAN","../operators/filter":"kk9Ge","./innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4uJAN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "not", ()=>not);
function not(pred, thisArg) {
    return function(value, index) {
        return !pred.call(thisArg, value, index);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kk9Ge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function filter(predicate, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6cMD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "raceInit", ()=>raceInit);
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
function race() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    sources = (0, _argsOrArgArray.argsOrArgArray)(sources);
    return sources.length === 1 ? (0, _innerFrom.innerFrom)(sources[0]) : new (0, _observable.Observable)(raceInit(sources));
}
function raceInit(sources) {
    return function(subscriber) {
        var subscriptions = [];
        var _loop_1 = function(i) {
            subscriptions.push((0, _innerFrom.innerFrom)(sources[i]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                if (subscriptions) {
                    for(var s = 0; s < subscriptions.length; s++)s !== i && subscriptions[s].unsubscribe();
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for(var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++)_loop_1(i);
    };
}

},{"../Observable":"cmjzh","./innerFrom":"hQbM7","../util/argsOrArgArray":"3cobE","../operators/OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"afzb5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "range", ()=>range);
var _observable = require("../Observable");
var _empty = require("./empty");
function range(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) return 0, _empty.EMPTY;
    var end = count + start;
    return new (0, _observable.Observable)(scheduler ? function(subscriber) {
        var n = start;
        return scheduler.schedule(function() {
            if (n < end) {
                subscriber.next(n++);
                this.schedule();
            } else subscriber.complete();
        });
    } : function(subscriber) {
        var n = start;
        while(n < end && !subscriber.closed)subscriber.next(n++);
        subscriber.complete();
    });
}

},{"../Observable":"cmjzh","./empty":"lbDEn","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bKeEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "using", ()=>using);
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
var _empty = require("./empty");
function using(resourceFactory, observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? (0, _innerFrom.innerFrom)(result) : (0, _empty.EMPTY);
        source.subscribe(subscriber);
        return function() {
            if (resource) resource.unsubscribe();
        };
    });
}

},{"../Observable":"cmjzh","./innerFrom":"hQbM7","./empty":"lbDEn","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9zyDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _empty = require("./empty");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _args = require("../util/args");
function zip() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, _args.popResultSelector)(args);
    var sources = (0, _argsOrArgArray.argsOrArgArray)(args);
    return sources.length ? new (0, _observable.Observable)(function(subscriber) {
        var buffers = sources.map(function() {
            return [];
        });
        var completed = sources.map(function() {
            return false;
        });
        subscriber.add(function() {
            buffers = completed = null;
        });
        var _loop_1 = function(sourceIndex) {
            (0, _innerFrom.innerFrom)(sources[sourceIndex]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                buffers[sourceIndex].push(value);
                if (buffers.every(function(buffer) {
                    return buffer.length;
                })) {
                    var result = buffers.map(function(buffer) {
                        return buffer.shift();
                    });
                    subscriber.next(resultSelector ? resultSelector.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(result))) : result);
                    if (buffers.some(function(buffer, i) {
                        return !buffer.length && completed[i];
                    })) subscriber.complete();
                }
            }, function() {
                completed[sourceIndex] = true;
                !buffers[sourceIndex].length && subscriber.complete();
            }));
        };
        for(var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++)_loop_1(sourceIndex);
        return function() {
            buffers = completed = null;
        };
    }) : (0, _empty.EMPTY);
}

},{"tslib":"h1Nlh","../Observable":"cmjzh","./innerFrom":"hQbM7","../util/argsOrArgArray":"3cobE","./empty":"lbDEn","../operators/OperatorSubscriber":"6STW8","../util/args":"1ipMv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gdwXG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"by7Z5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>audit);
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
function audit(durationSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function() {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) (0, _innerFrom.innerFrom)(durationSelector(value)).subscribe(durationSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, endDuration, cleanupDuration));
        }, function() {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}

},{"../util/lift":"d9IaV","../observable/innerFrom":"hQbM7","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"psoPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auditTime", ()=>auditTime);
var _async = require("../scheduler/async");
var _audit = require("./audit");
var _timer = require("../observable/timer");
function auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _audit.audit)(function() {
        return (0, _timer.timer)(duration, scheduler);
    });
}

},{"../scheduler/async":"3m7bL","./audit":"by7Z5","../observable/timer":"8Uhl1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9A7yb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function buffer(closingNotifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        (0, _innerFrom.innerFrom)(closingNotifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, (0, _noop.noop)));
        return function() {
            currentBuffer = null;
        };
    });
}

},{"../util/lift":"d9IaV","../util/noop":"eBCM1","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"e5ENZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferCount", ()=>bufferCount);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _arrRemove = require("../util/arrRemove");
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return (0, _lift.operate)(function(source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a, e_2, _b;
            var toEmit = null;
            if (count++ % startBufferEvery === 0) buffers.push([]);
            try {
                for(var buffers_1 = (0, _tslib.__values)(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                    if (bufferSize <= buffer.length) {
                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                        toEmit.push(buffer);
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (toEmit) try {
                for(var toEmit_1 = (0, _tslib.__values)(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()){
                    var buffer = toEmit_1_1.value;
                    (0, _arrRemove.arrRemove)(buffers, buffer);
                    subscriber.next(buffer);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }, function() {
            var e_3, _a;
            try {
                for(var buffers_2 = (0, _tslib.__values)(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()){
                    var buffer = buffers_2_1.value;
                    subscriber.next(buffer);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffers = null;
        }));
    });
}

},{"tslib":"h1Nlh","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/arrRemove":"1R6w9","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cSGPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferTime", ()=>bufferTime);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _arrRemove = require("../util/arrRemove");
var _async = require("../scheduler/async");
var _args = require("../util/args");
var _executeSchedule = require("../util/executeSchedule");
function bufferTime(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = (0, _args.popScheduler)(otherArgs)) !== null && _a !== void 0 ? _a : (0, _async.asyncScheduler);
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return (0, _lift.operate)(function(source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function(record) {
            var buffer = record.buffer, subs = record.subs;
            subs.unsubscribe();
            (0, _arrRemove.arrRemove)(bufferRecords, record);
            subscriber.next(buffer);
            restartOnEmit && startBuffer();
        };
        var startBuffer = function() {
            if (bufferRecords) {
                var subs = new (0, _subscription.Subscription)();
                subscriber.add(subs);
                var buffer = [];
                var record_1 = {
                    buffer: buffer,
                    subs: subs
                };
                bufferRecords.push(record_1);
                (0, _executeSchedule.executeSchedule)(subs, scheduler, function() {
                    return emit(record_1);
                }, bufferTimeSpan);
            }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) (0, _executeSchedule.executeSchedule)(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        else restartOnEmit = true;
        startBuffer();
        var bufferTimeSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            var recordsCopy = bufferRecords.slice();
            try {
                for(var recordsCopy_1 = (0, _tslib.__values)(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()){
                    var record = recordsCopy_1_1.value;
                    var buffer = record.buffer;
                    buffer.push(value);
                    maxBufferSize <= buffer.length && emit(record);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length)subscriber.next(bufferRecords.shift().buffer);
            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 || bufferTimeSubscriber.unsubscribe();
            subscriber.complete();
            subscriber.unsubscribe();
        }, undefined, function() {
            return bufferRecords = null;
        });
        source.subscribe(bufferTimeSubscriber);
    });
}

},{"tslib":"h1Nlh","../Subscription":"jB6sM","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/arrRemove":"1R6w9","../scheduler/async":"3m7bL","../util/args":"1ipMv","../util/executeSchedule":"fQYkB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aARRB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToggle", ()=>bufferToggle);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _arrRemove = require("../util/arrRemove");
function bufferToggle(openings, closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var buffers = [];
        (0, _innerFrom.innerFrom)(openings).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(openValue) {
            var buffer = [];
            buffers.push(buffer);
            var closingSubscription = new (0, _subscription.Subscription)();
            var emitBuffer = function() {
                (0, _arrRemove.arrRemove)(buffers, buffer);
                subscriber.next(buffer);
                closingSubscription.unsubscribe();
            };
            closingSubscription.add((0, _innerFrom.innerFrom)(closingSelector(openValue)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, emitBuffer, (0, _noop.noop))));
        }, (0, _noop.noop)));
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var buffers_1 = (0, _tslib.__values)(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(buffers.length > 0)subscriber.next(buffers.shift());
            subscriber.complete();
        }));
    });
}

},{"tslib":"h1Nlh","../Subscription":"jB6sM","../util/lift":"d9IaV","../observable/innerFrom":"hQbM7","./OperatorSubscriber":"6STW8","../util/noop":"eBCM1","../util/arrRemove":"1R6w9","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eadh9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferWhen", ()=>bufferWhen);
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function bufferWhen(closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var buffer = null;
        var closingSubscriber = null;
        var openBuffer = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            var b = buffer;
            buffer = [];
            b && subscriber.next(b);
            (0, _innerFrom.innerFrom)(closingSelector()).subscribe(closingSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, openBuffer, (0, _noop.noop)));
        };
        openBuffer();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return buffer === null || buffer === void 0 ? void 0 : buffer.push(value);
        }, function() {
            buffer && subscriber.next(buffer);
            subscriber.complete();
        }, undefined, function() {
            return buffer = closingSubscriber = null;
        }));
    });
}

},{"../util/lift":"d9IaV","../util/noop":"eBCM1","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"78nD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _lift = require("../util/lift");
function catchError(selector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, _innerFrom.innerFrom)(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

},{"../observable/innerFrom":"hQbM7","./OperatorSubscriber":"6STW8","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"llZTb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineAll", ()=>combineAll);
var _combineLatestAll = require("./combineLatestAll");
var combineAll = (0, _combineLatestAll.combineLatestAll);

},{"./combineLatestAll":"3GtTR","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3GtTR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatestAll", ()=>combineLatestAll);
var _combineLatest = require("../observable/combineLatest");
var _joinAllInternals = require("./joinAllInternals");
function combineLatestAll(project) {
    return (0, _joinAllInternals.joinAllInternals)((0, _combineLatest.combineLatest), project);
}

},{"../observable/combineLatest":"gEX6r","./joinAllInternals":"4qOxF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4qOxF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "joinAllInternals", ()=>joinAllInternals);
var _identity = require("../util/identity");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _pipe = require("../util/pipe");
var _mergeMap = require("./mergeMap");
var _toArray = require("./toArray");
function joinAllInternals(joinFn, project) {
    return (0, _pipe.pipe)((0, _toArray.toArray)(), (0, _mergeMap.mergeMap)(function(sources) {
        return joinFn(sources);
    }), project ? (0, _mapOneOrManyArgs.mapOneOrManyArgs)(project) : (0, _identity.identity));
}

},{"../util/identity":"3R9K0","../util/mapOneOrManyArgs":"76yj6","../util/pipe":"7GPyh","./mergeMap":"3P4JK","./toArray":"31L3f","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"31L3f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
var _reduce = require("./reduce");
var _lift = require("../util/lift");
var arrReducer = function(arr, value) {
    return arr.push(value), arr;
};
function toArray() {
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _reduce.reduce)(arrReducer, [])(source).subscribe(subscriber);
    });
}

},{"./reduce":"lcFGM","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lcFGM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _scanInternals = require("./scanInternals");
var _lift = require("../util/lift");
function reduce(accumulator, seed) {
    return (0, _lift.operate)((0, _scanInternals.scanInternals)(accumulator, seed, arguments.length >= 2, false, true));
}

},{"./scanInternals":"f7CW6","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"f7CW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scanInternals", ()=>scanInternals);
var _operatorSubscriber = require("./OperatorSubscriber");
function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}

},{"./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"j1Twf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatestWith", ()=>combineLatestWith);
var _tslib = require("tslib");
var _combineLatest = require("./combineLatest");
function combineLatestWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, _combineLatest.combineLatest).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherSources)));
}

},{"tslib":"h1Nlh","./combineLatest":"allhF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"allhF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
var _tslib = require("tslib");
var _combineLatest = require("../observable/combineLatest");
var _lift = require("../util/lift");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _pipe = require("../util/pipe");
var _args = require("../util/args");
function combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, _args.popResultSelector)(args);
    return resultSelector ? (0, _pipe.pipe)(combineLatest.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args))), (0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : (0, _lift.operate)(function(source, subscriber) {
        (0, _combineLatest.combineLatestInit)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)((0, _argsOrArgArray.argsOrArgArray)(args))))(subscriber);
    });
}

},{"tslib":"h1Nlh","../observable/combineLatest":"gEX6r","../util/lift":"d9IaV","../util/argsOrArgArray":"3cobE","../util/mapOneOrManyArgs":"76yj6","../util/pipe":"7GPyh","../util/args":"1ipMv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"az0GZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMap", ()=>concatMap);
var _mergeMap = require("./mergeMap");
var _isFunction = require("../util/isFunction");
function concatMap(project, resultSelector) {
    return (0, _isFunction.isFunction)(resultSelector) ? (0, _mergeMap.mergeMap)(project, resultSelector, 1) : (0, _mergeMap.mergeMap)(project, 1);
}

},{"./mergeMap":"3P4JK","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jfHN2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMapTo", ()=>concatMapTo);
var _concatMap = require("./concatMap");
var _isFunction = require("../util/isFunction");
function concatMapTo(innerObservable, resultSelector) {
    return (0, _isFunction.isFunction)(resultSelector) ? (0, _concatMap.concatMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _concatMap.concatMap)(function() {
        return innerObservable;
    });
}

},{"./concatMap":"az0GZ","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"b9TyJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatWith", ()=>concatWith);
var _tslib = require("tslib");
var _concat = require("./concat");
function concatWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, _concat.concat).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherSources)));
}

},{"tslib":"h1Nlh","./concat":"a4umE","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"a4umE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _concatAll = require("./concatAll");
var _args = require("../util/args");
var _from = require("../observable/from");
function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _concatAll.concatAll)()((0, _from.from)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(args)), scheduler)).subscribe(subscriber);
    });
}

},{"tslib":"h1Nlh","../util/lift":"d9IaV","./concatAll":"78ztJ","../util/args":"1ipMv","../observable/from":"ir8Cr","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jM60D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "connect", ()=>connect);
var _subject = require("../Subject");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _fromSubscribable = require("../observable/fromSubscribable");
var DEFAULT_CONFIG = {
    connector: function() {
        return new (0, _subject.Subject)();
    }
};
function connect(selector, config) {
    if (config === void 0) config = DEFAULT_CONFIG;
    var connector = config.connector;
    return (0, _lift.operate)(function(source, subscriber) {
        var subject = connector();
        (0, _innerFrom.innerFrom)(selector((0, _fromSubscribable.fromSubscribable)(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}

},{"../Subject":"kOvhz","../observable/innerFrom":"hQbM7","../util/lift":"d9IaV","../observable/fromSubscribable":"19WnB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"19WnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromSubscribable", ()=>fromSubscribable);
var _observable = require("../Observable");
function fromSubscribable(subscribable) {
    return new (0, _observable.Observable)(function(subscriber) {
        return subscribable.subscribe(subscriber);
    });
}

},{"../Observable":"cmjzh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8Eey7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", ()=>count);
var _reduce = require("./reduce");
function count(predicate) {
    return (0, _reduce.reduce)(function(total, value, i) {
        return !predicate || predicate(value, i) ? total + 1 : total;
    }, 0);
}

},{"./reduce":"lcFGM","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7SkeI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function debounce(durationSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            hasValue = true;
            lastValue = value;
            durationSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, emit, (0, _noop.noop));
            (0, _innerFrom.innerFrom)(durationSelector(value)).subscribe(durationSubscriber);
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = durationSubscriber = null;
        }));
    });
}

},{"../util/lift":"d9IaV","../util/noop":"eBCM1","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dD9nD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", ()=>debounceTime);
var _async = require("../scheduler/async");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _lift.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

},{"../scheduler/async":"3m7bL","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8NhEc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIfEmpty", ()=>defaultIfEmpty);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function defaultIfEmpty(defaultValue) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"izLke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _async = require("../scheduler/async");
var _delayWhen = require("./delayWhen");
var _timer = require("../observable/timer");
function delay(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    var duration = (0, _timer.timer)(due, scheduler);
    return (0, _delayWhen.delayWhen)(function() {
        return duration;
    });
}

},{"../scheduler/async":"3m7bL","./delayWhen":"lJfeU","../observable/timer":"8Uhl1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lJfeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", ()=>delayWhen);
var _concat = require("../observable/concat");
var _take = require("./take");
var _ignoreElements = require("./ignoreElements");
var _mapTo = require("./mapTo");
var _mergeMap = require("./mergeMap");
var _innerFrom = require("../observable/innerFrom");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, _concat.concat)(subscriptionDelay.pipe((0, _take.take)(1), (0, _ignoreElements.ignoreElements)()), source.pipe(delayWhen(delayDurationSelector)));
    };
    return (0, _mergeMap.mergeMap)(function(value, index) {
        return (0, _innerFrom.innerFrom)(delayDurationSelector(value, index)).pipe((0, _take.take)(1), (0, _mapTo.mapTo)(value));
    });
}

},{"../observable/concat":"jgH4Y","./take":"jkc4U","./ignoreElements":"bgzSn","./mapTo":"8xbwH","./mergeMap":"3P4JK","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jkc4U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function take(count) {
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

},{"../observable/empty":"lbDEn","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bgzSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", ()=>ignoreElements);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
function ignoreElements() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, (0, _noop.noop)));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/noop":"eBCM1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8xbwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", ()=>mapTo);
var _map = require("./map");
function mapTo(value) {
    return (0, _map.map)(function() {
        return value;
    });
}

},{"./map":"aLYgu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8pj1g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dematerialize", ()=>dematerialize);
var _notification = require("../Notification");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function dematerialize() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(notification) {
            return (0, _notification.observeNotification)(notification, subscriber);
        }));
    });
}

},{"../Notification":"1XSSK","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jMIBy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinct", ()=>distinct);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _innerFrom = require("../observable/innerFrom");
function distinct(keySelector, flushes) {
    return (0, _lift.operate)(function(source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
                distinctKeys.add(key);
                subscriber.next(value);
            }
        }));
        flushes && (0, _innerFrom.innerFrom)(flushes).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            return distinctKeys.clear();
        }, (0, _noop.noop)));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/noop":"eBCM1","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kO2be":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilChanged", ()=>distinctUntilChanged);
var _identity = require("../util/identity");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, _identity.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return (0, _lift.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function defaultCompare(a, b) {
    return a === b;
}

},{"../util/identity":"3R9K0","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lV5ed":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>distinctUntilKeyChanged);
var _distinctUntilChanged = require("./distinctUntilChanged");
function distinctUntilKeyChanged(key, compare) {
    return (0, _distinctUntilChanged.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

},{"./distinctUntilChanged":"kO2be","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jPnAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAt", ()=>elementAt);
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _filter = require("./filter");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _take = require("./take");
function elementAt(index, defaultValue) {
    if (index < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe((0, _filter.filter)(function(v, i) {
            return i === index;
        }), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
        }));
    };
}

},{"../util/ArgumentOutOfRangeError":"aKRd9","./filter":"kk9Ge","./throwIfEmpty":"67JYe","./defaultIfEmpty":"8NhEc","./take":"jkc4U","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"67JYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwIfEmpty", ()=>throwIfEmpty);
var _emptyError = require("../util/EmptyError");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = defaultErrorFactory;
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function defaultErrorFactory() {
    return new (0, _emptyError.EmptyError)();
}

},{"../util/EmptyError":"ikj9E","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eavh3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endWith", ()=>endWith);
var _tslib = require("tslib");
var _concat = require("../observable/concat");
var _of = require("../observable/of");
function endWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return function(source) {
        return (0, _concat.concat)(source, (0, _of.of).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(values))));
    };
}

},{"tslib":"h1Nlh","../observable/concat":"jgH4Y","../observable/of":"gx45o","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1Itrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "every", ()=>every);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function every(predicate, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (!predicate.call(thisArg, value, index++, source)) {
                subscriber.next(false);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bUsbZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaust", ()=>exhaust);
var _exhaustAll = require("./exhaustAll");
var exhaust = (0, _exhaustAll.exhaustAll);

},{"./exhaustAll":"aQzG3","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aQzG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustAll", ()=>exhaustAll);
var _exhaustMap = require("./exhaustMap");
var _identity = require("../util/identity");
function exhaustAll() {
    return (0, _exhaustMap.exhaustMap)((0, _identity.identity));
}

},{"./exhaustMap":"jdu2B","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jdu2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustMap", ()=>exhaustMap);
var _map = require("./map");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function exhaustMap(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe(exhaustMap(function(a, i) {
            return (0, _innerFrom.innerFrom)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(outerValue) {
            if (!innerSub) {
                innerSub = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, function() {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                (0, _innerFrom.innerFrom)(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function() {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}

},{"./map":"aLYgu","../observable/innerFrom":"hQbM7","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3ISEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expand", ()=>expand);
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Infinity;
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return (0, _lift.operate)(function(source, subscriber) {
        return (0, _mergeInternals.mergeInternals)(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}

},{"../util/lift":"d9IaV","./mergeInternals":"6f2Fi","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3sDHB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "finalize", ()=>finalize);
var _lift = require("../util/lift");
function finalize(callback) {
    return (0, _lift.operate)(function(source, subscriber) {
        try {
            source.subscribe(subscriber);
        } finally{
            subscriber.add(callback);
        }
    });
}

},{"../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3SGAc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "createFind", ()=>createFind);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function find(predicate, thisArg) {
    return (0, _lift.operate)(createFind(predicate, thisArg, 'value'));
}
function createFind(predicate, thisArg, emit) {
    var findIndex = emit === 'index';
    return function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            if (predicate.call(thisArg, value, i, source)) {
                subscriber.next(findIndex ? i : value);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(findIndex ? -1 : undefined);
            subscriber.complete();
        }));
    };
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3GiEY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
var _lift = require("../util/lift");
var _find = require("./find");
function findIndex(predicate, thisArg) {
    return (0, _lift.operate)((0, _find.createFind)(predicate, thisArg, 'index'));
}

},{"../util/lift":"d9IaV","./find":"3SGAc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8YZIh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "first", ()=>first);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _take = require("./take");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _throwIfEmpty = require("./throwIfEmpty");
var _identity = require("../util/identity");
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"ikj9E","./filter":"kk9Ge","./take":"jkc4U","./defaultIfEmpty":"8NhEc","./throwIfEmpty":"67JYe","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gnE9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
var _observable = require("../Observable");
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function groupBy(keySelector, elementOrOptions, duration, connector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === 'function') element = elementOrOptions;
        else duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector;
        var groups = new Map();
        var notify = function(cb) {
            groups.forEach(cb);
            cb(subscriber);
        };
        var handleError = function(err) {
            return notify(function(consumer) {
                return consumer.error(err);
            });
        };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new (0, _operatorSubscriber.OperatorSubscriber)(subscriber, function(value) {
            try {
                var key_1 = keySelector(value);
                var group_1 = groups.get(key_1);
                if (!group_1) {
                    groups.set(key_1, group_1 = connector ? connector() : new (0, _subject.Subject)());
                    var grouped = createGroupedObservable(key_1, group_1);
                    subscriber.next(grouped);
                    if (duration) {
                        var durationSubscriber_1 = (0, _operatorSubscriber.createOperatorSubscriber)(group_1, function() {
                            group_1.complete();
                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 || durationSubscriber_1.unsubscribe();
                        }, undefined, undefined, function() {
                            return groups.delete(key_1);
                        });
                        groupBySourceSubscriber.add((0, _innerFrom.innerFrom)(duration(grouped)).subscribe(durationSubscriber_1));
                    }
                }
                group_1.next(element ? element(value) : value);
            } catch (err) {
                handleError(err);
            }
        }, function() {
            return notify(function(consumer) {
                return consumer.complete();
            });
        }, handleError, function() {
            return groups.clear();
        }, function() {
            teardownAttempted = true;
            return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
            var result = new (0, _observable.Observable)(function(groupSubscriber) {
                activeGroups++;
                var innerSub = groupSubject.subscribe(groupSubscriber);
                return function() {
                    innerSub.unsubscribe();
                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
                };
            });
            result.key = key;
            return result;
        }
    });
}

},{"../Observable":"cmjzh","../observable/innerFrom":"hQbM7","../Subject":"kOvhz","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eKwbQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function isEmpty() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            subscriber.next(false);
            subscriber.complete();
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"je9YS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "last", ()=>last);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _takeLast = require("./takeLast");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _identity = require("../util/identity");
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _takeLast.takeLast)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"ikj9E","./filter":"kk9Ge","./takeLast":"glYcy","./throwIfEmpty":"67JYe","./defaultIfEmpty":"8NhEc","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"glYcy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeLast", ()=>takeLast);
var _tslib = require("tslib");
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function takeLast(count) {
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var buffer = [];
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            buffer.push(value);
            count < buffer.length && buffer.shift();
        }, function() {
            var e_1, _a;
            try {
                for(var buffer_1 = (0, _tslib.__values)(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()){
                    var value = buffer_1_1.value;
                    subscriber.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffer = null;
        }));
    });
}

},{"tslib":"h1Nlh","../observable/empty":"lbDEn","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"pf3ll":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "materialize", ()=>materialize);
var _notification = require("../Notification");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function materialize() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next((0, _notification.Notification).createNext(value));
        }, function() {
            subscriber.next((0, _notification.Notification).createComplete());
            subscriber.complete();
        }, function(err) {
            subscriber.next((0, _notification.Notification).createError(err));
            subscriber.complete();
        }));
    });
}

},{"../Notification":"1XSSK","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"54Hke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
var _reduce = require("./reduce");
var _isFunction = require("../util/isFunction");
function max(comparer) {
    return (0, _reduce.reduce)((0, _isFunction.isFunction)(comparer) ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    });
}

},{"./reduce":"lcFGM","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"idJOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _mergeMap = require("./mergeMap");
var flatMap = (0, _mergeMap.mergeMap);

},{"./mergeMap":"3P4JK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5WctF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMapTo", ()=>mergeMapTo);
var _mergeMap = require("./mergeMap");
var _isFunction = require("../util/isFunction");
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, _isFunction.isFunction)(resultSelector)) return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, concurrent);
}

},{"./mergeMap":"3P4JK","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3SsGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeScan", ()=>mergeScan);
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, _lift.operate)(function(source, subscriber) {
        var state = seed;
        return (0, _mergeInternals.mergeInternals)(source, subscriber, function(value, index) {
            return accumulator(state, value, index);
        }, concurrent, function(value) {
            state = value;
        }, false, undefined, function() {
            return state = null;
        });
    });
}

},{"../util/lift":"d9IaV","./mergeInternals":"6f2Fi","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3tsSO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeWith", ()=>mergeWith);
var _tslib = require("tslib");
var _merge = require("./merge");
function mergeWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, _merge.merge).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherSources)));
}

},{"tslib":"h1Nlh","./merge":"2Fc6Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2Fc6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _mergeAll = require("./mergeAll");
var _args = require("../util/args");
var _from = require("../observable/from");
function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var concurrent = (0, _args.popNumber)(args, Infinity);
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _mergeAll.mergeAll)(concurrent)((0, _from.from)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(args)), scheduler)).subscribe(subscriber);
    });
}

},{"tslib":"h1Nlh","../util/lift":"d9IaV","./mergeAll":"eGWmm","../util/args":"1ipMv","../observable/from":"ir8Cr","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cQ9iK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "min", ()=>min);
var _reduce = require("./reduce");
var _isFunction = require("../util/isFunction");
function min(comparer) {
    return (0, _reduce.reduce)((0, _isFunction.isFunction)(comparer) ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    });
}

},{"./reduce":"lcFGM","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lYmDp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multicast", ()=>multicast);
var _connectableObservable = require("../observable/ConnectableObservable");
var _isFunction = require("../util/isFunction");
var _connect = require("./connect");
function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = (0, _isFunction.isFunction)(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
    };
    if ((0, _isFunction.isFunction)(selector)) return (0, _connect.connect)(selector, {
        connector: subjectFactory
    });
    return function(source) {
        return new (0, _connectableObservable.ConnectableObservable)(source, subjectFactory);
    };
}

},{"../observable/ConnectableObservable":"ayC9d","../util/isFunction":"2Pp4R","./connect":"jM60D","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3EdOT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNextWith", ()=>onErrorResumeNextWith);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _tslib = require("tslib");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _onErrorResumeNext = require("../observable/onErrorResumeNext");
function onErrorResumeNextWith() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = (0, _argsOrArgArray.argsOrArgArray)(sources);
    return function(source) {
        return (0, _onErrorResumeNext.onErrorResumeNext).apply(void 0, (0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(nextSources)));
    };
}
var onErrorResumeNext = onErrorResumeNextWith;

},{"tslib":"h1Nlh","../util/argsOrArgArray":"3cobE","../observable/onErrorResumeNext":"eMPOL","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hEN0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairwise", ()=>pairwise);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function pairwise() {
    return (0, _lift.operate)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"exVUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pluck", ()=>pluck);
var _map = require("./map");
function pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return (0, _map.map)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}

},{"./map":"aLYgu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"WzriD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publish", ()=>publish);
var _subject = require("../Subject");
var _multicast = require("./multicast");
var _connect = require("./connect");
function publish(selector) {
    return selector ? function(source) {
        return (0, _connect.connect)(selector)(source);
    } : function(source) {
        return (0, _multicast.multicast)(new (0, _subject.Subject)())(source);
    };
}

},{"../Subject":"kOvhz","./multicast":"lYmDp","./connect":"jM60D","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jFZVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishBehavior", ()=>publishBehavior);
var _behaviorSubject = require("../BehaviorSubject");
var _connectableObservable = require("../observable/ConnectableObservable");
function publishBehavior(initialValue) {
    return function(source) {
        var subject = new (0, _behaviorSubject.BehaviorSubject)(initialValue);
        return new (0, _connectableObservable.ConnectableObservable)(source, function() {
            return subject;
        });
    };
}

},{"../BehaviorSubject":"8riRa","../observable/ConnectableObservable":"ayC9d","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lVnyF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishLast", ()=>publishLast);
var _asyncSubject = require("../AsyncSubject");
var _connectableObservable = require("../observable/ConnectableObservable");
function publishLast() {
    return function(source) {
        var subject = new (0, _asyncSubject.AsyncSubject)();
        return new (0, _connectableObservable.ConnectableObservable)(source, function() {
            return subject;
        });
    };
}

},{"../AsyncSubject":"g4Qg0","../observable/ConnectableObservable":"ayC9d","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"k5PlD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishReplay", ()=>publishReplay);
var _replaySubject = require("../ReplaySubject");
var _multicast = require("./multicast");
var _isFunction = require("../util/isFunction");
function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !(0, _isFunction.isFunction)(selectorOrScheduler)) timestampProvider = selectorOrScheduler;
    var selector = (0, _isFunction.isFunction)(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function(source) {
        return (0, _multicast.multicast)(new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, timestampProvider), selector)(source);
    };
}

},{"../ReplaySubject":"dz1Gz","./multicast":"lYmDp","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iRXzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "raceWith", ()=>raceWith);
var _tslib = require("tslib");
var _race = require("../observable/race");
var _lift = require("../util/lift");
var _identity = require("../util/identity");
function raceWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return !otherSources.length ? (0, _identity.identity) : (0, _lift.operate)(function(source, subscriber) {
        (0, _race.raceInit)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(otherSources)))(subscriber);
    });
}

},{"tslib":"h1Nlh","../observable/race":"6cMD5","../util/lift":"d9IaV","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1JzhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>repeat);
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _timer = require("../observable/timer");
function repeat(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
        if (typeof countOrConfig === 'object') _a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay;
        else count = countOrConfig;
    }
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var soFar = 0;
        var sourceSub;
        var resubscribe = function() {
            sourceSub === null || sourceSub === void 0 || sourceSub.unsubscribe();
            sourceSub = null;
            if (delay != null) {
                var notifier = typeof delay === 'number' ? (0, _timer.timer)(delay) : (0, _innerFrom.innerFrom)(delay(soFar));
                var notifierSubscriber_1 = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                    notifierSubscriber_1.unsubscribe();
                    subscribeToSource();
                });
                notifier.subscribe(notifierSubscriber_1);
            } else subscribeToSource();
        };
        var subscribeToSource = function() {
            var syncUnsub = false;
            sourceSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, function() {
                if (++soFar < count) {
                    if (sourceSub) resubscribe();
                    else syncUnsub = true;
                } else subscriber.complete();
            }));
            if (syncUnsub) resubscribe();
        };
        subscribeToSource();
    });
}

},{"../observable/empty":"lbDEn","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","../observable/timer":"8Uhl1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9ihhe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeatWhen", ()=>repeatWhen);
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function repeatWhen(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function() {
            return isMainComplete && isNotifierComplete && (subscriber.complete(), true);
        };
        var getCompletionSubject = function() {
            if (!completions$) {
                completions$ = new (0, _subject.Subject)();
                (0, _innerFrom.innerFrom)(notifier(completions$)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                    if (innerSub) subscribeForRepeatWhen();
                    else syncResub = true;
                }, function() {
                    isNotifierComplete = true;
                    checkComplete();
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function() {
            isMainComplete = false;
            innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, function() {
                isMainComplete = true;
                !checkComplete() && getCompletionSubject().next();
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
        };
        subscribeForRepeatWhen();
    });
}

},{"../observable/innerFrom":"hQbM7","../Subject":"kOvhz","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"elWVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retry", ()=>retry);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _identity = require("../util/identity");
var _timer = require("../observable/timer");
var _innerFrom = require("../observable/innerFrom");
function retry(configOrCount) {
    if (configOrCount === void 0) configOrCount = Infinity;
    var config;
    if (configOrCount && typeof configOrCount === 'object') config = configOrCount;
    else config = {
        count: configOrCount
    };
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0 ? (0, _identity.identity) : (0, _lift.operate)(function(source, subscriber) {
        var soFar = 0;
        var innerSub;
        var subscribeForRetry = function() {
            var syncUnsub = false;
            innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                if (resetOnSuccess) soFar = 0;
                subscriber.next(value);
            }, undefined, function(err) {
                if (soFar++ < count) {
                    var resub_1 = function() {
                        if (innerSub) {
                            innerSub.unsubscribe();
                            innerSub = null;
                            subscribeForRetry();
                        } else syncUnsub = true;
                    };
                    if (delay != null) {
                        var notifier = typeof delay === 'number' ? (0, _timer.timer)(delay) : (0, _innerFrom.innerFrom)(delay(err, soFar));
                        var notifierSubscriber_1 = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                            notifierSubscriber_1.unsubscribe();
                            resub_1();
                        }, function() {
                            subscriber.complete();
                        });
                        notifier.subscribe(notifierSubscriber_1);
                    } else resub_1();
                } else subscriber.error(err);
            }));
            if (syncUnsub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscribeForRetry();
            }
        };
        subscribeForRetry();
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/identity":"3R9K0","../observable/timer":"8Uhl1","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dvAD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryWhen", ()=>retryWhen);
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function retryWhen(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function() {
            innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
                if (!errors$) {
                    errors$ = new (0, _subject.Subject)();
                    (0, _innerFrom.innerFrom)(notifier(errors$)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                        return innerSub ? subscribeForRetryWhen() : syncResub = true;
                    }));
                }
                if (errors$) errors$.next(err);
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}

},{"../observable/innerFrom":"hQbM7","../Subject":"kOvhz","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ed9y7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sample", ()=>sample);
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
function sample(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
        }));
        (0, _innerFrom.innerFrom)(notifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        }, (0, _noop.noop)));
    });
}

},{"../observable/innerFrom":"hQbM7","../util/lift":"d9IaV","../util/noop":"eBCM1","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7XqCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleTime", ()=>sampleTime);
var _async = require("../scheduler/async");
var _sample = require("./sample");
var _interval = require("../observable/interval");
function sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _sample.sample)((0, _interval.interval)(period, scheduler));
}

},{"../scheduler/async":"3m7bL","./sample":"ed9y7","../observable/interval":"bYViF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lbX4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scan", ()=>scan);
var _lift = require("../util/lift");
var _scanInternals = require("./scanInternals");
function scan(accumulator, seed) {
    return (0, _lift.operate)((0, _scanInternals.scanInternals)(accumulator, seed, arguments.length >= 2, true));
}

},{"../util/lift":"d9IaV","./scanInternals":"f7CW6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1V9Fe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sequenceEqual", ()=>sequenceEqual);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function sequenceEqual(compareTo, comparator) {
    if (comparator === void 0) comparator = function(a, b) {
        return a === b;
    };
    return (0, _lift.operate)(function(source, subscriber) {
        var aState = createState();
        var bState = createState();
        var emit = function(isEqual) {
            subscriber.next(isEqual);
            subscriber.complete();
        };
        var createSubscriber = function(selfState, otherState) {
            var sequenceEqualSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(a) {
                var buffer = otherState.buffer, complete = otherState.complete;
                if (buffer.length === 0) complete ? emit(false) : selfState.buffer.push(a);
                else !comparator(a, buffer.shift()) && emit(false);
            }, function() {
                selfState.complete = true;
                var complete = otherState.complete, buffer = otherState.buffer;
                complete && emit(buffer.length === 0);
                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 || sequenceEqualSubscriber.unsubscribe();
            });
            return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        (0, _innerFrom.innerFrom)(compareTo).subscribe(createSubscriber(bState, aState));
    });
}
function createState() {
    return {
        buffer: [],
        complete: false
    };
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cARo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", ()=>share);
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _subscriber = require("../Subscriber");
var _lift = require("../util/lift");
function share(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, _subject.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, _lift.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, _subscriber.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, _innerFrom.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, _subscriber.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, _innerFrom.innerFrom)(on.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)))).subscribe(onSubscriber);
}

},{"tslib":"h1Nlh","../observable/innerFrom":"hQbM7","../Subject":"kOvhz","../Subscriber":"4uu7P","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"22B8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shareReplay", ()=>shareReplay);
var _replaySubject = require("../ReplaySubject");
var _share = require("./share");
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, _share.share)({
        connector: function() {
            return new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

},{"../ReplaySubject":"dz1Gz","./share":"cARo8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"c17as":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "single", ()=>single);
var _emptyError = require("../util/EmptyError");
var _sequenceError = require("../util/SequenceError");
var _notFoundError = require("../util/NotFoundError");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function single(predicate) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            seenValue = true;
            if (!predicate || predicate(value, index++, source)) {
                hasValue && subscriber.error(new (0, _sequenceError.SequenceError)('Too many matching values'));
                hasValue = true;
                singleValue = value;
            }
        }, function() {
            if (hasValue) {
                subscriber.next(singleValue);
                subscriber.complete();
            } else subscriber.error(seenValue ? new (0, _notFoundError.NotFoundError)('No matching values') : new (0, _emptyError.EmptyError)());
        }));
    });
}

},{"../util/EmptyError":"ikj9E","../util/SequenceError":"7MxXm","../util/NotFoundError":"cRrIH","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ihqWk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skip", ()=>skip);
var _filter = require("./filter");
function skip(count) {
    return (0, _filter.filter)(function(_, index) {
        return count <= index;
    });
}

},{"./filter":"kk9Ge","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9CGPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipLast", ()=>skipLast);
var _identity = require("../util/identity");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function skipLast(skipCount) {
    return skipCount <= 0 ? (0, _identity.identity) : (0, _lift.operate)(function(source, subscriber) {
        var ring = new Array(skipCount);
        var seen = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var valueIndex = seen++;
            if (valueIndex < skipCount) ring[valueIndex] = value;
            else {
                var index = valueIndex % skipCount;
                var oldValue = ring[index];
                ring[index] = value;
                subscriber.next(oldValue);
            }
        }));
        return function() {
            ring = null;
        };
    });
}

},{"../util/identity":"3R9K0","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iYiSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipUntil", ()=>skipUntil);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _noop = require("../util/noop");
function skipUntil(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var taking = false;
        var skipSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            skipSubscriber === null || skipSubscriber === void 0 || skipSubscriber.unsubscribe();
            taking = true;
        }, (0, _noop.noop));
        (0, _innerFrom.innerFrom)(notifier).subscribe(skipSubscriber);
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return taking && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","../util/noop":"eBCM1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cvBXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipWhile", ()=>skipWhile);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function skipWhile(predicate) {
    return (0, _lift.operate)(function(source, subscriber) {
        var taking = false;
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return (taking || (taking = !predicate(value, index++))) && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lm6WM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWith", ()=>startWith);
var _concat = require("../observable/concat");
var _args = require("../util/args");
var _lift = require("../util/lift");
function startWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(values);
    return (0, _lift.operate)(function(source, subscriber) {
        (scheduler ? (0, _concat.concat)(values, source, scheduler) : (0, _concat.concat)(values, source)).subscribe(subscriber);
    });
}

},{"../observable/concat":"jgH4Y","../util/args":"1ipMv","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6XryD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchAll", ()=>switchAll);
var _switchMap = require("./switchMap");
var _identity = require("../util/identity");
function switchAll() {
    return (0, _switchMap.switchMap)((0, _identity.identity));
}

},{"./switchMap":"bjPkB","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bjPkB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function switchMap(project, resultSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, _innerFrom.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

},{"../observable/innerFrom":"hQbM7","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"55Cae":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMapTo", ()=>switchMapTo);
var _switchMap = require("./switchMap");
var _isFunction = require("../util/isFunction");
function switchMapTo(innerObservable, resultSelector) {
    return (0, _isFunction.isFunction)(resultSelector) ? (0, _switchMap.switchMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _switchMap.switchMap)(function() {
        return innerObservable;
    });
}

},{"./switchMap":"bjPkB","../util/isFunction":"2Pp4R","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ehD6Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchScan", ()=>switchScan);
var _switchMap = require("./switchMap");
var _lift = require("../util/lift");
function switchScan(accumulator, seed) {
    return (0, _lift.operate)(function(source, subscriber) {
        var state = seed;
        (0, _switchMap.switchMap)(function(value, index) {
            return accumulator(state, value, index);
        }, function(_, innerValue) {
            return state = innerValue, innerValue;
        })(source).subscribe(subscriber);
        return function() {
            state = null;
        };
    });
}

},{"./switchMap":"bjPkB","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7tR5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeUntil", ()=>takeUntil);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _noop = require("../util/noop");
function takeUntil(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _innerFrom.innerFrom)(notifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, _noop.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","../util/noop":"eBCM1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9Q7X7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeWhile", ()=>takeWhile);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lDW82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tap", ()=>tap);
var _isFunction = require("../util/isFunction");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _identity = require("../util/identity");
function tap(observerOrNext, error, complete) {
    var tapObserver = (0, _isFunction.isFunction)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, _lift.operate)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, _identity.identity);
}

},{"../util/isFunction":"2Pp4R","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/identity":"3R9K0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fyMKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function throttle(durationSelector, config) {
    return (0, _lift.operate)(function(source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function() {
            throttled === null || throttled === void 0 || throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function() {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function(value) {
            return throttled = (0, _innerFrom.innerFrom)(durationSelector(value)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, endThrottling, cleanupThrottling));
        };
        var send = function() {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function() {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}

},{"../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bnY8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttleTime", ()=>throttleTime);
var _async = require("../scheduler/async");
var _throttle = require("./throttle");
var _timer = require("../observable/timer");
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    var duration$ = (0, _timer.timer)(duration, scheduler);
    return (0, _throttle.throttle)(function() {
        return duration$;
    }, config);
}

},{"../scheduler/async":"3m7bL","./throttle":"fyMKZ","../observable/timer":"8Uhl1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iqEjH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "TimeInterval", ()=>TimeInterval);
var _async = require("../scheduler/async");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _lift.operate)(function(source, subscriber) {
        var last = scheduler.now();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var now = scheduler.now();
            var interval = now - last;
            last = now;
            subscriber.next(new TimeInterval(value, interval));
        }));
    });
}
var TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();

},{"../scheduler/async":"3m7bL","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lHItB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutWith", ()=>timeoutWith);
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _timeout = require("./timeout");
function timeoutWith(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : (0, _async.async);
    if ((0, _isDate.isValidDate)(due)) first = due;
    else if (typeof due === 'number') each = due;
    if (withObservable) _with = function() {
        return withObservable;
    };
    else throw new TypeError('No observable provided to switch to');
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, _timeout.timeout)({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with
    });
}

},{"../scheduler/async":"3m7bL","../util/isDate":"gGR6h","./timeout":"33AiV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lqzQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timestamp", ()=>timestamp);
var _dateTimestampProvider = require("../scheduler/dateTimestampProvider");
var _map = require("./map");
function timestamp(timestampProvider) {
    if (timestampProvider === void 0) timestampProvider = (0, _dateTimestampProvider.dateTimestampProvider);
    return (0, _map.map)(function(value) {
        return {
            value: value,
            timestamp: timestampProvider.now()
        };
    });
}

},{"../scheduler/dateTimestampProvider":"84pzX","./map":"aLYgu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aFS6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "window", ()=>window);
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _innerFrom = require("../observable/innerFrom");
function window(windowBoundaries) {
    return (0, _lift.operate)(function(source, subscriber) {
        var windowSubject = new (0, _subject.Subject)();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function(err) {
            windowSubject.error(err);
            subscriber.error(err);
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value);
        }, function() {
            windowSubject.complete();
            subscriber.complete();
        }, errorHandler));
        (0, _innerFrom.innerFrom)(windowBoundaries).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            windowSubject.complete();
            subscriber.next(windowSubject = new (0, _subject.Subject)());
        }, (0, _noop.noop), errorHandler));
        return function() {
            windowSubject === null || windowSubject === void 0 || windowSubject.unsubscribe();
            windowSubject = null;
        };
    });
}

},{"../Subject":"kOvhz","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/noop":"eBCM1","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1BnOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowCount", ()=>windowCount);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return (0, _lift.operate)(function(source, subscriber) {
        var windows = [
            new (0, _subject.Subject)()
        ];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var windows_1 = (0, _tslib.__values)(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()){
                    var window_1 = windows_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var c = count - windowSize + 1;
            if (c >= 0 && c % startEvery === 0) windows.shift().complete();
            if (++count % startEvery === 0) {
                var window_2 = new (0, _subject.Subject)();
                windows.push(window_2);
                subscriber.next(window_2.asObservable());
            }
        }, function() {
            while(windows.length > 0)windows.shift().complete();
            subscriber.complete();
        }, function(err) {
            while(windows.length > 0)windows.shift().error(err);
            subscriber.error(err);
        }, function() {
            starts = null;
            windows = null;
        }));
    });
}

},{"tslib":"h1Nlh","../Subject":"kOvhz","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dBf9p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowTime", ()=>windowTime);
var _subject = require("../Subject");
var _async = require("../scheduler/async");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _arrRemove = require("../util/arrRemove");
var _args = require("../util/args");
var _executeSchedule = require("../util/executeSchedule");
function windowTime(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = (0, _args.popScheduler)(otherArgs)) !== null && _a !== void 0 ? _a : (0, _async.asyncScheduler);
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return (0, _lift.operate)(function(source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function(record) {
            var window = record.window, subs = record.subs;
            window.complete();
            subs.unsubscribe();
            (0, _arrRemove.arrRemove)(windowRecords, record);
            restartOnClose && startWindow();
        };
        var startWindow = function() {
            if (windowRecords) {
                var subs = new (0, _subscription.Subscription)();
                subscriber.add(subs);
                var window_1 = new (0, _subject.Subject)();
                var record_1 = {
                    window: window_1,
                    subs: subs,
                    seen: 0
                };
                windowRecords.push(record_1);
                subscriber.next(window_1.asObservable());
                (0, _executeSchedule.executeSchedule)(subs, scheduler, function() {
                    return closeWindow(record_1);
                }, windowTimeSpan);
            }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) (0, _executeSchedule.executeSchedule)(subscriber, scheduler, startWindow, windowCreationInterval, true);
        else restartOnClose = true;
        startWindow();
        var loop = function(cb) {
            return windowRecords.slice().forEach(cb);
        };
        var terminate = function(cb) {
            loop(function(_a) {
                var window = _a.window;
                return cb(window);
            });
            cb(subscriber);
            subscriber.unsubscribe();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            loop(function(record) {
                record.window.next(value);
                maxWindowSize <= ++record.seen && closeWindow(record);
            });
        }, function() {
            return terminate(function(consumer) {
                return consumer.complete();
            });
        }, function(err) {
            return terminate(function(consumer) {
                return consumer.error(err);
            });
        }));
        return function() {
            windowRecords = null;
        };
    });
}

},{"../Subject":"kOvhz","../scheduler/async":"3m7bL","../Subscription":"jB6sM","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../util/arrRemove":"1R6w9","../util/args":"1ipMv","../util/executeSchedule":"fQYkB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hheJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowToggle", ()=>windowToggle);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _arrRemove = require("../util/arrRemove");
function windowToggle(openings, closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var windows = [];
        var handleError = function(err) {
            while(0 < windows.length)windows.shift().error(err);
            subscriber.error(err);
        };
        (0, _innerFrom.innerFrom)(openings).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(openValue) {
            var window = new (0, _subject.Subject)();
            windows.push(window);
            var closingSubscription = new (0, _subscription.Subscription)();
            var closeWindow = function() {
                (0, _arrRemove.arrRemove)(windows, window);
                window.complete();
                closingSubscription.unsubscribe();
            };
            var closingNotifier;
            try {
                closingNotifier = (0, _innerFrom.innerFrom)(closingSelector(openValue));
            } catch (err) {
                handleError(err);
                return;
            }
            subscriber.next(window.asObservable());
            closingSubscription.add(closingNotifier.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, closeWindow, (0, _noop.noop), handleError)));
        }, (0, _noop.noop)));
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            var windowsCopy = windows.slice();
            try {
                for(var windowsCopy_1 = (0, _tslib.__values)(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()){
                    var window_1 = windowsCopy_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(0 < windows.length)windows.shift().complete();
            subscriber.complete();
        }, handleError, function() {
            while(0 < windows.length)windows.shift().unsubscribe();
        }));
    });
}

},{"tslib":"h1Nlh","../Subject":"kOvhz","../Subscription":"jB6sM","../util/lift":"d9IaV","../observable/innerFrom":"hQbM7","./OperatorSubscriber":"6STW8","../util/noop":"eBCM1","../util/arrRemove":"1R6w9","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cjHLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowWhen", ()=>windowWhen);
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function windowWhen(closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var window;
        var closingSubscriber;
        var handleError = function(err) {
            window.error(err);
            subscriber.error(err);
        };
        var openWindow = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window === null || window === void 0 || window.complete();
            window = new (0, _subject.Subject)();
            subscriber.next(window.asObservable());
            var closingNotifier;
            try {
                closingNotifier = (0, _innerFrom.innerFrom)(closingSelector());
            } catch (err) {
                handleError(err);
                return;
            }
            closingNotifier.subscribe(closingSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, openWindow, openWindow, handleError));
        };
        openWindow();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return window.next(value);
        }, function() {
            window.complete();
            subscriber.complete();
        }, handleError, function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window = null;
        }));
    });
}

},{"../Subject":"kOvhz","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"efgsf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withLatestFrom", ()=>withLatestFrom);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _identity = require("../util/identity");
var _noop = require("../util/noop");
var _args = require("../util/args");
function withLatestFrom() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, _args.popResultSelector)(inputs);
    return (0, _lift.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, _innerFrom.innerFrom)(inputs[i]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, _identity.identity))) && (hasValue = null);
                }
            }, (0, _noop.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, _tslib.__spreadArray)([
                    value
                ], (0, _tslib.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(values))) : values);
            }
        }));
    });
}

},{"tslib":"h1Nlh","../util/lift":"d9IaV","./OperatorSubscriber":"6STW8","../observable/innerFrom":"hQbM7","../util/identity":"3R9K0","../util/noop":"eBCM1","../util/args":"1ipMv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"67Mcf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipAll", ()=>zipAll);
var _zip = require("../observable/zip");
var _joinAllInternals = require("./joinAllInternals");
function zipAll(project) {
    return (0, _joinAllInternals.joinAllInternals)((0, _zip.zip), project);
}

},{"../observable/zip":"9zyDM","./joinAllInternals":"4qOxF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1rkRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipWith", ()=>zipWith);
var _tslib = require("tslib");
var _zip = require("./zip");
function zipWith() {
    var otherInputs = [];
    for(var _i = 0; _i < arguments.length; _i++)otherInputs[_i] = arguments[_i];
    return (0, _zip.zip).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherInputs)));
}

},{"tslib":"h1Nlh","./zip":"cwQAE","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cwQAE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _tslib = require("tslib");
var _zip = require("../observable/zip");
var _lift = require("../util/lift");
function zip() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _zip.zip).apply(void 0, (0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(sources))).subscribe(subscriber);
    });
}

},{"tslib":"h1Nlh","../observable/zip":"9zyDM","../util/lift":"d9IaV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iXFzc":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
const isWebWorker = ()=>{
    if (typeof self === 'undefined') return false;
    const selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' && self instanceof selfContext.WorkerGlobalScope;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4uBhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SESSION_START_EVENT", ()=>(0, _constantsMjs.SESSION_START_EVENT));
parcelHelpers.export(exports, "SESSION_STOP_EVENT", ()=>(0, _constantsMjs.SESSION_STOP_EVENT));
parcelHelpers.export(exports, "sessionListener", ()=>sessionListener);
var _sessionListenerMjs = require("./SessionListener.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const sessionListener = new (0, _sessionListenerMjs.SessionListener)();

},{"./SessionListener.mjs":"8prGH","./constants.mjs":"k9UzK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8prGH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionListener", ()=>SessionListener);
var _isBrowserMjs = require("../isBrowser.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const stateChangeListeners = new Set();
class SessionListener {
    addStateChangeListener(listener, notifyOnAdd = false) {
        // No-op if document listener is not active
        if (!this.listenerActive) return;
        stateChangeListeners.add(listener);
        // Notify new handlers of the current status on add
        if (notifyOnAdd) listener(this.getSessionState());
    }
    removeStateChangeListener(handler) {
        // No-op if document listener is not active
        if (!this.listenerActive) return;
        stateChangeListeners.delete(handler);
    }
    handleVisibilityChange() {
        this.notifyHandlers();
    }
    notifyHandlers() {
        const sessionState = this.getSessionState();
        stateChangeListeners.forEach((listener)=>{
            listener(sessionState);
        });
    }
    getSessionState() {
        if ((0, _isBrowserMjs.isBrowser)() && document.visibilityState !== 'hidden') return 'started';
        // If, for any reason, document is undefined the session will never start
        return 'ended';
    }
    constructor(){
        this.listenerActive = false;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        // Setup state listeners
        if ((0, _isBrowserMjs.isBrowser)()) {
            document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
            this.listenerActive = true;
        }
    }
}

},{"../isBrowser.mjs":"fcM16","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fcM16":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
const isBrowser = ()=>typeof window !== 'undefined' && typeof window.document !== 'undefined';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"k9UzK":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Standard session start & stop event names
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SESSION_START_EVENT", ()=>SESSION_START_EVENT);
parcelHelpers.export(exports, "SESSION_STOP_EVENT", ()=>SESSION_STOP_EVENT);
const SESSION_START_EVENT = '_session.start';
const SESSION_STOP_EVENT = '_session.stop';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aMUHt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthClass", ()=>AuthClass);
var _consoleLoggerMjs = require("../../Logger/ConsoleLogger.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('Auth');
class AuthClass {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        var _authResourcesConfig_Cognito, _authResourcesConfig_Cognito1;
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
        if (authResourcesConfig && ((_authResourcesConfig_Cognito = authResourcesConfig.Cognito) === null || _authResourcesConfig_Cognito === void 0 ? void 0 : _authResourcesConfig_Cognito.userPoolEndpoint)) logger.warn(getCustomEndpointWarningMessage('Amazon Cognito User Pool'));
        if (authResourcesConfig && ((_authResourcesConfig_Cognito1 = authResourcesConfig.Cognito) === null || _authResourcesConfig_Cognito1 === void 0 ? void 0 : _authResourcesConfig_Cognito1.identityPoolEndpoint)) logger.warn(getCustomEndpointWarningMessage('Amazon Cognito Identity Pool'));
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
     * of non-expired tokens with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        var _this_authOptions_credentialsProvider, _this_authOptions;
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            var _tokens_accessToken_payload, _tokens_accessToken, _this_authOptions_credentialsProvider1, _this_authOptions1;
            userSub = (_tokens_accessToken = tokens.accessToken) === null || _tokens_accessToken === void 0 ? void 0 : (_tokens_accessToken_payload = _tokens_accessToken.payload) === null || _tokens_accessToken_payload === void 0 ? void 0 : _tokens_accessToken_payload.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await ((_this_authOptions1 = this.authOptions) === null || _this_authOptions1 === void 0 ? void 0 : (_this_authOptions_credentialsProvider1 = _this_authOptions1.credentialsProvider) === null || _this_authOptions_credentialsProvider1 === void 0 ? void 0 : _this_authOptions_credentialsProvider1.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            }));
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await ((_this_authOptions = this.authOptions) === null || _this_authOptions === void 0 ? void 0 : (_this_authOptions_credentialsProvider = _this_authOptions.credentialsProvider) === null || _this_authOptions_credentialsProvider === void 0 ? void 0 : _this_authOptions_credentialsProvider.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        }));
        return {
            tokens,
            credentials: credentialsAndIdentityId === null || credentialsAndIdentityId === void 0 ? void 0 : credentialsAndIdentityId.credentials,
            identityId: credentialsAndIdentityId === null || credentialsAndIdentityId === void 0 ? void 0 : credentialsAndIdentityId.identityId,
            userSub
        };
    }
    async clearCredentials() {
        var _this_authOptions_credentialsProvider, _this_authOptions;
        await ((_this_authOptions = this.authOptions) === null || _this_authOptions === void 0 ? void 0 : (_this_authOptions_credentialsProvider = _this_authOptions.credentialsProvider) === null || _this_authOptions_credentialsProvider === void 0 ? void 0 : _this_authOptions_credentialsProvider.clearCredentialsAndIdentityId());
    }
    async getTokens(options) {
        var _this_authOptions_tokenProvider, _this_authOptions;
        var _ref;
        return (_ref = await ((_this_authOptions = this.authOptions) === null || _this_authOptions === void 0 ? void 0 : (_this_authOptions_tokenProvider = _this_authOptions.tokenProvider) === null || _this_authOptions_tokenProvider === void 0 ? void 0 : _this_authOptions_tokenProvider.getTokens(options))) !== null && _ref !== void 0 ? _ref : undefined;
    }
}
const getCustomEndpointWarningMessage = (target)=>`You are using a custom Amazon ${target} endpoint, ensure the endpoint is correct.`;

},{"../../Logger/ConsoleLogger.mjs":"6OFOw","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ecuoW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchAuthSession", ()=>fetchAuthSession);
var _amplifyMjs = require("../Amplify.mjs");
var _fetchAuthSessionMjs = require("./internal/fetchAuthSession.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetch the auth session including the tokens and credentials if they are available. By default it
 * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
 * of non-expired tokens with `{ forceRefresh: true }` input.
 *
 * @param options - Options configuring the fetch behavior.
 * @throws {@link AuthError} - Throws error when session information cannot be refreshed.
 * @returns Promise<AuthSession>
 */ const fetchAuthSession = (options)=>{
    return (0, _fetchAuthSessionMjs.fetchAuthSession)((0, _amplifyMjs.Amplify), options);
};

},{"../Amplify.mjs":"3ZpqK","./internal/fetchAuthSession.mjs":"2tfxu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2tfxu":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchAuthSession", ()=>fetchAuthSession);
const fetchAuthSession = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dMTIk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearCredentials", ()=>clearCredentials);
var _amplifyMjs = require("../Amplify.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function clearCredentials() {
    return (0, _amplifyMjs.Amplify).Auth.clearCredentials();
}

},{"../Amplify.mjs":"3ZpqK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9BciP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetCredentialsForIdentityClient", ()=>createGetCredentialsForIdentityClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _errorsMjs = require("../../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _errorHelpersMjs1 = require("../../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs = require("../../../../Platform/index.mjs");
var _typesMjs = require("../../../../Platform/types.mjs");
var _typesMjs1 = require("../../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../../Reachability/Reachability.mjs");
var _indexMjs1 = require("../../../../Hub/index.mjs");
var _indexMjs2 = require("../../../../utils/sessionListener/index.mjs");
var _responseInfoMjs = require("../../../../clients/serde/responseInfo.mjs");
var _jsonMjs = require("../../../../clients/serde/json.mjs");
var _composeServiceApiMjs = require("../../../../clients/internal/composeServiceApi.mjs");
var _constantsMjs = require("./constants.mjs");
var _cognitoIdentityTransferHandlerMjs = require("./handler/cognitoIdentityTransferHandler.mjs");
var _createClientSerializerMjs = require("./serde/createClientSerializer.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createGetCredentialsForIdentityClient = (config)=>(0, _composeServiceApiMjs.composeServiceApi)((0, _cognitoIdentityTransferHandlerMjs.cognitoIdentityTransferHandler), (0, _createClientSerializerMjs.createClientSerializer)('GetCredentialsForIdentity'), getCredentialsForIdentityDeserializer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config), {
        userAgentValue: (0, _indexMjs.getAmplifyUserAgent)()
    }));
const getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, _jsonMjs.parseJsonError)(response);
        throw error;
    }
    const body = await (0, _jsonMjs.parseJsonBody)(response);
    return {
        IdentityId: body.IdentityId,
        Credentials: deserializeCredentials(body.Credentials),
        $metadata: (0, _responseInfoMjs.parseMetadata)(response)
    };
};
const deserializeCredentials = (_param = {})=>{
    var { Expiration } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "Expiration"
    ]);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        Expiration: Expiration && new Date(Expiration * 1000)
    });
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@swc/helpers/_/_object_without_properties":"13dVA","../../../../types/errors.mjs":"2tN68","../../../../errors/errorHelpers.mjs":"fvR3Q","../../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../../utils/retry/retry.mjs":"eFvhH","../../../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../../Platform/index.mjs":"34W7w","../../../../Platform/types.mjs":"8YCjz","../../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../../Reachability/Reachability.mjs":"1EGHg","../../../../Hub/index.mjs":"hkdby","../../../../utils/sessionListener/index.mjs":"4uBhf","../../../../clients/serde/responseInfo.mjs":"88PMJ","../../../../clients/serde/json.mjs":"1pZXC","../../../../clients/internal/composeServiceApi.mjs":"cUdLo","./constants.mjs":"9Q8ds","./handler/cognitoIdentityTransferHandler.mjs":"c1WnZ","./serde/createClientSerializer.mjs":"7zIMc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"88PMJ":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", ()=>parseMetadata);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
const parseMetadata = (response)=>{
    const { headers, statusCode } = response;
    var _headers_xamznrequestid, _ref;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_ref = (_headers_xamznrequestid = headers['x-amzn-requestid']) !== null && _headers_xamznrequestid !== void 0 ? _headers_xamznrequestid : headers['x-amzn-request-id']) !== null && _ref !== void 0 ? _ref : headers['x-amz-request-id'],
        extendedRequestId: headers['x-amz-id-2'],
        cfId: headers['x-amz-cf-id']
    });
};
const isMetadataBearer = (response)=>typeof (response === null || response === void 0 ? void 0 : response.$metadata) === 'object';

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1pZXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsonBody", ()=>parseJsonBody);
parcelHelpers.export(exports, "parseJsonError", ()=>parseJsonError);
var _responseInfoMjs = require("./responseInfo.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const parseJsonError = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await parseJsonBody(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes('#')) return cleanValue.split('#')[1];
        return cleanValue;
    };
    var _response_headers_xamznerrortype, _ref, _ref1;
    const code = sanitizeErrorCode((_ref1 = (_ref = (_response_headers_xamznerrortype = response.headers['x-amzn-errortype']) !== null && _response_headers_xamznerrortype !== void 0 ? _response_headers_xamznerrortype : body.code) !== null && _ref !== void 0 ? _ref : body.__type) !== null && _ref1 !== void 0 ? _ref1 : 'UnknownError');
    var _body_message, _ref2;
    const message = (_ref2 = (_body_message = body.message) !== null && _body_message !== void 0 ? _body_message : body.Message) !== null && _ref2 !== void 0 ? _ref2 : 'Unknown error';
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, _responseInfoMjs.parseMetadata)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const parseJsonBody = async (response)=>{
    if (!response.body) throw new Error('Missing response payload');
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, _responseInfoMjs.parseMetadata)(response)
    });
};

},{"./responseInfo.mjs":"88PMJ","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cUdLo":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a service API handler that accepts input as defined shape and responds conforming to defined output shape.
 * A service API handler is composed with:
 * * A transfer handler
 * * A serializer function
 * * A deserializer function
 * * A default config object
 *
 * The returned service API handler, when called, will trigger the following workflow:
 * 1. When calling the service API handler function, the default config object is merged into the input config
 * object to assign the default values of some omitted configs, resulting to a resolved config object.
 * 2. The `endpointResolver` function from the default config object will be invoked with the resolved config object and
 * API input object resulting to an endpoint instance.
 * 3. The serializer function is invoked with API input object and the endpoint instance resulting to an HTTP request
 * instance.
 * 4. The HTTP request instance and the resolved config object is passed to the transfer handler function.
 * 5. The transfer handler function resolves to an HTTP response instance(can be either successful or failed status code).
 * 6. The deserializer function is invoked with the HTTP response instance resulting to the API output object, and
 * return to the caller.
 *
 *
 * @param transferHandler Async function for dispatching HTTP requests and returning HTTP response.
 * @param serializer  Async function for converting object in defined input shape into HTTP request targeting a given
 * 	endpoint.
 * @param deserializer Async function for converting HTTP response into output object in defined output shape, or error
 * 	shape.
 * @param defaultConfig  object containing default options to be consumed by transfer handler, serializer and
 *  deserializer.
 * @returns a async service API handler function that accepts a config object and input object in defined shape, returns
 * 	an output object in defined shape. It may also throw error instance in defined shape in deserializer. The config
 *  object type is composed with options type of transferHandler, endpointResolver function as well as endpointResolver
 *  function's input options type, region string. The config object property will be marked as optional if it's also
 * 	defined in defaultConfig.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", ()=>composeServiceApi);
var _objectSpread = require("@swc/helpers/_/_object_spread");
const composeServiceApi = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = (0, _objectSpread._)({}, defaultConfig, config);
        // We need to allow different endpoints based on both given config(other than region) and input.
        // However for most of non-S3 services, region is the only input for endpoint resolver.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, (0, _objectSpread._)({}, resolvedConfig));
        return deserializer(response);
    };
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9Q8ds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COGNITO_IDENTITY_SERVICE_NAME", ()=>COGNITO_IDENTITY_SERVICE_NAME);
parcelHelpers.export(exports, "DEFAULT_SERVICE_CLIENT_API_CONFIG", ()=>DEFAULT_SERVICE_CLIENT_API_CONFIG);
var _errorsMjs = require("../../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../../errors/errorHelpers.mjs");
var _jitteredBackoffMjs = require("../../../../clients/middleware/retry/jitteredBackoff.mjs");
var _defaultRetryDeciderMjs = require("../../../../clients/middleware/retry/defaultRetryDecider.mjs");
var _getClientInfoMjs = require("../../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _errorHelpersMjs1 = require("../../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs = require("../../../../Platform/index.mjs");
var _typesMjs = require("../../../../Platform/types.mjs");
var _typesMjs1 = require("../../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../../Reachability/Reachability.mjs");
var _indexMjs1 = require("../../../../Hub/index.mjs");
var _indexMjs2 = require("../../../../utils/sessionListener/index.mjs");
var _jsonMjs = require("../../../../clients/serde/json.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const COGNITO_IDENTITY_SERVICE_NAME = 'cognito-identity';
const DEFAULT_SERVICE_CLIENT_API_CONFIG = {
    service: COGNITO_IDENTITY_SERVICE_NAME,
    retryDecider: (0, _defaultRetryDeciderMjs.getRetryDecider)((0, _jsonMjs.parseJsonError)),
    computeDelay: (0, _jitteredBackoffMjs.jitteredBackoff),
    cache: 'no-store'
};

},{"../../../../types/errors.mjs":"2tN68","../../../../errors/errorHelpers.mjs":"fvR3Q","../../../../clients/middleware/retry/jitteredBackoff.mjs":"1gXeo","../../../../clients/middleware/retry/defaultRetryDecider.mjs":"kA0XD","../../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../../utils/retry/retry.mjs":"eFvhH","../../../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../../Platform/index.mjs":"34W7w","../../../../Platform/types.mjs":"8YCjz","../../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../../Reachability/Reachability.mjs":"1EGHg","../../../../Hub/index.mjs":"hkdby","../../../../utils/sessionListener/index.mjs":"4uBhf","../../../../clients/serde/json.mjs":"1pZXC","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1gXeo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jitteredBackoff", ()=>jitteredBackoff);
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../utils/getClientInfo/getClientInfo.mjs");
var _jitteredBackoffMjs = require("../../../utils/retry/jitteredBackoff.mjs");
var _retryMjs = require("../../../utils/retry/retry.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const jitteredBackoff = (attempt)=>{
    const delayFunction = (0, _jitteredBackoffMjs.jitteredBackoff)((0, _constantsMjs.DEFAULT_MAX_DELAY_MS));
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? (0, _constantsMjs.DEFAULT_MAX_DELAY_MS) : delay;
};

},{"../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../utils/retry/jitteredBackoff.mjs":"8sNtw","../../../utils/retry/retry.mjs":"eFvhH","./constants.mjs":"2XUGo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8sNtw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jitteredBackoff", ()=>jitteredBackoff);
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function jitteredBackoff(maxDelayMs = (0, _constantsMjs.MAX_DELAY_MS)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}

},{"./constants.mjs":"4RAEE","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4RAEE":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_DELAY_MS", ()=>MAX_DELAY_MS);
const MAX_DELAY_MS = 300000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2XUGo":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMZ_SDK_INVOCATION_ID_HEADER", ()=>AMZ_SDK_INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "AMZ_SDK_REQUEST_HEADER", ()=>AMZ_SDK_REQUEST_HEADER);
parcelHelpers.export(exports, "DEFAULT_MAX_DELAY_MS", ()=>DEFAULT_MAX_DELAY_MS);
parcelHelpers.export(exports, "DEFAULT_RETRY_ATTEMPTS", ()=>DEFAULT_RETRY_ATTEMPTS);
const DEFAULT_RETRY_ATTEMPTS = 3;
const AMZ_SDK_INVOCATION_ID_HEADER = 'amz-sdk-invocation-id';
const AMZ_SDK_REQUEST_HEADER = 'amz-sdk-request';
const DEFAULT_MAX_DELAY_MS = 300000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kA0XD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRetryDecider", ()=>getRetryDecider);
var _errorsMjs = require("../../../types/errors.mjs");
var _isClockSkewErrorMjs = require("./isClockSkewError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const getRetryDecider = (errorParser)=>async (response, error)=>{
        var _ref;
        const parsedError = (_ref = error !== null && error !== void 0 ? error : await errorParser(response)) !== null && _ref !== void 0 ? _ref : undefined;
        const errorCode = (parsedError === null || parsedError === void 0 ? void 0 : parsedError.code) || (parsedError === null || parsedError === void 0 ? void 0 : parsedError.name);
        const statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
        const isRetryable = isConnectionError(error) || isThrottlingError(statusCode, errorCode) || (0, _isClockSkewErrorMjs.isClockSkewError)(errorCode) || isServerSideError(statusCode, errorCode);
        return {
            retryable: isRetryable
        };
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const THROTTLING_ERROR_CODES = [
    'BandwidthLimitExceeded',
    'EC2ThrottledException',
    'LimitExceededException',
    'PriorRequestNotComplete',
    'ProvisionedThroughputExceededException',
    'RequestLimitExceeded',
    'RequestThrottled',
    'RequestThrottledException',
    'SlowDown',
    'ThrottledException',
    'Throttling',
    'ThrottlingException',
    'TooManyRequestsException'
];
const TIMEOUT_ERROR_CODES = [
    'TimeoutError',
    'RequestTimeout',
    'RequestTimeoutException'
];
const isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && THROTTLING_ERROR_CODES.includes(errorCode);
const isConnectionError = (error)=>[
        (0, _errorsMjs.AmplifyErrorCode).NetworkError,
        // TODO(vNext): unify the error code `ERR_NETWORK` used by the Storage XHR handler
        'ERR_NETWORK'
    ].includes(error === null || error === void 0 ? void 0 : error.name);
const isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && TIMEOUT_ERROR_CODES.includes(errorCode);

},{"../../../types/errors.mjs":"2tN68","./isClockSkewError.mjs":"7x9qs","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7x9qs":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
const CLOCK_SKEW_ERROR_CODES = [
    'AuthFailure',
    'InvalidSignatureException',
    'RequestExpired',
    'RequestInTheFuture',
    'RequestTimeTooSkewed',
    'SignatureDoesNotMatch',
    'BadRequestException'
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const isClockSkewError = (errorCode)=>!!errorCode && CLOCK_SKEW_ERROR_CODES.includes(errorCode);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"c1WnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoIdentityTransferHandler", ()=>cognitoIdentityTransferHandler);
var _errorsMjs = require("../../../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../../../errors/errorHelpers.mjs");
var _unauthenticatedMjs = require("../../../../../clients/handlers/aws/unauthenticated.mjs");
var _getClientInfoMjs = require("../../../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _errorHelpersMjs1 = require("../../../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs = require("../../../../../Platform/index.mjs");
var _typesMjs = require("../../../../../Platform/types.mjs");
var _typesMjs1 = require("../../../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../../../Reachability/Reachability.mjs");
var _indexMjs1 = require("../../../../../Hub/index.mjs");
var _indexMjs2 = require("../../../../../utils/sessionListener/index.mjs");
var _composeTransferHandlerMjs = require("../../../../../clients/internal/composeTransferHandler.mjs");
var _createDisableCacheMiddlewareMjs = require("../../../middleware/createDisableCacheMiddleware.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const cognitoIdentityTransferHandler = (0, _composeTransferHandlerMjs.composeTransferHandler)((0, _unauthenticatedMjs.unauthenticatedHandler), [
    (0, _createDisableCacheMiddlewareMjs.createDisableCacheMiddleware)
]);

},{"../../../../../types/errors.mjs":"2tN68","../../../../../errors/errorHelpers.mjs":"fvR3Q","../../../../../clients/handlers/aws/unauthenticated.mjs":"64TuP","../../../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../../../utils/retry/retry.mjs":"eFvhH","../../../../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../../../Platform/index.mjs":"34W7w","../../../../../Platform/types.mjs":"8YCjz","../../../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../../../Reachability/Reachability.mjs":"1EGHg","../../../../../Hub/index.mjs":"hkdby","../../../../../utils/sessionListener/index.mjs":"4uBhf","../../../../../clients/internal/composeTransferHandler.mjs":"aXWVV","../../../middleware/createDisableCacheMiddleware.mjs":"6J5ag","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"64TuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unauthenticatedHandler", ()=>unauthenticatedHandler);
var _retryMiddlewareMjs = require("../../middleware/retry/retryMiddleware.mjs");
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../utils/retry/retry.mjs");
var _amzSdkInvocationIdHeaderMiddlewareMjs = require("../../middleware/retry/amzSdkInvocationIdHeaderMiddleware.mjs");
var _amzSdkRequestHeaderMiddlewareMjs = require("../../middleware/retry/amzSdkRequestHeaderMiddleware.mjs");
var _middlewareMjs = require("../../middleware/userAgent/middleware.mjs");
var _composeTransferHandlerMjs = require("../../internal/composeTransferHandler.mjs");
var _fetchMjs = require("../fetch.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const unauthenticatedHandler = (0, _composeTransferHandlerMjs.composeTransferHandler)((0, _fetchMjs.fetchTransferHandler), [
    (0, _middlewareMjs.userAgentMiddlewareFactory),
    (0, _amzSdkInvocationIdHeaderMiddlewareMjs.amzSdkInvocationIdHeaderMiddlewareFactory),
    (0, _retryMiddlewareMjs.retryMiddlewareFactory),
    (0, _amzSdkRequestHeaderMiddlewareMjs.amzSdkRequestHeaderMiddlewareFactory)
]);

},{"../../middleware/retry/retryMiddleware.mjs":"iHnIY","../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../utils/retry/retry.mjs":"eFvhH","../../middleware/retry/amzSdkInvocationIdHeaderMiddleware.mjs":"ojiJg","../../middleware/retry/amzSdkRequestHeaderMiddleware.mjs":"hvueN","../../middleware/userAgent/middleware.mjs":"e6W9O","../../internal/composeTransferHandler.mjs":"aXWVV","../fetch.mjs":"eMjmx","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iHnIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddlewareFactory", ()=>retryMiddlewareFactory);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _constantsMjs = require("./constants.mjs");
/**
 * Middleware that executes the retry logic.
 */ const retryMiddlewareFactory = ({ maxAttempts = (0, _constantsMjs.DEFAULT_RETRY_ATTEMPTS), retryDecider, computeDelay, abortSignal })=>{
    if (maxAttempts < 1) throw new Error('maxAttempts must be greater than 0');
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            var _context_attemptsCount;
            let attemptsCount = (_context_attemptsCount = context.attemptsCount) !== null && _context_attemptsCount !== void 0 ? _context_attemptsCount : 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                var _context_attemptsCount1, _context_attemptsCount2;
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = ((_context_attemptsCount1 = context.attemptsCount) !== null && _context_attemptsCount1 !== void 0 ? _context_attemptsCount1 : 0) > attemptsCount ? (_context_attemptsCount2 = context.attemptsCount) !== null && _context_attemptsCount2 !== void 0 ? _context_attemptsCount2 : 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                const { isCredentialsExpiredError, retryable } = await retryDecider(response, error, context);
                if (retryable) {
                    // Setting isCredentialsInvalid flag to notify signing middleware to forceRefresh credentials provider.
                    context.isCredentialsExpired = !!isCredentialsExpiredError;
                    if (!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error('Request aborted.');
            else return handleTerminalErrorOrResponse();
        };
};
const cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener('abort', function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.removeEventListener('abort', cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== '[object Object]') return;
    var _nextHandlerOutput_$metadata;
    nextHandlerOutput.$metadata = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (_nextHandlerOutput_$metadata = nextHandlerOutput.$metadata) !== null && _nextHandlerOutput_$metadata !== void 0 ? _nextHandlerOutput_$metadata : {}), {
        attempts
    });
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","./constants.mjs":"2XUGo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ojiJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "amzSdkInvocationIdHeaderMiddlewareFactory", ()=>amzSdkInvocationIdHeaderMiddlewareFactory);
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../parseAWSExports.mjs");
var _indexMjs = require("../../../utils/amplifyUuid/index.mjs");
var _errorHelpersMjs1 = require("../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs1 = require("../../../Platform/index.mjs");
var _typesMjs = require("../../../Platform/types.mjs");
var _typesMjs1 = require("../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../Reachability/Reachability.mjs");
var _indexMjs2 = require("../../../Hub/index.mjs");
var _indexMjs3 = require("../../../utils/sessionListener/index.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects a UUID string to `amz-sdk-invocation-id` header.
 * if the header is not set already. This header is helpful to provide
 * observability to group the requests caused by automatic retry.
 *
 * This middleware is standalone because of extra UUID dependency, we will
 * NOT use this middleware for API categories.
 *
 * Ref: https://sdk.amazonaws.com/kotlin/api/smithy-kotlin/api/1.0.9/http-client/aws.smithy.kotlin.runtime.http.operation/-http-operation-context/-sdk-invocation-id.html
 */ const amzSdkInvocationIdHeaderMiddlewareFactory = ()=>(next)=>{
        return async function amzSdkInvocationIdHeaderMiddleware(request) {
            if (!request.headers[0, _constantsMjs.AMZ_SDK_INVOCATION_ID_HEADER]) request.headers[0, _constantsMjs.AMZ_SDK_INVOCATION_ID_HEADER] = (0, _indexMjs.amplifyUuid)();
            return next(request);
        };
    };

},{"../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../utils/retry/retry.mjs":"eFvhH","../../../parseAWSExports.mjs":"4w5h9","../../../utils/amplifyUuid/index.mjs":"9DnN6","../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../Platform/index.mjs":"34W7w","../../../Platform/types.mjs":"8YCjz","../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../Reachability/Reachability.mjs":"1EGHg","../../../Hub/index.mjs":"hkdby","../../../utils/sessionListener/index.mjs":"4uBhf","./constants.mjs":"2XUGo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9DnN6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "amplifyUuid", ()=>amplifyUuid);
var _uuid = require("uuid");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const amplifyUuid = (0, _uuid.v4);

},{"uuid":"5L12c","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hvueN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "amzSdkRequestHeaderMiddlewareFactory", ()=>amzSdkRequestHeaderMiddlewareFactory);
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects `amz-sdk-request` header to indicate the retry state at the time an HTTP request is made.
 * This middleware should co-exist with retryMiddleware as it relies on the retryAttempts value in middleware context
 * set by the retry middleware.
 *
 * Example header: `amz-sdk-request: attempt=1; max=3`.
 *
 * This middleware is standalone because of extra headers may conflict with custom endpoint settings(e.g. CORS), we will
 * NOT use this middleware for API categories.
 */ const amzSdkRequestHeaderMiddlewareFactory = ({ maxAttempts = (0, _constantsMjs.DEFAULT_RETRY_ATTEMPTS) })=>(next, context)=>{
        return async function amzSdkRequestHeaderMiddleware(request) {
            var _context_attemptsCount;
            const attemptsCount = (_context_attemptsCount = context.attemptsCount) !== null && _context_attemptsCount !== void 0 ? _context_attemptsCount : 0;
            request.headers[0, _constantsMjs.AMZ_SDK_REQUEST_HEADER] = `attempt=${attemptsCount + 1}; max=${maxAttempts}`;
            return next(request);
        };
    };

},{"./constants.mjs":"2XUGo","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"e6W9O":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddlewareFactory", ()=>userAgentMiddlewareFactory);
const userAgentMiddlewareFactory = ({ userAgentHeader = 'x-amz-user-agent', userAgentValue = '' })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aXWVV":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeTransferHandler", ()=>composeTransferHandler);
const composeTransferHandler = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eMjmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTransferHandler", ()=>fetchTransferHandler);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _amplifyErrorMjs = require("../../errors/AmplifyError.mjs");
var _errorsMjs = require("../../types/errors.mjs");
var _errorHelpersMjs = require("../../errors/errorHelpers.mjs");
var _memoizationMjs = require("../utils/memoization.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const shouldSendBody = (method)=>![
        'HEAD',
        'GET'
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const fetchTransferHandler = async ({ url, method, headers, body }, { abortSignal, cache, withCrossDomainCredentials })=>{
    var _resp_headers;
    let resp;
    try {
        resp = await fetch(url, {
            method,
            headers,
            body: shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache,
            credentials: withCrossDomainCredentials ? 'include' : 'same-origin'
        });
    } catch (e) {
        if (e instanceof TypeError) throw new (0, _amplifyErrorMjs.AmplifyError)({
            name: (0, _errorsMjs.AmplifyErrorCode).NetworkError,
            message: 'A network error has occurred.',
            underlyingError: e
        });
        throw e;
    }
    const responseHeaders = {};
    (_resp_headers = resp.headers) === null || _resp_headers === void 0 ? void 0 : _resp_headers.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    var _resp_body;
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign((_resp_body = resp.body) !== null && _resp_body !== void 0 ? _resp_body : {}, {
        text: (0, _memoizationMjs.withMemoization)(()=>resp.text()),
        blob: (0, _memoizationMjs.withMemoization)(()=>resp.blob()),
        json: (0, _memoizationMjs.withMemoization)(()=>resp.json())
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, httpResponse), {
        body: bodyWithMixin
    });
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../../errors/AmplifyError.mjs":"9LcuL","../../types/errors.mjs":"2tN68","../../errors/errorHelpers.mjs":"fvR3Q","../utils/memoization.mjs":"2wQb5","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2wQb5":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withMemoization", ()=>withMemoization);
const withMemoization = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6J5ag":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDisableCacheMiddleware", ()=>createDisableCacheMiddleware);
const createDisableCacheMiddleware = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers['cache-control'] = 'no-store';
            return next(request);
        };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7zIMc":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildHttpRpcRequest", ()=>buildHttpRpcRequest);
parcelHelpers.export(exports, "createClientSerializer", ()=>createClientSerializer);
const createClientSerializer = (operation)=>(input, endpoint)=>{
        const headers = getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return buildHttpRpcRequest(endpoint, headers, body);
    };
const getSharedHeaders = (operation)=>({
        'content-type': 'application/x-amz-json-1.1',
        'x-amz-target': `AWSCognitoIdentityService.${operation}`
    });
const buildHttpRpcRequest = ({ url }, headers, body)=>({
        headers,
        url,
        body,
        method: 'POST'
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lNTH7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetIdClient", ()=>createGetIdClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _errorsMjs = require("../../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _errorHelpersMjs1 = require("../../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs = require("../../../../Platform/index.mjs");
var _typesMjs = require("../../../../Platform/types.mjs");
var _typesMjs1 = require("../../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../../Reachability/Reachability.mjs");
var _indexMjs1 = require("../../../../Hub/index.mjs");
var _indexMjs2 = require("../../../../utils/sessionListener/index.mjs");
var _responseInfoMjs = require("../../../../clients/serde/responseInfo.mjs");
var _jsonMjs = require("../../../../clients/serde/json.mjs");
var _composeServiceApiMjs = require("../../../../clients/internal/composeServiceApi.mjs");
var _constantsMjs = require("./constants.mjs");
var _cognitoIdentityTransferHandlerMjs = require("./handler/cognitoIdentityTransferHandler.mjs");
var _createClientSerializerMjs = require("./serde/createClientSerializer.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createGetIdClient = (config)=>(0, _composeServiceApiMjs.composeServiceApi)((0, _cognitoIdentityTransferHandlerMjs.cognitoIdentityTransferHandler), (0, _createClientSerializerMjs.createClientSerializer)('GetId'), getIdDeserializer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config), {
        userAgentValue: (0, _indexMjs.getAmplifyUserAgent)()
    }));
const getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, _jsonMjs.parseJsonError)(response);
        throw error;
    }
    const body = await (0, _jsonMjs.parseJsonBody)(response);
    return {
        IdentityId: body.IdentityId,
        $metadata: (0, _responseInfoMjs.parseMetadata)(response)
    };
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../../../../types/errors.mjs":"2tN68","../../../../errors/errorHelpers.mjs":"fvR3Q","../../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../../utils/retry/retry.mjs":"eFvhH","../../../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../../Platform/index.mjs":"34W7w","../../../../Platform/types.mjs":"8YCjz","../../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../../Reachability/Reachability.mjs":"1EGHg","../../../../Hub/index.mjs":"hkdby","../../../../utils/sessionListener/index.mjs":"4uBhf","../../../../clients/serde/responseInfo.mjs":"88PMJ","../../../../clients/serde/json.mjs":"1pZXC","../../../../clients/internal/composeServiceApi.mjs":"cUdLo","./constants.mjs":"9Q8ds","./handler/cognitoIdentityTransferHandler.mjs":"c1WnZ","./serde/createClientSerializer.mjs":"7zIMc","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fDu4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoIdentityPoolEndpointResolver", ()=>cognitoIdentityPoolEndpointResolver);
var _getDnsSuffixMjs = require("../../../../clients/endpoints/getDnsSuffix.mjs");
var _errorsMjs = require("../../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _indexMjs = require("../../../../utils/amplifyUrl/index.mjs");
var _errorHelpersMjs1 = require("../../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs1 = require("../../../../Platform/index.mjs");
var _typesMjs = require("../../../../Platform/types.mjs");
var _typesMjs1 = require("../../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../../Reachability/Reachability.mjs");
var _indexMjs2 = require("../../../../Hub/index.mjs");
var _indexMjs3 = require("../../../../utils/sessionListener/index.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const cognitoIdentityPoolEndpointResolver = ({ region })=>({
        url: new (0, _indexMjs.AmplifyUrl)(`https://${(0, _constantsMjs.COGNITO_IDENTITY_SERVICE_NAME)}.${region}.${(0, _getDnsSuffixMjs.getDnsSuffix)(region)}`)
    });

},{"../../../../clients/endpoints/getDnsSuffix.mjs":"5u4oS","../../../../types/errors.mjs":"2tN68","../../../../errors/errorHelpers.mjs":"fvR3Q","../../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../../utils/retry/retry.mjs":"eFvhH","../../../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../../../utils/amplifyUrl/index.mjs":"4l1t5","../../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../../Platform/index.mjs":"34W7w","../../../../Platform/types.mjs":"8YCjz","../../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../../Reachability/Reachability.mjs":"1EGHg","../../../../Hub/index.mjs":"hkdby","../../../../utils/sessionListener/index.mjs":"4uBhf","./constants.mjs":"9Q8ds","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5u4oS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>getDnsSuffix);
var _partitionsMjs = require("./partitions.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const getDnsSuffix = (region)=>{
    const { partitions } = (0, _partitionsMjs.partitionsInfo);
    for (const { regions, outputs, regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, _partitionsMjs.defaultPartition).outputs.dnsSuffix;
};

},{"./partitions.mjs":"6BFe8","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6BFe8":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPartition", ()=>defaultPartition);
parcelHelpers.export(exports, "partitionsInfo", ()=>partitionsInfo);
const defaultPartition = {
    id: 'aws',
    outputs: {
        dnsSuffix: 'amazonaws.com'
    },
    regionRegex: '^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$',
    regions: [
        'aws-global'
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const partitionsInfo = {
    partitions: [
        defaultPartition,
        {
            id: 'aws-cn',
            outputs: {
                dnsSuffix: 'amazonaws.com.cn'
            },
            regionRegex: '^cn\\-\\w+\\-\\d+$',
            regions: [
                'aws-cn-global'
            ]
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4l1t5":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyUrl", ()=>AmplifyUrl);
parcelHelpers.export(exports, "AmplifyUrlSearchParams", ()=>AmplifyUrlSearchParams);
const AmplifyUrl = URL;
const AmplifyUrlSearchParams = URLSearchParams;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cXhBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _cookieStorageMjs.CookieStorage));
parcelHelpers.export(exports, "defaultStorage", ()=>defaultStorage);
parcelHelpers.export(exports, "sessionStorage", ()=>sessionStorage);
parcelHelpers.export(exports, "sharedInMemoryStorage", ()=>sharedInMemoryStorage);
parcelHelpers.export(exports, "syncSessionStorage", ()=>syncSessionStorage);
var _defaultStorageMjs = require("./DefaultStorage.mjs");
var _inMemoryStorageMjs = require("./InMemoryStorage.mjs");
var _keyValueStorageMjs = require("./KeyValueStorage.mjs");
var _sessionStorageMjs = require("./SessionStorage.mjs");
var _syncSessionStorageMjs = require("./SyncSessionStorage.mjs");
var _cookieStorageMjs = require("./CookieStorage.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const defaultStorage = new (0, _defaultStorageMjs.DefaultStorage)();
const sessionStorage = new (0, _sessionStorageMjs.SessionStorage)();
const syncSessionStorage = new (0, _syncSessionStorageMjs.SyncSessionStorage)();
const sharedInMemoryStorage = new (0, _keyValueStorageMjs.KeyValueStorage)(new (0, _inMemoryStorageMjs.InMemoryStorage)());

},{"./DefaultStorage.mjs":"9NTZf","./InMemoryStorage.mjs":"kALAd","./KeyValueStorage.mjs":"4rIUr","./SessionStorage.mjs":"7ewNs","./SyncSessionStorage.mjs":"eKlvZ","./CookieStorage.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9NTZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultStorage", ()=>DefaultStorage);
var _keyValueStorageMjs = require("./KeyValueStorage.mjs");
var _utilsMjs = require("./utils.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class DefaultStorage extends (0, _keyValueStorageMjs.KeyValueStorage) {
    constructor(){
        super((0, _utilsMjs.getLocalStorageWithFallback)());
    }
}

},{"./KeyValueStorage.mjs":"4rIUr","./utils.mjs":"aGjXp","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4rIUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyValueStorage", ()=>KeyValueStorage);
var _platformNotSupportedErrorMjs = require("../errors/PlatformNotSupportedError.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class KeyValueStorage {
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, _platformNotSupportedErrorMjs.PlatformNotSupportedError)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, _platformNotSupportedErrorMjs.PlatformNotSupportedError)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, _platformNotSupportedErrorMjs.PlatformNotSupportedError)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, _platformNotSupportedErrorMjs.PlatformNotSupportedError)();
        this.storage.clear();
    }
    constructor(storage){
        this.storage = storage;
    }
}

},{"../errors/PlatformNotSupportedError.mjs":"keBB5","../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"keBB5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlatformNotSupportedError", ()=>PlatformNotSupportedError);
var _errorsMjs = require("../types/errors.mjs");
var _amplifyErrorMjs = require("./AmplifyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class PlatformNotSupportedError extends (0, _amplifyErrorMjs.AmplifyError) {
    constructor(){
        super({
            name: (0, _errorsMjs.AmplifyErrorCode).PlatformNotSupported,
            message: 'Function not supported on current platform'
        });
    }
}

},{"../types/errors.mjs":"2tN68","./AmplifyError.mjs":"9LcuL","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aGjXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocalStorageWithFallback", ()=>getLocalStorageWithFallback);
parcelHelpers.export(exports, "getSessionStorageWithFallback", ()=>getSessionStorageWithFallback);
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
var _inMemoryStorageMjs = require("./InMemoryStorage.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('CoreStorageUtils');
const getLocalStorageWithFallback = ()=>{
    try {
        // Attempt to use localStorage directly
        if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
    } catch (e) {
        // Handle any errors related to localStorage access
        logger.info('localStorage not found. InMemoryStorage is used as a fallback.');
    }
    // Return in-memory storage as a fallback if localStorage is not accessible
    return new (0, _inMemoryStorageMjs.InMemoryStorage)();
};
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const getSessionStorageWithFallback = ()=>{
    try {
        // Attempt to use sessionStorage directly
        if (typeof window !== 'undefined' && window.sessionStorage) {
            // Verify we can actually use it by testing access
            window.sessionStorage.getItem('test');
            return window.sessionStorage;
        }
        throw new Error('sessionStorage is not defined');
    } catch (e) {
        // Handle any errors related to sessionStorage access
        logger.info('sessionStorage not found. InMemoryStorage is used as a fallback.');
        return new (0, _inMemoryStorageMjs.InMemoryStorage)();
    }
};

},{"../Logger/ConsoleLogger.mjs":"6OFOw","./InMemoryStorage.mjs":"kALAd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kALAd":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStorage", ()=>InMemoryStorage);
class InMemoryStorage {
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        var _this_storage_get;
        return (_this_storage_get = this.storage.get(key)) !== null && _this_storage_get !== void 0 ? _this_storage_get : null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
    constructor(){
        this.storage = new Map();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7ewNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionStorage", ()=>SessionStorage);
var _keyValueStorageMjs = require("./KeyValueStorage.mjs");
var _utilsMjs = require("./utils.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class SessionStorage extends (0, _keyValueStorageMjs.KeyValueStorage) {
    constructor(){
        super((0, _utilsMjs.getSessionStorageWithFallback)());
    }
}

},{"./KeyValueStorage.mjs":"4rIUr","./utils.mjs":"aGjXp","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eKlvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncSessionStorage", ()=>SyncSessionStorage);
var _syncKeyValueStorageMjs = require("./SyncKeyValueStorage.mjs");
var _utilsMjs = require("./utils.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class SyncSessionStorage extends (0, _syncKeyValueStorageMjs.SyncKeyValueStorage) {
    constructor(){
        super((0, _utilsMjs.getSessionStorageWithFallback)());
    }
}

},{"./SyncKeyValueStorage.mjs":"eemI6","./utils.mjs":"aGjXp","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eemI6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncKeyValueStorage", ()=>SyncKeyValueStorage);
var _platformNotSupportedErrorMjs = require("../errors/PlatformNotSupportedError.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class SyncKeyValueStorage {
    get storage() {
        if (!this._storage) throw new (0, _platformNotSupportedErrorMjs.PlatformNotSupportedError)();
        return this._storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ setItem(key, value) {
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ getItem(key) {
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ removeItem(key) {
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ clear() {
        this.storage.clear();
    }
    constructor(storage){
        this._storage = storage;
    }
}

},{"../errors/PlatformNotSupportedError.mjs":"keBB5","../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ghdeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieStorage", ()=>CookieStorage);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class CookieStorage {
    async setItem(key, value) {
        (0, _jsCookieDefault.default).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, _jsCookieDefault.default).get(key);
        return item !== null && item !== void 0 ? item : null;
    }
    async removeItem(key) {
        (0, _jsCookieDefault.default).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, _jsCookieDefault.default).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return (0, _objectSpread._)({
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        }, this.sameSite && {
            sameSite: this.sameSite
        });
    }
    constructor(data = {}){
        const { path, domain, expires, sameSite, secure } = data;
        this.domain = domain;
        this.path = path || '/';
        this.expires = Object.prototype.hasOwnProperty.call(data, 'expires') ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, 'secure') ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (!sameSite || ![
                'strict',
                'lax',
                'none'
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = sameSite;
        }
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","js-cookie":"3uW5j","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3uW5j":[function(require,module,exports,__globalThis) {
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});

},{}],"jU1bK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cache", ()=>Cache);
var _storageCacheMjs = require("./StorageCache.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const Cache = new (0, _storageCacheMjs.StorageCache)();

},{"./StorageCache.mjs":"3AuuV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3AuuV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageCache", ()=>StorageCache);
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
var _keyValueStorageMjs = require("../storage/KeyValueStorage.mjs");
var _utilsMjs = require("../storage/utils.mjs");
var _constantsMjs = require("./constants.mjs");
var _storageCacheCommonMjs = require("./StorageCacheCommon.mjs");
var _cacheHelpersMjs = require("./utils/cacheHelpers.mjs");
var _errorHelpersMjs = require("./utils/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('StorageCache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ class StorageCache extends (0, _storageCacheCommonMjs.StorageCacheCommon) {
    async getAllCacheKeys(options) {
        const { omitSizeKey } = options !== null && options !== void 0 ? options : {};
        const keys = [];
        for(let i = 0; i < this.storage.length; i++){
            const key = this.storage.key(i);
            if (omitSizeKey && key === (0, _cacheHelpersMjs.getCurrentSizeKey)(this.config.keyPrefix)) continue;
            if (key === null || key === void 0 ? void 0 : key.startsWith(this.config.keyPrefix)) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    }
    /**
     * Return a new instance of cache with customized configuration.
     * @param {Object} config - the customized configuration
     * @return {Object} - the new instance of Cache
     */ createInstance(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, _constantsMjs.defaultConfig).keyPrefix) {
            logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = (0, _cacheHelpersMjs.getCurrentTime).toString();
        }
        return new StorageCache(config);
    }
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ constructor(config){
        const storage = (0, _utilsMjs.getLocalStorageWithFallback)();
        super({
            config,
            keyValueStorage: new (0, _keyValueStorageMjs.KeyValueStorage)(storage)
        });
        this.storage = storage;
        this.getItem = this.getItem.bind(this);
        this.setItem = this.setItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }
}

},{"../Logger/ConsoleLogger.mjs":"6OFOw","../storage/KeyValueStorage.mjs":"4rIUr","../storage/utils.mjs":"aGjXp","./constants.mjs":"1e5Wi","./StorageCacheCommon.mjs":"4gUNs","./utils/cacheHelpers.mjs":"aAeUi","./utils/errorHelpers.mjs":"9L7XY","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1e5Wi":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default cache config
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "currentSizeKey", ()=>currentSizeKey);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
const defaultConfig = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8
};
const currentSizeKey = 'CurSize';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4gUNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageCacheCommon", ()=>StorageCacheCommon);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
var _constantsMjs = require("./constants.mjs");
var _cacheHelpersMjs = require("./utils/cacheHelpers.mjs");
var _errorHelpersMjs = require("./utils/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('StorageCache');
/**
 * Initialization of the cache
 *
 */ class StorageCacheCommon {
    getModuleName() {
        return 'Cache';
    }
    /**
     * Set custom configuration for the cache instance.
     *
     * @param config - customized configuration (without keyPrefix, which can't be changed)
     *
     * @return - the current configuration
     */ configure(config) {
        if (config) {
            if (config.keyPrefix) logger.warn('keyPrefix can not be re-configured on an existing Cache instance.');
            this.config = (0, _objectSpread._)({}, this.config, config);
        }
        this.sanitizeConfig();
        return this.config;
    }
    /**
     * return the current size of the cache
     * @return {Promise}
     */ async getCurrentCacheSize() {
        let size = await this.getStorage().getItem((0, _cacheHelpersMjs.getCurrentSizeKey)(this.config.keyPrefix));
        if (!size) {
            await this.getStorage().setItem((0, _cacheHelpersMjs.getCurrentSizeKey)(this.config.keyPrefix), '0');
            size = '0';
        }
        return Number(size);
    }
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param {String} key - the key of the item
     * @param {Object} value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     *
     * @return {Promise}
     */ async setItem(key, value, options) {
        logger.debug(`Set item: key is ${key}, value is ${value} with options: ${options}`);
        if (!key || key === (0, _constantsMjs.currentSizeKey)) {
            logger.warn(`Invalid key: should not be empty or reserved key: '${(0, _constantsMjs.currentSizeKey)}'`);
            return;
        }
        if (typeof value === 'undefined') {
            logger.warn(`The value of item should not be undefined!`);
            return;
        }
        const cacheItemOptions = {
            priority: (options === null || options === void 0 ? void 0 : options.priority) !== undefined ? options.priority : this.config.defaultPriority,
            expires: (options === null || options === void 0 ? void 0 : options.expires) !== undefined ? options.expires : this.config.defaultTTL + (0, _cacheHelpersMjs.getCurrentTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn(`Invalid parameter: priority due to out or range. It should be within 1 and 5.`);
            return;
        }
        const prefixedKey = `${this.config.keyPrefix}${key}`;
        const item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check whether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn(`Item with key: ${key} you are trying to put into is too big!`);
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            const val = await this.getStorage().getItem(prefixedKey);
            if (val) await this.removeCacheItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (await this.isCacheFull(item.byteSize)) {
                const validKeys = await this.clearInvalidAndGetRemainingKeys();
                if (await this.isCacheFull(item.byteSize)) {
                    const sizeToPop = await this.sizeToPop(item.byteSize);
                    await this.popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            return this.setCacheItem(prefixedKey, item);
        } catch (e) {
            logger.warn(`setItem failed! ${e}`);
        }
    }
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with AsyncStorage
     *
     * @param {String} key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return {Promise} - return a promise resolves to be the value of the item
     */ async getItem(key, options) {
        logger.debug(`Get item: key is ${key} with options ${options}`);
        let cached;
        if (!key || key === (0, _constantsMjs.currentSizeKey)) {
            logger.warn(`Invalid key: should not be empty or reserved key: '${(0, _constantsMjs.currentSizeKey)}'`);
            return null;
        }
        const prefixedKey = `${this.config.keyPrefix}${key}`;
        try {
            cached = await this.getStorage().getItem(prefixedKey);
            if (cached != null) {
                if (await this.isExpired(prefixedKey)) // if expired, remove that item and return null
                await this.removeCacheItem(prefixedKey, JSON.parse(cached).byteSize);
                else {
                    // if not expired, update its visitedTime and return the value
                    const item = await this.updateVisitedTime(JSON.parse(cached), prefixedKey);
                    return item.data;
                }
            }
            if (options === null || options === void 0 ? void 0 : options.callback) {
                const val = options.callback();
                if (val !== null) await this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            logger.warn(`getItem failed! ${e}`);
            return null;
        }
    }
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with AsyncStorage
     * @param {String} key - the key of the item
     * @return {Promise}
     */ async removeItem(key) {
        logger.debug(`Remove item: key is ${key}`);
        if (!key || key === (0, _constantsMjs.currentSizeKey)) {
            logger.warn(`Invalid key: should not be empty or reserved key: '${(0, _constantsMjs.currentSizeKey)}'`);
            return;
        }
        const prefixedKey = `${this.config.keyPrefix}${key}`;
        try {
            const val = await this.getStorage().getItem(prefixedKey);
            if (val) await this.removeCacheItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            logger.warn(`removeItem failed! ${e}`);
        }
    }
    /**
     * Return all the keys owned by this cache.
     * Will return an empty array if error occurred.
     *
     * @return {Promise}
     */ async getAllKeys() {
        try {
            return await this.getAllCacheKeys();
        } catch (e) {
            logger.warn(`getAllkeys failed! ${e}`);
            return [];
        }
    }
    getStorage() {
        return this.keyValueStorage;
    }
    /**
     * check whether item is expired
     *
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ async isExpired(key) {
        const text = await this.getStorage().getItem(key);
        (0, _errorHelpersMjs.assert)(text !== null, (0, _errorHelpersMjs.CacheErrorCode).NoCacheItem, `Key: ${key}`);
        const item = JSON.parse(text);
        if ((0, _cacheHelpersMjs.getCurrentTime)() >= item.expires) return true;
        return false;
    }
    /**
     * delete item from cache
     *
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ async removeCacheItem(prefixedKey, size) {
        const item = await this.getStorage().getItem(prefixedKey);
        (0, _errorHelpersMjs.assert)(item !== null, (0, _errorHelpersMjs.CacheErrorCode).NoCacheItem, `Key: ${prefixedKey}`);
        const itemSize = size !== null && size !== void 0 ? size : JSON.parse(item).byteSize;
        // first try to update the current size of the cache
        await this.decreaseCurrentSizeInBytes(itemSize);
        // try to remove the item from cache
        try {
            await this.getStorage().removeItem(prefixedKey);
        } catch (removeItemError) {
            // if some error happened, we need to rollback the current size
            await this.increaseCurrentSizeInBytes(itemSize);
            logger.error(`Failed to remove item: ${removeItemError}`);
        }
    }
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ fillCacheItem(key, value, options) {
        var _options_priority, _options_expires;
        const item = {
            key,
            data: value,
            timestamp: (0, _cacheHelpersMjs.getCurrentTime)(),
            visitedTime: (0, _cacheHelpersMjs.getCurrentTime)(),
            priority: (_options_priority = options.priority) !== null && _options_priority !== void 0 ? _options_priority : 0,
            expires: (_options_expires = options.expires) !== null && _options_expires !== void 0 ? _options_expires : 0,
            type: typeof value,
            byteSize: 0
        };
        // calculate byte size
        item.byteSize = (0, _cacheHelpersMjs.getByteLength)(JSON.stringify(item));
        // re-calculate using cache item with updated byteSize property
        item.byteSize = (0, _cacheHelpersMjs.getByteLength)(JSON.stringify(item));
        return item;
    }
    sanitizeConfig() {
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = (0, _constantsMjs.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = (0, _constantsMjs.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = (0, _constantsMjs.defaultConfig).warningThreshold;
        }
        // Set 5MB limit
        const cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = (0, _constantsMjs.defaultConfig).capacityInBytes;
        }
    }
    /**
     * increase current size of the cache
     *
     * @param amount - the amount of the cache szie which need to be increased
     */ async increaseCurrentSizeInBytes(amount) {
        const size = await this.getCurrentCacheSize();
        await this.getStorage().setItem((0, _cacheHelpersMjs.getCurrentSizeKey)(this.config.keyPrefix), (size + amount).toString());
    }
    /**
     * decrease current size of the cache
     *
     * @param amount - the amount of the cache size which needs to be decreased
     */ async decreaseCurrentSizeInBytes(amount) {
        const size = await this.getCurrentCacheSize();
        await this.getStorage().setItem((0, _cacheHelpersMjs.getCurrentSizeKey)(this.config.keyPrefix), (size - amount).toString());
    }
    /**
     * update the visited time if item has been visited
     *
     * @param item - the item which need to be updated
     * @param prefixedKey - the key of the item
     *
     * @return the updated item
     */ async updateVisitedTime(item, prefixedKey) {
        item.visitedTime = (0, _cacheHelpersMjs.getCurrentTime)();
        await this.getStorage().setItem(prefixedKey, JSON.stringify(item));
        return item;
    }
    /**
     * put item into cache
     *
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ async setCacheItem(prefixedKey, item) {
        // first try to update the current size of the cache.
        await this.increaseCurrentSizeInBytes(item.byteSize);
        // try to add the item into cache
        try {
            await this.getStorage().setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if some error happened, we need to rollback the current size
            await this.decreaseCurrentSizeInBytes(item.byteSize);
            logger.error(`Failed to set item ${setItemErr}`);
        }
    }
    /**
     * total space needed when poping out items
     *
     * @param itemSize
     *
     * @return total space needed
     */ async sizeToPop(itemSize) {
        const cur = await this.getCurrentCacheSize();
        const spaceItemNeed = cur + itemSize - this.config.capacityInBytes;
        const cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    }
    /**
     * see whether cache is full
     *
     * @param itemSize
     *
     * @return true if cache is full
     */ async isCacheFull(itemSize) {
        const cur = await this.getCurrentCacheSize();
        return itemSize + cur > this.config.capacityInBytes;
    }
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ async popOutItems(keys, sizeToPop) {
        const items = [];
        let remainedSize = sizeToPop;
        for (const key of keys){
            const val = await this.getStorage().getItem(key);
            if (val != null) {
                const item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort((a, b)=>{
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for (const item of items){
            // pop out items until we have enough room for new item
            await this.removeCacheItem(item.key, item.byteSize);
            remainedSize -= item.byteSize;
            if (remainedSize <= 0) return;
        }
    }
    /**
     * Scan the storage and combine the following operations for efficiency
     *   1. Clear out all expired keys owned by this cache, not including the size key.
     *   2. Return the remaining keys.
     *
     * @return The remaining valid keys
     */ async clearInvalidAndGetRemainingKeys() {
        const remainingKeys = [];
        const keys = await this.getAllCacheKeys({
            omitSizeKey: true
        });
        for (const key of keys)if (await this.isExpired(key)) await this.removeCacheItem(key);
        else remainingKeys.push(key);
        return remainingKeys;
    }
    /**
     * clear the entire cache
     * The cache will abort and output a warning if error occurs
     * @return {Promise}
     */ async clear() {
        logger.debug(`Clear Cache`);
        try {
            const keys = await this.getAllKeys();
            for (const key of keys){
                const prefixedKey = `${this.config.keyPrefix}${key}`;
                await this.getStorage().removeItem(prefixedKey);
            }
        } catch (e) {
            logger.warn(`clear failed! ${e}`);
        }
    }
    /**
     * Initialize the cache
     *
     * @param config - Custom configuration for this instance.
     */ constructor({ config, keyValueStorage }){
        this.config = (0, _objectSpread._)({}, (0, _constantsMjs.defaultConfig), config);
        this.keyValueStorage = keyValueStorage;
        this.sanitizeConfig();
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","../Logger/ConsoleLogger.mjs":"6OFOw","./constants.mjs":"1e5Wi","./utils/cacheHelpers.mjs":"aAeUi","./utils/errorHelpers.mjs":"9L7XY","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aAeUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getByteLength", ()=>getByteLength);
parcelHelpers.export(exports, "getCurrentSizeKey", ()=>getCurrentSizeKey);
parcelHelpers.export(exports, "getCurrentTime", ()=>getCurrentTime);
parcelHelpers.export(exports, "isInteger", ()=>isInteger);
var _constantsMjs = require("../constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * return the byte size of the string
 * @param str
 */ function getByteLength(str) {
    let ret = 0;
    ret = str.length;
    for(let i = str.length; i >= 0; i -= 1){
        const charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
/**
 * get current time
 */ function getCurrentTime() {
    const currentTime = new Date();
    return currentTime.getTime();
}
/**
 * check if passed value is an integer
 */ function isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
const getCurrentSizeKey = (keyPrefix)=>`${keyPrefix}${0, _constantsMjs.currentSizeKey}`;

},{"../constants.mjs":"1e5Wi","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9L7XY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheErrorCode", ()=>CacheErrorCode);
parcelHelpers.export(exports, "assert", ()=>assert);
var _createAssertionFunctionMjs = require("../../errors/createAssertionFunction.mjs");
var _errorsMjs = require("../../types/errors.mjs");
var _errorHelpersMjs = require("../../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var CacheErrorCode;
(function(CacheErrorCode) {
    CacheErrorCode["NoCacheItem"] = "NoCacheItem";
    CacheErrorCode["NullNextNode"] = "NullNextNode";
    CacheErrorCode["NullPreviousNode"] = "NullPreviousNode";
})(CacheErrorCode || (CacheErrorCode = {}));
const cacheErrorMap = {
    [CacheErrorCode.NoCacheItem]: {
        message: 'Item not found in the cache storage.'
    },
    [CacheErrorCode.NullNextNode]: {
        message: 'Next node is null.'
    },
    [CacheErrorCode.NullPreviousNode]: {
        message: 'Previous node is null.'
    }
};
const assert = (0, _createAssertionFunctionMjs.createAssertionFunction)(cacheErrorMap);

},{"../../errors/createAssertionFunction.mjs":"lBq8c","../../types/errors.mjs":"2tN68","../../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"845dP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
var _i18NMjs = require("./I18n.mjs");
var _errorHelpersMjs = require("./errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('I18n');
let _config = {
    language: null
};
let _i18n = null;
/**
 * Export I18n APIs
 */ class I18n {
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ static configure(config) {
        logger.debug('configure I18n');
        if (!config) return _config;
        _config = Object.assign({}, _config, config.I18n || config);
        I18n.createInstance();
        return _config;
    }
    static getModuleName() {
        return 'I18n';
    }
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ static createInstance() {
        logger.debug('create I18n instance');
        if (_i18n) return;
        _i18n = new (0, _i18NMjs.I18n)();
    }
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ static setLanguage(lang) {
        I18n.checkConfig();
        (0, _errorHelpersMjs.assert)(!!_i18n, (0, _errorHelpersMjs.I18nErrorCode).NotConfigured);
        _i18n.setLanguage(lang);
    }
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ static get(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        (0, _errorHelpersMjs.assert)(!!_i18n, (0, _errorHelpersMjs.I18nErrorCode).NotConfigured);
        return _i18n.get(key, defVal);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ static putVocabulariesForLanguage(language, vocabularies) {
        I18n.checkConfig();
        (0, _errorHelpersMjs.assert)(!!_i18n, (0, _errorHelpersMjs.I18nErrorCode).NotConfigured);
        _i18n.putVocabulariesForLanguage(language, vocabularies);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ static putVocabularies(vocabularies) {
        I18n.checkConfig();
        (0, _errorHelpersMjs.assert)(!!_i18n, (0, _errorHelpersMjs.I18nErrorCode).NotConfigured);
        _i18n.putVocabularies(vocabularies);
    }
    static checkConfig() {
        if (!_i18n) I18n.createInstance();
        return true;
    }
}
// Create an instance of I18n in the static class
I18n.createInstance();

},{"../Logger/ConsoleLogger.mjs":"6OFOw","./I18n.mjs":"f3BV5","./errorHelpers.mjs":"3rZAF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"f3BV5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n$1);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('I18n');
/**
 * Language translation utility.
 */ let I18n$1 = class I18n {
    /**
     * Sets the default language from the configuration when required.
     */ setDefaultLanguage() {
        // Default to window language if not set in instance
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ setLanguage(lang) {
        this._lang = lang;
    }
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ get(key, defVal) {
        this.setDefaultLanguage();
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        const lang = this._lang;
        let val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    }
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ getByLanguage(key, language, defVal = null) {
        if (!language) return defVal;
        const langDict = this._dict[language];
        if (!langDict) return defVal;
        return langDict[key];
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ putVocabulariesForLanguage(language, vocabularies) {
        let langDict = this._dict[language];
        if (!langDict) langDict = this._dict[language] = {};
        this._dict[language] = (0, _objectSpread._)({}, langDict, vocabularies);
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ putVocabularies(vocabularies) {
        Object.keys(vocabularies).forEach((key)=>{
            this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    }
    constructor(){
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
    }
};

},{"@swc/helpers/_/_object_spread":"PGIdx","../Logger/ConsoleLogger.mjs":"6OFOw","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3rZAF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nErrorCode", ()=>I18nErrorCode);
parcelHelpers.export(exports, "assert", ()=>assert);
var _createAssertionFunctionMjs = require("../errors/createAssertionFunction.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var I18nErrorCode;
(function(I18nErrorCode) {
    I18nErrorCode["NotConfigured"] = "NotConfigured";
})(I18nErrorCode || (I18nErrorCode = {}));
const i18nErrorMap = {
    [I18nErrorCode.NotConfigured]: {
        message: 'i18n is not configured.'
    }
};
const assert = (0, _createAssertionFunctionMjs.createAssertionFunction)(i18nErrorMap);

},{"../errors/createAssertionFunction.mjs":"lBq8c","../types/errors.mjs":"2tN68","../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4kMAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorkerClass", ()=>ServiceWorkerClass);
var _consoleLoggerMjs = require("../Logger/ConsoleLogger.mjs");
var _amplifyErrorMjs = require("../errors/AmplifyError.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../utils/getClientInfo/getClientInfo.mjs");
var _isBrowserMjs = require("../utils/isBrowser.mjs");
var _retryMjs = require("../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../parseAWSExports.mjs");
var _uuid = require("uuid");
var _errorHelpersMjs1 = require("../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs = require("../Platform/index.mjs");
var _typesMjs = require("../Platform/types.mjs");
var _typesMjs1 = require("../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../Reachability/Reachability.mjs");
var _indexMjs1 = require("../Hub/index.mjs");
var _indexMjs2 = require("../utils/sessionListener/index.mjs");
var _errorHelpersMjs2 = require("../awsClients/pinpoint/errorHelpers.mjs");
var _indexMjs3 = require("../Cache/index.mjs");
var _recordMjs = require("../providers/pinpoint/apis/record.mjs");
var _pinpointEventBufferMjs = require("../providers/pinpoint/utils/PinpointEventBuffer.mjs");
var _errorsMjs1 = require("../providers/pinpoint/types/errors.mjs");
var _amplifyMjs = require("../singleton/Amplify.mjs");
var _fetchAuthSessionMjs = require("../singleton/apis/fetchAuthSession.mjs");
var _errorHelpersMjs3 = require("./errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ class ServiceWorkerClass {
    /**
     * Get the currently active service worker
     */ get serviceWorker() {
        (0, _errorHelpersMjs3.assert)(this._serviceWorker !== undefined, (0, _errorHelpersMjs3.ServiceWorkerErrorCode).UndefinedInstance);
        return this._serviceWorker;
    }
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} filePath Service worker file. Defaults to "/service-worker.js"
     * @param {string} scope The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ register(filePath = '/service-worker.js', scope = '/') {
        this._logger.debug(`registering ${filePath}`);
        this._logger.debug(`registering service worker with scope ${scope}`);
        return new Promise((resolve, reject)=>{
            if (navigator && 'serviceWorker' in navigator) navigator.serviceWorker.register(filePath, {
                scope
            }).then((registration)=>{
                if (registration.installing) this._serviceWorker = registration.installing;
                else if (registration.waiting) this._serviceWorker = registration.waiting;
                else if (registration.active) this._serviceWorker = registration.active;
                this._registration = registration;
                this._setupListeners();
                this._logger.debug(`Service Worker Registration Success: ${registration}`);
                resolve(registration);
            }).catch((error)=>{
                this._logger.debug(`Service Worker Registration Failed ${error}`);
                reject(new (0, _amplifyErrorMjs.AmplifyError)({
                    name: (0, _errorHelpersMjs3.ServiceWorkerErrorCode).Unavailable,
                    message: 'Service Worker not available',
                    underlyingError: error
                }));
            });
            else reject(new (0, _amplifyErrorMjs.AmplifyError)({
                name: (0, _errorHelpersMjs3.ServiceWorkerErrorCode).Unavailable,
                message: 'Service Worker not available'
            }));
        });
    }
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ enablePush(publicKey) {
        (0, _errorHelpersMjs3.assert)(this._registration !== undefined, (0, _errorHelpersMjs3.ServiceWorkerErrorCode).UndefinedRegistration);
        this._publicKey = publicKey;
        return new Promise((resolve, reject)=>{
            if ((0, _isBrowserMjs.isBrowser)()) {
                (0, _errorHelpersMjs3.assert)(this._registration !== undefined, (0, _errorHelpersMjs3.ServiceWorkerErrorCode).UndefinedRegistration);
                this._registration.pushManager.getSubscription().then((subscription)=>{
                    if (subscription) {
                        this._subscription = subscription;
                        this._logger.debug(`User is subscribed to push: ${JSON.stringify(subscription)}`);
                        resolve(subscription);
                    } else {
                        this._logger.debug(`User is NOT subscribed to push`);
                        return this._registration.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: this._urlB64ToUint8Array(publicKey)
                        }).then((pushManagerSubscription)=>{
                            this._subscription = pushManagerSubscription;
                            this._logger.debug(`User subscribed: ${JSON.stringify(pushManagerSubscription)}`);
                            resolve(pushManagerSubscription);
                        }).catch((error)=>{
                            this._logger.error(error);
                        });
                    }
                });
            } else reject(new (0, _amplifyErrorMjs.AmplifyError)({
                name: (0, _errorHelpersMjs3.ServiceWorkerErrorCode).Unavailable,
                message: 'Service Worker not available'
            }));
        });
    }
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ _urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    }
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} message An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ send(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
    }
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ _setupListeners() {
        this.serviceWorker.addEventListener('statechange', async ()=>{
            var _Amplify_getConfig_Analytics;
            const currentState = this.serviceWorker.state;
            this._logger.debug(`ServiceWorker statechange: ${currentState}`);
            var _Amplify_getConfig_Analytics_Pinpoint;
            const { appId, region, bufferSize, flushInterval, flushSize, resendLimit } = (_Amplify_getConfig_Analytics_Pinpoint = (_Amplify_getConfig_Analytics = (0, _amplifyMjs.Amplify).getConfig().Analytics) === null || _Amplify_getConfig_Analytics === void 0 ? void 0 : _Amplify_getConfig_Analytics.Pinpoint) !== null && _Amplify_getConfig_Analytics_Pinpoint !== void 0 ? _Amplify_getConfig_Analytics_Pinpoint : {};
            const { credentials } = await (0, _fetchAuthSessionMjs.fetchAuthSession)();
            if (appId && region && credentials) // Pinpoint is configured, record an event
            (0, _recordMjs.record)({
                appId,
                region,
                category: 'Core',
                credentials,
                bufferSize,
                flushInterval,
                flushSize,
                resendLimit,
                event: {
                    name: 'ServiceWorker',
                    attributes: {
                        state: currentState
                    }
                }
            });
        });
        this.serviceWorker.addEventListener('message', (event)=>{
            this._logger.debug(`ServiceWorker message event: ${event}`);
        });
    }
    constructor(){
        // The AWS Amplify logger
        this._logger = new (0, _consoleLoggerMjs.ConsoleLogger)('ServiceWorker');
    }
}

},{"../Logger/ConsoleLogger.mjs":"6OFOw","../errors/AmplifyError.mjs":"9LcuL","../types/errors.mjs":"2tN68","../errors/errorHelpers.mjs":"fvR3Q","../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../utils/isBrowser.mjs":"fcM16","../utils/retry/retry.mjs":"eFvhH","../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../Platform/index.mjs":"34W7w","../Platform/types.mjs":"8YCjz","../BackgroundProcessManager/types.mjs":"3gmMQ","../Reachability/Reachability.mjs":"1EGHg","../Hub/index.mjs":"hkdby","../utils/sessionListener/index.mjs":"4uBhf","../awsClients/pinpoint/errorHelpers.mjs":"5Ffok","../Cache/index.mjs":"jU1bK","../providers/pinpoint/apis/record.mjs":"abZfy","../providers/pinpoint/utils/PinpointEventBuffer.mjs":"9ZYvj","../providers/pinpoint/types/errors.mjs":"7FICa","../singleton/Amplify.mjs":"3ZpqK","../singleton/apis/fetchAuthSession.mjs":"ecuoW","./errorHelpers.mjs":"ed0rE","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5Ffok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PinpointValidationErrorCode", ()=>PinpointValidationErrorCode);
parcelHelpers.export(exports, "assert", ()=>assert);
var _createAssertionFunctionMjs = require("../../errors/createAssertionFunction.mjs");
var _errorsMjs = require("../../types/errors.mjs");
var _errorHelpersMjs = require("../../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var PinpointValidationErrorCode;
(function(PinpointValidationErrorCode) {
    PinpointValidationErrorCode["NoAppId"] = "NoAppId";
})(PinpointValidationErrorCode || (PinpointValidationErrorCode = {}));
const pinpointValidationErrorMap = {
    [PinpointValidationErrorCode.NoAppId]: {
        message: 'Missing application id.'
    }
};
const assert = (0, _createAssertionFunctionMjs.createAssertionFunction)(pinpointValidationErrorMap);

},{"../../errors/createAssertionFunction.mjs":"lBq8c","../../types/errors.mjs":"2tN68","../../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"abZfy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "record", ()=>record);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _indexMjs = require("../../../utils/amplifyUuid/index.mjs");
var _indexMjs1 = require("../../../Cache/index.mjs");
var _resolveEndpointIdMjs = require("../utils/resolveEndpointId.mjs");
var _indexMjs2 = require("../../../utils/sessionListener/index.mjs");
var _constantsMjs = require("../utils/constants.mjs");
var _getEventBufferMjs = require("../utils/getEventBuffer.mjs");
var _constantsMjs1 = require("../../../utils/sessionListener/constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
let session;
/**
 * @internal
 */ const record = async ({ appId, category, channelType, credentials, event, identityId, region, userAgentValue, bufferSize, flushInterval, flushSize, resendLimit })=>{
    let eventSession = session;
    const currentTime = new Date();
    const timestampISOString = currentTime.toISOString();
    const eventId = (0, _indexMjs.amplifyUuid)();
    // Prepare event buffer if required
    const buffer = (0, _getEventBufferMjs.getEventBuffer)({
        appId,
        region,
        credentials,
        bufferSize: bufferSize !== null && bufferSize !== void 0 ? bufferSize : (0, _constantsMjs.BUFFER_SIZE),
        flushInterval: flushInterval !== null && flushInterval !== void 0 ? flushInterval : (0, _constantsMjs.FLUSH_INTERVAL),
        flushSize: flushSize !== null && flushSize !== void 0 ? flushSize : (0, _constantsMjs.FLUSH_SIZE),
        resendLimit: resendLimit !== null && resendLimit !== void 0 ? resendLimit : (0, _constantsMjs.RESEND_LIMIT),
        identityId,
        userAgentValue
    });
    const endpointId = await (0, _resolveEndpointIdMjs.resolveEndpointId)({
        appId,
        category,
        channelType,
        credentials,
        identityId,
        region,
        userAgentValue
    });
    // Generate session if required
    if (!eventSession || event.name === (0, _constantsMjs1.SESSION_START_EVENT)) {
        const sessionId = (0, _indexMjs.amplifyUuid)();
        session = {
            Id: sessionId,
            StartTimestamp: timestampISOString
        };
        eventSession = session;
    }
    // Terminate session when required
    if (session && event.name === (0, _constantsMjs1.SESSION_STOP_EVENT)) {
        eventSession = (0, _objectSpreadProps._)((0, _objectSpread._)({}, session), {
            StopTimestamp: timestampISOString,
            Duration: currentTime.getTime() - new Date(session.StartTimestamp).getTime()
        });
        session = undefined;
    }
    // Push event to buffer
    buffer.push({
        eventId,
        endpointId,
        event,
        session: eventSession,
        timestamp: timestampISOString,
        resendLimit: resendLimit !== null && resendLimit !== void 0 ? resendLimit : (0, _constantsMjs.RESEND_LIMIT)
    });
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../../../utils/amplifyUuid/index.mjs":"9DnN6","../../../Cache/index.mjs":"jU1bK","../utils/resolveEndpointId.mjs":"8eGNJ","../../../utils/sessionListener/index.mjs":"4uBhf","../utils/constants.mjs":"lKSTD","../utils/getEventBuffer.mjs":"0523X","../../../utils/sessionListener/constants.mjs":"k9UzK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8eGNJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointId", ()=>resolveEndpointId);
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _updateEndpointMjs = require("../apis/updateEndpoint.mjs");
var _getEndpointIdMjs = require("./getEndpointId.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resolves an endpoint id from cache or prepare via updateEndpoint if one does not already exist,
 * which will generate and cache an endpoint id between calls.
 *
 * @internal
 */ const resolveEndpointId = async ({ address, appId, category, channelType, credentials, identityId, region, userAgentValue })=>{
    let endpointId = await (0, _getEndpointIdMjs.getEndpointId)(appId, category);
    if (!endpointId) {
        await (0, _updateEndpointMjs.updateEndpoint)({
            address,
            appId,
            category,
            channelType,
            credentials,
            identityId,
            region,
            userAgentValue
        });
        endpointId = await (0, _getEndpointIdMjs.getEndpointId)(appId, category);
    }
    (0, _errorHelpersMjs.assert)(!!endpointId, (0, _errorsMjs.AmplifyErrorCode).NoEndpointId);
    return endpointId;
};

},{"../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../apis/updateEndpoint.mjs":"eEb3F","./getEndpointId.mjs":"lEgZZ","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eEb3F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateEndpoint", ()=>updateEndpoint);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../parseAWSExports.mjs");
var _indexMjs = require("../../../utils/amplifyUuid/index.mjs");
var _errorHelpersMjs1 = require("../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs1 = require("../../../Platform/index.mjs");
var _typesMjs = require("../../../Platform/types.mjs");
var _typesMjs1 = require("../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../Reachability/Reachability.mjs");
var _indexMjs2 = require("../../../Hub/index.mjs");
var _indexMjs3 = require("../../../utils/sessionListener/index.mjs");
var _errorHelpersMjs2 = require("../../../awsClients/pinpoint/errorHelpers.mjs");
var _updateEndpointMjs = require("../../../awsClients/pinpoint/updateEndpoint.mjs");
var _cacheEndpointIdMjs = require("../utils/cacheEndpointId.mjs");
var _createEndpointIdMjs = require("../utils/createEndpointId.mjs");
var _getEndpointIdMjs = require("../utils/getEndpointId.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const updateEndpoint = async ({ address, appId, category, channelType, credentials, identityId, optOut, region, userAttributes, userId, userProfile, userAgentValue })=>{
    const endpointId = await (0, _getEndpointIdMjs.getEndpointId)(appId, category);
    // only generate a new endpoint id if one was not found in cache
    const createdEndpointId = !endpointId ? (0, _createEndpointIdMjs.createEndpointId)(appId, category) : undefined;
    const { customProperties, demographic, email, location, metrics, name, plan } = userProfile !== null && userProfile !== void 0 ? userProfile : {};
    // only automatically populate the endpoint with client info and identity id upon endpoint creation to
    // avoid overwriting the endpoint with these values every time the endpoint is updated
    const demographicsFromClientInfo = {};
    const resolvedUserId = createdEndpointId ? userId !== null && userId !== void 0 ? userId : identityId : userId;
    if (createdEndpointId) {
        const clientInfo = (0, _getClientInfoMjs.getClientInfo)();
        demographicsFromClientInfo.appVersion = clientInfo.appVersion;
        demographicsFromClientInfo.make = clientInfo.make;
        demographicsFromClientInfo.model = clientInfo.model;
        demographicsFromClientInfo.modelVersion = clientInfo.version;
        demographicsFromClientInfo.platform = clientInfo.platform;
    }
    const mergedDemographic = (0, _objectSpread._)({}, demographicsFromClientInfo, demographic);
    const attributes = (0, _objectSpread._)({}, email && {
        email: [
            email
        ]
    }, name && {
        name: [
            name
        ]
    }, plan && {
        plan: [
            plan
        ]
    }, customProperties);
    const shouldAddDemographics = createdEndpointId || demographic;
    const shouldAddAttributes = email || customProperties || name || plan;
    const shouldAddUser = resolvedUserId || userAttributes;
    const input = {
        ApplicationId: appId,
        EndpointId: endpointId !== null && endpointId !== void 0 ? endpointId : createdEndpointId,
        EndpointRequest: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            RequestId: (0, _indexMjs.amplifyUuid)(),
            EffectiveDate: new Date().toISOString(),
            ChannelType: channelType,
            Address: address
        }, shouldAddAttributes && {
            Attributes: attributes
        }, shouldAddDemographics && {
            Demographic: {
                AppVersion: mergedDemographic.appVersion,
                Locale: mergedDemographic.locale,
                Make: mergedDemographic.make,
                Model: mergedDemographic.model,
                ModelVersion: mergedDemographic.modelVersion,
                Platform: mergedDemographic.platform,
                PlatformVersion: mergedDemographic.platformVersion,
                Timezone: mergedDemographic.timezone
            }
        }, location && {
            Location: {
                City: location.city,
                Country: location.country,
                Latitude: location.latitude,
                Longitude: location.longitude,
                PostalCode: location.postalCode,
                Region: location.region
            }
        }), {
            Metrics: metrics,
            OptOut: optOut
        }), shouldAddUser && {
            User: {
                UserId: resolvedUserId,
                UserAttributes: userAttributes
            }
        })
    };
    try {
        await (0, _updateEndpointMjs.updateEndpoint)({
            credentials,
            region,
            userAgentValue
        }, input);
        // if we had to create an endpoint id, we need to now cache it
        if (createdEndpointId) await (0, _cacheEndpointIdMjs.cacheEndpointId)(appId, category, createdEndpointId);
    } finally{
        // at this point, we completely reset the behavior so even if the update was unsuccessful
        // we can just start over with a newly created endpoint id
        if (createdEndpointId) (0, _createEndpointIdMjs.clearCreatedEndpointId)(appId, category);
    }
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../utils/retry/retry.mjs":"eFvhH","../../../parseAWSExports.mjs":"4w5h9","../../../utils/amplifyUuid/index.mjs":"9DnN6","../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../Platform/index.mjs":"34W7w","../../../Platform/types.mjs":"8YCjz","../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../Reachability/Reachability.mjs":"1EGHg","../../../Hub/index.mjs":"hkdby","../../../utils/sessionListener/index.mjs":"4uBhf","../../../awsClients/pinpoint/errorHelpers.mjs":"5Ffok","../../../awsClients/pinpoint/updateEndpoint.mjs":"jrNQP","../utils/cacheEndpointId.mjs":"8HmKT","../utils/createEndpointId.mjs":"73GB4","../utils/getEndpointId.mjs":"lEgZZ","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jrNQP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateEndpoint", ()=>updateEndpoint);
var _authenticatedMjs = require("../../clients/handlers/aws/authenticated.mjs");
var _composeServiceApiMjs = require("../../clients/internal/composeServiceApi.mjs");
var _extendedEncodeURIComponentMjs = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent.mjs");
var _responseInfoMjs = require("../../clients/serde/responseInfo.mjs");
var _jsonMjs = require("../../clients/serde/json.mjs");
var _indexMjs = require("../../utils/amplifyUrl/index.mjs");
var _baseMjs = require("./base.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const updateEndpointSerializer = ({ ApplicationId = '', EndpointId = '', EndpointRequest }, endpoint)=>{
    const headers = (0, _baseMjs.getSharedHeaders)();
    const url = new (0, _indexMjs.AmplifyUrl)(endpoint.url);
    url.pathname = `v1/apps/${(0, _extendedEncodeURIComponentMjs.extendedEncodeURIComponent)(ApplicationId)}/endpoints/${(0, _extendedEncodeURIComponentMjs.extendedEncodeURIComponent)(EndpointId)}`;
    const body = JSON.stringify(EndpointRequest);
    return {
        method: 'PUT',
        headers,
        url,
        body
    };
};
const updateEndpointDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, _jsonMjs.parseJsonError)(response);
        throw error;
    } else {
        const { Message, RequestID } = await (0, _jsonMjs.parseJsonBody)(response);
        return {
            MessageBody: {
                Message,
                RequestID
            },
            $metadata: (0, _responseInfoMjs.parseMetadata)(response)
        };
    }
};
/**
 * @internal
 */ const updateEndpoint = (0, _composeServiceApiMjs.composeServiceApi)((0, _authenticatedMjs.authenticatedHandler), updateEndpointSerializer, updateEndpointDeserializer, (0, _baseMjs.defaultConfig));

},{"../../clients/handlers/aws/authenticated.mjs":"aZd4V","../../clients/internal/composeServiceApi.mjs":"cUdLo","../../clients/middleware/signing/utils/extendedEncodeURIComponent.mjs":"6UFtc","../../clients/serde/responseInfo.mjs":"88PMJ","../../clients/serde/json.mjs":"1pZXC","../../utils/amplifyUrl/index.mjs":"4l1t5","./base.mjs":"cQN2m","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aZd4V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authenticatedHandler", ()=>authenticatedHandler);
var _retryMiddlewareMjs = require("../../middleware/retry/retryMiddleware.mjs");
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../utils/retry/retry.mjs");
var _amzSdkInvocationIdHeaderMiddlewareMjs = require("../../middleware/retry/amzSdkInvocationIdHeaderMiddleware.mjs");
var _amzSdkRequestHeaderMiddlewareMjs = require("../../middleware/retry/amzSdkRequestHeaderMiddleware.mjs");
var _middlewareMjs = require("../../middleware/signing/middleware.mjs");
var _middlewareMjs1 = require("../../middleware/userAgent/middleware.mjs");
var _composeTransferHandlerMjs = require("../../internal/composeTransferHandler.mjs");
var _fetchMjs = require("../fetch.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const authenticatedHandler = (0, _composeTransferHandlerMjs.composeTransferHandler)((0, _fetchMjs.fetchTransferHandler), [
    (0, _middlewareMjs1.userAgentMiddlewareFactory),
    (0, _amzSdkInvocationIdHeaderMiddlewareMjs.amzSdkInvocationIdHeaderMiddlewareFactory),
    (0, _retryMiddlewareMjs.retryMiddlewareFactory),
    (0, _amzSdkRequestHeaderMiddlewareMjs.amzSdkRequestHeaderMiddlewareFactory),
    (0, _middlewareMjs.signingMiddlewareFactory)
]);

},{"../../middleware/retry/retryMiddleware.mjs":"iHnIY","../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../utils/retry/retry.mjs":"eFvhH","../../middleware/retry/amzSdkInvocationIdHeaderMiddleware.mjs":"ojiJg","../../middleware/retry/amzSdkRequestHeaderMiddleware.mjs":"hvueN","../../middleware/signing/middleware.mjs":"4XVfc","../../middleware/userAgent/middleware.mjs":"e6W9O","../../internal/composeTransferHandler.mjs":"aXWVV","../fetch.mjs":"eMjmx","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4XVfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddlewareFactory", ()=>signingMiddlewareFactory);
var _signRequestMjs = require("./signer/signatureV4/signRequest.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _getSkewCorrectedDateMjs = require("./utils/getSkewCorrectedDate.mjs");
var _getUpdatedSystemClockOffsetMjs = require("./utils/getUpdatedSystemClockOffset.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware that SigV4 signs request with AWS credentials, and correct system clock offset.
 * This middleware is expected to be placed after retry middleware.
 */ const signingMiddlewareFactory = ({ credentials, region, service, uriEscapePath = true })=>{
    let currentSystemClockOffset;
    return (next, context)=>async function signingMiddleware(request) {
            currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
            const signRequestOptions = {
                credentials: typeof credentials === 'function' ? await credentials({
                    forceRefresh: !!(context === null || context === void 0 ? void 0 : context.isCredentialsExpired)
                }) : credentials,
                signingDate: (0, _getSkewCorrectedDateMjs.getSkewCorrectedDate)(currentSystemClockOffset),
                signingRegion: region,
                signingService: service,
                uriEscapePath
            };
            const signedRequest = await (0, _signRequestMjs.signRequest)(request, signRequestOptions);
            const response = await next(signedRequest);
            // Update system clock offset if response contains date header, regardless of the status code.
            // non-2xx response will still be returned from next handler instead of thrown, because it's
            // only thrown by the retry middleware.
            const dateString = getDateHeader(response);
            if (dateString) currentSystemClockOffset = (0, _getUpdatedSystemClockOffsetMjs.getUpdatedSystemClockOffset)(Date.parse(dateString), currentSystemClockOffset);
            return response;
        };
};
const getDateHeader = ({ headers } = {})=>{
    var _headers_date, _ref;
    return (_ref = (_headers_date = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _headers_date !== void 0 ? _headers_date : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _ref !== void 0 ? _ref : headers === null || headers === void 0 ? void 0 : headers['x-amz-date'];
};

},{"./signer/signatureV4/signRequest.mjs":"1bdLF","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","./utils/getSkewCorrectedDate.mjs":"hX5Zx","./utils/getUpdatedSystemClockOffset.mjs":"5m8Le","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1bdLF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", ()=>signRequest);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _getSignedHeadersMjs = require("./utils/getSignedHeaders.mjs");
var _getSigningValuesMjs = require("./utils/getSigningValues.mjs");
var _constantsMjs = require("./constants.mjs");
var _getSignatureMjs = require("./utils/getSignature.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Given a `HttpRequest`, returns a Signature Version 4 signed `HttpRequest`.
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns A `HttpRequest` with authentication headers which can grant temporary access to AWS resources.
 */ const signRequest = (request, options)=>{
    const signingValues = (0, _getSigningValuesMjs.getSigningValues)(options);
    const { accessKeyId, credentialScope, longDate, sessionToken } = signingValues;
    // create the request to sign
    const headers = (0, _objectSpread._)({}, request.headers);
    headers[0, _constantsMjs.HOST_HEADER] = request.url.host;
    headers[0, _constantsMjs.AMZ_DATE_HEADER] = longDate;
    if (sessionToken) headers[0, _constantsMjs.TOKEN_HEADER] = sessionToken;
    const requestToSign = (0, _objectSpreadProps._)((0, _objectSpread._)({}, request), {
        headers
    });
    // calculate and add the signature to the request
    const signature = (0, _getSignatureMjs.getSignature)(requestToSign, signingValues);
    const credentialEntry = `Credential=${accessKeyId}/${credentialScope}`;
    const signedHeadersEntry = `SignedHeaders=${(0, _getSignedHeadersMjs.getSignedHeaders)(headers)}`;
    const signatureEntry = `Signature=${signature}`;
    headers[0, _constantsMjs.AUTH_HEADER] = `${0, _constantsMjs.SHA256_ALGORITHM_IDENTIFIER} ${credentialEntry}, ${signedHeadersEntry}, ${signatureEntry}`;
    return requestToSign;
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","./utils/getSignedHeaders.mjs":"1GP0F","./utils/getSigningValues.mjs":"dhomR","./constants.mjs":"9SfSa","./utils/getSignature.mjs":"7fhkR","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1GP0F":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignedHeaders", ()=>getSignedHeaders);
const getSignedHeaders = (headers)=>Object.keys(headers).map((key)=>key.toLowerCase()).sort().join(';');

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dhomR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningValues", ()=>getSigningValues);
var _getCredentialScopeMjs = require("./getCredentialScope.mjs");
var _getFormattedDatesMjs = require("./getFormattedDates.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Extracts common values used for signing both requests and urls.
 *
 * @param options `SignRequestOptions` object containing values used to construct the signature.
 * @returns Common `SigningValues` used for signing.
 *
 * @internal
 */ const getSigningValues = ({ credentials, signingDate = new Date(), signingRegion, signingService, uriEscapePath = true })=>{
    // get properties from credentials
    const { accessKeyId, secretAccessKey, sessionToken } = credentials;
    // get formatted dates for signing
    const { longDate, shortDate } = (0, _getFormattedDatesMjs.getFormattedDates)(signingDate);
    // copy header and set signing properties
    const credentialScope = (0, _getCredentialScopeMjs.getCredentialScope)(shortDate, signingRegion, signingService);
    return {
        accessKeyId,
        credentialScope,
        longDate,
        secretAccessKey,
        sessionToken,
        shortDate,
        signingRegion,
        signingService,
        uriEscapePath
    };
};

},{"./getCredentialScope.mjs":"8NjgF","./getFormattedDates.mjs":"eWKNi","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8NjgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialScope", ()=>getCredentialScope);
var _constantsMjs = require("../constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the credential scope which restricts the resulting signature to the specified region and service.
 *
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns  A string representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 *
 * @internal
 */ const getCredentialScope = (date, region, service)=>`${date}/${region}/${service}/${0, _constantsMjs.KEY_TYPE_IDENTIFIER}`;

},{"../constants.mjs":"9SfSa","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9SfSa":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "EMPTY_HASH", ()=>EMPTY_HASH);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "SHA256_ALGORITHM_IDENTIFIER", ()=>SHA256_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "SIGNATURE_IDENTIFIER", ()=>SIGNATURE_IDENTIFIER);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
const ALGORITHM_QUERY_PARAM = 'X-Amz-Algorithm';
const AMZ_DATE_QUERY_PARAM = 'X-Amz-Date';
const CREDENTIAL_QUERY_PARAM = 'X-Amz-Credential';
const EXPIRES_QUERY_PARAM = 'X-Amz-Expires';
const REGION_SET_PARAM = 'X-Amz-Region-Set';
const SIGNATURE_QUERY_PARAM = 'X-Amz-Signature';
const SIGNED_HEADERS_QUERY_PARAM = 'X-Amz-SignedHeaders';
const TOKEN_QUERY_PARAM = 'X-Amz-Security-Token';
// headers
const AUTH_HEADER = 'authorization';
const HOST_HEADER = 'host';
const AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
const TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
// identifiers
const KEY_TYPE_IDENTIFIER = 'aws4_request';
const SHA256_ALGORITHM_IDENTIFIER = 'AWS4-HMAC-SHA256';
const SIGNATURE_IDENTIFIER = 'AWS4';
// preset values
const EMPTY_HASH = 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';
const UNSIGNED_PAYLOAD = 'UNSIGNED-PAYLOAD';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eWKNi":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormattedDates", ()=>getFormattedDates);
const getFormattedDates = (date)=>{
    const longDate = date.toISOString().replace(/[:-]|\.\d{3}/g, '');
    return {
        longDate,
        shortDate: longDate.slice(0, 8)
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7fhkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignature", ()=>getSignature);
var _dataHashHelpersMjs = require("./dataHashHelpers.mjs");
var _getCanonicalRequestMjs = require("./getCanonicalRequest.mjs");
var _getSigningKeyMjs = require("./getSigningKey.mjs");
var _getStringToSignMjs = require("./getStringToSign.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculates and returns an AWS API Signature.
 * https://docs.aws.amazon.com/IAM/latest/UserGuide/create-signed-request.html
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns AWS API Signature to sign a request or url with.
 *
 * @internal
 */ const getSignature = (request, { credentialScope, longDate, secretAccessKey, shortDate, signingRegion, signingService, uriEscapePath })=>{
    // step 1: create a canonical request
    const canonicalRequest = (0, _getCanonicalRequestMjs.getCanonicalRequest)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    const hashedRequest = (0, _dataHashHelpersMjs.getHashedDataAsHex)(null, canonicalRequest);
    // step 3: create a string to sign
    const stringToSign = (0, _getStringToSignMjs.getStringToSign)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    const signature = (0, _dataHashHelpersMjs.getHashedDataAsHex)((0, _getSigningKeyMjs.getSigningKey)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};

},{"./dataHashHelpers.mjs":"8mXlN","./getCanonicalRequest.mjs":"xOuSO","./getSigningKey.mjs":"jBhTq","./getStringToSign.mjs":"kLzn2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8mXlN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedData", ()=>getHashedData);
parcelHelpers.export(exports, "getHashedDataAsHex", ()=>getHashedDataAsHex);
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
/**
 * Returns the hashed data a `Uint8Array`.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns `Uint8Array` created from the data as input to a hash function.
 */ const getHashedData = (key, data)=>{
    const sha256 = new (0, _sha256Js.Sha256)(key !== null && key !== void 0 ? key : undefined);
    sha256.update(data);
    // TODO: V6 flip to async digest
    const hashedData = sha256.digestSync();
    return hashedData;
};
/**
 * Returns the hashed data as a hex string.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns String using lowercase hexadecimal characters created from the data as input to a hash function.
 *
 * @internal
 */ const getHashedDataAsHex = (key, data)=>{
    const hashedData = getHashedData(key, data);
    return (0, _utilHexEncoding.toHex)(hashedData);
};

},{"@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"xOuSO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalRequest", ()=>getCanonicalRequest);
var _getCanonicalHeadersMjs = require("./getCanonicalHeaders.mjs");
var _getCanonicalQueryStringMjs = require("./getCanonicalQueryString.mjs");
var _getCanonicalUriMjs = require("./getCanonicalUri.mjs");
var _getHashedPayloadMjs = require("./getHashedPayload.mjs");
var _getSignedHeadersMjs = require("./getSignedHeaders.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical request.
 *
 * @param request `HttpRequest` from which to create the canonical request from.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns String created by by concatenating the following strings, separated by newline characters:
 * - HTTPMethod
 * - CanonicalUri
 * - CanonicalQueryString
 * - CanonicalHeaders
 * - SignedHeaders
 * - HashedPayload
 *
 * @internal
 */ const getCanonicalRequest = ({ body, headers, method, url }, uriEscapePath = true)=>[
        method,
        (0, _getCanonicalUriMjs.getCanonicalUri)(url.pathname, uriEscapePath),
        (0, _getCanonicalQueryStringMjs.getCanonicalQueryString)(url.searchParams),
        (0, _getCanonicalHeadersMjs.getCanonicalHeaders)(headers),
        (0, _getSignedHeadersMjs.getSignedHeaders)(headers),
        (0, _getHashedPayloadMjs.getHashedPayload)(body)
    ].join('\n');

},{"./getCanonicalHeaders.mjs":"crXvR","./getCanonicalQueryString.mjs":"aqkwv","./getCanonicalUri.mjs":"cfEBA","./getHashedPayload.mjs":"h5ZwH","./getSignedHeaders.mjs":"1GP0F","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"crXvR":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns canonical headers.
 *
 * @param headers Headers from the request.
 * @returns Request headers that will be signed, and their values, separated by newline characters. Header names must
 * use lowercase characters, must appear in alphabetical order, and must be followed by a colon (:). For the values,
 * trim any leading or trailing spaces, convert sequential spaces to a single space, and separate the values
 * for a multi-value header using commas.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
const getCanonicalHeaders = (headers)=>Object.entries(headers).map(([key, value])=>{
        var _value_trim_replace;
        return {
            key: key.toLowerCase(),
            value: (_value_trim_replace = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, ' ')) !== null && _value_trim_replace !== void 0 ? _value_trim_replace : ''
        };
    }).sort((a, b)=>a.key < b.key ? -1 : 1).map((entry)=>`${entry.key}:${entry.value}\n`).join('');

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aqkwv":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical query string.
 *
 * @param searchParams `searchParams` from the request url.
 * @returns URL-encoded query string parameters, separated by ampersands (&). Percent-encode reserved characters,
 * including the space character. Encode names and values separately. If there are empty parameters, append the equals
 * sign to the parameter name before encoding. After encoding, sort the parameters alphabetically by key name. If there
 * is no query string, use an empty string ("").
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQueryString", ()=>getCanonicalQueryString);
const getCanonicalQueryString = (searchParams)=>Array.from(searchParams).sort(([keyA, valA], [keyB, valB])=>{
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(([key, val])=>`${escapeUri(key)}=${escapeUri(val)}`).join('&');
const escapeUri = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
const hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cfEBA":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalUri", ()=>getCanonicalUri);
const getCanonicalUri = (pathname, uriEscapePath = true)=>pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, '/') : pathname : '/';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"h5ZwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedPayload", ()=>getHashedPayload);
var _constantsMjs = require("../constants.mjs");
var _dataHashHelpersMjs = require("./dataHashHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the hashed payload.
 *
 * @param body `body` (payload) from the request.
 * @returns String created using the payload in the body of the HTTP request as input to a hash function. This string
 * uses lowercase hexadecimal characters. If the payload is empty, return precalculated result of an empty hash.
 *
 * @internal
 */ const getHashedPayload = (body)=>{
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, _constantsMjs.EMPTY_HASH;
    if (isSourceData(body)) {
        const hashedData = (0, _dataHashHelpersMjs.getHashedDataAsHex)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, _constantsMjs.UNSIGNED_PAYLOAD;
};
const isSourceData = (body)=>// Exclude UNSIGNED_PAYLOAD constant to prevent it from being hashed as a string
    body !== (0, _constantsMjs.UNSIGNED_PAYLOAD) && (typeof body === 'string' || ArrayBuffer.isView(body) || isArrayBuffer(body));
const isArrayBuffer = (arg)=>typeof ArrayBuffer === 'function' && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === '[object ArrayBuffer]';

},{"../constants.mjs":"9SfSa","./dataHashHelpers.mjs":"8mXlN","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jBhTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
var _constantsMjs = require("../constants.mjs");
var _dataHashHelpersMjs = require("./dataHashHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a signing key to be used for signing requests.
 *
 * @param secretAccessKey AWS secret access key from credentials.
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns `Uint8Array` calculated from its composite parts.
 *
 * @internal
 */ const getSigningKey = (secretAccessKey, date, region, service)=>{
    const key = `${(0, _constantsMjs.SIGNATURE_IDENTIFIER)}${secretAccessKey}`;
    const dateKey = (0, _dataHashHelpersMjs.getHashedData)(key, date);
    const regionKey = (0, _dataHashHelpersMjs.getHashedData)(dateKey, region);
    const serviceKey = (0, _dataHashHelpersMjs.getHashedData)(regionKey, service);
    const signingKey = (0, _dataHashHelpersMjs.getHashedData)(serviceKey, (0, _constantsMjs.KEY_TYPE_IDENTIFIER));
    return signingKey;
};

},{"../constants.mjs":"9SfSa","./dataHashHelpers.mjs":"8mXlN","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kLzn2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStringToSign", ()=>getStringToSign);
var _constantsMjs = require("../constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a string to be signed.
 *
 * @param date Current date in the format 'YYYYMMDDThhmmssZ'.
 * @param credentialScope String representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 * @param hashedRequest Hashed canonical request.
 *
 * @returns A string created by by concatenating the following strings, separated by newline characters:
 * - Algorithm
 * - RequestDateTime
 * - CredentialScope
 * - HashedCanonicalRequest
 *
 * @internal
 */ const getStringToSign = (date, credentialScope, hashedRequest)=>[
        (0, _constantsMjs.SHA256_ALGORITHM_IDENTIFIER),
        date,
        credentialScope,
        hashedRequest
    ].join('\n');

},{"../constants.mjs":"9SfSa","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hX5Zx":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
const getSkewCorrectedDate = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5m8Le":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewedMjs = require("./isClockSkewed.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the difference between clock time and the current system time if clock is skewed.
 *
 * @param clockTimeInMilliseconds Clock time in milliseconds.
 * @param currentSystemClockOffset Current system clock offset in milliseconds.
 *
 * @internal
 */ const getUpdatedSystemClockOffset = (clockTimeInMilliseconds, currentSystemClockOffset)=>{
    if ((0, _isClockSkewedMjs.isClockSkewed)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed.mjs":"gZtk3","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gZtk3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDateMjs = require("./getSkewCorrectedDate.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
const SKEW_WINDOW = 300000;
/**
 * Checks if the provided date is within the skew window of 5 minutes.
 *
 * @param clockTimeInMilliseconds Time to check for skew in milliseconds.
 * @param clockOffsetInMilliseconds Offset to check clock against in milliseconds.
 *
 * @returns True if skewed. False otherwise.
 *
 * @internal
 */ const isClockSkewed = (clockTimeInMilliseconds, clockOffsetInMilliseconds)=>Math.abs((0, _getSkewCorrectedDateMjs.getSkewCorrectedDate)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= SKEW_WINDOW;

},{"./getSkewCorrectedDate.mjs":"hX5Zx","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6UFtc":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Wraps encodeURIComponent to encode additional characters to fully adhere to RFC 3986.
 * @see https://github.com/aws/aws-sdk-js-v3/blob/86b432c464150069678b25ff88d57c2ca26e75a2/packages/smithy-client/src/extended-encode-uri-component.ts#L7
 *
 * @param uri URI string to encode
 * @returns RFC 3986 encoded string
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
const extendedEncodeURIComponent = (uri)=>{
    // Match characters normally not encoded by `encodeURIComponent`
    const extendedCharacters = /[!'()*]/g;
    return encodeURIComponent(uri).replace(extendedCharacters, hexEncode);
};
const hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cQN2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "getSharedHeaders", ()=>getSharedHeaders);
var _getDnsSuffixMjs = require("../../clients/endpoints/getDnsSuffix.mjs");
var _jitteredBackoffMjs = require("../../clients/middleware/retry/jitteredBackoff.mjs");
var _defaultRetryDeciderMjs = require("../../clients/middleware/retry/defaultRetryDecider.mjs");
var _errorsMjs = require("../../types/errors.mjs");
var _errorHelpersMjs = require("../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _indexMjs = require("../../utils/amplifyUrl/index.mjs");
var _errorHelpersMjs1 = require("../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs1 = require("../../Platform/index.mjs");
var _typesMjs = require("../../Platform/types.mjs");
var _typesMjs1 = require("../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../Reachability/Reachability.mjs");
var _indexMjs2 = require("../../Hub/index.mjs");
var _indexMjs3 = require("../../utils/sessionListener/index.mjs");
var _jsonMjs = require("../../clients/serde/json.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const SERVICE_NAME = 'mobiletargeting';
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const endpointResolver = ({ region })=>({
        url: new (0, _indexMjs.AmplifyUrl)(`https://pinpoint.${region}.${(0, _getDnsSuffixMjs.getDnsSuffix)(region)}`)
    });
/**
 * @internal
 */ const defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver,
    retryDecider: (0, _defaultRetryDeciderMjs.getRetryDecider)((0, _jsonMjs.parseJsonError)),
    computeDelay: (0, _jitteredBackoffMjs.jitteredBackoff),
    get userAgentValue () {
        return (0, _indexMjs1.getAmplifyUserAgent)();
    }
};
/**
 * @internal
 */ const getSharedHeaders = ()=>({
        'content-type': 'application/json'
    });

},{"../../clients/endpoints/getDnsSuffix.mjs":"5u4oS","../../clients/middleware/retry/jitteredBackoff.mjs":"1gXeo","../../clients/middleware/retry/defaultRetryDecider.mjs":"kA0XD","../../types/errors.mjs":"2tN68","../../errors/errorHelpers.mjs":"fvR3Q","../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../utils/retry/retry.mjs":"eFvhH","../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../utils/amplifyUrl/index.mjs":"4l1t5","../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../Platform/index.mjs":"34W7w","../../Platform/types.mjs":"8YCjz","../../BackgroundProcessManager/types.mjs":"3gmMQ","../../Reachability/Reachability.mjs":"1EGHg","../../Hub/index.mjs":"hkdby","../../utils/sessionListener/index.mjs":"4uBhf","../../clients/serde/json.mjs":"1pZXC","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8HmKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cacheEndpointId", ()=>cacheEndpointId);
var _indexMjs = require("../../../Cache/index.mjs");
var _getCacheKeyMjs = require("./getCacheKey.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Writes an endpoint id to a long-lived cache.
 *
 * @internal
 */ const cacheEndpointId = async (appId, category, endpointId)=>{
    const cacheKey = (0, _getCacheKeyMjs.getCacheKey)(appId, category);
    // Set a longer TTL to avoid endpoint id being deleted after the default TTL (3 days)
    // Also set its priority to the highest to reduce its chance of being deleted when cache is full
    const ttl = 3153600000000; // 100 years
    const expiration = new Date().getTime() + ttl;
    return (0, _indexMjs.Cache).setItem(cacheKey, endpointId, {
        expires: expiration,
        priority: 1
    });
};

},{"../../../Cache/index.mjs":"jU1bK","./getCacheKey.mjs":"6LeyF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6LeyF":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCacheKey", ()=>getCacheKey);
const PROVIDER_NAME = 'pinpoint';
/**
 * Returns a unique cache key for a particular category/appId combination.
 *
 * @internal
 */ const getCacheKey = (appId, category)=>`${category}:${PROVIDER_NAME}:${appId}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"73GB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearCreatedEndpointId", ()=>clearCreatedEndpointId);
parcelHelpers.export(exports, "createEndpointId", ()=>createEndpointId);
var _indexMjs = require("../../../utils/amplifyUuid/index.mjs");
var _getCacheKeyMjs = require("./getCacheKey.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createdEndpointIds = {};
/**
 * Creates an endpoint id and guarantees multiple creations for a category returns the same uuid.
 *
 * @internal
 */ const createEndpointId = (appId, category)=>{
    const cacheKey = (0, _getCacheKeyMjs.getCacheKey)(appId, category);
    if (!createdEndpointIds[cacheKey]) createdEndpointIds[cacheKey] = (0, _indexMjs.amplifyUuid)();
    return createdEndpointIds[cacheKey];
};
/**
 * Clears a created endpoint id for a category.
 *
 * @internal
 */ const clearCreatedEndpointId = (appId, category)=>{
    const cacheKey = (0, _getCacheKeyMjs.getCacheKey)(appId, category);
    delete createdEndpointIds[cacheKey];
};

},{"../../../utils/amplifyUuid/index.mjs":"9DnN6","./getCacheKey.mjs":"6LeyF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lEgZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointId", ()=>getEndpointId);
var _indexMjs = require("../../../Cache/index.mjs");
var _getCacheKeyMjs = require("./getCacheKey.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns an endpoint id from cache or `undefined` if not found.
 *
 * @internal
 */ const getEndpointId = async (appId, category)=>{
    const cacheKey = (0, _getCacheKeyMjs.getCacheKey)(appId, category);
    const cachedEndpointId = await (0, _indexMjs.Cache).getItem(cacheKey);
    return cachedEndpointId !== null && cachedEndpointId !== void 0 ? cachedEndpointId : undefined;
};

},{"../../../Cache/index.mjs":"jU1bK","./getCacheKey.mjs":"6LeyF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lKSTD":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Default buffer constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BUFFER_SIZE", ()=>BUFFER_SIZE);
parcelHelpers.export(exports, "FLUSH_INTERVAL", ()=>FLUSH_INTERVAL);
parcelHelpers.export(exports, "FLUSH_SIZE", ()=>FLUSH_SIZE);
parcelHelpers.export(exports, "RESEND_LIMIT", ()=>RESEND_LIMIT);
const BUFFER_SIZE = 1000;
const FLUSH_SIZE = 100;
const FLUSH_INTERVAL = 5000; // 5s
const RESEND_LIMIT = 5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"0523X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEventBuffer", ()=>getEventBuffer);
var _pinpointEventBufferMjs = require("./PinpointEventBuffer.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Map of buffers by region -> appId
const eventBufferMap = {};
/**
 * Returns a PinpointEventBuffer instance for the specified region & app ID, creating one if it does not yet exist.
 *
 * @internal
 */ const getEventBuffer = ({ appId, region, credentials, bufferSize, flushInterval, flushSize, resendLimit, identityId, userAgentValue })=>{
    var _eventBufferMap_region;
    if ((_eventBufferMap_region = eventBufferMap[region]) === null || _eventBufferMap_region === void 0 ? void 0 : _eventBufferMap_region[appId]) {
        const buffer = eventBufferMap[region][appId];
        /*
        If the identity or credentials has changed flush out the buffer and create a new instance. The old instance will be garbage
        collected.
        */ const shouldFlushBuffer = buffer.identityHasChanged(identityId) || buffer.haveCredentialsChanged(credentials);
        if (shouldFlushBuffer) buffer.flush();
        else return buffer;
    }
    const buffer = new (0, _pinpointEventBufferMjs.PinpointEventBuffer)({
        appId,
        bufferSize,
        credentials,
        flushInterval,
        flushSize,
        identityId,
        region,
        resendLimit,
        userAgentValue
    });
    if (!eventBufferMap[region]) eventBufferMap[region] = {};
    eventBufferMap[region][appId] = buffer;
    return buffer;
};

},{"./PinpointEventBuffer.mjs":"9ZYvj","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9ZYvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PinpointEventBuffer", ()=>PinpointEventBuffer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _consoleLoggerMjs = require("../../../Logger/ConsoleLogger.mjs");
var _errorsMjs = require("../../../types/errors.mjs");
var _errorHelpersMjs = require("../../../errors/errorHelpers.mjs");
var _getClientInfoMjs = require("../../../utils/getClientInfo/getClientInfo.mjs");
var _retryMjs = require("../../../utils/retry/retry.mjs");
var _parseAWSExportsMjs = require("../../../parseAWSExports.mjs");
var _uuid = require("uuid");
var _errorHelpersMjs1 = require("../../../singleton/Auth/utils/errorHelpers.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _haveCredentialsChangedMjs = require("../../../utils/haveCredentialsChanged.mjs");
var _indexMjs = require("../../../Platform/index.mjs");
var _typesMjs = require("../../../Platform/types.mjs");
var _typesMjs1 = require("../../../BackgroundProcessManager/types.mjs");
var _reachabilityMjs = require("../../../Reachability/Reachability.mjs");
var _indexMjs1 = require("../../../Hub/index.mjs");
var _indexMjs2 = require("../../../utils/sessionListener/index.mjs");
var _putEventsMjs = require("../../../awsClients/pinpoint/putEvents.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _consoleLoggerMjs.ConsoleLogger)('PinpointEventBuffer');
const RETRYABLE_CODES = [
    429,
    500
];
const ACCEPTED_CODES = [
    202
];
class PinpointEventBuffer {
    push(event) {
        if (this._buffer.length >= this._config.bufferSize) {
            logger.debug('Exceeded Pinpoint event buffer limits, event dropped.', {
                eventId: event.eventId
            });
            return;
        }
        this._buffer.push({
            [event.eventId]: event
        });
    }
    pause() {
        this._pause = true;
    }
    resume() {
        this._pause = false;
    }
    flush() {
        this._flush = true;
    }
    identityHasChanged(identityId) {
        return this._config.identityId !== identityId;
    }
    haveCredentialsChanged(credentials) {
        return (0, _haveCredentialsChangedMjs.haveCredentialsChanged)(this._config.credentials, credentials);
    }
    flushAll() {
        this._putEvents(this._buffer.splice(0, this._buffer.length));
    }
    _startLoop() {
        if (this._interval) clearInterval(this._interval);
        const { flushInterval } = this._config;
        this._interval = setInterval(this._sendBatch, flushInterval);
    }
    _sendBatch() {
        const bufferLength = this._buffer.length;
        if (this._flush && !bufferLength && this._interval) clearInterval(this._interval);
        if (this._pause || !bufferLength || false) return;
        const { flushSize } = this._config;
        const batchSize = Math.min(flushSize, bufferLength);
        const bufferSubset = this._buffer.splice(0, batchSize);
        this._putEvents(bufferSubset);
    }
    async _putEvents(buffer) {
        const eventMap = this._bufferToMap(buffer);
        const batchEventParams = this._generateBatchEventParams(eventMap);
        try {
            const { credentials, region, userAgentValue } = this._config;
            const data = await (0, _putEventsMjs.putEvents)({
                credentials,
                region,
                userAgentValue
            }, batchEventParams);
            this._processPutEventsSuccessResponse(data, eventMap);
        } catch (err) {
            this._handlePutEventsFailure(err, eventMap);
        }
    }
    _generateBatchEventParams(eventMap) {
        const batchItem = {};
        Object.values(eventMap).forEach((item)=>{
            var _batchItem_endpointId, _batchItem_endpointId1;
            const { event, timestamp, endpointId, eventId, session } = item;
            const { name, attributes, metrics } = event;
            batchItem[endpointId] = {
                Endpoint: (0, _objectSpread._)({}, (_batchItem_endpointId = batchItem[endpointId]) === null || _batchItem_endpointId === void 0 ? void 0 : _batchItem_endpointId.Endpoint),
                Events: (0, _objectSpreadProps._)((0, _objectSpread._)({}, (_batchItem_endpointId1 = batchItem[endpointId]) === null || _batchItem_endpointId1 === void 0 ? void 0 : _batchItem_endpointId1.Events), {
                    [eventId]: {
                        EventType: name,
                        Timestamp: new Date(timestamp).toISOString(),
                        Attributes: attributes,
                        Metrics: metrics,
                        Session: session
                    }
                })
            };
        });
        return {
            ApplicationId: this._config.appId,
            EventsRequest: {
                BatchItem: batchItem
            }
        };
    }
    _handlePutEventsFailure(err, eventMap) {
        logger.debug('putEvents call to Pinpoint failed.', err);
        const statusCode = err.$metadata && err.$metadata.httpStatusCode;
        if (RETRYABLE_CODES.includes(statusCode)) {
            const retryableEvents = Object.values(eventMap);
            this._retry(retryableEvents);
        }
    }
    _processPutEventsSuccessResponse(data, eventMap) {
        var _data_EventsResponse;
        const { Results = {} } = (_data_EventsResponse = data.EventsResponse) !== null && _data_EventsResponse !== void 0 ? _data_EventsResponse : {};
        const retryableEvents = [];
        Object.entries(Results).forEach(([_, endpointValues])=>{
            var _endpointValues_EventsItemResponse;
            const responses = (_endpointValues_EventsItemResponse = endpointValues.EventsItemResponse) !== null && _endpointValues_EventsItemResponse !== void 0 ? _endpointValues_EventsItemResponse : {};
            Object.entries(responses).forEach(([eventId, eventValues])=>{
                const eventObject = eventMap[eventId];
                if (!eventObject) return;
                const { StatusCode, Message } = eventValues !== null && eventValues !== void 0 ? eventValues : {};
                if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) return;
                if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) {
                    retryableEvents.push(eventObject);
                    return;
                }
                const { name } = eventObject.event;
                logger.warn('Pinpoint event failed to send.', {
                    eventId,
                    name,
                    message: Message
                });
            });
        });
        if (retryableEvents.length) this._retry(retryableEvents);
    }
    _retry(retryableEvents) {
        // retryable events that haven't reached the resendLimit
        const eligibleEvents = [];
        retryableEvents.forEach((bufferedEvent)=>{
            const { eventId } = bufferedEvent;
            const { name } = bufferedEvent.event;
            if (bufferedEvent.resendLimit-- > 0) {
                logger.debug('Resending event.', {
                    eventId,
                    name,
                    remainingAttempts: bufferedEvent.resendLimit
                });
                eligibleEvents.push({
                    [eventId]: bufferedEvent
                });
                return;
            }
            logger.debug('No retry attempts remaining for event.', {
                eventId,
                name
            });
        });
        // add the events to the front of the buffer
        this._buffer.unshift(...eligibleEvents);
    }
    _bufferToMap(buffer) {
        return buffer.reduce((acc, curVal)=>{
            const [[key, value]] = Object.entries(curVal);
            acc[key] = value;
            return acc;
        }, {});
    }
    constructor(config){
        this._interval = undefined;
        this._pause = false;
        this._flush = false;
        this._buffer = [];
        this._config = config;
        this._sendBatch = this._sendBatch.bind(this);
        this._startLoop();
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../../../Logger/ConsoleLogger.mjs":"6OFOw","../../../types/errors.mjs":"2tN68","../../../errors/errorHelpers.mjs":"fvR3Q","../../../utils/getClientInfo/getClientInfo.mjs":"gMIbI","../../../utils/retry/retry.mjs":"eFvhH","../../../parseAWSExports.mjs":"4w5h9","uuid":"5L12c","../../../singleton/Auth/utils/errorHelpers.mjs":"cz6fR","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../../../utils/haveCredentialsChanged.mjs":"eIhnN","../../../Platform/index.mjs":"34W7w","../../../Platform/types.mjs":"8YCjz","../../../BackgroundProcessManager/types.mjs":"3gmMQ","../../../Reachability/Reachability.mjs":"1EGHg","../../../Hub/index.mjs":"hkdby","../../../utils/sessionListener/index.mjs":"4uBhf","../../../awsClients/pinpoint/putEvents.mjs":"jvSG3","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eIhnN":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility for determining if credentials have changed.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "haveCredentialsChanged", ()=>haveCredentialsChanged);
const haveCredentialsChanged = (cachedCredentials, credentials)=>{
    return cachedCredentials.accessKeyId !== credentials.accessKeyId || cachedCredentials.sessionToken !== credentials.sessionToken || cachedCredentials.secretAccessKey !== credentials.secretAccessKey;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jvSG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putEvents", ()=>putEvents);
var _authenticatedMjs = require("../../clients/handlers/aws/authenticated.mjs");
var _composeServiceApiMjs = require("../../clients/internal/composeServiceApi.mjs");
var _extendedEncodeURIComponentMjs = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent.mjs");
var _responseInfoMjs = require("../../clients/serde/responseInfo.mjs");
var _jsonMjs = require("../../clients/serde/json.mjs");
var _indexMjs = require("../../utils/amplifyUrl/index.mjs");
var _baseMjs = require("./base.mjs");
var _errorHelpersMjs = require("./errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const putEventsSerializer = ({ ApplicationId, EventsRequest }, endpoint)=>{
    (0, _errorHelpersMjs.assert)(!!ApplicationId, (0, _errorHelpersMjs.PinpointValidationErrorCode).NoAppId);
    const headers = (0, _baseMjs.getSharedHeaders)();
    const url = new (0, _indexMjs.AmplifyUrl)(endpoint.url);
    url.pathname = `v1/apps/${(0, _extendedEncodeURIComponentMjs.extendedEncodeURIComponent)(ApplicationId)}/events`;
    const body = JSON.stringify(EventsRequest !== null && EventsRequest !== void 0 ? EventsRequest : {});
    return {
        method: 'POST',
        headers,
        url,
        body
    };
};
const putEventsDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, _jsonMjs.parseJsonError)(response);
        throw error;
    } else {
        const { Results } = await (0, _jsonMjs.parseJsonBody)(response);
        return {
            EventsResponse: {
                Results
            },
            $metadata: (0, _responseInfoMjs.parseMetadata)(response)
        };
    }
};
/**
 * @internal
 */ const putEvents = (0, _composeServiceApiMjs.composeServiceApi)((0, _authenticatedMjs.authenticatedHandler), putEventsSerializer, putEventsDeserializer, (0, _baseMjs.defaultConfig));

},{"../../clients/handlers/aws/authenticated.mjs":"aZd4V","../../clients/internal/composeServiceApi.mjs":"cUdLo","../../clients/middleware/signing/utils/extendedEncodeURIComponent.mjs":"6UFtc","../../clients/serde/responseInfo.mjs":"88PMJ","../../clients/serde/json.mjs":"1pZXC","../../utils/amplifyUrl/index.mjs":"4l1t5","./base.mjs":"cQN2m","./errorHelpers.mjs":"5Ffok","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7FICa":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateEndpointException", ()=>UpdateEndpointException);
var UpdateEndpointException;
(function(UpdateEndpointException) {
    UpdateEndpointException["BadRequestException"] = "BadRequestException";
    UpdateEndpointException["ForbiddenException"] = "ForbiddenException";
    UpdateEndpointException["InternalServerErrorException"] = "InternalServerErrorException";
    UpdateEndpointException["MethodNotAllowedException"] = "MethodNotAllowedException";
    UpdateEndpointException["NotFoundException"] = "NotFoundException";
    UpdateEndpointException["PayloadTooLargeException"] = "PayloadTooLargeException";
    UpdateEndpointException["TooManyRequestsException"] = "TooManyRequestsException";
})(UpdateEndpointException || (UpdateEndpointException = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ed0rE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorkerErrorCode", ()=>ServiceWorkerErrorCode);
parcelHelpers.export(exports, "assert", ()=>assert);
var _createAssertionFunctionMjs = require("../errors/createAssertionFunction.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _errorHelpersMjs = require("../errors/errorHelpers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var ServiceWorkerErrorCode;
(function(ServiceWorkerErrorCode) {
    ServiceWorkerErrorCode["UndefinedInstance"] = "UndefinedInstance";
    ServiceWorkerErrorCode["UndefinedRegistration"] = "UndefinedRegistration";
    ServiceWorkerErrorCode["Unavailable"] = "Unavailable";
})(ServiceWorkerErrorCode || (ServiceWorkerErrorCode = {}));
const serviceWorkerErrorMap = {
    [ServiceWorkerErrorCode.UndefinedInstance]: {
        message: 'Service Worker instance is undefined.'
    },
    [ServiceWorkerErrorCode.UndefinedRegistration]: {
        message: 'Service Worker registration is undefined.'
    },
    [ServiceWorkerErrorCode.Unavailable]: {
        message: 'Service Worker not available.'
    }
};
const assert = (0, _createAssertionFunctionMjs.createAssertionFunction)(serviceWorkerErrorMap);

},{"../errors/createAssertionFunction.mjs":"lBq8c","../types/errors.mjs":"2tN68","../errors/errorHelpers.mjs":"fvR3Q","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3cRL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("@aws-amplify/auth");
parcelHelpers.exportAll(_auth, exports);

},{"@aws-amplify/auth":"8MHzf","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8MHzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signUp", ()=>(0, _signUpMjs.signUp));
parcelHelpers.export(exports, "resetPassword", ()=>(0, _resetPasswordMjs.resetPassword));
parcelHelpers.export(exports, "confirmResetPassword", ()=>(0, _confirmResetPasswordMjs.confirmResetPassword));
parcelHelpers.export(exports, "signIn", ()=>(0, _signInMjs.signIn));
parcelHelpers.export(exports, "resendSignUpCode", ()=>(0, _resendSignUpCodeMjs.resendSignUpCode));
parcelHelpers.export(exports, "confirmSignUp", ()=>(0, _confirmSignUpMjs.confirmSignUp));
parcelHelpers.export(exports, "confirmSignIn", ()=>(0, _confirmSignInMjs.confirmSignIn));
parcelHelpers.export(exports, "updateMFAPreference", ()=>(0, _updateMFAPreferenceMjs.updateMFAPreference));
parcelHelpers.export(exports, "fetchMFAPreference", ()=>(0, _fetchMFAPreferenceMjs.fetchMFAPreference));
parcelHelpers.export(exports, "verifyTOTPSetup", ()=>(0, _verifyTOTPSetupMjs.verifyTOTPSetup));
parcelHelpers.export(exports, "updatePassword", ()=>(0, _updatePasswordMjs.updatePassword));
parcelHelpers.export(exports, "setUpTOTP", ()=>(0, _setUpTOTPMjs.setUpTOTP));
parcelHelpers.export(exports, "updateUserAttributes", ()=>(0, _updateUserAttributesMjs.updateUserAttributes));
parcelHelpers.export(exports, "updateUserAttribute", ()=>(0, _updateUserAttributeMjs.updateUserAttribute));
parcelHelpers.export(exports, "getCurrentUser", ()=>(0, _getCurrentUserMjs.getCurrentUser));
parcelHelpers.export(exports, "confirmUserAttribute", ()=>(0, _confirmUserAttributeMjs.confirmUserAttribute));
parcelHelpers.export(exports, "signInWithRedirect", ()=>(0, _signInWithRedirectMjs.signInWithRedirect));
parcelHelpers.export(exports, "fetchUserAttributes", ()=>(0, _fetchUserAttributesMjs.fetchUserAttributes));
parcelHelpers.export(exports, "signOut", ()=>(0, _signOutMjs.signOut));
parcelHelpers.export(exports, "sendUserAttributeVerificationCode", ()=>(0, _sendUserAttributeVerificationCodeMjs.sendUserAttributeVerificationCode));
parcelHelpers.export(exports, "deleteUserAttributes", ()=>(0, _deleteUserAttributesMjs.deleteUserAttributes));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _deleteUserMjs.deleteUser));
parcelHelpers.export(exports, "rememberDevice", ()=>(0, _rememberDeviceMjs.rememberDevice));
parcelHelpers.export(exports, "forgetDevice", ()=>(0, _forgetDeviceMjs.forgetDevice));
parcelHelpers.export(exports, "fetchDevices", ()=>(0, _fetchDevicesMjs.fetchDevices));
parcelHelpers.export(exports, "autoSignIn", ()=>(0, _autoSignInMjs.autoSignIn));
parcelHelpers.export(exports, "decodeJWT", ()=>(0, _core.decodeJWT));
parcelHelpers.export(exports, "fetchAuthSession", ()=>(0, _core.fetchAuthSession));
parcelHelpers.export(exports, "AuthError", ()=>(0, _authErrorMjs.AuthError));
parcelHelpers.export(exports, "associateWebAuthnCredential", ()=>(0, _associateWebAuthnCredentialMjs.associateWebAuthnCredential));
parcelHelpers.export(exports, "listWebAuthnCredentials", ()=>(0, _listWebAuthnCredentialsMjs.listWebAuthnCredentials));
parcelHelpers.export(exports, "deleteWebAuthnCredential", ()=>(0, _deleteWebAuthnCredentialMjs.deleteWebAuthnCredential));
var _signUpMjs = require("./providers/cognito/apis/signUp.mjs");
var _resetPasswordMjs = require("./providers/cognito/apis/resetPassword.mjs");
var _confirmResetPasswordMjs = require("./providers/cognito/apis/confirmResetPassword.mjs");
var _signInMjs = require("./providers/cognito/apis/signIn.mjs");
var _resendSignUpCodeMjs = require("./providers/cognito/apis/resendSignUpCode.mjs");
var _confirmSignUpMjs = require("./providers/cognito/apis/confirmSignUp.mjs");
var _confirmSignInMjs = require("./providers/cognito/apis/confirmSignIn.mjs");
var _updateMFAPreferenceMjs = require("./providers/cognito/apis/updateMFAPreference.mjs");
var _fetchMFAPreferenceMjs = require("./providers/cognito/apis/fetchMFAPreference.mjs");
var _verifyTOTPSetupMjs = require("./providers/cognito/apis/verifyTOTPSetup.mjs");
var _updatePasswordMjs = require("./providers/cognito/apis/updatePassword.mjs");
var _setUpTOTPMjs = require("./providers/cognito/apis/setUpTOTP.mjs");
var _updateUserAttributesMjs = require("./providers/cognito/apis/updateUserAttributes.mjs");
var _updateUserAttributeMjs = require("./providers/cognito/apis/updateUserAttribute.mjs");
var _getCurrentUserMjs = require("./providers/cognito/apis/getCurrentUser.mjs");
var _confirmUserAttributeMjs = require("./providers/cognito/apis/confirmUserAttribute.mjs");
var _signInWithRedirectMjs = require("./providers/cognito/apis/signInWithRedirect.mjs");
var _fetchUserAttributesMjs = require("./providers/cognito/apis/fetchUserAttributes.mjs");
var _signOutMjs = require("./providers/cognito/apis/signOut.mjs");
var _sendUserAttributeVerificationCodeMjs = require("./providers/cognito/apis/sendUserAttributeVerificationCode.mjs");
var _deleteUserAttributesMjs = require("./providers/cognito/apis/deleteUserAttributes.mjs");
var _deleteUserMjs = require("./providers/cognito/apis/deleteUser.mjs");
var _rememberDeviceMjs = require("./providers/cognito/apis/rememberDevice.mjs");
var _forgetDeviceMjs = require("./providers/cognito/apis/forgetDevice.mjs");
var _fetchDevicesMjs = require("./providers/cognito/apis/fetchDevices.mjs");
var _autoSignInMjs = require("./providers/cognito/apis/autoSignIn.mjs");
var _core = require("@aws-amplify/core");
var _identityIdStoreMjs = require("./providers/cognito/credentialsProvider/IdentityIdStore.mjs");
var _credentialsProviderMjs = require("./providers/cognito/credentialsProvider/credentialsProvider.mjs");
var _refreshAuthTokensMjs = require("./providers/cognito/utils/refreshAuthTokens.mjs");
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("./errors/AuthError.mjs");
var _errorHelpersMjs = require("./providers/cognito/tokenProvider/errorHelpers.mjs");
var _typesMjs = require("./providers/cognito/utils/types.mjs");
var _tokenProviderMjs = require("./providers/cognito/tokenProvider/tokenProvider.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _constantsMjs = require("./errors/constants.mjs");
var _errorsMjs = require("./Errors.mjs");
var _authErrorStringsMjs = require("./common/AuthErrorStrings.mjs");
var _authMjs = require("./types/Auth.mjs");
var _associateWebAuthnCredentialMjs = require("./client/apis/associateWebAuthnCredential.mjs");
var _listWebAuthnCredentialsMjs = require("./client/apis/listWebAuthnCredentials.mjs");
var _deleteWebAuthnCredentialMjs = require("./client/apis/deleteWebAuthnCredential.mjs");

},{"./providers/cognito/apis/signUp.mjs":"6nZRY","./providers/cognito/apis/resetPassword.mjs":"anzc6","./providers/cognito/apis/confirmResetPassword.mjs":"4pSNA","./providers/cognito/apis/signIn.mjs":"d1zyQ","./providers/cognito/apis/resendSignUpCode.mjs":"kjjWl","./providers/cognito/apis/confirmSignUp.mjs":"4B5Op","./providers/cognito/apis/confirmSignIn.mjs":"kpY4F","./providers/cognito/apis/updateMFAPreference.mjs":"aGvVO","./providers/cognito/apis/fetchMFAPreference.mjs":"jD2u5","./providers/cognito/apis/verifyTOTPSetup.mjs":"6prqr","./providers/cognito/apis/updatePassword.mjs":"9s8BB","./providers/cognito/apis/setUpTOTP.mjs":"7yigh","./providers/cognito/apis/updateUserAttributes.mjs":"HYnWw","./providers/cognito/apis/updateUserAttribute.mjs":"aqmtL","./providers/cognito/apis/getCurrentUser.mjs":"gllvP","./providers/cognito/apis/confirmUserAttribute.mjs":"fmKvE","./providers/cognito/apis/signInWithRedirect.mjs":"5fLS2","./providers/cognito/apis/fetchUserAttributes.mjs":"Eu74O","./providers/cognito/apis/signOut.mjs":"8tOG3","./providers/cognito/apis/sendUserAttributeVerificationCode.mjs":"28INX","./providers/cognito/apis/deleteUserAttributes.mjs":"kNiQK","./providers/cognito/apis/deleteUser.mjs":"2DqRw","./providers/cognito/apis/rememberDevice.mjs":"5PGM4","./providers/cognito/apis/forgetDevice.mjs":"5U9Bh","./providers/cognito/apis/fetchDevices.mjs":"exXI6","./providers/cognito/apis/autoSignIn.mjs":"jECSX","@aws-amplify/core":"94XF7","./providers/cognito/credentialsProvider/IdentityIdStore.mjs":"8kQMk","./providers/cognito/credentialsProvider/credentialsProvider.mjs":"amlGl","./providers/cognito/utils/refreshAuthTokens.mjs":"5xqj9","@aws-amplify/core/internals/utils":"aiEf6","./errors/AuthError.mjs":"4RqZd","./providers/cognito/tokenProvider/errorHelpers.mjs":"5hyq8","./providers/cognito/utils/types.mjs":"4GeFs","./providers/cognito/tokenProvider/tokenProvider.mjs":"9mSqK","@aws-crypto/sha256-js":"5A0J7","./errors/constants.mjs":"8qcdh","./Errors.mjs":"6EoGv","./common/AuthErrorStrings.mjs":"eO30C","./types/Auth.mjs":"lMA8M","./client/apis/associateWebAuthnCredential.mjs":"2HJzb","./client/apis/listWebAuthnCredentials.mjs":"dMbFS","./client/apis/deleteWebAuthnCredential.mjs":"2JRid","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6nZRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signUp", ()=>signUp);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _apiHelpersMjs = require("../utils/apiHelpers.mjs");
var _signUpHelpersMjs = require("../utils/signUpHelpers.mjs");
var _userContextDataMjs = require("../utils/userContextData.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _createSignUpClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createSignUpClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _autoSignInMjs = require("./autoSignIn.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signUp(input) {
    var _Amplify_getConfig_Auth;
    const { username, password, options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    var _authConfig_signUpVerificationMethod;
    const signUpVerificationMethod = (_authConfig_signUpVerificationMethod = authConfig === null || authConfig === void 0 ? void 0 : authConfig.signUpVerificationMethod) !== null && _authConfig_signUpVerificationMethod !== void 0 ? _authConfig_signUpVerificationMethod : 'code';
    var _input_options;
    const { clientMetadata, validationData, autoSignIn } = (_input_options = input.options) !== null && _input_options !== void 0 ? _input_options : {};
    (0, _utils.assertTokenProviderConfig)(authConfig);
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignUpUsername);
    const signInServiceOptions = typeof autoSignIn !== 'boolean' ? autoSignIn : undefined;
    const signInInput = {
        username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if ((signInServiceOptions === null || signInServiceOptions === void 0 ? void 0 : signInServiceOptions.authFlowType) !== 'CUSTOM_WITHOUT_SRP') signInInput.password = password;
    const { userPoolId, userPoolClientId, userPoolEndpoint } = authConfig;
    const signUpClient = (0, _createSignUpClientMjs.createSignUpClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const signUpClientInput = {
        Username: username,
        Password: undefined,
        UserAttributes: (options === null || options === void 0 ? void 0 : options.userAttributes) && (0, _apiHelpersMjs.toAttributeType)(options === null || options === void 0 ? void 0 : options.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, _apiHelpersMjs.toAttributeType)(validationData),
        ClientId: userPoolClientId,
        UserContextData: (0, _userContextDataMjs.getUserContextData)({
            username,
            userPoolId,
            userPoolClientId
        })
    };
    if (password) signUpClientInput.Password = password;
    const { UserSub: userId, CodeDeliveryDetails: cdd, UserConfirmed: userConfirmed, Session: session } = await signUpClient({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignUp)
    }, signUpClientInput);
    if (signInServiceOptions || autoSignIn === true) {
        (0, _autoSignInStoreMjs.autoSignInStore).dispatch({
            type: 'START'
        });
        (0, _autoSignInStoreMjs.autoSignInStore).dispatch({
            type: 'SET_USERNAME',
            value: username
        });
        (0, _autoSignInStoreMjs.autoSignInStore).dispatch({
            type: 'SET_SESSION',
            value: session
        });
    }
    const codeDeliveryDetails = {
        destination: cdd === null || cdd === void 0 ? void 0 : cdd.Destination,
        deliveryMedium: cdd === null || cdd === void 0 ? void 0 : cdd.DeliveryMedium,
        attributeName: cdd === null || cdd === void 0 ? void 0 : cdd.AttributeName
    };
    const isSignUpComplete = !!userConfirmed;
    const isAutoSignInStarted = (0, _autoSignInStoreMjs.autoSignInStore).getState().active;
    // Sign Up Complete
    // No Confirm Sign In Step Required
    if (isSignUpComplete) {
        if (isAutoSignInStarted) {
            (0, _autoSignInMjs.setAutoSignIn)((0, _signUpHelpersMjs.autoSignInUserConfirmed)(signInInput));
            return {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: 'COMPLETE_AUTO_SIGN_IN'
                },
                userId
            };
        }
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: 'DONE'
            },
            userId
        };
    }
    // Sign Up Not Complete
    // Confirm Sign Up Step Required
    if (isAutoSignInStarted) {
        // Confirmation Via Link Occurs In Separate Context
        // AutoSignIn Fn Will Initiate Polling Once Executed
        if (signUpVerificationMethod === 'link') {
            (0, _autoSignInMjs.setAutoSignIn)((0, _signUpHelpersMjs.autoSignInWhenUserIsConfirmedWithLink)(signInInput));
            return {
                isSignUpComplete: false,
                nextStep: {
                    signUpStep: 'COMPLETE_AUTO_SIGN_IN',
                    codeDeliveryDetails
                },
                userId
            };
        }
        // Confirmation Via Code Occurs In Same Context
        // AutoSignIn Next Step Will Be Returned From Confirm Sign Up
        (0, _signUpHelpersMjs.handleCodeAutoSignIn)(signInInput);
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: 'CONFIRM_SIGN_UP',
            codeDeliveryDetails
        },
        userId
    };
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/types/validation.mjs":"frXJ6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/apiHelpers.mjs":"8W5aY","../utils/signUpHelpers.mjs":"bGQ9F","../utils/userContextData.mjs":"hZOPS","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createSignUpClient.mjs":"217m3","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","./autoSignIn.mjs":"jECSX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aiEf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateRandomString", ()=>(0, _generateRandomStringMjs.generateRandomString));
parcelHelpers.export(exports, "getClientInfo", ()=>(0, _getClientInfoMjs.getClientInfo));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserMjs.isBrowser));
parcelHelpers.export(exports, "isWebWorker", ()=>(0, _isWebWorkerMjs.isWebWorker));
parcelHelpers.export(exports, "NonRetryableError", ()=>(0, _nonRetryableErrorMjs.NonRetryableError));
parcelHelpers.export(exports, "isNonRetryableError", ()=>(0, _isNonRetryableErrorMjs.isNonRetryableError));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _jitteredBackoffMjs.jitteredBackoff));
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>(0, _jitteredExponentialRetryMjs.jitteredExponentialRetry));
parcelHelpers.export(exports, "retry", ()=>(0, _retryMjs.retry));
parcelHelpers.export(exports, "urlSafeDecode", ()=>(0, _urlSafeDecodeMjs.urlSafeDecode));
parcelHelpers.export(exports, "urlSafeEncode", ()=>(0, _urlSafeEncodeMjs.urlSafeEncode));
parcelHelpers.export(exports, "deDupeAsyncFunction", ()=>(0, _deDupeAsyncFunctionMjs.deDupeAsyncFunction));
parcelHelpers.export(exports, "isTokenExpired", ()=>(0, _isTokenExpiredMjs.isTokenExpired));
parcelHelpers.export(exports, "parseAWSExports", ()=>(0, _parseAWSExportsMjs.parseAWSExports));
parcelHelpers.export(exports, "isAmplifyOutputs", ()=>(0, _parseAmplifyOutputsMjs.isAmplifyOutputs));
parcelHelpers.export(exports, "parseAmplifyOutputs", ()=>(0, _parseAmplifyOutputsMjs.parseAmplifyOutputs));
parcelHelpers.export(exports, "ADD_OAUTH_LISTENER", ()=>(0, _constantsMjs.ADD_OAUTH_LISTENER));
parcelHelpers.export(exports, "amplifyUuid", ()=>(0, _indexMjs.amplifyUuid));
parcelHelpers.export(exports, "AmplifyUrl", ()=>(0, _indexMjs1.AmplifyUrl));
parcelHelpers.export(exports, "AmplifyUrlSearchParams", ()=>(0, _indexMjs1.AmplifyUrlSearchParams));
parcelHelpers.export(exports, "parseAmplifyConfig", ()=>(0, _parseAmplifyConfigMjs.parseAmplifyConfig));
parcelHelpers.export(exports, "getDeviceName", ()=>(0, _getDeviceNameMjs.getDeviceName));
parcelHelpers.export(exports, "assertIdentityPoolIdConfig", ()=>(0, _indexMjs2.assertIdentityPoolIdConfig));
parcelHelpers.export(exports, "assertOAuthConfig", ()=>(0, _indexMjs2.assertOAuthConfig));
parcelHelpers.export(exports, "assertTokenProviderConfig", ()=>(0, _indexMjs2.assertTokenProviderConfig));
parcelHelpers.export(exports, "decodeJWT", ()=>(0, _indexMjs2.decodeJWT));
parcelHelpers.export(exports, "Signer", ()=>(0, _signerMjs.Signer));
parcelHelpers.export(exports, "haveCredentialsChanged", ()=>(0, _haveCredentialsChangedMjs.haveCredentialsChanged));
parcelHelpers.export(exports, "Platform", ()=>(0, _indexMjs3.Platform));
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>(0, _indexMjs3.getAmplifyUserAgent));
parcelHelpers.export(exports, "getAmplifyUserAgentObject", ()=>(0, _indexMjs3.getAmplifyUserAgentObject));
parcelHelpers.export(exports, "AiAction", ()=>(0, _typesMjs.AiAction));
parcelHelpers.export(exports, "AnalyticsAction", ()=>(0, _typesMjs.AnalyticsAction));
parcelHelpers.export(exports, "ApiAction", ()=>(0, _typesMjs.ApiAction));
parcelHelpers.export(exports, "AuthAction", ()=>(0, _typesMjs.AuthAction));
parcelHelpers.export(exports, "Category", ()=>(0, _typesMjs.Category));
parcelHelpers.export(exports, "DataStoreAction", ()=>(0, _typesMjs.DataStoreAction));
parcelHelpers.export(exports, "Framework", ()=>(0, _typesMjs.Framework));
parcelHelpers.export(exports, "GeoAction", ()=>(0, _typesMjs.GeoAction));
parcelHelpers.export(exports, "InAppMessagingAction", ()=>(0, _typesMjs.InAppMessagingAction));
parcelHelpers.export(exports, "InteractionsAction", ()=>(0, _typesMjs.InteractionsAction));
parcelHelpers.export(exports, "PredictionsAction", ()=>(0, _typesMjs.PredictionsAction));
parcelHelpers.export(exports, "PubSubAction", ()=>(0, _typesMjs.PubSubAction));
parcelHelpers.export(exports, "PushNotificationAction", ()=>(0, _typesMjs.PushNotificationAction));
parcelHelpers.export(exports, "StorageAction", ()=>(0, _typesMjs.StorageAction));
parcelHelpers.export(exports, "setCustomUserAgent", ()=>(0, _customUserAgentMjs.setCustomUserAgent));
parcelHelpers.export(exports, "AmplifyError", ()=>(0, _amplifyErrorMjs.AmplifyError));
parcelHelpers.export(exports, "ApiError", ()=>(0, _apierrorMjs.ApiError));
parcelHelpers.export(exports, "createAssertionFunction", ()=>(0, _createAssertionFunctionMjs.createAssertionFunction));
parcelHelpers.export(exports, "PlatformNotSupportedError", ()=>(0, _platformNotSupportedErrorMjs.PlatformNotSupportedError));
parcelHelpers.export(exports, "AmplifyErrorCode", ()=>(0, _errorsMjs.AmplifyErrorCode));
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>(0, _backgroundProcessManagerMjs.BackgroundProcessManager));
parcelHelpers.export(exports, "Mutex", ()=>(0, _mutexMjs.Mutex));
parcelHelpers.export(exports, "Reachability", ()=>(0, _reachabilityMjs.Reachability));
parcelHelpers.export(exports, "USER_AGENT_HEADER", ()=>(0, _constantsMjs1.USER_AGENT_HEADER));
parcelHelpers.export(exports, "fetchAuthSession", ()=>(0, _fetchAuthSessionMjs.fetchAuthSession));
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>(0, _indexMjs4.AMPLIFY_SYMBOL));
parcelHelpers.export(exports, "HubInternal", ()=>(0, _indexMjs4.HubInternal));
parcelHelpers.export(exports, "base64Decoder", ()=>(0, _base64DecoderMjs.base64Decoder));
parcelHelpers.export(exports, "base64Encoder", ()=>(0, _base64EncoderMjs.base64Encoder));
parcelHelpers.export(exports, "getCrypto", ()=>(0, _indexMjs5.getCrypto));
parcelHelpers.export(exports, "cryptoSecureRandomInt", ()=>(0, _cryptoSecureRandomIntMjs.cryptoSecureRandomInt));
parcelHelpers.export(exports, "WordArray", ()=>(0, _wordArrayMjs.WordArray));
parcelHelpers.export(exports, "sessionListener", ()=>(0, _indexMjs6.sessionListener));
parcelHelpers.export(exports, "SESSION_START_EVENT", ()=>(0, _constantsMjs2.SESSION_START_EVENT));
parcelHelpers.export(exports, "SESSION_STOP_EVENT", ()=>(0, _constantsMjs2.SESSION_STOP_EVENT));
var _generateRandomStringMjs = require("./utils/generateRandomString.mjs");
var _getClientInfoMjs = require("./utils/getClientInfo/getClientInfo.mjs");
var _isBrowserMjs = require("./utils/isBrowser.mjs");
var _isWebWorkerMjs = require("./utils/isWebWorker.mjs");
var _nonRetryableErrorMjs = require("./utils/retry/NonRetryableError.mjs");
var _isNonRetryableErrorMjs = require("./utils/retry/isNonRetryableError.mjs");
var _jitteredBackoffMjs = require("./utils/retry/jitteredBackoff.mjs");
var _jitteredExponentialRetryMjs = require("./utils/retry/jitteredExponentialRetry.mjs");
var _retryMjs = require("./utils/retry/retry.mjs");
var _urlSafeDecodeMjs = require("./utils/urlSafeDecode.mjs");
var _urlSafeEncodeMjs = require("./utils/urlSafeEncode.mjs");
var _deDupeAsyncFunctionMjs = require("./utils/deDupeAsyncFunction.mjs");
var _isTokenExpiredMjs = require("./utils/isTokenExpired.mjs");
var _parseAWSExportsMjs = require("./parseAWSExports.mjs");
var _parseAmplifyOutputsMjs = require("./parseAmplifyOutputs.mjs");
var _constantsMjs = require("./singleton/constants.mjs");
var _indexMjs = require("./utils/amplifyUuid/index.mjs");
var _indexMjs1 = require("./utils/amplifyUrl/index.mjs");
var _parseAmplifyConfigMjs = require("./utils/parseAmplifyConfig.mjs");
var _getDeviceNameMjs = require("./utils/deviceName/getDeviceName.mjs");
var _indexMjs2 = require("./singleton/Auth/utils/index.mjs");
var _signerMjs = require("./Signer/Signer.mjs");
var _haveCredentialsChangedMjs = require("./utils/haveCredentialsChanged.mjs");
var _indexMjs3 = require("./Platform/index.mjs");
var _typesMjs = require("./Platform/types.mjs");
var _customUserAgentMjs = require("./Platform/customUserAgent.mjs");
var _amplifyErrorMjs = require("./errors/AmplifyError.mjs");
var _apierrorMjs = require("./errors/APIError.mjs");
var _createAssertionFunctionMjs = require("./errors/createAssertionFunction.mjs");
var _platformNotSupportedErrorMjs = require("./errors/PlatformNotSupportedError.mjs");
var _errorHelpersMjs = require("./errors/errorHelpers.mjs");
var _errorsMjs = require("./types/errors.mjs");
var _backgroundProcessManagerMjs = require("./BackgroundProcessManager/BackgroundProcessManager.mjs");
var _mutexMjs = require("./Mutex/Mutex.mjs");
var _reachabilityMjs = require("./Reachability/Reachability.mjs");
var _constantsMjs1 = require("./constants.mjs");
var _fetchAuthSessionMjs = require("./singleton/apis/internal/fetchAuthSession.mjs");
var _indexMjs4 = require("./Hub/index.mjs");
var _base64DecoderMjs = require("./utils/convert/base64/base64Decoder.mjs");
var _base64EncoderMjs = require("./utils/convert/base64/base64Encoder.mjs");
var _indexMjs5 = require("./utils/globalHelpers/index.mjs");
var _cryptoSecureRandomIntMjs = require("./utils/cryptoSecureRandomInt.mjs");
var _wordArrayMjs = require("./utils/WordArray.mjs");
var _indexMjs6 = require("./utils/sessionListener/index.mjs");
var _constantsMjs2 = require("./utils/sessionListener/constants.mjs");

},{"./utils/generateRandomString.mjs":"dkTFD","./utils/getClientInfo/getClientInfo.mjs":"gMIbI","./utils/isBrowser.mjs":"fcM16","./utils/isWebWorker.mjs":"iXFzc","./utils/retry/NonRetryableError.mjs":"8WBmM","./utils/retry/isNonRetryableError.mjs":"kyGTP","./utils/retry/jitteredBackoff.mjs":"8sNtw","./utils/retry/jitteredExponentialRetry.mjs":"lWMRE","./utils/retry/retry.mjs":"eFvhH","./utils/urlSafeDecode.mjs":"34pT8","./utils/urlSafeEncode.mjs":"cZoCm","./utils/deDupeAsyncFunction.mjs":"ggsQP","./utils/isTokenExpired.mjs":"4efZi","./parseAWSExports.mjs":"4w5h9","./parseAmplifyOutputs.mjs":"iA5kP","./singleton/constants.mjs":"f5Lch","./utils/amplifyUuid/index.mjs":"9DnN6","./utils/amplifyUrl/index.mjs":"4l1t5","./utils/parseAmplifyConfig.mjs":"5uPpw","./utils/deviceName/getDeviceName.mjs":"dD8hh","./singleton/Auth/utils/index.mjs":"57gzf","./Signer/Signer.mjs":"4cBcL","./utils/haveCredentialsChanged.mjs":"eIhnN","./Platform/index.mjs":"34W7w","./Platform/types.mjs":"8YCjz","./Platform/customUserAgent.mjs":"9MkrV","./errors/AmplifyError.mjs":"9LcuL","./errors/APIError.mjs":"gdAfY","./errors/createAssertionFunction.mjs":"lBq8c","./errors/PlatformNotSupportedError.mjs":"keBB5","./errors/errorHelpers.mjs":"fvR3Q","./types/errors.mjs":"2tN68","./BackgroundProcessManager/BackgroundProcessManager.mjs":"iFzIG","./Mutex/Mutex.mjs":"2cOrg","./Reachability/Reachability.mjs":"1EGHg","./constants.mjs":"1d7L6","./singleton/apis/internal/fetchAuthSession.mjs":"2tfxu","./Hub/index.mjs":"hkdby","./utils/convert/base64/base64Decoder.mjs":"58oTM","./utils/convert/base64/base64Encoder.mjs":"PazUa","./utils/globalHelpers/index.mjs":"5JDaI","./utils/cryptoSecureRandomInt.mjs":"9CgaU","./utils/WordArray.mjs":"9EK58","./utils/sessionListener/index.mjs":"4uBhf","./utils/sessionListener/constants.mjs":"k9UzK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dkTFD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateRandomString", ()=>generateRandomString);
var _indexMjs = require("./globalHelpers/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const generateRandomString = (length)=>{
    const STATE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const result = [];
    const randomNums = new Uint8Array(length);
    (0, _indexMjs.getCrypto)().getRandomValues(randomNums);
    for (const num of randomNums)result.push(STATE_CHARSET[num % STATE_CHARSET.length]);
    return result.join('');
};

},{"./globalHelpers/index.mjs":"5JDaI","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8WBmM":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", ()=>NonRetryableError);
class NonRetryableError extends Error {
    constructor(){
        super(...arguments);
        this.nonRetryable = true;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lWMRE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>jitteredExponentialRetry);
var _constantsMjs = require("./constants.mjs");
var _jitteredBackoffMjs = require("./jitteredBackoff.mjs");
var _retryMjs = require("./retry.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ const jitteredExponentialRetry = (functionToRetry, args, maxDelayMs = (0, _constantsMjs.MAX_DELAY_MS), onTerminate)=>(0, _retryMjs.retry)(functionToRetry, args, (0, _jitteredBackoffMjs.jitteredBackoff)(maxDelayMs), onTerminate);

},{"./constants.mjs":"4RAEE","./jitteredBackoff.mjs":"8sNtw","./retry.mjs":"eFvhH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"34pT8":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlSafeDecode", ()=>urlSafeDecode);
function urlSafeDecode(hex) {
    const matchArr = hex.match(/.{2}/g) || [];
    return matchArr.map((char)=>String.fromCharCode(parseInt(char, 16))).join('');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cZoCm":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlSafeEncode", ()=>urlSafeEncode);
function urlSafeEncode(str) {
    return str.split('').map((char)=>char.charCodeAt(0).toString(16).padStart(2, '0')).join('');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ggsQP":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deDupeAsyncFunction", ()=>deDupeAsyncFunction);
const deDupeAsyncFunction = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4efZi":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTokenExpired", ()=>isTokenExpired);
function isTokenExpired({ expiresAt, clockDrift, tolerance = 5000 }) {
    const currentTime = Date.now();
    return currentTime + clockDrift + tolerance > expiresAt;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dD8hh":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Retrieves the device name using the User-Agent Client Hints API if available,
 * falling back to the traditional userAgent string if not.
 *
 * @returns {Promise<string>} A promise that resolves with a string representing the device name.
 *
 * Example Output:
 * navigator.userAgentData:
 *   'macOS 14.2.1 arm macOS Not A(Brand/99.0.0.0;Google Chrome/121.0.6167.160;Chromium/121.0.6167.160'
 * navigator.userAgent:
 *   'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/115.0'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDeviceName", ()=>getDeviceName);
const getDeviceName = async ()=>{
    const { userAgentData } = navigator;
    if (!userAgentData) return navigator.userAgent;
    const { platform = '', platformVersion = '', model = '', architecture = '', fullVersionList = [] } = await userAgentData.getHighEntropyValues([
        'platform',
        'platformVersion',
        'architecture',
        'model',
        'fullVersionList'
    ]);
    const versionList = fullVersionList.map((v)=>`${v.brand}/${v.version}`).join(';');
    const deviceName = [
        platform,
        platformVersion,
        architecture,
        model,
        platform,
        versionList
    ].filter((value)=>value).join(' ');
    return deviceName || navigator.userAgent;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4cBcL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Signer", ()=>Signer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _signRequestMjs = require("../clients/middleware/signing/signer/signatureV4/signRequest.mjs");
var _presignUrlMjs = require("../clients/middleware/signing/signer/signatureV4/presignUrl.mjs");
var _constantsMjs = require("../clients/middleware/signing/signer/signatureV4/constants.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@smithy/util-hex-encoding");
var _indexMjs = require("../utils/amplifyUrl/index.mjs");
var _dateUtilsMjs = require("./DateUtils.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const IOT_SERVICE_NAME = 'iotdevicegateway';
// Best practice regex to parse the service and region from an AWS endpoint
const AWS_ENDPOINT_REGEX = /([^.]+)\.(?:([^.]*)\.)?amazonaws\.com(.cn)?$/;
/**
 * This class is intended to be deprecated and replaced by `signRequest` and `presignUrl` functions from
 * `clients/middleware/signing/signer/signatureV4`.
 *
 * TODO: refactor the logics here into `signRequest` and `presignUrl` functions and remove this class.
 *
 * @internal
 * @deprecated
 */ class Signer {
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ static sign(request, accessInfo, serviceInfo) {
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        const requestToSign = (0, _objectSpreadProps._)((0, _objectSpread._)({}, request), {
            body: request.data,
            url: new (0, _indexMjs.AmplifyUrl)(request.url)
        });
        const options = getOptions(requestToSign, accessInfo, serviceInfo);
        const signedRequest = (0, _signRequestMjs.signRequest)(requestToSign, options);
        // Prior to using `signRequest`, Signer accepted urls as strings and outputted urls as string. Coerce the property
        // back to a string so as not to disrupt consumers of Signer.
        signedRequest.url = signedRequest.url.toString();
        // HTTP headers should be case insensitive but, to maintain parity with the previous Signer implementation and
        // limit the impact of this implementation swap, replace lowercased headers with title cased ones.
        signedRequest.headers.Authorization = signedRequest.headers.authorization;
        signedRequest.headers['X-Amz-Security-Token'] = signedRequest.headers['x-amz-security-token'];
        delete signedRequest.headers.authorization;
        delete signedRequest.headers['x-amz-security-token'];
        return signedRequest;
    }
    static signUrl(urlOrRequest, accessInfo, serviceInfo, expiration) {
        const urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        const method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        const body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        const presignable = {
            body,
            method,
            url: new (0, _indexMjs.AmplifyUrl)(urlToSign)
        };
        const options = getOptions(presignable, accessInfo, serviceInfo, expiration);
        const signedUrl = (0, _presignUrlMjs.presignUrl)(presignable, options);
        if (accessInfo.session_token && !sessionTokenRequiredInSigning(options.signingService)) signedUrl.searchParams.append((0, _constantsMjs.TOKEN_QUERY_PARAM), accessInfo.session_token);
        return signedUrl.toString();
    }
}
const getOptions = (request, accessInfo, serviceInfo, expiration)=>{
    const { access_key, secret_key, session_token } = accessInfo !== null && accessInfo !== void 0 ? accessInfo : {};
    const { region: urlRegion, service: urlService } = parseServiceInfo(request.url);
    const { region = urlRegion, service = urlService } = serviceInfo !== null && serviceInfo !== void 0 ? serviceInfo : {};
    const credentials = (0, _objectSpread._)({
        accessKeyId: access_key,
        secretAccessKey: secret_key
    }, sessionTokenRequiredInSigning(service) ? {
        sessionToken: session_token
    } : {});
    return (0, _objectSpread._)({
        credentials,
        signingDate: (0, _dateUtilsMjs.DateUtils).getDateWithClockOffset(),
        signingRegion: region,
        signingService: service
    }, expiration && {
        expiration
    });
};
const parseServiceInfo = (url)=>{
    const { host } = url;
    var _host_match;
    const matched = (_host_match = host.match(AWS_ENDPOINT_REGEX)) !== null && _host_match !== void 0 ? _host_match : [];
    let parsed = matched.slice(1, 3);
    if (parsed[1] === 'es') // Elastic Search
    parsed = parsed.reverse();
    return {
        service: parsed[0],
        region: parsed[1]
    };
};
// IoT service does not allow the session token in the canonical request
// https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
const sessionTokenRequiredInSigning = (service)=>service !== IOT_SERVICE_NAME;

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../clients/middleware/signing/signer/signatureV4/signRequest.mjs":"1bdLF","../clients/middleware/signing/signer/signatureV4/presignUrl.mjs":"ii53b","../clients/middleware/signing/signer/signatureV4/constants.mjs":"9SfSa","@aws-crypto/sha256-js":"5A0J7","@smithy/util-hex-encoding":"ghBtt","../utils/amplifyUrl/index.mjs":"4l1t5","./DateUtils.mjs":"hulZB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ii53b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presignUrl", ()=>presignUrl);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _indexMjs = require("../../../../../utils/amplifyUrl/index.mjs");
var _constantsMjs = require("./constants.mjs");
var _getSigningValuesMjs = require("./utils/getSigningValues.mjs");
var _getSignatureMjs = require("./utils/getSignature.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Given a `Presignable` object, returns a Signature Version 4 presigned `URL` object.
 *
 * @param presignable `Presignable` object containing at least a url to be presigned with authentication query params.
 * @param presignUrlOptions `PresignUrlOptions` object containing values used to construct the signature.
 * @returns A `URL` with authentication query params which can grant temporary access to AWS resources.
 */ const presignUrl = (_param, _param1)=>{
    var { body, method = 'GET', url } = _param, { expiration } = _param1, options = (0, _objectWithoutProperties._)(_param1, [
        "expiration"
    ]);
    const signingValues = (0, _getSigningValuesMjs.getSigningValues)(options);
    const { accessKeyId, credentialScope, longDate, sessionToken } = signingValues;
    // create the request to sign
    const presignedUrl = new (0, _indexMjs.AmplifyUrl)(url);
    Object.entries((0, _objectSpread._)({
        [(0, _constantsMjs.ALGORITHM_QUERY_PARAM)]: (0, _constantsMjs.SHA256_ALGORITHM_IDENTIFIER),
        [(0, _constantsMjs.CREDENTIAL_QUERY_PARAM)]: `${accessKeyId}/${credentialScope}`,
        [(0, _constantsMjs.AMZ_DATE_QUERY_PARAM)]: longDate,
        [(0, _constantsMjs.SIGNED_HEADERS_QUERY_PARAM)]: (0, _constantsMjs.HOST_HEADER)
    }, expiration && {
        [(0, _constantsMjs.EXPIRES_QUERY_PARAM)]: expiration.toString()
    }, sessionToken && {
        [(0, _constantsMjs.TOKEN_QUERY_PARAM)]: sessionToken
    })).forEach(([key, value])=>{
        presignedUrl.searchParams.append(key, value);
    });
    const requestToSign = {
        body,
        headers: {
            [(0, _constantsMjs.HOST_HEADER)]: url.host
        },
        method,
        url: presignedUrl
    };
    // calculate and add the signature to the url
    const signature = (0, _getSignatureMjs.getSignature)(requestToSign, signingValues);
    presignedUrl.searchParams.append((0, _constantsMjs.SIGNATURE_QUERY_PARAM), signature);
    return presignedUrl;
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_without_properties":"13dVA","../../../../../utils/amplifyUrl/index.mjs":"4l1t5","./constants.mjs":"9SfSa","./utils/getSigningValues.mjs":"dhomR","./utils/getSignature.mjs":"7fhkR","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hulZB":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateUtils", ()=>DateUtils);
const FIVE_MINUTES_IN_MS = 300000;
/**
 * This utility is intended to be deprecated and replaced by `signRequest` and `presignUrl` functions from
 * `clients/middleware/signing/signer/signatureV4`.
 *
 * TODO: refactor the logics here into `signRequest` and `presignUrl` functions and remove this class.
 *
 * @internal
 * @deprecated
 */ const DateUtils = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset () {
        if (DateUtils.clockOffset) return new Date(new Date().getTime() + DateUtils.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset () {
        return DateUtils.clockOffset;
    },
    getHeaderStringFromDate (date = DateUtils.getDateWithClockOffset()) {
        return date.toISOString().replace(/[:-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString (header) {
        const [, year, month, day, hour, minute, second] = header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/);
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed (serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - DateUtils.getDateWithClockOffset().getTime()) >= FIVE_MINUTES_IN_MS;
    },
    isClockSkewError (error) {
        if (!error.response || !error.response.headers) return false;
        const { headers } = error.response;
        return Boolean([
            'BadRequestException',
            'InvalidSignatureException'
        ].includes(headers['x-amzn-errortype']) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset (offset) {
        DateUtils.clockOffset = offset;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gdAfY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApiError", ()=>ApiError);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _amplifyErrorMjs = require("./AmplifyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Error class for errors that associated with unsuccessful HTTP responses.
 * It's throw by API category REST API handlers and GraphQL query handlers for now.
 */ class ApiError extends (0, _amplifyErrorMjs.AmplifyError) {
    /**
     * The unwrapped HTTP response causing the given API error.
     */ get response() {
        return this._response ? replicateApiErrorResponse(this._response) : undefined;
    }
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = ApiError;
        Object.setPrototypeOf(this, ApiError.prototype);
        if (params.response) this._response = params.response;
    }
}
const replicateApiErrorResponse = (response)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, response), {
        headers: (0, _objectSpread._)({}, response.headers)
    });

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","./AmplifyError.mjs":"9LcuL","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iFzIG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>BackgroundProcessManager);
var _backgroundManagerNotOpenErrorMjs = require("./BackgroundManagerNotOpenError.mjs");
var _typesMjs = require("./types.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private For internal Amplify use.
 *
 * Creates a new scope for promises, observables, and other types of work or
 * processes that may be running in the background. This manager provides
 * an singular entrypoint to request termination and await completion.
 *
 * As work completes on its own prior to close, the manager removes them
 * from the registry to avoid holding references to completed jobs.
 */ class BackgroundProcessManager {
    add(jobOrDescription, optionalDescription) {
        let job;
        let description;
        if (typeof jobOrDescription === 'string') {
            job = undefined;
            description = jobOrDescription;
        } else {
            job = jobOrDescription;
            description = optionalDescription;
        }
        const error = this.closedFailure(description);
        if (error) return error;
        if (job === undefined) return this.addHook(description);
        else if (typeof job === 'function') return this.addFunction(job, description);
        else if (job instanceof BackgroundProcessManager) this.addManager(job, description);
        else throw new Error('If `job` is provided, it must be an Observable, Function, or BackgroundProcessManager.');
    }
    /**
     * Adds a **cleaner** function that doesn't immediately get executed.
     * Instead, the caller gets a **terminate** function back. The *cleaner* is
     * invoked only once the mananger *closes* or the returned **terminate**
     * function is called.
     *
     * @param clean The cleanup function.
     * @param description Optional description to help identify pending jobs.
     * @returns A terminate function.
     */ addCleaner(clean, description) {
        const { resolve, onTerminate } = this.addHook(description);
        const proxy = async ()=>{
            await clean();
            resolve();
        };
        onTerminate.then(proxy);
        return proxy;
    }
    addFunction(job, description) {
        // the function we call when we want to try to terminate this job.
        let terminate;
        // the promise the job can opt into listening to for termination.
        const onTerminate = new Promise((resolve)=>{
            terminate = resolve;
        });
        // finally! start the job.
        const jobResult = job(onTerminate);
        // depending on what the job gives back, register the result
        // so we can monitor for completion.
        if (typeof (jobResult === null || jobResult === void 0 ? void 0 : jobResult.then) === 'function') this.registerPromise(jobResult, terminate, description);
        // At the end of the day, or you know, method call, it doesn't matter
        // what the return value is at all; we just pass it through to the
        // caller.
        return jobResult;
    }
    addManager(manager, description) {
        this.addCleaner(async ()=>manager.close(), description);
    }
    /**
     * Creates and registers a fabricated job for processes that need to operate
     * with callbacks/hooks. The returned `resolve` and `reject`
     * functions can be used to signal the job is done successfully or not.
     * The returned `onTerminate` is a promise that will resolve when the
     * manager is requesting the termination of the job.
     *
     * @param description Optional description to help identify pending jobs.
     * @returns `{ resolve, reject, onTerminate }`
     */ addHook(description) {
        // the resolve/reject functions we'll provide to the caller to signal
        // the state of the job.
        let promiseResolve;
        let promiseReject;
        // the underlying promise we'll use to manage it, pretty much like
        // any other promise.
        const promise = new Promise((resolve, reject)=>{
            promiseResolve = resolve;
            promiseReject = reject;
        });
        // the function we call when we want to try to terminate this job.
        let terminate;
        // the promise the job can opt into listening to for termination.
        const onTerminate = new Promise((resolve)=>{
            terminate = resolve;
        });
        this.registerPromise(promise, terminate, description);
        return {
            resolve: promiseResolve,
            reject: promiseReject,
            onTerminate
        };
    }
    /**
     * Adds a Promise based job to the list of jobs for monitoring and listens
     * for either a success or failure, upon which the job is considered "done"
     * and removed from the registry.
     *
     * @param promise A promise that is on its way to being returned to a
     * caller, which needs to be tracked as a background job.
     * @param terminate The termination function to register, which can be
     * invoked to request the job stop.
     * @param description Optional description to help identify pending jobs.
     */ registerPromise(promise, terminate, description) {
        const jobEntry = {
            promise,
            terminate,
            description
        };
        this.jobs.add(jobEntry);
        // in all of my testing, it is safe to multi-subscribe to a promise.
        // so, rather than create another layer of promising, we're just going
        // to hook into the promise we already have, and when it's done
        // (successfully or not), we no longer need to wait for it upon close.
        //
        // sorry this is a bit hand-wavy:
        //
        // i believe we use `.then` and `.catch` instead of `.finally` because
        // `.finally` is invoked in a different order in the sequence, and this
        // breaks assumptions throughout and causes failures.
        promise.then(()=>{
            this.jobs.delete(jobEntry);
        }).catch(()=>{
            this.jobs.delete(jobEntry);
        });
    }
    /**
     * The number of jobs being waited on.
     *
     * We don't use this for anything. It's just informational for the caller,
     * and can be used in logging and testing.
     *
     * @returns the number of jobs.
     */ get length() {
        return this.jobs.size;
    }
    /**
     * The execution state of the manager. One of:
     *
     * 1. "Open" -> Accepting new jobs
     * 1. "Closing" -> Not accepting new work. Waiting for jobs to complete.
     * 1. "Closed" -> Not accepting new work. All submitted jobs are complete.
     */ get state() {
        return this._state;
    }
    /**
     * The registered `description` of all still-pending jobs.
     *
     * @returns descriptions as an array.
     */ get pending() {
        return Array.from(this.jobs).map((job)=>job.description);
    }
    /**
     * Whether the manager is accepting new jobs.
     */ get isOpen() {
        return this._state === (0, _typesMjs.BackgroundProcessManagerState).Open;
    }
    /**
     * Whether the manager is rejecting new work, but still waiting for
     * submitted work to complete.
     */ get isClosing() {
        return this._state === (0, _typesMjs.BackgroundProcessManagerState).Closing;
    }
    /**
     * Whether the manager is rejecting work and done waiting for submitted
     * work to complete.
     */ get isClosed() {
        return this._state === (0, _typesMjs.BackgroundProcessManagerState).Closed;
    }
    closedFailure(description) {
        if (!this.isOpen) return Promise.reject(new (0, _backgroundManagerNotOpenErrorMjs.BackgroundManagerNotOpenError)([
            `The manager is ${this.state}.`,
            `You tried to add "${description}".`,
            `Pending jobs: [\n${this.pending.map((t)=>'    ' + t).join(',\n')}\n]`
        ].join('\n')));
    }
    /**
     * Signals jobs to stop (for those that accept interruptions) and waits
     * for confirmation that jobs have stopped.
     *
     * This immediately puts the manager into a closing state and just begins
     * to reject new work. After all work in the manager is complete, the
     * manager goes into a `Completed` state and `close()` returns.
     *
     * This call is idempotent.
     *
     * If the manager is already closing or closed, `finalCleaup` is not executed.
     *
     * @param onClosed
     * @returns The settled results of each still-running job's promise. If the
     * manager is already closed, this will contain the results as of when the
     * manager's `close()` was called in an `Open` state.
     */ async close() {
        if (this.isOpen) {
            this._state = (0, _typesMjs.BackgroundProcessManagerState).Closing;
            for (const job of Array.from(this.jobs))try {
                job.terminate();
            } catch (error) {
                // Due to potential races with a job's natural completion, it's
                // reasonable to expect the termination call to fail. Hence,
                // not logging as an error.
                // eslint-disable-next-line no-console
                console.warn(`Failed to send termination signal to job. Error: ${error.message}`, job);
            }
            // Use `allSettled()` because we want to wait for all to finish. We do
            // not want to stop waiting if there is a failure.
            this._closingPromise = Promise.allSettled(Array.from(this.jobs).map((j)=>j.promise));
            await this._closingPromise;
            this._state = (0, _typesMjs.BackgroundProcessManagerState).Closed;
        }
        return this._closingPromise;
    }
    /**
     * Signals the manager to start accepting work (again) and returns once
     * the manager is ready to do so.
     *
     * If the state is already `Open`, this call is a no-op.
     *
     * If the state is `Closed`, this call simply updates state and returns.
     *
     * If the state is `Closing`, this call waits for completion before it
     * updates the state and returns.
     */ async open() {
        if (this.isClosing) await this.close();
        this._state = (0, _typesMjs.BackgroundProcessManagerState).Open;
    }
    constructor(){
        /**
         * A string indicating whether the manager is accepting new work ("Open"),
         * waiting for work to complete ("Closing"), or fully done with all
         * submitted work and *not* accepting new jobs ("Closed").
         */ this._state = (0, _typesMjs.BackgroundProcessManagerState).Open;
        /**
         * The list of outstanding jobs we'll need to wait for upon `close()`
         */ this.jobs = new Set();
    }
}

},{"./BackgroundManagerNotOpenError.mjs":"9XG0K","./types.mjs":"3gmMQ","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9XG0K":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>BackgroundManagerNotOpenError);
class BackgroundManagerNotOpenError extends Error {
    constructor(message){
        super(`BackgroundManagerNotOpenError: ${message}`);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2cOrg":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutex", ()=>Mutex);
class Mutex {
    isLocked() {
        return this._pending;
    }
    acquire() {
        const ticket = new Promise((resolve)=>this._queue.push(resolve));
        if (!this._pending) this._dispatchNext();
        return ticket;
    }
    runExclusive(callback) {
        return this.acquire().then((release)=>{
            let result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then((x)=>{
                release();
                return x;
            }, (e)=>{
                release();
                throw e;
            });
        });
    }
    _dispatchNext() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    }
    constructor(){
        this._queue = [];
        this._pending = false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"PazUa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base64Encoder", ()=>base64Encoder);
var _indexMjs = require("../../globalHelpers/index.mjs");
var _bytesToStringMjs = require("./bytesToString.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const base64Encoder = {
    /**
     * Convert input to base64-encoded string
     * @param input - string to convert to base64
     * @param options - encoding options that can optionally produce a base64url string
     * @returns base64-encoded string
     */ convert (input, options = {
        urlSafe: false,
        skipPadding: false
    }) {
        const inputStr = typeof input === 'string' ? input : (0, _bytesToStringMjs.bytesToString)(input);
        let encodedStr = (0, _indexMjs.getBtoa)()(inputStr);
        // urlSafe char replacement and skipPadding options conform to the base64url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#section-5
        if (options.urlSafe) encodedStr = encodedStr.replace(/\+/g, '-').replace(/\//g, '_');
        if (options.skipPadding) encodedStr = encodedStr.replace(/=/g, '');
        return encodedStr;
    }
};

},{"../../globalHelpers/index.mjs":"5JDaI","./bytesToString.mjs":"9hyD7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9hyD7":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bytesToString", ()=>bytesToString);
function bytesToString(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join('');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9CgaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cryptoSecureRandomInt", ()=>cryptoSecureRandomInt);
var _indexMjs = require("./globalHelpers/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function cryptoSecureRandomInt() {
    const crypto = (0, _indexMjs.getCrypto)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}

},{"./globalHelpers/index.mjs":"5JDaI","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9EK58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordArray", ()=>WordArray);
var _cryptoSecureRandomIntMjs = require("./cryptoSecureRandomInt.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function hexStringify(wordArray) {
    // Shortcuts
    const { words } = wordArray;
    const { sigBytes } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
class WordArray {
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, _cryptoSecureRandomIntMjs.cryptoSecureRandomInt)());
        return new WordArray(words, nBytes);
    }
    toString() {
        return hexStringify(this);
    }
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
}

},{"./cryptoSecureRandomInt.mjs":"9CgaU","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"81Pnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertValidationError", ()=>assertValidationError);
var _authErrorStringsMjs = require("../../common/AuthErrorStrings.mjs");
var _authErrorMjs = require("../AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function assertValidationError(assertion, name) {
    const { message, recoverySuggestion } = (0, _authErrorStringsMjs.validationErrorMap)[name];
    if (!assertion) throw new (0, _authErrorMjs.AuthError)({
        name,
        message,
        recoverySuggestion
    });
}

},{"../../common/AuthErrorStrings.mjs":"eO30C","../AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eO30C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthErrorCodes", ()=>AuthErrorCodes);
parcelHelpers.export(exports, "AuthErrorStrings", ()=>AuthErrorStrings);
parcelHelpers.export(exports, "validationErrorMap", ()=>validationErrorMap);
var _validationMjs = require("../errors/types/validation.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const validationErrorMap = {
    [(0, _validationMjs.AuthValidationErrorCode).EmptyChallengeResponse]: {
        message: 'challengeResponse is required to confirmSignIn'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyConfirmResetPasswordUsername]: {
        message: 'username is required to confirmResetPassword'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyConfirmSignUpCode]: {
        message: 'code is required to confirmSignUp'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyConfirmSignUpUsername]: {
        message: 'username is required to confirmSignUp'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyConfirmResetPasswordConfirmationCode]: {
        message: 'confirmationCode is required to confirmResetPassword'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyConfirmResetPasswordNewPassword]: {
        message: 'newPassword is required to confirmResetPassword'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyResendSignUpCodeUsername]: {
        message: 'username is required to confirmSignUp'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyResetPasswordUsername]: {
        message: 'username is required to resetPassword'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptySignInPassword]: {
        message: 'password is required to signIn'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptySignInUsername]: {
        message: 'username is required to signIn'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptySignUpPassword]: {
        message: 'password is required to signUp'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptySignUpUsername]: {
        message: 'username is required to signUp'
    },
    [(0, _validationMjs.AuthValidationErrorCode).CustomAuthSignInPassword]: {
        message: 'A password is not needed when signing in with CUSTOM_WITHOUT_SRP',
        recoverySuggestion: 'Do not include a password in your signIn call.'
    },
    [(0, _validationMjs.AuthValidationErrorCode).IncorrectMFAMethod]: {
        message: 'Incorrect MFA method was chosen. It should be either SMS, TOTP, or EMAIL',
        recoverySuggestion: 'Try to pass SMS, TOTP, or EMAIL as the challengeResponse'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyVerifyTOTPSetupCode]: {
        message: 'code is required to verifyTotpSetup'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyUpdatePassword]: {
        message: 'oldPassword and newPassword are required to changePassword'
    },
    [(0, _validationMjs.AuthValidationErrorCode).EmptyConfirmUserAttributeCode]: {
        message: 'confirmation code is required to confirmUserAttribute'
    },
    [(0, _validationMjs.AuthValidationErrorCode).InvalidPreferredChallenge]: {
        message: 'The preferred challenge is not enabled in your backend configuration',
        recoverySuggestion: 'Ensure the authentication method is enabled in your Amplify backend configuration'
    }
};
// TODO: delete this code when the Auth class is removed.
var AuthErrorStrings;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})(AuthErrorStrings || (AuthErrorStrings = {}));
var AuthErrorCodes;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})(AuthErrorCodes || (AuthErrorCodes = {}));

},{"../errors/types/validation.mjs":"frXJ6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"frXJ6":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthValidationErrorCode", ()=>AuthValidationErrorCode);
var AuthValidationErrorCode;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
    AuthValidationErrorCode["InvalidPreferredChallenge"] = "InvalidPreferredChallenge";
})(AuthValidationErrorCode || (AuthValidationErrorCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4RqZd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>AuthError);
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class AuthError extends (0, _utils.AmplifyError) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = AuthError;
        Object.setPrototypeOf(this, AuthError.prototype);
    }
}

},{"@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9YQHb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionFromIdentityPoolId", ()=>getRegionFromIdentityPoolId);
parcelHelpers.export(exports, "getRegionFromUserPoolId", ()=>getRegionFromUserPoolId);
var _authErrorMjs = require("../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function getRegionFromUserPoolId(userPoolId) {
    const region = userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split('_')[0];
    if (!userPoolId || userPoolId.indexOf('_') < 0 || !region || typeof region !== 'string') throw new (0, _authErrorMjs.AuthError)({
        name: 'InvalidUserPoolId',
        message: 'Invalid user pool id provided.'
    });
    return region;
}
function getRegionFromIdentityPoolId(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(':')) throw new (0, _authErrorMjs.AuthError)({
        name: 'InvalidIdentityPoolIdException',
        message: 'Invalid identity pool id provided.',
        recoverySuggestion: 'Make sure a valid identityPoolId is given in the config.'
    });
    return identityPoolId.split(':')[0];
}

},{"../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8W5aY":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toAttributeType", ()=>toAttributeType);
parcelHelpers.export(exports, "toAuthUserAttribute", ()=>toAuthUserAttribute);
function toAttributeType(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function toAuthUserAttribute(attributes) {
    const userAttributes = {};
    attributes === null || attributes === void 0 ? void 0 : attributes.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bGQ9F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoSignInUserConfirmed", ()=>autoSignInUserConfirmed);
parcelHelpers.export(exports, "autoSignInWhenUserIsConfirmedWithLink", ()=>autoSignInWhenUserIsConfirmedWithLink);
parcelHelpers.export(exports, "handleCodeAutoSignIn", ()=>handleCodeAutoSignIn);
var _utils = require("@aws-amplify/core/internals/utils");
var _signInMjs = require("../apis/signIn.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _autoSignInMjs = require("../apis/autoSignIn.mjs");
var _constantsMjs = require("../../../errors/constants.mjs");
var _signInWithUserAuthMjs = require("../apis/signInWithUserAuth.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const MAX_AUTOSIGNIN_POLLING_MS = 180000;
function handleCodeAutoSignIn(signInInput) {
    const stopHubListener = (0, _utils.HubInternal).listen('auth-internal', async ({ payload })=>{
        switch(payload.event){
            case 'confirmSignUp':
                {
                    const response = payload.data;
                    if (response === null || response === void 0 ? void 0 : response.isSignUpComplete) {
                        (0, _utils.HubInternal).dispatch('auth-internal', {
                            event: 'autoSignIn'
                        });
                        (0, _autoSignInMjs.setAutoSignIn)(autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        clearTimeout(timeOutId);
        (0, _autoSignInMjs.resetAutoSignIn)();
    }, MAX_AUTOSIGNIN_POLLING_MS);
}
function debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            reject(new (0, _authErrorMjs.AuthError)({
                name: (0, _constantsMjs.AUTO_SIGN_IN_EXCEPTION),
                message: 'The account was not confirmed on time.',
                recoverySuggestion: 'Try to verify your account by clicking the link sent your email or phone and then login manually.'
            }));
            (0, _autoSignInMjs.resetAutoSignIn)();
        } else try {
            const signInOutput = await (0, _signInMjs.signIn)(signInInput);
            if (signInOutput.nextStep.signInStep !== 'CONFIRM_SIGN_UP') {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                (0, _autoSignInMjs.resetAutoSignIn)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            reject(error);
            (0, _autoSignInMjs.resetAutoSignIn)();
        }
    }, 5000);
}
const debouncedAutoSignInWithLink = debounce(handleAutoSignInWithLink, 300);
const debouncedAutoSignWithCodeOrUserConfirmed = debounce(handleAutoSignInWithCodeOrUserConfirmed, 300);
function autoSignInWhenUserIsConfirmedWithLink(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        var _signInInput_options;
        const output = (signInInput === null || signInInput === void 0 ? void 0 : (_signInInput_options = signInInput.options) === null || _signInInput_options === void 0 ? void 0 : _signInInput_options.authFlowType) === 'USER_AUTH' ? await (0, _signInWithUserAuthMjs.signInWithUserAuth)(signInInput) : await (0, _signInMjs.signIn)(signInInput);
        resolve(output);
        (0, _autoSignInMjs.resetAutoSignIn)();
    } catch (error) {
        reject(error);
        (0, _autoSignInMjs.resetAutoSignIn)();
    }
}
function autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const autoSignInUserConfirmed = autoSignInWithCode;

},{"@aws-amplify/core/internals/utils":"aiEf6","../apis/signIn.mjs":"d1zyQ","../../../errors/AuthError.mjs":"4RqZd","../apis/autoSignIn.mjs":"jECSX","../../../errors/constants.mjs":"8qcdh","../apis/signInWithUserAuth.mjs":"9gnv0","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"d1zyQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signIn", ()=>signIn);
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _signInWithCustomAuthMjs = require("./signInWithCustomAuth.mjs");
var _signInWithCustomSRPAuthMjs = require("./signInWithCustomSRPAuth.mjs");
var _signInWithSRPMjs = require("./signInWithSRP.mjs");
var _signInWithUserPasswordMjs = require("./signInWithUserPassword.mjs");
var _signInWithUserAuthMjs = require("./signInWithUserAuth.mjs");
var _autoSignInMjs = require("./autoSignIn.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signIn(input) {
    var _input_options;
    // Here we want to reset the store but not reassign the callback.
    // The callback is reset when the underlying promise resolves or rejects.
    // With the advent of session based sign in, this guarantees that the signIn API initiates a new auth flow,
    // regardless of whether it is called for a user currently engaged in an active auto sign in session.
    (0, _autoSignInMjs.resetAutoSignIn)(false);
    const authFlowType = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.authFlowType;
    await (0, _signInHelpersMjs.assertUserNotAuthenticated)();
    switch(authFlowType){
        case 'USER_SRP_AUTH':
            return (0, _signInWithSRPMjs.signInWithSRP)(input);
        case 'USER_PASSWORD_AUTH':
            return (0, _signInWithUserPasswordMjs.signInWithUserPassword)(input);
        case 'CUSTOM_WITHOUT_SRP':
            return (0, _signInWithCustomAuthMjs.signInWithCustomAuth)(input);
        case 'CUSTOM_WITH_SRP':
            return (0, _signInWithCustomSRPAuthMjs.signInWithCustomSRPAuth)(input);
        case 'USER_AUTH':
            return (0, _signInWithUserAuthMjs.signInWithUserAuth)(input);
        default:
            return (0, _signInWithSRPMjs.signInWithSRP)(input);
    }
}

},{"../utils/signInHelpers.mjs":"2HTeV","./signInWithCustomAuth.mjs":"44jNE","./signInWithCustomSRPAuth.mjs":"hbU37","./signInWithSRP.mjs":"edaLU","./signInWithUserPassword.mjs":"jGrv3","./signInWithUserAuth.mjs":"9gnv0","./autoSignIn.mjs":"jECSX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2HTeV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertUserNotAuthenticated", ()=>assertUserNotAuthenticated);
parcelHelpers.export(exports, "createAttributes", ()=>createAttributes);
parcelHelpers.export(exports, "getActiveSignInUsername", ()=>getActiveSignInUsername);
parcelHelpers.export(exports, "getAllowedMfaSetupTypes", ()=>getAllowedMfaSetupTypes);
parcelHelpers.export(exports, "getMFAType", ()=>getMFAType);
parcelHelpers.export(exports, "getMFATypes", ()=>getMFATypes);
parcelHelpers.export(exports, "getSignInResult", ()=>getSignInResult);
parcelHelpers.export(exports, "getSignInResultFromError", ()=>getSignInResultFromError);
parcelHelpers.export(exports, "getTOTPSetupDetails", ()=>getTOTPSetupDetails);
parcelHelpers.export(exports, "handleChallengeName", ()=>handleChallengeName);
parcelHelpers.export(exports, "handleCompleteNewPasswordChallenge", ()=>handleCompleteNewPasswordChallenge);
parcelHelpers.export(exports, "handleCustomAuthFlowWithoutSRP", ()=>handleCustomAuthFlowWithoutSRP);
parcelHelpers.export(exports, "handleCustomChallenge", ()=>handleCustomChallenge);
parcelHelpers.export(exports, "handleCustomSRPAuthFlow", ()=>handleCustomSRPAuthFlow);
parcelHelpers.export(exports, "handleMFAChallenge", ()=>handleMFAChallenge);
parcelHelpers.export(exports, "handleMFASetupChallenge", ()=>handleMFASetupChallenge);
parcelHelpers.export(exports, "handleSelectMFATypeChallenge", ()=>handleSelectMFATypeChallenge);
parcelHelpers.export(exports, "handleUserPasswordAuthFlow", ()=>handleUserPasswordAuthFlow);
parcelHelpers.export(exports, "handleUserSRPAuthFlow", ()=>handleUserSRPAuthFlow);
parcelHelpers.export(exports, "mapMfaType", ()=>mapMfaType);
parcelHelpers.export(exports, "parseAttributes", ()=>parseAttributes);
parcelHelpers.export(exports, "parseMFATypes", ()=>parseMFATypes);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _constantsMjs = require("../../../errors/constants.mjs");
var _getCurrentUserMjs = require("../apis/getCurrentUser.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _createInitiateAuthClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createInitiateAuthClient.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs1 = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _createVerifySoftwareTokenClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createVerifySoftwareTokenClient.mjs");
var _createAssociateSoftwareTokenClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createAssociateSoftwareTokenClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _handleWebAuthnSignInResultMjs = require("../../../client/flows/userAuth/handleWebAuthnSignInResult.mjs");
var _handlePasswordSRPMjs = require("../../../client/flows/shared/handlePasswordSRP.mjs");
var _handleSelectChallengeMjs = require("../../../client/flows/userAuth/handleSelectChallenge.mjs");
var _handleSelectChallengeWithPasswordMjs = require("../../../client/flows/userAuth/handleSelectChallengeWithPassword.mjs");
var _handleSelectChallengeWithPasswordSRPMjs = require("../../../client/flows/userAuth/handleSelectChallengeWithPasswordSRP.mjs");
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _getAuthenticationHelperMjs = require("./srp/getAuthenticationHelper.mjs");
var _constantsMjs2 = require("./srp/constants.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _userContextDataMjs = require("./userContextData.mjs");
var _handlePasswordVerifierChallengeMjs = require("./handlePasswordVerifierChallenge.mjs");
var _handleDeviceSRPAuthMjs = require("./handleDeviceSRPAuth.mjs");
var _retryOnResourceNotFoundExceptionMjs = require("./retryOnResourceNotFoundException.mjs");
var _setActiveSignInUsernameMjs = require("./setActiveSignInUsername.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const USER_ATTRIBUTES = 'userAttributes.';
function isWebAuthnResultAuthSignInOutput(result) {
    return 'isSignedIn' in result && 'nextStep' in result;
}
async function handleCustomChallenge({ challengeResponse, clientMetadata, session, username, config, tokenOrchestrator }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        ChallengeName: 'CUSTOM_CHALLENGE',
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, _handleDeviceSRPAuthMjs.handleDeviceSRPAuth)({
        username,
        config,
        clientMetadata,
        session: response.Session,
        tokenOrchestrator
    });
    return response;
}
async function handleMFASetupChallenge({ challengeResponse, username, clientMetadata, session, deviceName, config }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    if (challengeResponse === 'EMAIL') return {
        ChallengeName: 'MFA_SETUP',
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["EMAIL_OTP"]'
        },
        $metadata: {}
    };
    if (challengeResponse === 'TOTP') return {
        ChallengeName: 'MFA_SETUP',
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["SOFTWARE_TOKEN_MFA"]'
        },
        $metadata: {}
    };
    const challengeResponses = {
        USERNAME: username
    };
    const isTOTPCode = /^\d+$/.test(challengeResponse);
    if (isTOTPCode) {
        const verifySoftwareToken = (0, _createVerifySoftwareTokenClientMjs.createVerifySoftwareTokenClient)({
            endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                endpointOverride: userPoolEndpoint
            })
        });
        const { Session } = await verifySoftwareToken({
            region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
            userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
        }, {
            UserCode: challengeResponse,
            Session: session,
            FriendlyDeviceName: deviceName
        });
        (0, _signInStoreMjs.signInStore).dispatch({
            type: 'SET_SIGN_IN_SESSION',
            value: Session
        });
        const jsonReq = {
            ChallengeName: 'MFA_SETUP',
            ChallengeResponses: challengeResponses,
            Session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
            endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
            userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
        }, jsonReq);
    }
    const isEmail = challengeResponse.includes('@');
    if (isEmail) {
        challengeResponses.EMAIL = challengeResponse;
        const jsonReq = {
            ChallengeName: 'MFA_SETUP',
            ChallengeResponses: challengeResponses,
            Session: session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
            endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
            userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
        }, jsonReq);
    }
    throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
        message: `Cannot proceed with MFA setup using challengeResponse: ${challengeResponse}`,
        recoverySuggestion: 'Try passing "EMAIL", "TOTP", a valid email, or OTP code as the challengeResponse.'
    });
}
async function handleSelectMFATypeChallenge({ challengeResponse, username, clientMetadata, session, config }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    (0, _assertValidationErrorMjs.assertValidationError)(challengeResponse === 'TOTP' || challengeResponse === 'SMS' || challengeResponse === 'EMAIL', (0, _validationMjs.AuthValidationErrorCode).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: mapMfaType(challengeResponse)
    };
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        ChallengeName: 'SELECT_MFA_TYPE',
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, jsonReq);
}
async function handleCompleteNewPasswordChallenge({ challengeResponse, clientMetadata, session, username, requiredAttributes, config }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const challengeResponses = (0, _objectSpreadProps._)((0, _objectSpread._)({}, createAttributes(requiredAttributes)), {
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    });
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        ChallengeName: 'NEW_PASSWORD_REQUIRED',
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, jsonReq);
}
async function handleUserPasswordAuthFlow(username, password, clientMetadata, config, tokenOrchestrator) {
    var _response_ChallengeParameters, _response_ChallengeParameters1;
    const { userPoolClientId, userPoolId, userPoolEndpoint } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        AuthFlow: 'USER_PASSWORD_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    const initiateAuth = (0, _createInitiateAuthClientMjs.createInitiateAuthClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignIn)
    }, jsonReq);
    var _response_ChallengeParameters_USERNAME, _ref;
    const activeUsername = (_ref = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : (_response_ChallengeParameters1 = response.ChallengeParameters) === null || _response_ChallengeParameters1 === void 0 ? void 0 : _response_ChallengeParameters1.USER_ID_FOR_SRP) !== null && _ref !== void 0 ? _ref : username;
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(activeUsername);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, _handleDeviceSRPAuthMjs.handleDeviceSRPAuth)({
        username: activeUsername,
        config,
        clientMetadata,
        session: response.Session,
        tokenOrchestrator
    });
    return response;
}
async function handleUserSRPAuthFlow(username, password, clientMetadata, config, tokenOrchestrator) {
    return (0, _handlePasswordSRPMjs.handlePasswordSRP)({
        username,
        password,
        clientMetadata,
        config,
        tokenOrchestrator,
        authFlow: 'USER_SRP_AUTH'
    });
}
async function handleCustomAuthFlowWithoutSRP(username, clientMetadata, config, tokenOrchestrator) {
    var _response_ChallengeParameters;
    const { userPoolClientId, userPoolId, userPoolEndpoint } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        AuthFlow: 'CUSTOM_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    const initiateAuth = (0, _createInitiateAuthClientMjs.createInitiateAuthClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignIn)
    }, jsonReq);
    var _response_ChallengeParameters_USERNAME;
    const activeUsername = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : username;
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(activeUsername);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, _handleDeviceSRPAuthMjs.handleDeviceSRPAuth)({
        username: activeUsername,
        config,
        clientMetadata,
        session: response.Session,
        tokenOrchestrator
    });
    return response;
}
async function handleCustomSRPAuthFlow(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, _utils.assertTokenProviderConfig)(config);
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const userPoolName = (userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split('_')[1]) || '';
    const authenticationHelper = await (0, _getAuthenticationHelperMjs.getAuthenticationHelper)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: 'SRP_A'
    };
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        AuthFlow: 'CUSTOM_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    const initiateAuth = (0, _createInitiateAuthClientMjs.createInitiateAuthClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: challengeParameters, Session: session } = await initiateAuth({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignIn)
    }, jsonReq);
    var _challengeParameters_USERNAME;
    const activeUsername = (_challengeParameters_USERNAME = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USERNAME) !== null && _challengeParameters_USERNAME !== void 0 ? _challengeParameters_USERNAME : username;
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(activeUsername);
    return (0, _retryOnResourceNotFoundExceptionMjs.retryOnResourceNotFoundException)((0, _handlePasswordVerifierChallengeMjs.handlePasswordVerifierChallenge), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function getSignInResult(params) {
    var _Amplify_getConfig_Auth;
    const { challengeName, challengeParameters, availableChallenges } = params;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    switch(challengeName){
        case 'CUSTOM_CHALLENGE':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE',
                    additionalInfo: challengeParameters
                }
            };
        case 'MFA_SETUP':
            {
                const { signInSession, username } = (0, _signInStoreMjs.signInStore).getState();
                const mfaSetupTypes = getMFATypes(parseMFATypes(challengeParameters.MFAS_CAN_SETUP)) || [];
                const allowedMfaSetupTypes = getAllowedMfaSetupTypes(mfaSetupTypes);
                const isTotpMfaSetupAvailable = allowedMfaSetupTypes.includes('TOTP');
                const isEmailMfaSetupAvailable = allowedMfaSetupTypes.includes('EMAIL');
                if (isTotpMfaSetupAvailable && isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: 'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION',
                        allowedMFATypes: allowedMfaSetupTypes
                    }
                };
                if (isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: 'CONTINUE_SIGN_IN_WITH_EMAIL_SETUP'
                    }
                };
                if (isTotpMfaSetupAvailable) {
                    const associateSoftwareToken = (0, _createAssociateSoftwareTokenClientMjs.createAssociateSoftwareTokenClient)({
                        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                            endpointOverride: authConfig.userPoolEndpoint
                        })
                    });
                    const { Session, SecretCode: secretCode } = await associateSoftwareToken({
                        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(authConfig.userPoolId)
                    }, {
                        Session: signInSession
                    });
                    (0, _signInStoreMjs.signInStore).dispatch({
                        type: 'SET_SIGN_IN_SESSION',
                        value: Session
                    });
                    return {
                        isSignedIn: false,
                        nextStep: {
                            signInStep: 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP',
                            totpSetupDetails: getTOTPSetupDetails(secretCode, username)
                        }
                    };
                }
                throw new (0, _authErrorMjs.AuthError)({
                    name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${mfaSetupTypes}`
                });
            }
        case 'NEW_PASSWORD_REQUIRED':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
                    missingAttributes: parseAttributes(challengeParameters.requiredAttributes)
                }
            };
        case 'SELECT_MFA_TYPE':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
                    allowedMFATypes: getMFATypes(parseMFATypes(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case 'SMS_OTP':
        case 'SMS_MFA':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case 'SOFTWARE_TOKEN_MFA':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_TOTP_CODE'
                }
            };
        case 'EMAIL_OTP':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE',
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case 'WEB_AUTHN':
            {
                const result = await (0, _handleWebAuthnSignInResultMjs.handleWebAuthnSignInResult)(challengeParameters);
                if (isWebAuthnResultAuthSignInOutput(result)) return result;
                return getSignInResult(result);
            }
        case 'PASSWORD':
        case 'PASSWORD_SRP':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_PASSWORD'
                }
            };
        case 'SELECT_CHALLENGE':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION',
                    availableChallenges
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
        message: 'An error occurred during the sign in process. ' + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function getTOTPSetupDetails(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName !== null && accountName !== void 0 ? accountName : username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, _utils.AmplifyUrl)(totpUri);
        }
    };
}
function getSignInResultFromError(errorName) {
    if (errorName === (0, _errorsMjs.InitiateAuthException).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: 'RESET_PASSWORD'
        }
    };
    else if (errorName === (0, _errorsMjs.InitiateAuthException).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: 'CONFIRM_SIGN_UP'
        }
    };
}
function parseAttributes(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes(USER_ATTRIBUTES) ? att.replace(USER_ATTRIBUTES, '') : att);
    return parsedAttributes;
}
function createAttributes(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function handleChallengeName(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options === null || options === void 0 ? void 0 : options.userAttributes;
    const deviceName = options === null || options === void 0 ? void 0 : options.friendlyDeviceName;
    switch(challengeName){
        case 'WEB_AUTHN':
        case 'SELECT_CHALLENGE':
            if (challengeResponse === 'PASSWORD_SRP' || challengeResponse === 'PASSWORD') return {
                ChallengeName: challengeResponse,
                Session: session,
                $metadata: {}
            };
            return (0, _handleSelectChallengeMjs.initiateSelectedChallenge)({
                username,
                session,
                selectedChallenge: challengeResponse,
                config,
                clientMetadata
            });
        case 'SELECT_MFA_TYPE':
            return handleSelectMFATypeChallenge({
                challengeResponse,
                clientMetadata,
                session,
                username,
                config
            });
        case 'MFA_SETUP':
            return handleMFASetupChallenge({
                challengeResponse,
                clientMetadata,
                session,
                username,
                deviceName,
                config
            });
        case 'NEW_PASSWORD_REQUIRED':
            return handleCompleteNewPasswordChallenge({
                challengeResponse,
                clientMetadata,
                session,
                username,
                requiredAttributes: userAttributes,
                config
            });
        case 'CUSTOM_CHALLENGE':
            return (0, _retryOnResourceNotFoundExceptionMjs.retryOnResourceNotFoundException)(handleCustomChallenge, [
                {
                    challengeResponse,
                    clientMetadata,
                    session,
                    username,
                    config,
                    tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case 'SMS_MFA':
        case 'SOFTWARE_TOKEN_MFA':
        case 'SMS_OTP':
        case 'EMAIL_OTP':
            return handleMFAChallenge({
                challengeName,
                challengeResponse,
                clientMetadata,
                session,
                username,
                config,
                tokenOrchestrator
            });
        case 'PASSWORD':
            return (0, _handleSelectChallengeWithPasswordMjs.handleSelectChallengeWithPassword)(username, challengeResponse, clientMetadata, config, session);
        case 'PASSWORD_SRP':
            return (0, _handleSelectChallengeWithPasswordSRPMjs.handleSelectChallengeWithPasswordSRP)(username, challengeResponse, clientMetadata, config, session, tokenOrchestrator);
    }
    // TODO: remove this error message for production apps
    throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
        message: `An error occurred during the sign in process.
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function mapMfaType(mfa) {
    let mfaType = 'SMS_MFA';
    if (mfa === 'TOTP') mfaType = 'SOFTWARE_TOKEN_MFA';
    if (mfa === 'EMAIL') mfaType = 'EMAIL_OTP';
    return mfaType;
}
function getMFAType(type) {
    if (type === 'SMS_MFA') return 'SMS';
    if (type === 'SOFTWARE_TOKEN_MFA') return 'TOTP';
    if (type === 'EMAIL_OTP') return 'EMAIL';
// TODO: log warning for unknown MFA type
}
function getMFATypes(types) {
    if (!types) return undefined;
    return types.map(getMFAType).filter(Boolean);
}
function parseMFATypes(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function getAllowedMfaSetupTypes(availableMfaSetupTypes) {
    return availableMfaSetupTypes.filter((authMfaType)=>authMfaType === 'EMAIL' || authMfaType === 'TOTP');
}
async function assertUserNotAuthenticated() {
    let authUser;
    try {
        authUser = await (0, _getCurrentUserMjs.getCurrentUser)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _constantsMjs.USER_ALREADY_AUTHENTICATED_EXCEPTION),
        message: 'There is already a signed in user.',
        recoverySuggestion: 'Call signOut before calling signIn again.'
    });
}
function getActiveSignInUsername(username) {
    const state = (0, _signInStoreMjs.signInStore).getState();
    var _state_username;
    return (_state_username = state.username) !== null && _state_username !== void 0 ? _state_username : username;
}
async function handleMFAChallenge({ challengeName, challengeResponse, clientMetadata, session, username, config, tokenOrchestrator }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const challengeResponses = {
        USERNAME: username
    };
    if (challengeName === 'EMAIL_OTP') challengeResponses.EMAIL_OTP_CODE = challengeResponse;
    if (challengeName === 'SMS_MFA') challengeResponses.SMS_MFA_CODE = challengeResponse;
    if (challengeName === 'SMS_OTP') challengeResponses.SMS_OTP_CODE = challengeResponse;
    if (challengeName === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = challengeResponse;
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const userContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        ChallengeName: challengeName,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: userContextData
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, _handleDeviceSRPAuthMjs.handleDeviceSRPAuth)({
        username,
        config,
        clientMetadata,
        session: response.Session,
        tokenOrchestrator
    });
    return response;
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/AuthError.mjs":"4RqZd","../types/errors.mjs":"fLYtN","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/constants.mjs":"8qcdh","../apis/getCurrentUser.mjs":"gllvP","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createInitiateAuthClient.mjs":"5m6Bo","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createVerifySoftwareTokenClient.mjs":"7g18x","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createAssociateSoftwareTokenClient.mjs":"fQ4xk","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../client/flows/userAuth/handleWebAuthnSignInResult.mjs":"8QS6B","../../../client/flows/shared/handlePasswordSRP.mjs":"5RD60","../../../client/flows/userAuth/handleSelectChallenge.mjs":"cpviR","../../../client/flows/userAuth/handleSelectChallengeWithPassword.mjs":"kn37s","../../../client/flows/userAuth/handleSelectChallengeWithPasswordSRP.mjs":"fVlFB","../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","./srp/getAuthenticationHelper.mjs":"8ZYMr","./srp/constants.mjs":"dvWBF","@aws-crypto/sha256-js":"5A0J7","./userContextData.mjs":"hZOPS","./handlePasswordVerifierChallenge.mjs":"eBuIt","./handleDeviceSRPAuth.mjs":"jjI97","./retryOnResourceNotFoundException.mjs":"54URn","./setActiveSignInUsername.mjs":"3xyHv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fLYtN":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssociateSoftwareTokenException", ()=>AssociateSoftwareTokenException);
parcelHelpers.export(exports, "ChangePasswordException", ()=>ChangePasswordException);
parcelHelpers.export(exports, "ConfirmDeviceException", ()=>ConfirmDeviceException);
parcelHelpers.export(exports, "ConfirmForgotPasswordException", ()=>ConfirmForgotPasswordException);
parcelHelpers.export(exports, "ConfirmSignUpException", ()=>ConfirmSignUpException);
parcelHelpers.export(exports, "DeleteUserAttributesException", ()=>DeleteUserAttributesException);
parcelHelpers.export(exports, "DeleteUserException", ()=>DeleteUserException);
parcelHelpers.export(exports, "ForgetDeviceException", ()=>ForgetDeviceException);
parcelHelpers.export(exports, "ForgotPasswordException", ()=>ForgotPasswordException);
parcelHelpers.export(exports, "GetCredentialsForIdentityException", ()=>GetCredentialsForIdentityException);
parcelHelpers.export(exports, "GetIdException", ()=>GetIdException);
parcelHelpers.export(exports, "GetUserAttributeVerificationException", ()=>GetUserAttributeVerificationException);
parcelHelpers.export(exports, "GetUserException", ()=>GetUserException);
parcelHelpers.export(exports, "GlobalSignOutException", ()=>GlobalSignOutException);
parcelHelpers.export(exports, "InitiateAuthException", ()=>InitiateAuthException);
parcelHelpers.export(exports, "ListDevicesException", ()=>ListDevicesException);
parcelHelpers.export(exports, "ResendConfirmationException", ()=>ResendConfirmationException);
parcelHelpers.export(exports, "RespondToAuthChallengeException", ()=>RespondToAuthChallengeException);
parcelHelpers.export(exports, "SETUP_TOTP_EXCEPTION", ()=>SETUP_TOTP_EXCEPTION);
parcelHelpers.export(exports, "SetUserMFAPreferenceException", ()=>SetUserMFAPreferenceException);
parcelHelpers.export(exports, "SignUpException", ()=>SignUpException);
parcelHelpers.export(exports, "UpdateDeviceStatusException", ()=>UpdateDeviceStatusException);
parcelHelpers.export(exports, "UpdateUserAttributesException", ()=>UpdateUserAttributesException);
parcelHelpers.export(exports, "VerifySoftwareTokenException", ()=>VerifySoftwareTokenException);
parcelHelpers.export(exports, "VerifyUserAttributeException", ()=>VerifyUserAttributeException);
var AssociateSoftwareTokenException;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})(AssociateSoftwareTokenException || (AssociateSoftwareTokenException = {}));
var ChangePasswordException;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})(ChangePasswordException || (ChangePasswordException = {}));
var ConfirmDeviceException;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})(ConfirmDeviceException || (ConfirmDeviceException = {}));
var ConfirmForgotPasswordException;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})(ConfirmForgotPasswordException || (ConfirmForgotPasswordException = {}));
var ConfirmSignUpException;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})(ConfirmSignUpException || (ConfirmSignUpException = {}));
var DeleteUserAttributesException;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})(DeleteUserAttributesException || (DeleteUserAttributesException = {}));
var DeleteUserException;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})(DeleteUserException || (DeleteUserException = {}));
var ForgetDeviceException;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})(ForgetDeviceException || (ForgetDeviceException = {}));
var ForgotPasswordException;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})(ForgotPasswordException || (ForgotPasswordException = {}));
var GetUserException;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})(GetUserException || (GetUserException = {}));
var GetIdException;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})(GetIdException || (GetIdException = {}));
var GetCredentialsForIdentityException;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})(GetCredentialsForIdentityException || (GetCredentialsForIdentityException = {}));
var GetUserAttributeVerificationException;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})(GetUserAttributeVerificationException || (GetUserAttributeVerificationException = {}));
var GlobalSignOutException;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})(GlobalSignOutException || (GlobalSignOutException = {}));
var InitiateAuthException;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})(InitiateAuthException || (InitiateAuthException = {}));
var ResendConfirmationException;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})(ResendConfirmationException || (ResendConfirmationException = {}));
var RespondToAuthChallengeException;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})(RespondToAuthChallengeException || (RespondToAuthChallengeException = {}));
var SetUserMFAPreferenceException;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})(SetUserMFAPreferenceException || (SetUserMFAPreferenceException = {}));
var SignUpException;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})(SignUpException || (SignUpException = {}));
var UpdateUserAttributesException;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})(UpdateUserAttributesException || (UpdateUserAttributesException = {}));
var VerifySoftwareTokenException;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})(VerifySoftwareTokenException || (VerifySoftwareTokenException = {}));
var VerifyUserAttributeException;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})(VerifyUserAttributeException || (VerifyUserAttributeException = {}));
var UpdateDeviceStatusException;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})(UpdateDeviceStatusException || (UpdateDeviceStatusException = {}));
var ListDevicesException;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})(ListDevicesException || (ListDevicesException = {}));
const SETUP_TOTP_EXCEPTION = 'SetUpTOTPException';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8qcdh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTO_SIGN_IN_EXCEPTION", ()=>AUTO_SIGN_IN_EXCEPTION);
parcelHelpers.export(exports, "DEVICE_METADATA_NOT_FOUND_EXCEPTION", ()=>DEVICE_METADATA_NOT_FOUND_EXCEPTION);
parcelHelpers.export(exports, "INVALID_APP_SCHEME_EXCEPTION", ()=>INVALID_APP_SCHEME_EXCEPTION);
parcelHelpers.export(exports, "INVALID_ORIGIN_EXCEPTION", ()=>INVALID_ORIGIN_EXCEPTION);
parcelHelpers.export(exports, "INVALID_PREFERRED_REDIRECT_EXCEPTION", ()=>INVALID_PREFERRED_REDIRECT_EXCEPTION);
parcelHelpers.export(exports, "INVALID_REDIRECT_EXCEPTION", ()=>INVALID_REDIRECT_EXCEPTION);
parcelHelpers.export(exports, "OAUTH_SIGNOUT_EXCEPTION", ()=>OAUTH_SIGNOUT_EXCEPTION);
parcelHelpers.export(exports, "TOKEN_REFRESH_EXCEPTION", ()=>TOKEN_REFRESH_EXCEPTION);
parcelHelpers.export(exports, "UNEXPECTED_SIGN_IN_INTERRUPTION_EXCEPTION", ()=>UNEXPECTED_SIGN_IN_INTERRUPTION_EXCEPTION);
parcelHelpers.export(exports, "USER_ALREADY_AUTHENTICATED_EXCEPTION", ()=>USER_ALREADY_AUTHENTICATED_EXCEPTION);
parcelHelpers.export(exports, "USER_UNAUTHENTICATED_EXCEPTION", ()=>USER_UNAUTHENTICATED_EXCEPTION);
parcelHelpers.export(exports, "invalidAppSchemeException", ()=>invalidAppSchemeException);
parcelHelpers.export(exports, "invalidOriginException", ()=>invalidOriginException);
parcelHelpers.export(exports, "invalidPreferredRedirectUrlException", ()=>invalidPreferredRedirectUrlException);
parcelHelpers.export(exports, "invalidRedirectException", ()=>invalidRedirectException);
var _authErrorMjs = require("./AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const USER_UNAUTHENTICATED_EXCEPTION = 'UserUnAuthenticatedException';
const USER_ALREADY_AUTHENTICATED_EXCEPTION = 'UserAlreadyAuthenticatedException';
const DEVICE_METADATA_NOT_FOUND_EXCEPTION = 'DeviceMetadataNotFoundException';
const AUTO_SIGN_IN_EXCEPTION = 'AutoSignInException';
const INVALID_REDIRECT_EXCEPTION = 'InvalidRedirectException';
const INVALID_APP_SCHEME_EXCEPTION = 'InvalidAppSchemeException';
const INVALID_PREFERRED_REDIRECT_EXCEPTION = 'InvalidPreferredRedirectUrlException';
const invalidRedirectException = new (0, _authErrorMjs.AuthError)({
    name: INVALID_REDIRECT_EXCEPTION,
    message: 'signInRedirect or signOutRedirect had an invalid format or was not found.',
    recoverySuggestion: 'Please make sure the signIn/Out redirect in your oauth config is valid.'
});
const invalidAppSchemeException = new (0, _authErrorMjs.AuthError)({
    name: INVALID_APP_SCHEME_EXCEPTION,
    message: 'A valid non-http app scheme was not found in the config.',
    recoverySuggestion: 'Please make sure a valid custom app scheme is present in the config.'
});
const invalidPreferredRedirectUrlException = new (0, _authErrorMjs.AuthError)({
    name: INVALID_PREFERRED_REDIRECT_EXCEPTION,
    message: 'The given preferredRedirectUrl does not match any items in the redirectSignOutUrls array from the config.',
    recoverySuggestion: 'Please make sure a matching preferredRedirectUrl is provided.'
});
const INVALID_ORIGIN_EXCEPTION = 'InvalidOriginException';
const invalidOriginException = new (0, _authErrorMjs.AuthError)({
    name: INVALID_ORIGIN_EXCEPTION,
    message: 'redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin',
    recoverySuggestion: 'Please call signInWithRedirect from the same origin.'
});
const OAUTH_SIGNOUT_EXCEPTION = 'OAuthSignOutException';
const TOKEN_REFRESH_EXCEPTION = 'TokenRefreshException';
const UNEXPECTED_SIGN_IN_INTERRUPTION_EXCEPTION = 'UnexpectedSignInInterruptionException';

},{"./AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gllvP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentUser", ()=>getCurrentUser);
var _core = require("@aws-amplify/core");
var _getCurrentUserMjs = require("./internal/getCurrentUser.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const getCurrentUser = async ()=>{
    return (0, _getCurrentUserMjs.getCurrentUser)((0, _core.Amplify));
};

},{"@aws-amplify/core":"94XF7","./internal/getCurrentUser.mjs":"hiBWA","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hiBWA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentUser", ()=>getCurrentUser);
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../../utils/types.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getCurrentUser = async (amplify)=>{
    var _amplify_getConfig_Auth, _tokens_idToken;
    const authConfig = (_amplify_getConfig_Auth = amplify.getConfig().Auth) === null || _amplify_getConfig_Auth === void 0 ? void 0 : _amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    var _tokens_idToken_payload;
    const { 'cognito:username': username, sub } = (_tokens_idToken_payload = (_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.payload) !== null && _tokens_idToken_payload !== void 0 ? _tokens_idToken_payload : {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function getSignInDetailsFromTokens(tokens) {
    return tokens === null || tokens === void 0 ? void 0 : tokens.signInDetails;
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../../utils/types.mjs":"4GeFs","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4GeFs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OAuthStorageKeys", ()=>OAuthStorageKeys);
parcelHelpers.export(exports, "assertAuthTokens", ()=>assertAuthTokens);
parcelHelpers.export(exports, "assertAuthTokensWithRefreshToken", ()=>assertAuthTokensWithRefreshToken);
parcelHelpers.export(exports, "assertDeviceMetadata", ()=>assertDeviceMetadata);
parcelHelpers.export(exports, "assertIdTokenInAuthTokens", ()=>assertIdTokenInAuthTokens);
parcelHelpers.export(exports, "isTypeUserPoolConfig", ()=>isTypeUserPoolConfig);
parcelHelpers.export(exports, "oAuthTokenRefreshException", ()=>oAuthTokenRefreshException);
parcelHelpers.export(exports, "tokenRefreshException", ()=>tokenRefreshException);
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _constantsMjs = require("../../../errors/constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function isTypeUserPoolConfig(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function assertAuthTokens(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _constantsMjs.USER_UNAUTHENTICATED_EXCEPTION),
        message: 'User needs to be authenticated to call this API.',
        recoverySuggestion: 'Sign in before calling this API again.'
    });
}
function assertIdTokenInAuthTokens(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _constantsMjs.USER_UNAUTHENTICATED_EXCEPTION),
        message: 'User needs to be authenticated to call this API.',
        recoverySuggestion: 'Sign in before calling this API again.'
    });
}
const oAuthTokenRefreshException = new (0, _authErrorMjs.AuthError)({
    name: (0, _constantsMjs.TOKEN_REFRESH_EXCEPTION),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const tokenRefreshException = new (0, _authErrorMjs.AuthError)({
    name: (0, _constantsMjs.USER_UNAUTHENTICATED_EXCEPTION),
    message: 'User needs to be authenticated to call this API.',
    recoverySuggestion: 'Sign in before calling this API again.'
});
function assertAuthTokensWithRefreshToken(tokens) {
    if (isAuthenticatedWithImplicitOauthFlow(tokens)) throw oAuthTokenRefreshException;
    if (!isAuthenticatedWithRefreshToken(tokens)) throw tokenRefreshException;
}
function assertDeviceMetadata(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _constantsMjs.DEVICE_METADATA_NOT_FOUND_EXCEPTION),
        message: 'Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.',
        recoverySuggestion: 'Make sure to not clear storage after calling the signIn API.'
    });
}
const OAuthStorageKeys = {
    inflightOAuth: 'inflightOAuth',
    oauthSignIn: 'oauthSignIn',
    oauthPKCE: 'oauthPKCE',
    oauthState: 'oauthState'
};
function isAuthenticated(tokens) {
    return (tokens === null || tokens === void 0 ? void 0 : tokens.accessToken) || (tokens === null || tokens === void 0 ? void 0 : tokens.idToken);
}
function isAuthenticatedWithRefreshToken(tokens) {
    return isAuthenticated(tokens) && (tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken);
}
function isAuthenticatedWithImplicitOauthFlow(tokens) {
    return isAuthenticated(tokens) && !(tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken);
}

},{"../../../errors/AuthError.mjs":"4RqZd","../../../errors/constants.mjs":"8qcdh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6soVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthUserAgentValue", ()=>getAuthUserAgentValue);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getAuthUserAgentValue = (action, customUserAgentDetails)=>(0, _utils.getAmplifyUserAgent)((0, _objectSpread._)({
        category: (0, _utils.Category).Auth,
        action
    }, customUserAgentDetails));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5m6Bo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInitiateAuthClient", ()=>createInitiateAuthClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createInitiateAuthClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('InitiateAuth'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3t5JD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", ()=>(0, _composeServiceApiMjs.composeServiceApi));
parcelHelpers.export(exports, "composeTransferHandler", ()=>(0, _composeTransferHandlerMjs.composeTransferHandler));
var _composeServiceApiMjs = require("./composeServiceApi.mjs");
var _composeTransferHandlerMjs = require("./composeTransferHandler.mjs");

},{"./composeServiceApi.mjs":"cUdLo","./composeTransferHandler.mjs":"aXWVV","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"c3JYT":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUserPoolSerializer", ()=>createUserPoolSerializer);
const createUserPoolSerializer = (operation)=>(input, endpoint)=>{
        const headers = getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return buildHttpRpcRequest(endpoint, headers, body);
    };
const getSharedHeaders = (operation)=>({
        'content-type': 'application/x-amz-json-1.1',
        'x-amz-target': `AWSCognitoIdentityProviderService.${operation}`
    });
const buildHttpRpcRequest = ({ url }, headers, body)=>({
        headers,
        url,
        body,
        method: 'POST'
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bgSB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUserPoolDeserializer", ()=>createUserPoolDeserializer);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _assertServiceErrorMjs = require("../../../../../../errors/utils/assertServiceError.mjs");
var _authErrorMjs = require("../../../../../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createUserPoolDeserializer = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, _awsClientUtils.parseJsonError)(response);
            (0, _assertServiceErrorMjs.assertServiceError)(error);
            throw new (0, _authErrorMjs.AuthError)({
                name: error.name,
                message: error.message,
                metadata: error.$metadata
            });
        }
        return (0, _awsClientUtils.parseJsonBody)(response);
    };

},{"@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../../../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gSPGh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>(0, _getDnsSuffixMjs.getDnsSuffix));
parcelHelpers.export(exports, "fetchTransferHandler", ()=>(0, _fetchMjs.fetchTransferHandler));
parcelHelpers.export(exports, "unauthenticatedHandler", ()=>(0, _unauthenticatedMjs.unauthenticatedHandler));
parcelHelpers.export(exports, "authenticatedHandler", ()=>(0, _authenticatedMjs.authenticatedHandler));
parcelHelpers.export(exports, "signRequest", ()=>(0, _signRequestMjs.signRequest));
parcelHelpers.export(exports, "presignUrl", ()=>(0, _presignUrlMjs.presignUrl));
parcelHelpers.export(exports, "EMPTY_SHA256_HASH", ()=>(0, _constantsMjs.EMPTY_HASH));
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>(0, _constantsMjs.UNSIGNED_PAYLOAD));
parcelHelpers.export(exports, "getHashedPayload", ()=>(0, _getHashedPayloadMjs.getHashedPayload));
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>(0, _extendedEncodeURIComponentMjs.extendedEncodeURIComponent));
parcelHelpers.export(exports, "signingMiddlewareFactory", ()=>(0, _middlewareMjs.signingMiddlewareFactory));
parcelHelpers.export(exports, "retryMiddlewareFactory", ()=>(0, _retryMiddlewareMjs.retryMiddlewareFactory));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _jitteredBackoffMjs.jitteredBackoff));
parcelHelpers.export(exports, "getRetryDecider", ()=>(0, _defaultRetryDeciderMjs.getRetryDecider));
parcelHelpers.export(exports, "amzSdkInvocationIdHeaderMiddlewareFactory", ()=>(0, _amzSdkInvocationIdHeaderMiddlewareMjs.amzSdkInvocationIdHeaderMiddlewareFactory));
parcelHelpers.export(exports, "amzSdkRequestHeaderMiddlewareFactory", ()=>(0, _amzSdkRequestHeaderMiddlewareMjs.amzSdkRequestHeaderMiddlewareFactory));
parcelHelpers.export(exports, "userAgentMiddlewareFactory", ()=>(0, _middlewareMjs1.userAgentMiddlewareFactory));
parcelHelpers.export(exports, "parseMetadata", ()=>(0, _responseInfoMjs.parseMetadata));
parcelHelpers.export(exports, "parseJsonBody", ()=>(0, _jsonMjs.parseJsonBody));
parcelHelpers.export(exports, "parseJsonError", ()=>(0, _jsonMjs.parseJsonError));
parcelHelpers.export(exports, "withMemoization", ()=>(0, _memoizationMjs.withMemoization));
var _getDnsSuffixMjs = require("./endpoints/getDnsSuffix.mjs");
var _fetchMjs = require("./handlers/fetch.mjs");
var _unauthenticatedMjs = require("./handlers/aws/unauthenticated.mjs");
var _authenticatedMjs = require("./handlers/aws/authenticated.mjs");
var _signRequestMjs = require("./middleware/signing/signer/signatureV4/signRequest.mjs");
var _presignUrlMjs = require("./middleware/signing/signer/signatureV4/presignUrl.mjs");
var _constantsMjs = require("./middleware/signing/signer/signatureV4/constants.mjs");
var _getHashedPayloadMjs = require("./middleware/signing/signer/signatureV4/utils/getHashedPayload.mjs");
var _extendedEncodeURIComponentMjs = require("./middleware/signing/utils/extendedEncodeURIComponent.mjs");
var _middlewareMjs = require("./middleware/signing/middleware.mjs");
var _retryMiddlewareMjs = require("./middleware/retry/retryMiddleware.mjs");
var _jitteredBackoffMjs = require("./middleware/retry/jitteredBackoff.mjs");
var _defaultRetryDeciderMjs = require("./middleware/retry/defaultRetryDecider.mjs");
var _amzSdkInvocationIdHeaderMiddlewareMjs = require("./middleware/retry/amzSdkInvocationIdHeaderMiddleware.mjs");
var _amzSdkRequestHeaderMiddlewareMjs = require("./middleware/retry/amzSdkRequestHeaderMiddleware.mjs");
var _middlewareMjs1 = require("./middleware/userAgent/middleware.mjs");
var _responseInfoMjs = require("./serde/responseInfo.mjs");
var _jsonMjs = require("./serde/json.mjs");
var _memoizationMjs = require("./utils/memoization.mjs");

},{"./endpoints/getDnsSuffix.mjs":"5u4oS","./handlers/fetch.mjs":"eMjmx","./handlers/aws/unauthenticated.mjs":"64TuP","./handlers/aws/authenticated.mjs":"aZd4V","./middleware/signing/signer/signatureV4/signRequest.mjs":"1bdLF","./middleware/signing/signer/signatureV4/presignUrl.mjs":"ii53b","./middleware/signing/signer/signatureV4/constants.mjs":"9SfSa","./middleware/signing/signer/signatureV4/utils/getHashedPayload.mjs":"h5ZwH","./middleware/signing/utils/extendedEncodeURIComponent.mjs":"6UFtc","./middleware/signing/middleware.mjs":"4XVfc","./middleware/retry/retryMiddleware.mjs":"iHnIY","./middleware/retry/jitteredBackoff.mjs":"1gXeo","./middleware/retry/defaultRetryDecider.mjs":"kA0XD","./middleware/retry/amzSdkInvocationIdHeaderMiddleware.mjs":"ojiJg","./middleware/retry/amzSdkRequestHeaderMiddleware.mjs":"hvueN","./middleware/userAgent/middleware.mjs":"e6W9O","./serde/responseInfo.mjs":"88PMJ","./serde/json.mjs":"1pZXC","./utils/memoization.mjs":"2wQb5","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"e7Z2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertServiceError", ()=>assertServiceError);
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("../AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function assertServiceError(error) {
    if (!error || error.name === 'Error' || error instanceof TypeError) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _utils.AmplifyErrorCode).Unknown,
        message: 'An unknown error has occurred.',
        underlyingError: error
    });
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"CUUvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoUserPoolTransferHandler", ()=>cognitoUserPoolTransferHandler);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            var _Amplify_libraryOptions_Auth_headers, _Amplify_libraryOptions_Auth, _Amplify_libraryOptions;
            request.headers = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, request.headers), {
                'cache-control': 'no-store'
            }), await ((_Amplify_libraryOptions = (0, _core.Amplify).libraryOptions) === null || _Amplify_libraryOptions === void 0 ? void 0 : (_Amplify_libraryOptions_Auth = _Amplify_libraryOptions.Auth) === null || _Amplify_libraryOptions_Auth === void 0 ? void 0 : (_Amplify_libraryOptions_Auth_headers = _Amplify_libraryOptions_Auth.headers) === null || _Amplify_libraryOptions_Auth_headers === void 0 ? void 0 : _Amplify_libraryOptions_Auth_headers.call(_Amplify_libraryOptions_Auth)));
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const cognitoUserPoolTransferHandler = (0, _composers.composeTransferHandler)((0, _awsClientUtils.unauthenticatedHandler), [
    disableCacheMiddlewareFactory
]);

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bHH4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SERVICE_CLIENT_API_CONFIG", ()=>DEFAULT_SERVICE_CLIENT_API_CONFIG);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("../../../constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const DEFAULT_SERVICE_CLIENT_API_CONFIG = {
    service: (0, _constantsMjs.COGNITO_IDP_SERVICE_NAME),
    retryDecider: (0, _awsClientUtils.getRetryDecider)((0, _awsClientUtils.parseJsonError)),
    computeDelay: (0, _awsClientUtils.jitteredBackoff),
    get userAgentValue () {
        return (0, _utils.getAmplifyUserAgent)();
    },
    cache: 'no-store'
};

},{"@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","../../../constants.mjs":"f8RHF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"f8RHF":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COGNITO_IDP_SERVICE_NAME", ()=>COGNITO_IDP_SERVICE_NAME);
const COGNITO_IDP_SERVICE_NAME = 'cognito-idp';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1D9mM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRespondToAuthChallengeClient", ()=>createRespondToAuthChallengeClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createRespondToAuthChallengeClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('RespondToAuthChallenge'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7g18x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createVerifySoftwareTokenClient", ()=>createVerifySoftwareTokenClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createVerifySoftwareTokenClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('VerifySoftwareToken'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fQ4xk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAssociateSoftwareTokenClient", ()=>createAssociateSoftwareTokenClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createAssociateSoftwareTokenClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('AssociateSoftwareToken'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"l16n2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCognitoUserPoolEndpointResolver", ()=>createCognitoUserPoolEndpointResolver);
var _utils = require("@aws-amplify/core/internals/utils");
var _cognitoUserPoolEndpointResolverMjs = require("../../../foundation/cognitoUserPoolEndpointResolver.mjs");
const createCognitoUserPoolEndpointResolver = ({ endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, _utils.AmplifyUrl)(endpointOverride)
        };
        return (0, _cognitoUserPoolEndpointResolverMjs.cognitoUserPoolEndpointResolver)(input);
    };

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/cognitoUserPoolEndpointResolver.mjs":"ibyno","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"ibyno":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoUserPoolEndpointResolver", ()=>cognitoUserPoolEndpointResolver);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const cognitoUserPoolEndpointResolver = ({ region })=>({
        url: new (0, _utils.AmplifyUrl)(`https://${(0, _constantsMjs.COGNITO_IDP_SERVICE_NAME)}.${region}.${(0, _awsClientUtils.getDnsSuffix)(region)}`)
    });

},{"@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"f8RHF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8QS6B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleWebAuthnSignInResult", ()=>handleWebAuthnSignInResult);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../../../providers/cognito/types/errors.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _cacheTokensMjs = require("../../../providers/cognito/tokenProvider/cacheTokens.mjs");
var _dispatchSignedInHubEventMjs = require("../../../providers/cognito/utils/dispatchSignedInHubEvent.mjs");
var _autoSignInStoreMjs = require("../../utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../utils/store/signInStore.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _passkeyErrorMjs = require("../../utils/passkey/errors/passkeyError.mjs");
var _getPasskeyMjs = require("../../utils/passkey/getPasskey.mjs");
var _getNewDeviceMetadataMjs = require("../../../providers/cognito/utils/getNewDeviceMetadata.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function handleWebAuthnSignInResult(challengeParameters) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { username, signInSession, signInDetails, challengeName } = (0, _signInStoreMjs.signInStore).getState();
    if (challengeName !== 'WEB_AUTHN' || !username) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
        message: 'Unable to proceed due to invalid sign in state.'
    });
    const { CREDENTIAL_REQUEST_OPTIONS: credentialRequestOptions } = challengeParameters;
    (0, _passkeyErrorMjs.assertPasskeyError)(!!credentialRequestOptions, (0, _passkeyErrorMjs.PasskeyErrorCode).InvalidPasskeyAuthenticationOptions);
    const cred = await (0, _getPasskeyMjs.getPasskey)(JSON.parse(credentialRequestOptions));
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: authConfig.userPoolEndpoint
        })
    });
    const { ChallengeName: nextChallengeName, ChallengeParameters: nextChallengeParameters, AuthenticationResult: authenticationResult, Session: nextSession } = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(authConfig.userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, {
        ChallengeName: 'WEB_AUTHN',
        ChallengeResponses: {
            USERNAME: username,
            CREDENTIAL: JSON.stringify(cred)
        },
        ClientId: authConfig.userPoolClientId,
        Session: signInSession
    });
    (0, _signInStoreMjs.setActiveSignInState)({
        signInSession: nextSession,
        username,
        challengeName: nextChallengeName,
        signInDetails
    });
    if (authenticationResult) {
        await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({}, authenticationResult), {
            username,
            NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                userPoolId: authConfig.userPoolId,
                userPoolEndpoint: authConfig.userPoolEndpoint,
                newDeviceMetadata: authenticationResult.NewDeviceMetadata,
                accessToken: authenticationResult.AccessToken
            }),
            signInDetails
        }));
        (0, _signInStoreMjs.signInStore).dispatch({
            type: 'RESET_STATE'
        });
        await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
        return {
            isSignedIn: true,
            nextStep: {
                signInStep: 'DONE'
            }
        };
    }
    if (nextChallengeName === 'WEB_AUTHN') throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
        message: 'Sequential WEB_AUTHN challenges returned from underlying service cannot be handled.'
    });
    return {
        challengeName: nextChallengeName,
        challengeParameters: nextChallengeParameters
    };
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../common/AuthErrorStrings.mjs":"eO30C","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../errors/AuthError.mjs":"4RqZd","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../errors/types/validation.mjs":"frXJ6","../../../providers/cognito/types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","../../../providers/cognito/tokenProvider/cacheTokens.mjs":"bsRco","../../../providers/cognito/utils/dispatchSignedInHubEvent.mjs":"2RLlL","../../utils/store/autoSignInStore.mjs":"gZWar","../../utils/store/signInStore.mjs":"chngd","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../../utils/passkey/errors/passkeyError.mjs":"bpX9I","../../utils/passkey/getPasskey.mjs":"cpCdr","../../../providers/cognito/utils/getNewDeviceMetadata.mjs":"jJyS1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bsRco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cacheCognitoTokens", ()=>cacheCognitoTokens);
var _utils = require("@aws-amplify/core/internals/utils");
var _tokenProviderMjs = require("./tokenProvider.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function cacheCognitoTokens(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, _utils.decodeJWT)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, _utils.decodeJWT)(AuthenticationResult.IdToken);
        if (AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken,
            idToken,
            refreshToken,
            clockDrift,
            deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, _tokenProviderMjs.tokenOrchestrator).setTokens({
            tokens
        });
    } else // This would be a service error
    throw new (0, _utils.AmplifyError)({
        message: 'Invalid tokens',
        name: 'InvalidTokens',
        recoverySuggestion: 'Check Cognito UserPool settings'
    });
}

},{"@aws-amplify/core/internals/utils":"aiEf6","./tokenProvider.mjs":"9mSqK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9mSqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoUserPoolsTokenProvider", ()=>cognitoUserPoolsTokenProvider);
parcelHelpers.export(exports, "tokenOrchestrator", ()=>tokenOrchestrator);
var _cognitoUserPoolsTokenProviderMjs = require("./CognitoUserPoolsTokenProvider.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const cognitoUserPoolsTokenProvider = new (0, _cognitoUserPoolsTokenProviderMjs.CognitoUserPoolsTokenProvider)();
const { tokenOrchestrator } = cognitoUserPoolsTokenProvider;

},{"./CognitoUserPoolsTokenProvider.mjs":"s8KxS","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"s8KxS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CognitoUserPoolsTokenProvider", ()=>CognitoUserPoolsTokenProvider);
var _core = require("@aws-amplify/core");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _tokenStoreMjs = require("./TokenStore.mjs");
var _tokenOrchestratorMjs = require("./TokenOrchestrator.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class CognitoUserPoolsTokenProvider {
    getTokens(options = {}) {
        return this.tokenOrchestrator.getTokens(options);
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setClientMetadataProvider(clientMetadataProvider) {
        this.tokenOrchestrator.setClientMetadataProvider(clientMetadataProvider);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
    constructor(){
        this.authTokenStore = new (0, _tokenStoreMjs.DefaultTokenStore)();
        this.authTokenStore.setKeyValueStorage((0, _core.defaultStorage));
        this.tokenOrchestrator = new (0, _tokenOrchestratorMjs.TokenOrchestrator)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, _refreshAuthTokensMjs.refreshAuthTokens));
    }
}

},{"@aws-amplify/core":"94XF7","../utils/refreshAuthTokens.mjs":"5xqj9","./TokenStore.mjs":"huiyc","./TokenOrchestrator.mjs":"5y1TR","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5xqj9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refreshAuthTokens", ()=>refreshAuthTokens);
parcelHelpers.export(exports, "refreshAuthTokensWithoutDedupe", ()=>refreshAuthTokensWithoutDedupe);
var _utils = require("@aws-amplify/core/internals/utils");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("./types.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _createGetTokensFromRefreshTokenClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetTokensFromRefreshTokenClient.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const refreshAuthTokensFunction = async ({ tokens, authConfig, username, clientMetadata })=>{
    var _tokens_deviceMetadata;
    (0, _utils.assertTokenProviderConfig)(authConfig === null || authConfig === void 0 ? void 0 : authConfig.Cognito);
    const { userPoolId, userPoolClientId, userPoolEndpoint } = authConfig.Cognito;
    const region = (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId);
    (0, _typesMjs.assertAuthTokensWithRefreshToken)(tokens);
    const getTokensFromRefreshToken = (0, _createGetTokensFromRefreshTokenClientMjs.createGetTokensFromRefreshTokenClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { AuthenticationResult } = await getTokensFromRefreshToken({
        region
    }, {
        ClientId: userPoolClientId,
        RefreshToken: tokens.refreshToken,
        DeviceKey: (_tokens_deviceMetadata = tokens.deviceMetadata) === null || _tokens_deviceMetadata === void 0 ? void 0 : _tokens_deviceMetadata.deviceKey,
        ClientMetadata: clientMetadata
    });
    var _AuthenticationResult_AccessToken;
    const accessToken = (0, _utils.decodeJWT)((_AuthenticationResult_AccessToken = AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.AccessToken) !== null && _AuthenticationResult_AccessToken !== void 0 ? _AuthenticationResult_AccessToken : '');
    const idToken = (AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.IdToken) ? (0, _utils.decodeJWT)(AuthenticationResult.IdToken) : undefined;
    const { iat } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, _authErrorMjs.AuthError)({
        name: 'iatNotFoundException',
        message: 'iat not found in access token'
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    var _AuthenticationResult_RefreshToken;
    return {
        accessToken,
        idToken,
        clockDrift,
        refreshToken: (_AuthenticationResult_RefreshToken = AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.RefreshToken) !== null && _AuthenticationResult_RefreshToken !== void 0 ? _AuthenticationResult_RefreshToken : tokens.refreshToken,
        username
    };
};
const refreshAuthTokens = (0, _utils.deDupeAsyncFunction)(refreshAuthTokensFunction);
const refreshAuthTokensWithoutDedupe = refreshAuthTokensFunction;

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","./types.mjs":"4GeFs","../../../errors/AuthError.mjs":"4RqZd","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetTokensFromRefreshTokenClient.mjs":"eUCPX","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eUCPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetTokensFromRefreshTokenClient", ()=>createGetTokensFromRefreshTokenClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createGetTokensFromRefreshTokenClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('GetTokensFromRefreshToken'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"huiyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTokenStore", ()=>DefaultTokenStore);
parcelHelpers.export(exports, "createKeysForAuthStorage", ()=>createKeysForAuthStorage);
parcelHelpers.export(exports, "getAuthStorageKeys", ()=>getAuthStorageKeys);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _typesMjs = require("./types.mjs");
var _errorHelpersMjs = require("./errorHelpers.mjs");
var _constantsMjs = require("./constants.mjs");
class DefaultTokenStore {
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, _authErrorMjs.AuthError)({
            name: 'KeyValueStorageNotFoundException',
            message: 'KeyValueStorage was not found in TokenStore'
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, _authErrorMjs.AuthError)({
                name: 'NoSessionFoundException',
                message: 'Auth session was not found. Make sure to call signIn.'
            });
            const accessToken = (0, _utils.decodeJWT)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, _utils.decodeJWT)(itString) : undefined;
            var _ref;
            const refreshToken = (_ref = await this.getKeyValueStorage().getItem(authKeys.refreshToken)) !== null && _ref !== void 0 ? _ref : undefined;
            var _ref1;
            const clockDriftString = (_ref1 = await this.getKeyValueStorage().getItem(authKeys.clockDrift)) !== null && _ref1 !== void 0 ? _ref1 : '0';
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            var _ref2;
            const tokens = {
                accessToken,
                idToken,
                refreshToken,
                deviceMetadata: (_ref2 = await this.getDeviceMetadata()) !== null && _ref2 !== void 0 ? _ref2 : undefined,
                clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, _errorHelpersMjs.assert)(tokens !== undefined, (0, _errorHelpersMjs.TokenProviderErrorCode).InvalidAuthTokens);
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        else await this.getKeyValueStorage().removeItem(authKeys.idToken);
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        else await this.getKeyValueStorage().removeItem(authKeys.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        else await this.getKeyValueStorage().removeItem(authKeys.signInDetails);
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey()),
            this.getKeyValueStorage().removeItem(authKeys.oauthMetadata)
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey,
            deviceGroupKey,
            randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        var _this_authConfig;
        (0, _utils.assertTokenProviderConfig)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        const lastAuthUser = username !== null && username !== void 0 ? username : await this.getLastAuthUser();
        return createKeysForAuthStorage((0, _constantsMjs.AUTH_KEY_PREFIX), `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        var _this_authConfig;
        (0, _utils.assertTokenProviderConfig)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${0, _constantsMjs.AUTH_KEY_PREFIX}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        var _ref;
        const lastAuthUser = (_ref = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey())) !== null && _ref !== void 0 ? _ref : 'username';
        return lastAuthUser;
    }
    async setOAuthMetadata(metadata) {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(oauthMetadataKey, JSON.stringify(metadata));
    }
    async getOAuthMetadata() {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        const oauthMetadata = await this.getKeyValueStorage().getItem(oauthMetadataKey);
        return oauthMetadata && JSON.parse(oauthMetadata);
    }
}
const createKeysForAuthStorage = (provider, identifier)=>{
    return getAuthStorageKeys((0, _typesMjs.AuthTokenStorageKeys))(`${provider}`, identifier);
};
function getAuthStorageKeys(authKeys) {
    const keys = Object.values((0, _objectSpread._)({}, authKeys));
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/AuthError.mjs":"4RqZd","./types.mjs":"1rAQA","./errorHelpers.mjs":"5hyq8","./constants.mjs":"entLw","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1rAQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthTokenStorageKeys", ()=>AuthTokenStorageKeys);
const AuthTokenStorageKeys = {
    accessToken: 'accessToken',
    idToken: 'idToken',
    oidcProvider: 'oidcProvider',
    clockDrift: 'clockDrift',
    refreshToken: 'refreshToken',
    deviceKey: 'deviceKey',
    randomPasswordKey: 'randomPasswordKey',
    deviceGroupKey: 'deviceGroupKey',
    signInDetails: 'signInDetails',
    oauthMetadata: 'oauthMetadata'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5hyq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderErrorCode", ()=>TokenProviderErrorCode);
parcelHelpers.export(exports, "assert", ()=>assert);
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var TokenProviderErrorCode;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})(TokenProviderErrorCode || (TokenProviderErrorCode = {}));
const tokenValidationErrorMap = {
    [TokenProviderErrorCode.InvalidAuthTokens]: {
        message: 'Invalid tokens.',
        recoverySuggestion: 'Make sure the tokens are valid.'
    }
};
const assert = (0, _utils.createAssertionFunction)(tokenValidationErrorMap);

},{"@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"entLw":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTH_KEY_PREFIX", ()=>AUTH_KEY_PREFIX);
const AUTH_KEY_PREFIX = 'CognitoIdentityServiceProvider';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5y1TR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenOrchestrator", ()=>TokenOrchestrator);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _oAuthStoreMjs = require("../utils/oauth/oAuthStore.mjs");
var _inflightPromiseMjs = require("../utils/oauth/inflightPromise.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class TokenOrchestrator {
    setAuthConfig(authConfig) {
        (0, _oAuthStoreMjs.oAuthStore).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, _authErrorMjs.AuthError)({
            name: 'EmptyTokenStoreException',
            message: 'TokenStore not set'
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, _authErrorMjs.AuthError)({
            name: 'EmptyTokenRefresherException',
            message: 'TokenRefresher not set'
        });
        return this.tokenRefresher;
    }
    setClientMetadataProvider(clientMetadataProvider) {
        this.clientMetadataProvider = clientMetadataProvider;
    }
    async getTokens(options) {
        var _tokens_idToken_payload, _tokens_idToken, _tokens_accessToken_payload, _tokens_accessToken;
        let tokens;
        try {
            var _this_authConfig;
            (0, _utils.assertTokenProviderConfig)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        var _tokens_idToken_payload_exp, _tokens_clockDrift;
        const idTokenExpired = !!(tokens === null || tokens === void 0 ? void 0 : tokens.idToken) && (0, _utils.isTokenExpired)({
            expiresAt: ((_tokens_idToken_payload_exp = (_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : (_tokens_idToken_payload = _tokens_idToken.payload) === null || _tokens_idToken_payload === void 0 ? void 0 : _tokens_idToken_payload.exp) !== null && _tokens_idToken_payload_exp !== void 0 ? _tokens_idToken_payload_exp : 0) * 1000,
            clockDrift: (_tokens_clockDrift = tokens.clockDrift) !== null && _tokens_clockDrift !== void 0 ? _tokens_clockDrift : 0
        });
        var _tokens_accessToken_payload_exp, _tokens_clockDrift1;
        const accessTokenExpired = (0, _utils.isTokenExpired)({
            expiresAt: ((_tokens_accessToken_payload_exp = (_tokens_accessToken = tokens.accessToken) === null || _tokens_accessToken === void 0 ? void 0 : (_tokens_accessToken_payload = _tokens_accessToken.payload) === null || _tokens_accessToken_payload === void 0 ? void 0 : _tokens_accessToken_payload.exp) !== null && _tokens_accessToken_payload_exp !== void 0 ? _tokens_accessToken_payload_exp : 0) * 1000,
            clockDrift: (_tokens_clockDrift1 = tokens.clockDrift) !== null && _tokens_clockDrift1 !== void 0 ? _tokens_clockDrift1 : 0
        });
        if ((options === null || options === void 0 ? void 0 : options.forceRefresh) || idTokenExpired || accessTokenExpired) {
            var _this_clientMetadataProvider, _this;
            var _options_clientMetadata;
            tokens = await this.refreshTokens({
                tokens,
                username,
                clientMetadata: (_options_clientMetadata = options === null || options === void 0 ? void 0 : options.clientMetadata) !== null && _options_clientMetadata !== void 0 ? _options_clientMetadata : await ((_this_clientMetadataProvider = (_this = this).clientMetadataProvider) === null || _this_clientMetadataProvider === void 0 ? void 0 : _this_clientMetadataProvider.call(_this))
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens === null || tokens === void 0 ? void 0 : tokens.accessToken,
            idToken: tokens === null || tokens === void 0 ? void 0 : tokens.idToken,
            signInDetails: tokens === null || tokens === void 0 ? void 0 : tokens.signInDetails
        };
    }
    async refreshTokens({ tokens, username, clientMetadata }) {
        try {
            const { signInDetails } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens,
                authConfig: this.authConfig,
                username,
                clientMetadata
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, _core.Hub).dispatch('auth', {
                event: 'tokenRefresh'
            }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, _assertServiceErrorMjs.assertServiceError)(err);
        // Only clear tokens for definitive authentication failures
        // Do NOT clear tokens for transient errors like service issues, rate limits, etc.
        const shouldClearTokens = this.isAuthenticationError(err);
        if (shouldClearTokens) this.clearTokens();
        (0, _core.Hub).dispatch('auth', {
            event: 'tokenRefresh_failure',
            data: {
                error: err
            }
        }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
        if (err.name.startsWith('NotAuthorizedException')) return null;
        throw err;
    }
    isAuthenticationError(err) {
        // Only clear tokens for errors that definitively indicate the tokens are invalid
        // and re-authentication is required. All other errors (service errors, rate limits, etc.)
        // should preserve the tokens to allow for retry.
        // See: https://github.com/aws-amplify/amplify-js/issues/14534
        const authErrorNames = [
            'NotAuthorizedException',
            'TokenRevokedException',
            'UserNotFoundException',
            'PasswordResetRequiredException',
            'UserNotConfirmedException',
            'RefreshTokenReuseException'
        ];
        return authErrorNames.some((errorName)=>{
            var _err_name_startsWith, _err_name;
            return err === null || err === void 0 ? void 0 : (_err_name = err.name) === null || _err_name === void 0 ? void 0 : (_err_name_startsWith = _err_name.startsWith) === null || _err_name_startsWith === void 0 ? void 0 : _err_name_startsWith.call(_err_name, errorName);
        });
    }
    async setTokens({ tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
    setOAuthMetadata(metadata) {
        return this.getTokenStore().setOAuthMetadata(metadata);
    }
    getOAuthMetadata() {
        return this.getTokenStore().getOAuthMetadata();
    }
    constructor(){
        this.waitForInflightOAuth = (0, _utils.isBrowser)() ? async ()=>{
            if (!await (0, _oAuthStoreMjs.oAuthStore).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, _inflightPromiseMjs.addInflightPromise)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../errors/AuthError.mjs":"4RqZd","../utils/oauth/oAuthStore.mjs":"1uhgp","../utils/oauth/inflightPromise.mjs":"6zbeu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1uhgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "oAuthStore", ()=>oAuthStore);
var _core = require("@aws-amplify/core");
var _signInWithRedirectStoreMjs = require("../signInWithRedirectStore.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const oAuthStore = new (0, _signInWithRedirectStoreMjs.DefaultOAuthStore)((0, _core.defaultStorage));

},{"@aws-amplify/core":"94XF7","../signInWithRedirectStore.mjs":"4PmDB","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4PmDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultOAuthStore", ()=>DefaultOAuthStore);
var _utils = require("@aws-amplify/core/internals/utils");
var _tokenStoreMjs = require("../tokenProvider/TokenStore.mjs");
var _typesMjs = require("./types.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const V5_HOSTED_UI_KEY = 'amplify-signin-with-hostedUI';
const name = 'CognitoIdentityServiceProvider';
class DefaultOAuthStore {
    async clearOAuthInflightData() {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem(V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === 'true';
    }
    async storeOAuthInFlight(inflight) {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        var _this;
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem(V5_HOSTED_UI_KEY);
        var _split;
        const [isOAuthSignIn, preferPrivateSession] = (_split = (_this = await this.keyValueStorage.getItem(authKeys.oauthSignIn)) === null || _this === void 0 ? void 0 : _this.split(',')) !== null && _split !== void 0 ? _split : [];
        return {
            isOAuthSignIn: isOAuthSignIn === 'true' || isLegacyHostedUISignIn === 'true',
            preferPrivateSession: preferPrivateSession === 'true'
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, _utils.assertTokenProviderConfig)(this.cognitoConfig);
        const authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
}
const createKeysForAuthStorage = (provider, identifier)=>{
    return (0, _tokenStoreMjs.getAuthStorageKeys)((0, _typesMjs.OAuthStorageKeys))(provider, identifier);
};

},{"@aws-amplify/core/internals/utils":"aiEf6","../tokenProvider/TokenStore.mjs":"huiyc","./types.mjs":"4GeFs","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6zbeu":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addInflightPromise", ()=>addInflightPromise);
parcelHelpers.export(exports, "resolveAndClearInflightPromises", ()=>resolveAndClearInflightPromises);
const inflightPromises = [];
const addInflightPromise = (resolver)=>{
    inflightPromises.push(resolver);
};
const resolveAndClearInflightPromises = ()=>{
    var _inflightPromises_pop;
    while(inflightPromises.length)(_inflightPromises_pop = inflightPromises.pop()) === null || _inflightPromises_pop === void 0 ? void 0 : _inflightPromises_pop();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2RLlL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_MESSAGE", ()=>ERROR_MESSAGE);
parcelHelpers.export(exports, "dispatchSignedInHubEvent", ()=>dispatchSignedInHubEvent);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _getCurrentUserMjs = require("../apis/getCurrentUser.mjs");
var _constantsMjs = require("../../../errors/constants.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const ERROR_MESSAGE = 'Unable to get user session following successful sign-in.';
const dispatchSignedInHubEvent = async ()=>{
    try {
        (0, _core.Hub).dispatch('auth', {
            event: 'signedIn',
            data: await (0, _getCurrentUserMjs.getCurrentUser)()
        }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
    } catch (error) {
        if (error.name === (0, _constantsMjs.USER_UNAUTHENTICATED_EXCEPTION)) throw new (0, _authErrorMjs.AuthError)({
            name: (0, _constantsMjs.UNEXPECTED_SIGN_IN_INTERRUPTION_EXCEPTION),
            message: ERROR_MESSAGE,
            recoverySuggestion: 'This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server.'
        });
        throw error;
    }
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../apis/getCurrentUser.mjs":"gllvP","../../../errors/constants.mjs":"8qcdh","../../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gZWar":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoSignInStore", ()=>autoSignInStore);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
function defaultState() {
    return {
        active: false
    };
}
const autoSignInReducer = (state, action)=>{
    switch(action.type){
        case 'SET_USERNAME':
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                username: action.value
            });
        case 'SET_SESSION':
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                session: action.value
            });
        case 'START':
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                active: true
            });
        case 'RESET':
            return defaultState();
        default:
            return state;
    }
};
const createAutoSignInStore = (reducer)=>{
    let currentState = reducer(defaultState(), {
        type: 'RESET'
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const autoSignInStore = createAutoSignInStore(autoSignInReducer);

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"chngd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "persistSignInState", ()=>persistSignInState);
parcelHelpers.export(exports, "resetActiveSignInState", ()=>resetActiveSignInState);
parcelHelpers.export(exports, "setActiveSignInState", ()=>setActiveSignInState);
parcelHelpers.export(exports, "signInStore", ()=>signInStore);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Minutes until stored session invalidates is defaulted to 3 minutes
// to maintain parity with Amazon Cognito user pools API behavior
const MS_TO_EXPIRY = 180000;
const TGT_STATE = 'CognitoSignInState';
const SIGN_IN_STATE_KEYS = {
    username: `${TGT_STATE}.username`,
    challengeName: `${TGT_STATE}.challengeName`,
    signInSession: `${TGT_STATE}.signInSession`,
    expiry: `${TGT_STATE}.expiry`
};
const signInReducer = (state, action)=>{
    switch(action.type){
        case 'SET_SIGN_IN_SESSION':
            persistSignInState({
                signInSession: action.value
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                signInSession: action.value
            });
        case 'SET_SIGN_IN_STATE':
            persistSignInState(action.value);
            return (0, _objectSpread._)({}, action.value);
        case 'SET_CHALLENGE_NAME':
            persistSignInState({
                challengeName: action.value
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                challengeName: action.value
            });
        case 'SET_USERNAME':
            persistSignInState({
                username: action.value
            });
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                username: action.value
            });
        case 'SET_INITIAL_STATE':
            return getInitialState();
        case 'RESET_STATE':
            clearPersistedSignInState();
            return getDefaultState();
        // this state is never reachable
        default:
            return state;
    }
};
const isExpired = (expiryDate)=>{
    const expiryTimestamp = Number(expiryDate);
    const currentTimestamp = Date.now();
    return expiryTimestamp <= currentTimestamp;
};
const resetActiveSignInState = ()=>{
    signInStore.dispatch({
        type: 'RESET_STATE'
    });
};
const clearPersistedSignInState = ()=>{
    for (const stateKey of Object.values(SIGN_IN_STATE_KEYS))(0, _core.syncSessionStorage).removeItem(stateKey);
};
const getDefaultState = ()=>({
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    });
// Hydrate signInStore from syncSessionStorage if the session has not expired
const getInitialState = ()=>{
    const expiry = (0, _core.syncSessionStorage).getItem(SIGN_IN_STATE_KEYS.expiry);
    if (!expiry || isExpired(expiry)) {
        clearPersistedSignInState();
        return getDefaultState();
    }
    var _syncSessionStorage_getItem;
    const username = (_syncSessionStorage_getItem = (0, _core.syncSessionStorage).getItem(SIGN_IN_STATE_KEYS.username)) !== null && _syncSessionStorage_getItem !== void 0 ? _syncSessionStorage_getItem : undefined;
    var _syncSessionStorage_getItem1;
    const challengeName = (_syncSessionStorage_getItem1 = (0, _core.syncSessionStorage).getItem(SIGN_IN_STATE_KEYS.challengeName)) !== null && _syncSessionStorage_getItem1 !== void 0 ? _syncSessionStorage_getItem1 : undefined;
    var _syncSessionStorage_getItem2;
    const signInSession = (_syncSessionStorage_getItem2 = (0, _core.syncSessionStorage).getItem(SIGN_IN_STATE_KEYS.signInSession)) !== null && _syncSessionStorage_getItem2 !== void 0 ? _syncSessionStorage_getItem2 : undefined;
    return {
        username,
        challengeName,
        signInSession
    };
};
const createStore = (reducer)=>{
    let currentState = reducer(getDefaultState(), {
        type: 'SET_INITIAL_STATE'
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const signInStore = createStore(signInReducer);
function setActiveSignInState(state) {
    signInStore.dispatch({
        type: 'SET_SIGN_IN_STATE',
        value: state
    });
}
// Save local state into Session Storage
const persistSignInState = ({ challengeName, signInSession, username })=>{
    username && (0, _core.syncSessionStorage).setItem(SIGN_IN_STATE_KEYS.username, username);
    challengeName && (0, _core.syncSessionStorage).setItem(SIGN_IN_STATE_KEYS.challengeName, challengeName);
    if (signInSession) {
        (0, _core.syncSessionStorage).setItem(SIGN_IN_STATE_KEYS.signInSession, signInSession);
        // Updates expiry when session is passed
        (0, _core.syncSessionStorage).setItem(SIGN_IN_STATE_KEYS.expiry, String(Date.now() + MS_TO_EXPIRY));
    }
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bpX9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PasskeyError", ()=>PasskeyError);
parcelHelpers.export(exports, "PasskeyErrorCode", ()=>PasskeyErrorCode);
parcelHelpers.export(exports, "assertPasskeyError", ()=>assertPasskeyError);
parcelHelpers.export(exports, "passkeyErrorMap", ()=>passkeyErrorMap);
var _utils = require("@aws-amplify/core/internals/utils");
var _passkeyErrorPlatformConstantsMjs = require("./passkeyErrorPlatformConstants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class PasskeyError extends (0, _utils.AmplifyError) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = PasskeyError;
        Object.setPrototypeOf(this, PasskeyError.prototype);
    }
}
var PasskeyErrorCode;
(function(PasskeyErrorCode) {
    // not supported
    PasskeyErrorCode["PasskeyNotSupported"] = "PasskeyNotSupported";
    // duplicate passkey
    PasskeyErrorCode["PasskeyAlreadyExists"] = "PasskeyAlreadyExists";
    // misconfigurations
    PasskeyErrorCode["InvalidPasskeyRegistrationOptions"] = "InvalidPasskeyRegistrationOptions";
    PasskeyErrorCode["InvalidPasskeyAuthenticationOptions"] = "InvalidPasskeyAuthenticationOptions";
    PasskeyErrorCode["RelyingPartyMismatch"] = "RelyingPartyMismatch";
    // failed credential creation / retrieval
    PasskeyErrorCode["PasskeyRegistrationFailed"] = "PasskeyRegistrationFailed";
    PasskeyErrorCode["PasskeyRetrievalFailed"] = "PasskeyRetrievalFailed";
    // cancel / aborts
    PasskeyErrorCode["PasskeyRegistrationCanceled"] = "PasskeyRegistrationCanceled";
    PasskeyErrorCode["PasskeyAuthenticationCanceled"] = "PasskeyAuthenticationCanceled";
    PasskeyErrorCode["PasskeyOperationAborted"] = "PasskeyOperationAborted";
})(PasskeyErrorCode || (PasskeyErrorCode = {}));
const ABORT_OR_CANCEL_RECOVERY_SUGGESTION = 'User may have canceled the ceremony or another interruption has occurred. Check underlying error for details.';
const MISCONFIGURATION_RECOVERY_SUGGESTION = 'Ensure your user pool is configured to support the WEB_AUTHN as an authentication factor.';
const passkeyErrorMap = {
    [PasskeyErrorCode.PasskeyNotSupported]: {
        message: 'Passkeys may not be supported on this device.',
        recoverySuggestion: (0, _passkeyErrorPlatformConstantsMjs.NOT_SUPPORTED_RECOVERY_SUGGESTION)
    },
    [PasskeyErrorCode.InvalidPasskeyRegistrationOptions]: {
        message: 'Invalid passkey registration options.',
        recoverySuggestion: MISCONFIGURATION_RECOVERY_SUGGESTION
    },
    [PasskeyErrorCode.InvalidPasskeyAuthenticationOptions]: {
        message: 'Invalid passkey authentication options.',
        recoverySuggestion: MISCONFIGURATION_RECOVERY_SUGGESTION
    },
    [PasskeyErrorCode.PasskeyRegistrationFailed]: {
        message: 'Device failed to create passkey.',
        recoverySuggestion: (0, _passkeyErrorPlatformConstantsMjs.NOT_SUPPORTED_RECOVERY_SUGGESTION)
    },
    [PasskeyErrorCode.PasskeyRetrievalFailed]: {
        message: 'Device failed to retrieve passkey.',
        recoverySuggestion: 'Passkeys may not be available on this device. Try an alternative authentication factor like PASSWORD, EMAIL_OTP, or SMS_OTP.'
    },
    [PasskeyErrorCode.PasskeyAlreadyExists]: {
        message: 'Passkey already exists in authenticator.',
        recoverySuggestion: 'Proceed with existing passkey or try again after deleting the credential.'
    },
    [PasskeyErrorCode.PasskeyRegistrationCanceled]: {
        message: 'Passkey registration ceremony has been canceled.',
        recoverySuggestion: ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [PasskeyErrorCode.PasskeyAuthenticationCanceled]: {
        message: 'Passkey authentication ceremony has been canceled.',
        recoverySuggestion: ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [PasskeyErrorCode.PasskeyOperationAborted]: {
        message: 'Passkey operation has been aborted.',
        recoverySuggestion: ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [PasskeyErrorCode.RelyingPartyMismatch]: {
        message: 'Relying party does not match current domain.',
        recoverySuggestion: 'Ensure relying party identifier matches current domain.'
    }
};
const assertPasskeyError = (0, _utils.createAssertionFunction)(passkeyErrorMap, PasskeyError);

},{"@aws-amplify/core/internals/utils":"aiEf6","./passkeyErrorPlatformConstants.mjs":"iBeWL","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iBeWL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOT_SUPPORTED_RECOVERY_SUGGESTION", ()=>NOT_SUPPORTED_RECOVERY_SUGGESTION);
const NOT_SUPPORTED_RECOVERY_SUGGESTION = 'Passkeys may not be supported on this device. Ensure your application is running in a secure context (HTTPS) and Web Authentication API is supported.';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cpCdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPasskey", ()=>getPasskey);
var _handlePasskeyAuthenticationErrorMjs = require("./errors/handlePasskeyAuthenticationError.mjs");
var _utils = require("@aws-amplify/core/internals/utils");
var _passkeyErrorMjs = require("./errors/passkeyError.mjs");
var _getIsPasskeySupportedMjs = require("./getIsPasskeySupported.mjs");
var _serdeMjs = require("./serde.mjs");
var _indexMjs = require("./types/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getPasskey = async (input)=>{
    try {
        const isPasskeySupported = (0, _getIsPasskeySupportedMjs.getIsPasskeySupported)();
        (0, _passkeyErrorMjs.assertPasskeyError)(isPasskeySupported, (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyNotSupported);
        const passkeyGetOptions = (0, _serdeMjs.deserializeJsonToPkcGetOptions)(input);
        const credential = await navigator.credentials.get({
            publicKey: passkeyGetOptions
        });
        (0, _indexMjs.assertCredentialIsPkcWithAuthenticatorAssertionResponse)(credential);
        return (0, _serdeMjs.serializePkcWithAssertionToJson)(credential);
    } catch (err) {
        throw (0, _handlePasskeyAuthenticationErrorMjs.handlePasskeyAuthenticationError)(err);
    }
};

},{"./errors/handlePasskeyAuthenticationError.mjs":"kasZh","@aws-amplify/core/internals/utils":"aiEf6","./errors/passkeyError.mjs":"bpX9I","./getIsPasskeySupported.mjs":"lIcwO","./serde.mjs":"aVrg6","./types/index.mjs":"53f0G","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kasZh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handlePasskeyAuthenticationError", ()=>handlePasskeyAuthenticationError);
var _handlePasskeyErrorMjs = require("./handlePasskeyError.mjs");
var _passkeyErrorMjs = require("./passkeyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handle Passkey Authentication Errors
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const handlePasskeyAuthenticationError = (err)=>{
    if (err instanceof (0, _passkeyErrorMjs.PasskeyError)) return err;
    if (err instanceof Error) {
        if (err.name === 'NotAllowedError') {
            const { message, recoverySuggestion } = (0, _passkeyErrorMjs.passkeyErrorMap)[(0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyAuthenticationCanceled];
            return new (0, _passkeyErrorMjs.PasskeyError)({
                name: (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyAuthenticationCanceled,
                message,
                recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return (0, _handlePasskeyErrorMjs.handlePasskeyError)(err);
};

},{"./handlePasskeyError.mjs":"3h25d","./passkeyError.mjs":"bpX9I","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3h25d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handlePasskeyError", ()=>handlePasskeyError);
var _utils = require("@aws-amplify/core/internals/utils");
var _passkeyErrorMjs = require("./passkeyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles Overlapping Passkey Errors Between Registration & Authentication
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const handlePasskeyError = (err)=>{
    if (err instanceof Error) {
        // Passkey Operation Aborted
        if (err.name === 'AbortError') {
            const { message, recoverySuggestion } = (0, _passkeyErrorMjs.passkeyErrorMap)[(0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyOperationAborted];
            return new (0, _passkeyErrorMjs.PasskeyError)({
                name: (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyOperationAborted,
                message,
                recoverySuggestion,
                underlyingError: err
            });
        }
        // Relying Party / Domain Mismatch
        if (err.name === 'SecurityError') {
            const { message, recoverySuggestion } = (0, _passkeyErrorMjs.passkeyErrorMap)[(0, _passkeyErrorMjs.PasskeyErrorCode).RelyingPartyMismatch];
            return new (0, _passkeyErrorMjs.PasskeyError)({
                name: (0, _passkeyErrorMjs.PasskeyErrorCode).RelyingPartyMismatch,
                message,
                recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return new (0, _passkeyErrorMjs.PasskeyError)({
        name: (0, _utils.AmplifyErrorCode).Unknown,
        message: 'An unknown error has occurred.',
        underlyingError: err
    });
};

},{"@aws-amplify/core/internals/utils":"aiEf6","./passkeyError.mjs":"bpX9I","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lIcwO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIsPasskeySupported", ()=>getIsPasskeySupported);
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if passkey is supported in current context
 * Will return false if executed in non-secure context
 * @returns boolean
 */ const getIsPasskeySupported = ()=>{
    return (0, _utils.isBrowser)() && window.isSecureContext && 'credentials' in navigator && typeof window.PublicKeyCredential === 'function';
};

},{"@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aVrg6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializeJsonToPkcCreationOptions", ()=>deserializeJsonToPkcCreationOptions);
parcelHelpers.export(exports, "deserializeJsonToPkcGetOptions", ()=>deserializeJsonToPkcGetOptions);
parcelHelpers.export(exports, "serializePkcWithAssertionToJson", ()=>serializePkcWithAssertionToJson);
parcelHelpers.export(exports, "serializePkcWithAttestationToJson", ()=>serializePkcWithAttestationToJson);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _convertArrayBufferToBase64UrlMjs = require("../../../foundation/convert/base64url/convertArrayBufferToBase64Url.mjs");
var _convertBase64UrlToArrayBufferMjs = require("../../../foundation/convert/base64url/convertBase64UrlToArrayBuffer.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deserializes Public Key Credential Creation Options JSON
 * @param input PasskeyCreateOptionsJson
 * @returns PublicKeyCredentialCreationOptions
 */ const deserializeJsonToPkcCreationOptions = (input)=>{
    const userIdBuffer = (0, _convertBase64UrlToArrayBufferMjs.convertBase64UrlToArrayBuffer)(input.user.id);
    const challengeBuffer = (0, _convertBase64UrlToArrayBufferMjs.convertBase64UrlToArrayBuffer)(input.challenge);
    const excludeCredentialsWithBuffer = (input.excludeCredentials || []).map((excludeCred)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, excludeCred), {
            id: (0, _convertBase64UrlToArrayBufferMjs.convertBase64UrlToArrayBuffer)(excludeCred.id)
        }));
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, input), {
        excludeCredentials: excludeCredentialsWithBuffer,
        challenge: challengeBuffer,
        user: (0, _objectSpreadProps._)((0, _objectSpread._)({}, input.user), {
            id: userIdBuffer
        })
    });
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyCreateResult
 * @returns PasskeyCreateResultJson
 */ const serializePkcWithAttestationToJson = (input)=>{
    const response = {
        clientDataJSON: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.clientDataJSON),
        attestationObject: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.attestationObject),
        transports: input.response.getTransports(),
        publicKeyAlgorithm: input.response.getPublicKeyAlgorithm(),
        authenticatorData: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.getAuthenticatorData())
    };
    const publicKey = input.response.getPublicKey();
    if (publicKey) response.publicKey = (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(publicKey);
    const resultJson = {
        type: input.type,
        id: input.id,
        rawId: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.rawId),
        clientExtensionResults: input.getClientExtensionResults(),
        response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};
/**
 * Deserializes Public Key Credential Get Options JSON
 * @param input PasskeyGetOptionsJson
 * @returns PublicKeyCredentialRequestOptions
 */ const deserializeJsonToPkcGetOptions = (input)=>{
    const challengeBuffer = (0, _convertBase64UrlToArrayBufferMjs.convertBase64UrlToArrayBuffer)(input.challenge);
    const allowedCredentialsWithBuffer = (input.allowCredentials || []).map((allowedCred)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, allowedCred), {
            id: (0, _convertBase64UrlToArrayBufferMjs.convertBase64UrlToArrayBuffer)(allowedCred.id)
        }));
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, input), {
        challenge: challengeBuffer,
        allowCredentials: allowedCredentialsWithBuffer
    });
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyGetResult
 * @returns PasskeyGetResultJson
 */ const serializePkcWithAssertionToJson = (input)=>{
    const response = {
        clientDataJSON: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.clientDataJSON),
        authenticatorData: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.authenticatorData),
        signature: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.signature)
    };
    if (input.response.userHandle) response.userHandle = (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.response.userHandle);
    const resultJson = {
        id: input.id,
        rawId: (0, _convertArrayBufferToBase64UrlMjs.convertArrayBufferToBase64Url)(input.rawId),
        type: input.type,
        clientExtensionResults: input.getClientExtensionResults(),
        response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","../../../foundation/convert/base64url/convertArrayBufferToBase64Url.mjs":"2xu3F","../../../foundation/convert/base64url/convertBase64UrlToArrayBuffer.mjs":"7zkEq","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2xu3F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertArrayBufferToBase64Url", ()=>convertArrayBufferToBase64Url);
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// https://datatracker.ietf.org/doc/html/rfc4648#page-7
/**
 * Converts an ArrayBuffer to a base64url encoded string
 * @param buffer - the ArrayBuffer instance of a Uint8Array
 * @returns string - a base64url encoded string
 */ const convertArrayBufferToBase64Url = (buffer)=>{
    return (0, _utils.base64Encoder).convert(new Uint8Array(buffer), {
        urlSafe: true,
        skipPadding: true
    });
};

},{"@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7zkEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertBase64UrlToArrayBuffer", ()=>convertBase64UrlToArrayBuffer);
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a base64url encoded string to an ArrayBuffer
 * @param base64url - a base64url encoded string
 * @returns ArrayBuffer
 */ const convertBase64UrlToArrayBuffer = (base64url)=>{
    return Uint8Array.from((0, _utils.base64Decoder).convert(base64url, {
        urlSafe: true
    }), (x)=>x.charCodeAt(0)).buffer;
};

},{"@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"53f0G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertValidCredentialCreationOptions", ()=>(0, _sharedMjs.assertValidCredentialCreationOptions));
parcelHelpers.export(exports, "assertCredentialIsPkcWithAuthenticatorAssertionResponse", ()=>assertCredentialIsPkcWithAuthenticatorAssertionResponse);
parcelHelpers.export(exports, "assertCredentialIsPkcWithAuthenticatorAttestationResponse", ()=>assertCredentialIsPkcWithAuthenticatorAttestationResponse);
var _utils = require("@aws-amplify/core/internals/utils");
var _passkeyErrorMjs = require("../errors/passkeyError.mjs");
var _sharedMjs = require("./shared.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function assertCredentialIsPkcWithAuthenticatorAttestationResponse(credential) {
    (0, _passkeyErrorMjs.assertPasskeyError)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAttestationResponse, (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyRegistrationFailed);
}
function assertCredentialIsPkcWithAuthenticatorAssertionResponse(credential) {
    (0, _passkeyErrorMjs.assertPasskeyError)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAssertionResponse, (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyRetrievalFailed);
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../errors/passkeyError.mjs":"bpX9I","./shared.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5uOzs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertValidCredentialCreationOptions", ()=>assertValidCredentialCreationOptions);
var _utils = require("@aws-amplify/core/internals/utils");
var _passkeyErrorMjs = require("../errors/passkeyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function assertValidCredentialCreationOptions(credentialCreationOptions) {
    (0, _passkeyErrorMjs.assertPasskeyError)([
        !!credentialCreationOptions,
        !!(credentialCreationOptions === null || credentialCreationOptions === void 0 ? void 0 : credentialCreationOptions.challenge),
        !!(credentialCreationOptions === null || credentialCreationOptions === void 0 ? void 0 : credentialCreationOptions.user),
        !!(credentialCreationOptions === null || credentialCreationOptions === void 0 ? void 0 : credentialCreationOptions.rp),
        !!(credentialCreationOptions === null || credentialCreationOptions === void 0 ? void 0 : credentialCreationOptions.pubKeyCredParams)
    ].every(Boolean), (0, _passkeyErrorMjs.PasskeyErrorCode).InvalidPasskeyRegistrationOptions);
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../errors/passkeyError.mjs":"bpX9I","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jJyS1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNewDeviceMetadata", ()=>getNewDeviceMetadata);
var _utils = require("@aws-amplify/core/internals/utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createConfirmDeviceClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createConfirmDeviceClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthenticationHelperMjs = require("./srp/getAuthenticationHelper.mjs");
var _getBytesFromHexMjs = require("./srp/getBytesFromHex.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function getNewDeviceMetadata({ userPoolId, userPoolEndpoint, newDeviceMetadata, accessToken }) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split('_')[1] || '';
    const authenticationHelper = await (0, _getAuthenticationHelperMjs.getAuthenticationHelper)(userPoolName);
    const deviceKey = newDeviceMetadata === null || newDeviceMetadata === void 0 ? void 0 : newDeviceMetadata.DeviceKey;
    const deviceGroupKey = newDeviceMetadata === null || newDeviceMetadata === void 0 ? void 0 : newDeviceMetadata.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey !== null && deviceGroupKey !== void 0 ? deviceGroupKey : '', deviceKey !== null && deviceKey !== void 0 ? deviceKey : '');
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, _utils.base64Encoder).convert((0, _getBytesFromHexMjs.getBytesFromHex)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, _utils.base64Encoder).convert((0, _getBytesFromHexMjs.getBytesFromHex)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        const confirmDevice = (0, _createConfirmDeviceClientMjs.createConfirmDeviceClient)({
            endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                endpointOverride: userPoolEndpoint
            })
        });
        await confirmDevice({
            region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceName: await (0, _utils.getDeviceName)(),
            DeviceKey: newDeviceMetadata === null || newDeviceMetadata === void 0 ? void 0 : newDeviceMetadata.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey,
            deviceGroupKey,
            randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}

},{"@aws-amplify/core/internals/utils":"aiEf6","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createConfirmDeviceClient.mjs":"kGYSh","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","./srp/getAuthenticationHelper.mjs":"8ZYMr","./srp/getBytesFromHex.mjs":"kwD5W","@aws-crypto/sha256-js":"5A0J7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kGYSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConfirmDeviceClient", ()=>createConfirmDeviceClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createConfirmDeviceClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ConfirmDevice'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8ZYMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthenticationHelper", ()=>getAuthenticationHelper);
var _authenticationHelperMjs = require("./AuthenticationHelper/AuthenticationHelper.mjs");
var _authenticationHelperMjsDefault = parcelHelpers.interopDefault(_authenticationHelperMjs);
var _bigIntegerMjs = require("./BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
var _calculateAMjs = require("./calculate/calculateA.mjs");
var _constantsMjs = require("./constants.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _getHexFromBytesMjs = require("./getHexFromBytes.mjs");
var _getRandomBytesMjs = require("./getRandomBytes.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const getAuthenticationHelper = async (userPoolName)=>{
    const N = new (0, _bigIntegerMjsDefault.default)((0, _constantsMjs.INIT_N), 16);
    const g = new (0, _bigIntegerMjsDefault.default)('2', 16);
    const a = generateRandomBigInteger();
    const A = await (0, _calculateAMjs.calculateA)({
        a,
        g,
        N
    });
    return new (0, _authenticationHelperMjsDefault.default)({
        userPoolName,
        a,
        g,
        A,
        N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, _getHexFromBytesMjs.getHexFromBytes)((0, _getRandomBytesMjs.getRandomBytes)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, _bigIntegerMjsDefault.default)(hexRandom, 16);
};

},{"./AuthenticationHelper/AuthenticationHelper.mjs":"bhXqf","./BigInteger/BigInteger.mjs":"jjSj2","./calculate/calculateA.mjs":"5lL2P","./constants.mjs":"dvWBF","@aws-crypto/sha256-js":"5A0J7","./getHexFromBytes.mjs":"lVd7M","./getRandomBytes.mjs":"jxb7g","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"bhXqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationHelper);
var _authErrorMjs = require("../../../../../errors/AuthError.mjs");
var _indexMjs = require("../../textEncoder/index.mjs");
var _bigIntegerMjs = require("../BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
var _calculateSMjs = require("../calculate/calculateS.mjs");
var _calculateUMjs = require("../calculate/calculateU.mjs");
var _getBytesFromHexMjs = require("../getBytesFromHex.mjs");
var _getHashFromDataMjs = require("../getHashFromData.mjs");
var _getHashFromHexMjs = require("../getHashFromHex.mjs");
var _getHexFromBytesMjs = require("../getHexFromBytes.mjs");
var _getHkdfKeyMjs = require("../getHkdfKey.mjs");
var _getPaddedHexMjs = require("../getPaddedHex.mjs");
var _getRandomBytesMjs = require("../getRandomBytes.mjs");
var _getRandomStringMjs = require("../getRandomString.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class AuthenticationHelper {
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, _authErrorMjs.AuthError)({
            name: 'EmptyBigIntegerRandomPassword',
            message: 'random password is empty'
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, _authErrorMjs.AuthError)({
            name: 'EmptyBigIntegersaltToHashDevices',
            message: 'saltToHashDevices is empty'
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, _authErrorMjs.AuthError)({
            name: 'EmptyBigIntegerVerifierDevices',
            message: 'verifyDevices is empty'
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, _getRandomStringMjs.getRandomString)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, _getHashFromDataMjs.getHashFromData)(combinedString);
        const hexRandom = (0, _getHexFromBytesMjs.getHexFromBytes)((0, _getRandomBytesMjs.getRandomBytes)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, _getPaddedHexMjs.getPaddedHex)(new (0, _bigIntegerMjsDefault.default)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, _bigIntegerMjsDefault.default)((0, _getHashFromHexMjs.getHashFromHex)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, _getPaddedHexMjs.getPaddedHex)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username, password, serverBValue, salt }) {
        if (serverBValue.mod(this.N).equals((0, _bigIntegerMjsDefault.default).ZERO)) throw new Error('B cannot be zero.');
        const U = (0, _calculateUMjs.calculateU)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, _getHashFromDataMjs.getHashFromData)(usernamePassword);
        const x = new (0, _bigIntegerMjsDefault.default)((0, _getHashFromHexMjs.getHashFromHex)((0, _getPaddedHexMjs.getPaddedHex)(salt) + usernamePasswordHash), 16);
        const S = await (0, _calculateSMjs.calculateS)({
            a: this.a,
            g: this.g,
            k: this.k,
            x,
            B: serverBValue,
            N: this.N,
            U
        });
        const context = this.encoder.convert('Caldera Derived Key');
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, _getHkdfKeyMjs.getHkdfKey)((0, _getBytesFromHexMjs.getBytesFromHex)((0, _getPaddedHexMjs.getPaddedHex)(S)), (0, _getBytesFromHexMjs.getBytesFromHex)((0, _getPaddedHexMjs.getPaddedHex)(U)), info);
        return hkdfKey;
    }
    constructor({ userPoolName, a, g, A, N }){
        this.encoder = (0, _indexMjs.textEncoder);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, _bigIntegerMjsDefault.default)((0, _getHashFromHexMjs.getHashFromHex)(`${(0, _getPaddedHexMjs.getPaddedHex)(N)}${(0, _getPaddedHexMjs.getPaddedHex)(g)}`), 16);
    }
}

},{"../../../../../errors/AuthError.mjs":"4RqZd","../../textEncoder/index.mjs":"6K8Fy","../BigInteger/BigInteger.mjs":"jjSj2","../calculate/calculateS.mjs":"cW2By","../calculate/calculateU.mjs":"cE4lI","../getBytesFromHex.mjs":"kwD5W","../getHashFromData.mjs":"8FGxE","../getHashFromHex.mjs":"2HLCD","../getHexFromBytes.mjs":"lVd7M","../getHkdfKey.mjs":"1AAlj","../getPaddedHex.mjs":"py7CW","../getRandomBytes.mjs":"jxb7g","../getRandomString.mjs":"hvbYS","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6K8Fy":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textEncoder", ()=>textEncoder);
const textEncoder = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jjSj2":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BigInteger);
function BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function nbi() {
    return new BigInteger(null, null);
}
// Bits per digit
let dbits;
// JavaScript engine analysis
const canary = 0xdeadbeefcafe;
const j_lm = (canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const inBrowser = typeof navigator !== 'undefined';
if (inBrowser && j_lm && navigator.appName === 'Microsoft Internet Explorer') {
    BigInteger.prototype.am = am2;
    dbits = 30;
} else if (inBrowser && j_lm && navigator.appName !== 'Netscape') {
    BigInteger.prototype.am = am1;
    dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
const BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
const BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
const BI_RC = [];
let rr, vv;
rr = '0'.charCodeAt(0);
for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
rr = 'a'.charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
rr = 'A'.charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
function int2char(n) {
    return BI_RM.charAt(n);
}
function intAt(s, i) {
    const c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function nbv(i) {
    const r = nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === '-') mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = '';
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
        }
    }
    return m ? r : '0';
}
// (public) -this
function bnNegate() {
    const r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = nbi();
    const y = nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function bnMod(a) {
    const r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function bnAdd(a) {
    const r = nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function bnSubtract(a) {
    const r = nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function bnMultiply(a) {
    const r = nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function bnDivide(a) {
    const r = nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function montConvert(x) {
    const r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function montRevert(x) {
    const r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = nbv(1);
    const z = new Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = nbi();
    let t;
    i = nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;
// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cW2By":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateS", ()=>calculateS);
const calculateS = async ({ a, g, k, x, B, N, U })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cE4lI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateU", ()=>calculateU);
var _bigIntegerMjs = require("../BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
var _getHashFromHexMjs = require("../getHashFromHex.mjs");
var _getPaddedHexMjs = require("../getPaddedHex.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const calculateU = ({ A, B })=>{
    const U = new (0, _bigIntegerMjsDefault.default)((0, _getHashFromHexMjs.getHashFromHex)((0, _getPaddedHexMjs.getPaddedHex)(A) + (0, _getPaddedHexMjs.getPaddedHex)(B)), 16);
    if (U.equals((0, _bigIntegerMjsDefault.default).ZERO)) throw new Error('U cannot be zero.');
    return U;
};

},{"../BigInteger/BigInteger.mjs":"jjSj2","../getHashFromHex.mjs":"2HLCD","../getPaddedHex.mjs":"py7CW","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2HLCD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashFromHex", ()=>getHashFromHex);
var _getBytesFromHexMjs = require("./getBytesFromHex.mjs");
var _getHashFromDataMjs = require("./getHashFromData.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const getHashFromHex = (hexStr)=>(0, _getHashFromDataMjs.getHashFromData)((0, _getBytesFromHexMjs.getBytesFromHex)(hexStr));

},{"./getBytesFromHex.mjs":"kwD5W","./getHashFromData.mjs":"8FGxE","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kwD5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBytesFromHex", ()=>getBytesFromHex);
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const getBytesFromHex = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error('Hex encoded strings must have an even number length');
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, _constantsMjs.HEX_TO_SHORT)) out[i / 2] = (0, _constantsMjs.HEX_TO_SHORT)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};

},{"./constants.mjs":"dvWBF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dvWBF":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HEX_TO_SHORT", ()=>HEX_TO_SHORT);
parcelHelpers.export(exports, "INIT_N", ()=>INIT_N);
parcelHelpers.export(exports, "SHORT_TO_HEX", ()=>SHORT_TO_HEX);
const INIT_N = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const SHORT_TO_HEX = {};
const HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8FGxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashFromData", ()=>getHashFromData);
var _sha256Js = require("@aws-crypto/sha256-js");
var _getHexFromBytesMjs = require("./getHexFromBytes.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const getHashFromData = (data)=>{
    const sha256 = new (0, _sha256Js.Sha256)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, _getHexFromBytesMjs.getHexFromBytes)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join('0') + hashHexFromUint8;
};

},{"@aws-crypto/sha256-js":"5A0J7","./getHexFromBytes.mjs":"lVd7M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lVd7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHexFromBytes", ()=>getHexFromBytes);
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const getHexFromBytes = (bytes)=>{
    let out = '';
    for(let i = 0; i < bytes.byteLength; i++)out += (0, _constantsMjs.SHORT_TO_HEX)[bytes[i]];
    return out;
};

},{"./constants.mjs":"dvWBF","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"py7CW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaddedHex", ()=>getPaddedHex);
var _bigIntegerMjs = require("./BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const getPaddedHex = (bigInt)=>{
    if (!(bigInt instanceof (0, _bigIntegerMjsDefault.default))) throw new Error('Not a BigInteger');
    const isNegative = bigInt.compareTo((0, _bigIntegerMjsDefault.default).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split('').map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return '0123456789ABCDEF'.charAt(invertedNibble);
        }).join('');
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, _bigIntegerMjsDefault.default)(invertedNibbles, 16).add((0, _bigIntegerMjsDefault.default).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith('FF8')) hexStr = hexStr.substring(2);
    }
    return hexStr;
};

},{"./BigInteger/BigInteger.mjs":"jjSj2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1AAlj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHkdfKey", ()=>getHkdfKey);
var _sha256Js = require("@aws-crypto/sha256-js");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const getHkdfKey = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, _sha256Js.Sha256)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, _sha256Js.Sha256)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};

},{"@aws-crypto/sha256-js":"5A0J7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jxb7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRandomBytes", ()=>getRandomBytes);
var _utils = require("@aws-amplify/core/internals/utils");
var _getBytesFromHexMjs = require("./getBytesFromHex.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const getRandomBytes = (nBytes)=>{
    const str = new (0, _utils.WordArray)().random(nBytes).toString();
    return (0, _getBytesFromHexMjs.getBytesFromHex)(str);
};

},{"@aws-amplify/core/internals/utils":"aiEf6","./getBytesFromHex.mjs":"kwD5W","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hvbYS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRandomString", ()=>getRandomString);
var _utils = require("@aws-amplify/core/internals/utils");
var _getRandomBytesMjs = require("./getRandomBytes.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const getRandomString = ()=>(0, _utils.base64Encoder).convert((0, _getRandomBytesMjs.getRandomBytes)(40));

},{"@aws-amplify/core/internals/utils":"aiEf6","./getRandomBytes.mjs":"jxb7g","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5lL2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateA", ()=>calculateA);
var _bigIntegerMjs = require("../BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const calculateA = async ({ a, g, N })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, _bigIntegerMjsDefault.default).ZERO)) {
                reject(new Error('Illegal parameter. A mod N cannot be 0.'));
                return;
            }
            resolve(A);
        });
    });
};

},{"../BigInteger/BigInteger.mjs":"jjSj2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5RD60":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handlePasswordSRP", ()=>handlePasswordSRP);
var _utils = require("@aws-amplify/core/internals/utils");
var _userContextDataMjs = require("../../../providers/cognito/utils/userContextData.mjs");
var _getAuthenticationHelperMjs = require("../../../providers/cognito/utils/srp/getAuthenticationHelper.mjs");
var _constantsMjs = require("../../../providers/cognito/utils/srp/constants.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _createInitiateAuthClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createInitiateAuthClient.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs1 = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../../../providers/cognito/types/errors.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _handlePasswordVerifierChallengeMjs = require("../../../providers/cognito/utils/handlePasswordVerifierChallenge.mjs");
var _retryOnResourceNotFoundExceptionMjs = require("../../../providers/cognito/utils/retryOnResourceNotFoundException.mjs");
var _setActiveSignInUsernameMjs = require("../../../providers/cognito/utils/setActiveSignInUsername.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the Password SRP (Secure Remote Password) authentication flow.
 * This function can be used with both USER_SRP_AUTH and USER_AUTH flows.
 *
 * @param {Object} params - The parameters for the Password SRP authentication
 * @param {string} params.username - The username for authentication
 * @param {string} params.password - The user's password
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Token orchestrator for managing auth tokens
 * @param {AuthFlowType} params.authFlow - The type of authentication flow ('USER_SRP_AUTH' or 'USER_AUTH')
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred challenge type when using USER_AUTH flow
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The authentication response
 */ async function handlePasswordSRP({ username, password, clientMetadata, config, tokenOrchestrator, authFlow, preferredChallenge }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const userPoolName = (userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split('_')[1]) || '';
    const authenticationHelper = await (0, _getAuthenticationHelperMjs.getAuthenticationHelper)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    if (authFlow === 'USER_AUTH' && preferredChallenge) authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReq = {
        AuthFlow: authFlow,
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    const initiateAuth = (0, _createInitiateAuthClientMjs.createInitiateAuthClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const resp = await initiateAuth({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters, Session: session } = resp;
    var _challengeParameters_USERNAME;
    const activeUsername = (_challengeParameters_USERNAME = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USERNAME) !== null && _challengeParameters_USERNAME !== void 0 ? _challengeParameters_USERNAME : username;
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(activeUsername);
    if (resp.ChallengeName === 'PASSWORD_VERIFIER') return (0, _retryOnResourceNotFoundExceptionMjs.retryOnResourceNotFoundException)((0, _handlePasswordVerifierChallengeMjs.handlePasswordVerifierChallenge), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return resp;
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../providers/cognito/utils/userContextData.mjs":"hZOPS","../../../providers/cognito/utils/srp/getAuthenticationHelper.mjs":"8ZYMr","../../../providers/cognito/utils/srp/constants.mjs":"dvWBF","@aws-crypto/sha256-js":"5A0J7","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createInitiateAuthClient.mjs":"5m6Bo","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../providers/cognito/types/errors.mjs":"fLYtN","../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../../../providers/cognito/utils/handlePasswordVerifierChallenge.mjs":"eBuIt","../../../providers/cognito/utils/retryOnResourceNotFoundException.mjs":"54URn","../../../providers/cognito/utils/setActiveSignInUsername.mjs":"3xyHv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hZOPS":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserContextData", ()=>getUserContextData);
function getUserContextData({ username, userPoolId, userPoolClientId }) {
    if (typeof window === 'undefined') return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === 'undefined') return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eBuIt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handlePasswordVerifierChallenge", ()=>handlePasswordVerifierChallenge);
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _bigIntegerMjs = require("./srp/BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
var _constantsMjs1 = require("./srp/constants.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _getNowStringMjs = require("./srp/getNowString.mjs");
var _getSignatureStringMjs = require("./srp/getSignatureString.mjs");
var _userContextDataMjs = require("./userContextData.mjs");
var _handleDeviceSRPAuthMjs = require("./handleDeviceSRPAuth.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function handlePasswordVerifierChallenge(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const userPoolName = (userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split('_')[1]) || '';
    const serverBValue = new (0, _bigIntegerMjsDefault.default)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SRP_B, 16);
    const salt = new (0, _bigIntegerMjsDefault.default)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SALT, 16);
    const username = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USER_ID_FOR_SRP;
    if (!username) throw new (0, _authErrorMjs.AuthError)({
        name: 'EmptyUserIdForSRPException',
        message: 'USER_ID_FOR_SRP was not found in challengeParameters'
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username,
        password,
        serverBValue,
        salt
    });
    const dateNow = (0, _getNowStringMjs.getNowString)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, _getSignatureStringMjs.getSignatureString)({
            username,
            userPoolName,
            challengeParameters,
            dateNow,
            hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: 'PASSWORD_VERIFIER',
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, _handleDeviceSRPAuthMjs.handleDeviceSRPAuth)({
        username,
        config,
        clientMetadata,
        session: response.Session,
        tokenOrchestrator
    });
    return response;
}

},{"../../../errors/AuthError.mjs":"4RqZd","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","./srp/BigInteger/BigInteger.mjs":"jjSj2","./srp/constants.mjs":"dvWBF","@aws-crypto/sha256-js":"5A0J7","./srp/getNowString.mjs":"a0VfY","./srp/getSignatureString.mjs":"9KgQN","./userContextData.mjs":"hZOPS","./handleDeviceSRPAuth.mjs":"jjI97","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"a0VfY":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNowString", ()=>getNowString);
const MONTH_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const WEEK_NAMES = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
const getNowString = ()=>{
    const now = new Date();
    const weekDay = WEEK_NAMES[now.getUTCDay()];
    const month = MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9KgQN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignatureString", ()=>getSignatureString);
var _sha256Js = require("@aws-crypto/sha256-js");
var _utils = require("@aws-amplify/core/internals/utils");
var _indexMjs = require("../textEncoder/index.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getSignatureString = ({ userPoolName, username, challengeParameters, dateNow, hkdf })=>{
    const bufUPIDaToB = (0, _indexMjs.textEncoder).convert(userPoolName);
    const bufUNaToB = (0, _indexMjs.textEncoder).convert(username);
    const bufSBaToB = urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, _indexMjs.textEncoder).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, _utils.base64Encoder).convert(resultFromAWSCrypto);
    return signatureString;
};
const urlB64ToUint8Array = (base64String)=>{
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = (0, _utils.base64Decoder).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};

},{"@aws-crypto/sha256-js":"5A0J7","@aws-amplify/core/internals/utils":"aiEf6","../textEncoder/index.mjs":"6K8Fy","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jjI97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleDeviceSRPAuth", ()=>handleDeviceSRPAuth);
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("./types.mjs");
var _getAuthenticationHelperMjs = require("./srp/getAuthenticationHelper.mjs");
var _constantsMjs1 = require("./srp/constants.mjs");
var _getNowStringMjs = require("./srp/getNowString.mjs");
var _getSignatureStringMjs = require("./srp/getSignatureString.mjs");
var _bigIntegerMjs = require("./srp/BigInteger/BigInteger.mjs");
var _bigIntegerMjsDefault = parcelHelpers.interopDefault(_bigIntegerMjs);
var _userContextDataMjs = require("./userContextData.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function handleDeviceSRPAuth({ username, config, clientMetadata, session, tokenOrchestrator }) {
    const { userPoolId, userPoolEndpoint } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    (0, _typesMjs.assertDeviceMetadata)(deviceMetadata);
    const authenticationHelper = await (0, _getAuthenticationHelperMjs.getAuthenticationHelper)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: 'DEVICE_SRP_AUTH',
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: respondedChallengeParameters, Session } = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId)
    }, jsonReqResponseChallenge);
    return handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId, userPoolClientId, userPoolEndpoint }, tokenOrchestrator) {
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    (0, _typesMjs.assertDeviceMetadata)(deviceMetadata);
    const serverBValue = new (0, _bigIntegerMjsDefault.default)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SRP_B, 16);
    const salt = new (0, _bigIntegerMjsDefault.default)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SALT, 16);
    const { deviceKey } = deviceMetadata;
    const { deviceGroupKey } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue,
        salt
    });
    const dateNow = (0, _getNowStringMjs.getNowString)();
    var _challengeParameters_USERNAME;
    const challengeResponses = {
        USERNAME: (_challengeParameters_USERNAME = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USERNAME) !== null && _challengeParameters_USERNAME !== void 0 ? _challengeParameters_USERNAME : username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, _getSignatureStringMjs.getSignatureString)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters,
            dateNow,
            hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData
    };
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId)
    }, jsonReqResponseChallenge);
}

},{"@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","./types.mjs":"4GeFs","./srp/getAuthenticationHelper.mjs":"8ZYMr","./srp/constants.mjs":"dvWBF","./srp/getNowString.mjs":"a0VfY","./srp/getSignatureString.mjs":"9KgQN","./srp/BigInteger/BigInteger.mjs":"jjSj2","./userContextData.mjs":"hZOPS","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"54URn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryOnResourceNotFoundException", ()=>retryOnResourceNotFoundException);
var _authErrorMjs = require("../../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function retryOnResourceNotFoundException(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, _authErrorMjs.AuthError) && error.name === 'ResourceNotFoundException' && error.message.includes('Device does not exist.')) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}

},{"../../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3xyHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setActiveSignInUsername", ()=>setActiveSignInUsername);
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function setActiveSignInUsername(username) {
    const { dispatch } = (0, _signInStoreMjs.signInStore);
    dispatch({
        type: 'SET_USERNAME',
        value: username
    });
}

},{"../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"cpviR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initiateSelectedChallenge", ()=>initiateSelectedChallenge);
var _utils = require("@aws-amplify/core/internals/utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../../../providers/cognito/types/errors.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response for authentication.
 * Initiates the selected authentication challenge based on user choice.
 *
 * @param {Object} params - The parameters for handling the selected challenge
 * @param {string} params.username - The username for authentication
 * @param {string} params.session - The current authentication session token
 * @param {string} params.selectedChallenge - The challenge type selected by the user
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function initiateSelectedChallenge({ username, session, selectedChallenge, config, clientMetadata }) {
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: config.userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(config.userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, {
        ChallengeName: 'SELECT_CHALLENGE',
        ChallengeResponses: {
            USERNAME: username,
            ANSWER: selectedChallenge
        },
        ClientId: config.userPoolClientId,
        Session: session,
        ClientMetadata: clientMetadata
    });
}

},{"@aws-amplify/core/internals/utils":"aiEf6","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../providers/cognito/types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kn37s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleSelectChallengeWithPassword", ()=>handleSelectChallengeWithPassword);
var _utils = require("@aws-amplify/core/internals/utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../../../providers/cognito/types/errors.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _userContextDataMjs = require("../../../providers/cognito/utils/userContextData.mjs");
var _setActiveSignInUsernameMjs = require("../../../providers/cognito/utils/setActiveSignInUsername.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password authentication.
 * This function combines the SELECT_CHALLENGE flow with standard password authentication.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function handleSelectChallengeWithPassword(username, password, clientMetadata, config, session) {
    var _response_ChallengeParameters;
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const authParameters = {
        ANSWER: 'PASSWORD',
        USERNAME: username,
        PASSWORD: password
    };
    const userContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, {
        ChallengeName: 'SELECT_CHALLENGE',
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    var _response_ChallengeParameters_USERNAME;
    const activeUsername = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : username;
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(activeUsername);
    return response;
}

},{"@aws-amplify/core/internals/utils":"aiEf6","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../providers/cognito/types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../../../providers/cognito/utils/userContextData.mjs":"hZOPS","../../../providers/cognito/utils/setActiveSignInUsername.mjs":"3xyHv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fVlFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleSelectChallengeWithPasswordSRP", ()=>handleSelectChallengeWithPasswordSRP);
var _utils = require("@aws-amplify/core/internals/utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../../../providers/cognito/types/errors.mjs");
var _createRespondToAuthChallengeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _getAuthenticationHelperMjs = require("../../../providers/cognito/utils/srp/getAuthenticationHelper.mjs");
var _constantsMjs1 = require("../../../providers/cognito/utils/srp/constants.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _userContextDataMjs = require("../../../providers/cognito/utils/userContextData.mjs");
var _setActiveSignInUsernameMjs = require("../../../providers/cognito/utils/setActiveSignInUsername.mjs");
var _retryOnResourceNotFoundExceptionMjs = require("../../../providers/cognito/utils/retryOnResourceNotFoundException.mjs");
var _handlePasswordVerifierChallengeMjs = require("../../../providers/cognito/utils/handlePasswordVerifierChallenge.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password SRP authentication.
 * This function combines the SELECT_CHALLENGE flow with Password SRP protocol.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 * @param {AuthTokenOrchestrator} tokenOrchestrator - Token orchestrator for managing auth tokens
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function handleSelectChallengeWithPasswordSRP(username, password, clientMetadata, config, session, tokenOrchestrator) {
    var _response_ChallengeParameters;
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const userPoolName = userPoolId.split('_')[1] || '';
    const authenticationHelper = await (0, _getAuthenticationHelperMjs.getAuthenticationHelper)(userPoolName);
    const authParameters = {
        ANSWER: 'PASSWORD_SRP',
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const userContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const respondToAuthChallenge = (0, _createRespondToAuthChallengeClientMjs.createRespondToAuthChallengeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignIn)
    }, {
        ChallengeName: 'SELECT_CHALLENGE',
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    var _response_ChallengeParameters_USERNAME;
    const activeUsername = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : username;
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(activeUsername);
    if (response.ChallengeName === 'PASSWORD_VERIFIER') return (0, _retryOnResourceNotFoundExceptionMjs.retryOnResourceNotFoundException)((0, _handlePasswordVerifierChallengeMjs.handlePasswordVerifierChallenge), [
        password,
        response.ChallengeParameters,
        clientMetadata,
        response.Session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return response;
}

},{"@aws-amplify/core/internals/utils":"aiEf6","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../providers/cognito/types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRespondToAuthChallengeClient.mjs":"1D9mM","../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../../../providers/cognito/utils/srp/getAuthenticationHelper.mjs":"8ZYMr","../../../providers/cognito/utils/srp/constants.mjs":"dvWBF","@aws-crypto/sha256-js":"5A0J7","../../../providers/cognito/utils/userContextData.mjs":"hZOPS","../../../providers/cognito/utils/setActiveSignInUsername.mjs":"3xyHv","../../../providers/cognito/utils/retryOnResourceNotFoundException.mjs":"54URn","../../../providers/cognito/utils/handlePasswordVerifierChallenge.mjs":"eBuIt","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"44jNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInWithCustomAuth", ()=>signInWithCustomAuth);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _cacheTokensMjs = require("../tokenProvider/cacheTokens.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _dispatchSignedInHubEventMjs = require("../utils/dispatchSignedInHubEvent.mjs");
var _retryOnResourceNotFoundExceptionMjs = require("../utils/retryOnResourceNotFoundException.mjs");
var _getNewDeviceMetadataMjs = require("../utils/getNewDeviceMetadata.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function signInWithCustomAuth(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { username, password, options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: 'CUSTOM_WITHOUT_SRP'
    };
    const metadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignInUsername);
    (0, _assertValidationErrorMjs.assertValidationError)(!password, (0, _validationMjs.AuthValidationErrorCode).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName, ChallengeParameters: retiredChallengeParameters, AuthenticationResult, Session } = await (0, _retryOnResourceNotFoundExceptionMjs.retryOnResourceNotFoundException)((0, _signInHelpersMjs.handleCustomAuthFlowWithoutSRP), [
            username,
            metadata,
            authConfig,
            (0, _tokenProviderMjs.tokenOrchestrator)
        ], username, (0, _tokenProviderMjs.tokenOrchestrator));
        const activeUsername = (0, _signInHelpersMjs.getActiveSignInUsername)(username);
        // sets up local state used during the sign-in process
        (0, _signInStoreMjs.setActiveSignInState)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails
        });
        if (AuthenticationResult) {
            await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({
                username: activeUsername
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails
            }));
            (0, _signInStoreMjs.resetActiveSignInState)();
            await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, _signInHelpersMjs.getSignInResult)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, _signInStoreMjs.resetActiveSignInState)();
        (0, _assertServiceErrorMjs.assertServiceError)(error);
        const result = (0, _signInHelpersMjs.getSignInResultFromError)(error.name);
        if (result) return result;
        throw error;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../utils/signInHelpers.mjs":"2HTeV","../../../client/utils/store/signInStore.mjs":"chngd","../tokenProvider/cacheTokens.mjs":"bsRco","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/types.mjs":"4GeFs","../tokenProvider/tokenProvider.mjs":"9mSqK","../utils/dispatchSignedInHubEvent.mjs":"2RLlL","../utils/retryOnResourceNotFoundException.mjs":"54URn","../utils/getNewDeviceMetadata.mjs":"jJyS1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hbU37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInWithCustomSRPAuth", ()=>signInWithCustomSRPAuth);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _cacheTokensMjs = require("../tokenProvider/cacheTokens.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _dispatchSignedInHubEventMjs = require("../utils/dispatchSignedInHubEvent.mjs");
var _getNewDeviceMetadataMjs = require("../utils/getNewDeviceMetadata.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signInWithCustomSRPAuth(input) {
    var _Amplify_getConfig_Auth;
    const { username, password, options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: 'CUSTOM_WITH_SRP'
    };
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const metadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignInUsername);
    (0, _assertValidationErrorMjs.assertValidationError)(!!password, (0, _validationMjs.AuthValidationErrorCode).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName, ChallengeParameters: handledChallengeParameters, AuthenticationResult, Session } = await (0, _signInHelpersMjs.handleCustomSRPAuthFlow)(username, password, metadata, authConfig, (0, _tokenProviderMjs.tokenOrchestrator));
        const activeUsername = (0, _signInHelpersMjs.getActiveSignInUsername)(username);
        // sets up local state used during the sign-in process
        (0, _signInStoreMjs.setActiveSignInState)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails
        });
        if (AuthenticationResult) {
            await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({
                username: activeUsername
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails
            }));
            (0, _signInStoreMjs.resetActiveSignInState)();
            await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, _signInHelpersMjs.getSignInResult)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, _signInStoreMjs.resetActiveSignInState)();
        (0, _assertServiceErrorMjs.assertServiceError)(error);
        const result = (0, _signInHelpersMjs.getSignInResultFromError)(error.name);
        if (result) return result;
        throw error;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../utils/signInHelpers.mjs":"2HTeV","../../../client/utils/store/signInStore.mjs":"chngd","../tokenProvider/cacheTokens.mjs":"bsRco","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/types.mjs":"4GeFs","../tokenProvider/tokenProvider.mjs":"9mSqK","../utils/dispatchSignedInHubEvent.mjs":"2RLlL","../utils/getNewDeviceMetadata.mjs":"jJyS1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"edaLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInWithSRP", ()=>signInWithSRP);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _cacheTokensMjs = require("../tokenProvider/cacheTokens.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _dispatchSignedInHubEventMjs = require("../utils/dispatchSignedInHubEvent.mjs");
var _getNewDeviceMetadataMjs = require("../utils/getNewDeviceMetadata.mjs");
var _autoSignInMjs = require("./autoSignIn.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signInWithSRP(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const { username, password } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: 'USER_SRP_AUTH'
    };
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const clientMetaData = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignInUsername);
    (0, _assertValidationErrorMjs.assertValidationError)(!!password, (0, _validationMjs.AuthValidationErrorCode).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName, ChallengeParameters: handledChallengeParameters, AuthenticationResult, Session } = await (0, _signInHelpersMjs.handleUserSRPAuthFlow)(username, password, clientMetaData, authConfig, (0, _tokenProviderMjs.tokenOrchestrator));
        const activeUsername = (0, _signInHelpersMjs.getActiveSignInUsername)(username);
        // sets up local state used during the sign-in process
        (0, _signInStoreMjs.setActiveSignInState)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails
        });
        if (AuthenticationResult) {
            await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({
                username: activeUsername
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails
            }));
            (0, _signInStoreMjs.resetActiveSignInState)();
            await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
            (0, _autoSignInMjs.resetAutoSignIn)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, _signInHelpersMjs.getSignInResult)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, _signInStoreMjs.resetActiveSignInState)();
        (0, _autoSignInMjs.resetAutoSignIn)();
        (0, _assertServiceErrorMjs.assertServiceError)(error);
        const result = (0, _signInHelpersMjs.getSignInResultFromError)(error.name);
        if (result) return result;
        throw error;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../utils/signInHelpers.mjs":"2HTeV","../../../client/utils/store/signInStore.mjs":"chngd","../tokenProvider/cacheTokens.mjs":"bsRco","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/types.mjs":"4GeFs","../tokenProvider/tokenProvider.mjs":"9mSqK","../utils/dispatchSignedInHubEvent.mjs":"2RLlL","../utils/getNewDeviceMetadata.mjs":"jJyS1","./autoSignIn.mjs":"jECSX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jECSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoSignIn", ()=>autoSignIn);
parcelHelpers.export(exports, "resetAutoSignIn", ()=>resetAutoSignIn);
parcelHelpers.export(exports, "setAutoSignIn", ()=>setAutoSignIn);
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _constantsMjs = require("../../../errors/constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const initialAutoSignIn = async ()=>{
    throw new (0, _authErrorMjs.AuthError)({
        name: (0, _constantsMjs.AUTO_SIGN_IN_EXCEPTION),
        message: 'The autoSignIn flow has not started, or has been cancelled/completed.',
        recoverySuggestion: 'Please try to use the signIn API or log out before starting a new autoSignIn flow.'
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let autoSignIn = initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function setAutoSignIn(callback) {
    autoSignIn = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function resetAutoSignIn(resetCallback = true) {
    if (resetCallback) autoSignIn = initialAutoSignIn;
    (0, _autoSignInStoreMjs.autoSignInStore).dispatch({
        type: 'RESET'
    });
}

},{"../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","../../../errors/AuthError.mjs":"4RqZd","../../../errors/constants.mjs":"8qcdh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jGrv3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInWithUserPassword", ()=>signInWithUserPassword);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _cacheTokensMjs = require("../tokenProvider/cacheTokens.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _dispatchSignedInHubEventMjs = require("../utils/dispatchSignedInHubEvent.mjs");
var _retryOnResourceNotFoundExceptionMjs = require("../utils/retryOnResourceNotFoundException.mjs");
var _getNewDeviceMetadataMjs = require("../utils/getNewDeviceMetadata.mjs");
var _autoSignInMjs = require("./autoSignIn.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signInWithUserPassword(input) {
    var _Amplify_getConfig_Auth;
    const { username, password, options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: 'USER_PASSWORD_AUTH'
    };
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const metadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignInUsername);
    (0, _assertValidationErrorMjs.assertValidationError)(!!password, (0, _validationMjs.AuthValidationErrorCode).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName, ChallengeParameters: retriedChallengeParameters, AuthenticationResult, Session } = await (0, _retryOnResourceNotFoundExceptionMjs.retryOnResourceNotFoundException)((0, _signInHelpersMjs.handleUserPasswordAuthFlow), [
            username,
            password,
            metadata,
            authConfig,
            (0, _tokenProviderMjs.tokenOrchestrator)
        ], username, (0, _tokenProviderMjs.tokenOrchestrator));
        const activeUsername = (0, _signInHelpersMjs.getActiveSignInUsername)(username);
        // sets up local state used during the sign-in process
        (0, _signInStoreMjs.setActiveSignInState)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails
        });
        if (AuthenticationResult) {
            await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({}, AuthenticationResult), {
                username: activeUsername,
                NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails
            }));
            (0, _signInStoreMjs.resetActiveSignInState)();
            await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
            (0, _autoSignInMjs.resetAutoSignIn)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, _signInHelpersMjs.getSignInResult)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, _signInStoreMjs.resetActiveSignInState)();
        (0, _autoSignInMjs.resetAutoSignIn)();
        (0, _assertServiceErrorMjs.assertServiceError)(error);
        const result = (0, _signInHelpersMjs.getSignInResultFromError)(error.name);
        if (result) return result;
        throw error;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../errors/utils/assertValidationError.mjs":"81Pnh","../utils/signInHelpers.mjs":"2HTeV","../../../client/utils/store/signInStore.mjs":"chngd","../tokenProvider/cacheTokens.mjs":"bsRco","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/types.mjs":"4GeFs","../tokenProvider/tokenProvider.mjs":"9mSqK","../utils/dispatchSignedInHubEvent.mjs":"2RLlL","../utils/retryOnResourceNotFoundException.mjs":"54URn","../utils/getNewDeviceMetadata.mjs":"jJyS1","./autoSignIn.mjs":"jECSX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9gnv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInWithUserAuth", ()=>signInWithUserAuth);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _cacheTokensMjs = require("../tokenProvider/cacheTokens.mjs");
var _dispatchSignedInHubEventMjs = require("../utils/dispatchSignedInHubEvent.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _handleUserAuthFlowMjs = require("../../../client/flows/userAuth/handleUserAuthFlow.mjs");
var _getNewDeviceMetadataMjs = require("../utils/getNewDeviceMetadata.mjs");
var _autoSignInMjs = require("./autoSignIn.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in through a registered email or phone number without a password by by receiving and entering an OTP.
 *
 * @param input - The SignInWithUserAuthInput object
 * @returns SignInWithUserAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password -- needs to change
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signInWithUserAuth(input) {
    var _Amplify_getConfig_Auth, _authConfig_passwordless;
    const { username, password, options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: 'USER_AUTH'
    };
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const clientMetaData = options === null || options === void 0 ? void 0 : options.clientMetadata;
    var _options_preferredChallenge;
    const preferredChallenge = (_options_preferredChallenge = options === null || options === void 0 ? void 0 : options.preferredChallenge) !== null && _options_preferredChallenge !== void 0 ? _options_preferredChallenge : authConfig === null || authConfig === void 0 ? void 0 : (_authConfig_passwordless = authConfig.passwordless) === null || _authConfig_passwordless === void 0 ? void 0 : _authConfig_passwordless.preferredChallenge;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignInUsername);
    try {
        const handleUserAuthFlowInput = {
            username,
            config: authConfig,
            tokenOrchestrator: (0, _tokenProviderMjs.tokenOrchestrator),
            clientMetadata: clientMetaData,
            preferredChallenge,
            password
        };
        const autoSignInStoreState = (0, _autoSignInStoreMjs.autoSignInStore).getState();
        if (autoSignInStoreState.active && autoSignInStoreState.username === username) handleUserAuthFlowInput.session = autoSignInStoreState.session;
        const response = await (0, _handleUserAuthFlowMjs.handleUserAuthFlow)(handleUserAuthFlowInput);
        const activeUsername = (0, _signInHelpersMjs.getActiveSignInUsername)(username);
        (0, _signInStoreMjs.setActiveSignInState)({
            signInSession: response.Session,
            username: activeUsername,
            challengeName: response.ChallengeName,
            signInDetails
        });
        if (response.AuthenticationResult) {
            await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({
                username: activeUsername
            }, response.AuthenticationResult), {
                NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: response.AuthenticationResult.NewDeviceMetadata,
                    accessToken: response.AuthenticationResult.AccessToken
                }),
                signInDetails
            }));
            (0, _signInStoreMjs.resetActiveSignInState)();
            await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
            (0, _autoSignInMjs.resetAutoSignIn)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, _signInHelpersMjs.getSignInResult)({
            challengeName: response.ChallengeName,
            challengeParameters: response.ChallengeParameters,
            availableChallenges: 'AvailableChallenges' in response ? response.AvailableChallenges : undefined
        });
    } catch (error) {
        (0, _signInStoreMjs.resetActiveSignInState)();
        (0, _autoSignInMjs.resetAutoSignIn)();
        (0, _assertServiceErrorMjs.assertServiceError)(error);
        const result = (0, _signInHelpersMjs.getSignInResultFromError)(error.name);
        if (result) return result;
        throw error;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../utils/signInHelpers.mjs":"2HTeV","../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","../tokenProvider/cacheTokens.mjs":"bsRco","../utils/dispatchSignedInHubEvent.mjs":"2RLlL","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/types.mjs":"4GeFs","../tokenProvider/tokenProvider.mjs":"9mSqK","../../../client/flows/userAuth/handleUserAuthFlow.mjs":"gC31O","../utils/getNewDeviceMetadata.mjs":"jJyS1","./autoSignIn.mjs":"jECSX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gC31O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleUserAuthFlow", ()=>handleUserAuthFlow);
var _utils = require("@aws-amplify/core/internals/utils");
var _userContextDataMjs = require("../../../providers/cognito/utils/userContextData.mjs");
var _createInitiateAuthClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createInitiateAuthClient.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../../../providers/cognito/types/errors.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _handlePasswordSRPMjs = require("../shared/handlePasswordSRP.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _setActiveSignInUsernameMjs = require("../../../providers/cognito/utils/setActiveSignInUsername.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles user authentication flow with configurable challenge preferences.
 * Supports AuthFactorType challenges through the USER_AUTH flow.
 *
 * @param {HandleUserAuthFlowInput} params - Authentication flow parameters
 * @param {string} params.username - The username for authentication
 * @param {Record<string, string>} [params.clientMetadata] - Optional metadata to pass to authentication service
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Manages authentication tokens and device tracking
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred authentication method
 * @param {string} [params.password] - Required when preferredChallenge is 'PASSWORD' or 'PASSWORD_SRP'
 *
 * @returns {Promise<InitiateAuthCommandOutput>} The authentication response from Cognito
 */ async function handleUserAuthFlow({ username, clientMetadata, config, tokenOrchestrator, preferredChallenge, password, session }) {
    const { userPoolId, userPoolClientId, userPoolEndpoint } = config;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const authParameters = {
        USERNAME: username
    };
    if (preferredChallenge) {
        // Validate that the preferred challenge is enabled in the backend config
        // Only validate if passwordless config exists (for backward compatibility)
        if (config.passwordless) {
            const isInvalidChallenge = preferredChallenge === 'EMAIL_OTP' && !config.passwordless.emailOtpEnabled || preferredChallenge === 'SMS_OTP' && !config.passwordless.smsOtpEnabled || preferredChallenge === 'WEB_AUTHN' && !config.passwordless.webAuthn;
            if (isInvalidChallenge) (0, _assertValidationErrorMjs.assertValidationError)(false, (0, _validationMjs.AuthValidationErrorCode).InvalidPreferredChallenge);
        }
        if (preferredChallenge === 'PASSWORD_SRP') {
            (0, _assertValidationErrorMjs.assertValidationError)(!!password, (0, _validationMjs.AuthValidationErrorCode).EmptySignInPassword);
            return (0, _handlePasswordSRPMjs.handlePasswordSRP)({
                username,
                password,
                clientMetadata,
                config,
                tokenOrchestrator,
                authFlow: 'USER_AUTH',
                preferredChallenge
            });
        }
        if (preferredChallenge === 'PASSWORD') {
            (0, _assertValidationErrorMjs.assertValidationError)(!!password, (0, _validationMjs.AuthValidationErrorCode).EmptySignInPassword);
            authParameters.PASSWORD = password;
        }
        authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    }
    const jsonReq = {
        AuthFlow: 'USER_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    };
    if (session) jsonReq.Session = session;
    const initiateAuth = (0, _createInitiateAuthClientMjs.createInitiateAuthClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignIn)
    }, jsonReq);
    // Set the active username immediately after successful authentication attempt
    // If a user starts a new sign-in while another sign-in is incomplete,
    // this ensures we're tracking the correct user for subsequent auth challenges.
    (0, _setActiveSignInUsernameMjs.setActiveSignInUsername)(username);
    return response;
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../providers/cognito/utils/userContextData.mjs":"hZOPS","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createInitiateAuthClient.mjs":"5m6Bo","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../providers/cognito/types/errors.mjs":"fLYtN","../../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../shared/handlePasswordSRP.mjs":"5RD60","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../providers/cognito/utils/setActiveSignInUsername.mjs":"3xyHv","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"217m3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSignUpClient", ()=>createSignUpClient);
parcelHelpers.export(exports, "createSignUpClientDeserializer", ()=>createSignUpClientDeserializer);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _authErrorStringsMjs = require("../../../../common/AuthErrorStrings.mjs");
var _authErrorMjs = require("../../../../errors/AuthError.mjs");
var _validationMjs = require("../../../../errors/types/validation.mjs");
var _assertServiceErrorMjs = require("../../../../errors/utils/assertServiceError.mjs");
var _errorsMjs = require("../../../../providers/cognito/types/errors.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createSignUpClientDeserializer = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, _awsClientUtils.parseJsonError)(response);
            (0, _assertServiceErrorMjs.assertServiceError)(error);
            if (// Missing Password Error
            // 1 validation error detected: Value at 'password'failed to satisfy constraint: Member must not be null
            error.name === (0, _errorsMjs.SignUpException).InvalidParameterException && /'password'/.test(error.message) && /Member must not be null/.test(error.message)) {
                const name = (0, _validationMjs.AuthValidationErrorCode).EmptySignUpPassword;
                const { message, recoverySuggestion } = (0, _authErrorStringsMjs.validationErrorMap)[name];
                throw new (0, _authErrorMjs.AuthError)({
                    name,
                    message,
                    recoverySuggestion
                });
            }
            throw new (0, _authErrorMjs.AuthError)({
                name: error.name,
                message: error.message
            });
        }
        return (0, _awsClientUtils.parseJsonBody)(response);
    };
const createSignUpClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('SignUp'), createSignUpClientDeserializer(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../../common/AuthErrorStrings.mjs":"eO30C","../../../../errors/AuthError.mjs":"4RqZd","../../../../errors/types/validation.mjs":"frXJ6","../../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../../providers/cognito/types/errors.mjs":"fLYtN","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"anzc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetPassword", ()=>resetPassword);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _userContextDataMjs = require("../utils/userContextData.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createForgotPasswordClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createForgotPasswordClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resets a user's password.
 *
 * @param input -  The ResetPasswordInput object.
 * @returns ResetPasswordOutput
 * @throws -{@link ForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function resetPassword(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const { username } = input;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptyResetPasswordUsername);
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolClientId, userPoolId, userPoolEndpoint } = authConfig;
    const clientMetadata = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const forgotPassword = (0, _createForgotPasswordClientMjs.createForgotPasswordClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const res = await forgotPassword({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ResetPassword)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData
    });
    const codeDeliveryDetails = res.CodeDeliveryDetails;
    return {
        isPasswordReset: false,
        nextStep: {
            resetPasswordStep: 'CONFIRM_RESET_PASSWORD_WITH_CODE',
            codeDeliveryDetails: {
                deliveryMedium: codeDeliveryDetails === null || codeDeliveryDetails === void 0 ? void 0 : codeDeliveryDetails.DeliveryMedium,
                destination: codeDeliveryDetails === null || codeDeliveryDetails === void 0 ? void 0 : codeDeliveryDetails.Destination,
                attributeName: codeDeliveryDetails === null || codeDeliveryDetails === void 0 ? void 0 : codeDeliveryDetails.AttributeName
            }
        }
    };
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../utils/userContextData.mjs":"hZOPS","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createForgotPasswordClient.mjs":"8rSZs","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8rSZs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createForgotPasswordClient", ()=>createForgotPasswordClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createForgotPasswordClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ForgotPassword'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4pSNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "confirmResetPassword", ()=>confirmResetPassword);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _userContextDataMjs = require("../utils/userContextData.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createConfirmForgotPasswordClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createConfirmForgotPasswordClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms the new password and verification code to reset the password.
 *
 * @param input -  The ConfirmResetPasswordInput object.
 * @throws -{@link ConfirmForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code, password or username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function confirmResetPassword(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolClientId, userPoolId, userPoolEndpoint } = authConfig;
    const { username, newPassword } = input;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptyConfirmResetPasswordUsername);
    (0, _assertValidationErrorMjs.assertValidationError)(!!newPassword, (0, _validationMjs.AuthValidationErrorCode).EmptyConfirmResetPasswordNewPassword);
    const code = input.confirmationCode;
    (0, _assertValidationErrorMjs.assertValidationError)(!!code, (0, _validationMjs.AuthValidationErrorCode).EmptyConfirmResetPasswordConfirmationCode);
    const metadata = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const confirmForgotPassword = (0, _createConfirmForgotPasswordClientMjs.createConfirmForgotPasswordClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await confirmForgotPassword({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(authConfig.userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmResetPassword)
    }, {
        Username: username,
        ConfirmationCode: code,
        Password: newPassword,
        ClientMetadata: metadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../utils/userContextData.mjs":"hZOPS","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createConfirmForgotPasswordClient.mjs":"fYDDk","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","../../../foundation/parsers/regionParsers.mjs":"9YQHb","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fYDDk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConfirmForgotPasswordClient", ()=>createConfirmForgotPasswordClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createConfirmForgotPasswordClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ConfirmForgotPassword'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kjjWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resendSignUpCode", ()=>resendSignUpCode);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _userContextDataMjs = require("../utils/userContextData.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createResendConfirmationCodeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createResendConfirmationCodeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resend the confirmation code while signing up
 *
 * @param input -  The ResendSignUpCodeInput object
 * @returns ResendSignUpCodeOutput
 * @throws service: {@link ResendConfirmationException } - Cognito service errors thrown when resending the code.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function resendSignUpCode(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const { username } = input;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptySignUpUsername);
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolClientId, userPoolId, userPoolEndpoint } = authConfig;
    const clientMetadata = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const resendConfirmationCode = (0, _createResendConfirmationCodeClientMjs.createResendConfirmationCodeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetails } = await resendConfirmationCode({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(authConfig.userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ResendSignUpCode)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData
    });
    const { DeliveryMedium, AttributeName, Destination } = (0, _objectSpread._)({}, CodeDeliveryDetails);
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName ? AttributeName : undefined
    };
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/types/validation.mjs":"frXJ6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../utils/userContextData.mjs":"hZOPS","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createResendConfirmationCodeClient.mjs":"8kHzq","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8kHzq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResendConfirmationCodeClient", ()=>createResendConfirmationCodeClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createResendConfirmationCodeClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ResendConfirmationCode'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4B5Op":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "confirmSignUp", ()=>confirmSignUp);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _userContextDataMjs = require("../utils/userContextData.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createConfirmSignUpClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createConfirmSignUpClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _autoSignInMjs = require("./autoSignIn.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function confirmSignUp(input) {
    var _Amplify_getConfig_Auth;
    const { username, confirmationCode, options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolId, userPoolClientId, userPoolEndpoint } = authConfig;
    const clientMetadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _assertValidationErrorMjs.assertValidationError)(!!username, (0, _validationMjs.AuthValidationErrorCode).EmptyConfirmSignUpUsername);
    (0, _assertValidationErrorMjs.assertValidationError)(!!confirmationCode, (0, _validationMjs.AuthValidationErrorCode).EmptyConfirmSignUpCode);
    const UserContextData = (0, _userContextDataMjs.getUserContextData)({
        username,
        userPoolId,
        userPoolClientId
    });
    const confirmSignUpClient = (0, _createConfirmSignUpClientMjs.createConfirmSignUpClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Session: session } = await confirmSignUpClient({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(authConfig.userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options === null || options === void 0 ? void 0 : options.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: 'DONE'
                }
            };
            const autoSignInStoreState = (0, _autoSignInStoreMjs.autoSignInStore).getState();
            if (!autoSignInStoreState.active || autoSignInStoreState.username !== username) {
                resolve(signUpOut);
                (0, _autoSignInMjs.resetAutoSignIn)();
                return;
            }
            (0, _autoSignInStoreMjs.autoSignInStore).dispatch({
                type: 'SET_SESSION',
                value: session
            });
            const stopListener = (0, _utils.HubInternal).listen('auth-internal', ({ payload })=>{
                switch(payload.event){
                    case 'autoSignIn':
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: 'COMPLETE_AUTO_SIGN_IN'
                            }
                        });
                        stopListener();
                }
            });
            (0, _utils.HubInternal).dispatch('auth-internal', {
                event: 'confirmSignUp',
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/types/validation.mjs":"frXJ6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../utils/userContextData.mjs":"hZOPS","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createConfirmSignUpClient.mjs":"78UfW","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","./autoSignIn.mjs":"jECSX","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"78UfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConfirmSignUpClient", ()=>createConfirmSignUpClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _constantsMjs = require("./constants.mjs");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createConfirmSignUpClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ConfirmSignUp'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./constants.mjs":"bHH4M","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kpY4F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "confirmSignIn", ()=>confirmSignIn);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _autoSignInStoreMjs = require("../../../client/utils/store/autoSignInStore.mjs");
var _signInStoreMjs = require("../../../client/utils/store/signInStore.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _cacheTokensMjs = require("../tokenProvider/cacheTokens.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _dispatchSignedInHubEventMjs = require("../utils/dispatchSignedInHubEvent.mjs");
var _getNewDeviceMetadataMjs = require("../utils/getNewDeviceMetadata.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Continues or completes the sign in process when required by the initial call to `signIn`.
 *
 * @param input -  The ConfirmSignInInput object
 * @returns ConfirmSignInOutput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link RespondToAuthChallengeException }:
 * Thrown due to an invalid auth challenge response.
 * @throws  -{@link AssociateSoftwareTokenException}:
 * Thrown due to a service error during the MFA setup process.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `challengeResponse` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function confirmSignIn(input) {
    var _Amplify_getConfig_Auth;
    const { challengeResponse, options } = input;
    const { username, challengeName, signInSession, signInDetails } = (0, _signInStoreMjs.signInStore).getState();
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const clientMetaData = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _assertValidationErrorMjs.assertValidationError)(!!challengeResponse, (0, _validationMjs.AuthValidationErrorCode).EmptyChallengeResponse);
    if (!username || !challengeName || !signInSession) // TODO: remove this error message for production apps
    throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authErrorStringsMjs.AuthErrorCodes).SignInException,
        message: `
			An error occurred during the sign in process.

			This most likely occurred due to:
			1. signIn was not called before confirmSignIn.
			2. signIn threw an exception.
			3. page was refreshed during the sign in flow and session has expired.
			`,
        recoverySuggestion: "Make sure a successful call to signIn is made before calling confirmSignInand that the session has not expired."
    });
    try {
        const { Session, ChallengeName: handledChallengeName, AuthenticationResult, ChallengeParameters: handledChallengeParameters } = await (0, _signInHelpersMjs.handleChallengeName)(username, challengeName, signInSession, challengeResponse, authConfig, (0, _tokenProviderMjs.tokenOrchestrator), clientMetaData, options);
        // sets up local state used during the sign-in process
        (0, _signInStoreMjs.setActiveSignInState)({
            signInSession: Session,
            username,
            challengeName: handledChallengeName,
            signInDetails
        });
        if (AuthenticationResult) {
            await (0, _cacheTokensMjs.cacheCognitoTokens)((0, _objectSpreadProps._)((0, _objectSpread._)({
                username
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, _getNewDeviceMetadataMjs.getNewDeviceMetadata)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails
            }));
            (0, _signInStoreMjs.resetActiveSignInState)();
            await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, _signInHelpersMjs.getSignInResult)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, _assertServiceErrorMjs.assertServiceError)(error);
        const result = (0, _signInHelpersMjs.getSignInResultFromError)(error.name);
        if (result) return result;
        throw error;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../client/utils/store/autoSignInStore.mjs":"gZWar","../../../client/utils/store/signInStore.mjs":"chngd","../../../errors/AuthError.mjs":"4RqZd","../utils/signInHelpers.mjs":"2HTeV","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../errors/types/validation.mjs":"frXJ6","../../../common/AuthErrorStrings.mjs":"eO30C","../tokenProvider/cacheTokens.mjs":"bsRco","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/types.mjs":"4GeFs","../tokenProvider/tokenProvider.mjs":"9mSqK","../utils/dispatchSignedInHubEvent.mjs":"2RLlL","../utils/getNewDeviceMetadata.mjs":"jJyS1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aGvVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMFASettings", ()=>getMFASettings);
parcelHelpers.export(exports, "updateMFAPreference", ()=>updateMFAPreference);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createSetUserMFAPreferenceClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createSetUserMFAPreferenceClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates the MFA preference of the user.
 *
 * @param input - The UpdateMFAPreferenceInput object.
 * @throws -{@link SetUserMFAPreferenceException } - Service error thrown when the MFA preference cannot be updated.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function updateMFAPreference(input) {
    var _Amplify_getConfig_Auth;
    const { sms, totp, email } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const setUserMFAPreference = (0, _createSetUserMFAPreferenceClientMjs.createSetUserMFAPreferenceClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await setUserMFAPreference({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).UpdateMFAPreference)
    }, {
        AccessToken: tokens.accessToken.toString(),
        SMSMfaSettings: getMFASettings(sms),
        SoftwareTokenMfaSettings: getMFASettings(totp),
        EmailMfaSettings: getMFASettings(email)
    });
}
function getMFASettings(mfaPreference) {
    if (mfaPreference === 'DISABLED') return {
        Enabled: false
    };
    else if (mfaPreference === 'PREFERRED') return {
        Enabled: true,
        PreferredMfa: true
    };
    else if (mfaPreference === 'ENABLED') return {
        Enabled: true
    };
    else if (mfaPreference === 'NOT_PREFERRED') return {
        Enabled: true,
        PreferredMfa: false
    };
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createSetUserMFAPreferenceClient.mjs":"2edU8","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2edU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSetUserMFAPreferenceClient", ()=>createSetUserMFAPreferenceClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createSetUserMFAPreferenceClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('SetUserMFAPreference'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jD2u5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchMFAPreference", ()=>fetchMFAPreference);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createGetUserClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetUserClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the preferred MFA setting and enabled MFA settings for the user.
 *
 * @returns FetchMFAPreferenceOutput
 * @throws  -{@link GetUserException} : error thrown when the service fails to fetch MFA preference
 * and settings.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function fetchMFAPreference() {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const getUser = (0, _createGetUserClientMjs.createGetUserClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { PreferredMfaSetting, UserMFASettingList } = await getUser({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).FetchMFAPreference)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return {
        preferred: (0, _signInHelpersMjs.getMFAType)(PreferredMfaSetting),
        enabled: (0, _signInHelpersMjs.getMFATypes)(UserMFASettingList)
    };
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/signInHelpers.mjs":"2HTeV","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetUserClient.mjs":"4asv5","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4asv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetUserClient", ()=>createGetUserClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createGetUserClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('GetUser'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6prqr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "verifyTOTPSetup", ()=>verifyTOTPSetup);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createVerifySoftwareTokenClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createVerifySoftwareTokenClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Verifies an OTP code retrieved from an associated authentication app.
 *
 * @param input - The VerifyTOTPSetupInput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `code` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function verifyTOTPSetup(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { code, options } = input;
    (0, _assertValidationErrorMjs.assertValidationError)(!!code, (0, _validationMjs.AuthValidationErrorCode).EmptyVerifyTOTPSetupCode);
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const verifySoftwareToken = (0, _createVerifySoftwareTokenClientMjs.createVerifySoftwareTokenClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await verifySoftwareToken({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).VerifyTOTPSetup)
    }, {
        AccessToken: tokens.accessToken.toString(),
        UserCode: code,
        FriendlyDeviceName: options === null || options === void 0 ? void 0 : options.friendlyDeviceName
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createVerifySoftwareTokenClient.mjs":"7g18x","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9s8BB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updatePassword", ()=>updatePassword);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createChangePasswordClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createChangePasswordClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's password while authenticated.
 *
 * @param input - The UpdatePasswordInput object.
 * @throws - {@link ChangePasswordException} - Cognito service errors thrown when updating a password.
 * @throws - {@link AuthValidationErrorCode} - Validation errors thrown when oldPassword or newPassword are empty.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function updatePassword(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { oldPassword, newPassword } = input;
    (0, _assertValidationErrorMjs.assertValidationError)(!!oldPassword, (0, _validationMjs.AuthValidationErrorCode).EmptyUpdatePassword);
    (0, _assertValidationErrorMjs.assertValidationError)(!!newPassword, (0, _validationMjs.AuthValidationErrorCode).EmptyUpdatePassword);
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const changePassword = (0, _createChangePasswordClientMjs.createChangePasswordClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await changePassword({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).UpdatePassword)
    }, {
        AccessToken: tokens.accessToken.toString(),
        PreviousPassword: oldPassword,
        ProposedPassword: newPassword
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createChangePasswordClient.mjs":"5Yh7G","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5Yh7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createChangePasswordClient", ()=>createChangePasswordClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createChangePasswordClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ChangePassword'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7yigh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setUpTOTP", ()=>setUpTOTP);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _createAssociateSoftwareTokenClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createAssociateSoftwareTokenClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Sets up TOTP for the user.
 *
 * @returns SetUpTOTPOutput
 * @throws -{@link AssociateSoftwareTokenException}
 * Thrown if a service occurs while setting up TOTP.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function setUpTOTP() {
    var _Amplify_getConfig_Auth, _tokens_idToken;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    var _tokens_idToken_payload_cognitousername;
    const username = (_tokens_idToken_payload_cognitousername = (_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.payload['cognito:username']) !== null && _tokens_idToken_payload_cognitousername !== void 0 ? _tokens_idToken_payload_cognitousername : '';
    const associateSoftwareToken = (0, _createAssociateSoftwareTokenClientMjs.createAssociateSoftwareTokenClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { SecretCode } = await associateSoftwareToken({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SetUpTOTP)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    if (!SecretCode) // This should never happen.
    throw new (0, _authErrorMjs.AuthError)({
        name: (0, _errorsMjs.SETUP_TOTP_EXCEPTION),
        message: 'Failed to set up TOTP.'
    });
    return (0, _signInHelpersMjs.getTOTPSetupDetails)(SecretCode, JSON.stringify(username));
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/AuthError.mjs":"4RqZd","../types/errors.mjs":"fLYtN","../utils/signInHelpers.mjs":"2HTeV","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createAssociateSoftwareTokenClient.mjs":"fQ4xk","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"HYnWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateUserAttributes", ()=>updateUserAttributes);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../utils/types.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _apiHelpersMjs = require("../utils/apiHelpers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createUpdateUserAttributesClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createUpdateUserAttributesClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's attributes while authenticated.
 *
 * @param input - The UpdateUserAttributesInput object
 * @returns UpdateUserAttributesOutput
 * @throws - {@link UpdateUserAttributesException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const updateUserAttributes = async (input)=>{
    var _Amplify_getConfig_Auth;
    const { userAttributes, options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const clientMetadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const updateUserAttributesClient = (0, _createUpdateUserAttributesClientMjs.createUpdateUserAttributesClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetailsList } = await updateUserAttributesClient({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).UpdateUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString(),
        ClientMetadata: clientMetadata,
        UserAttributes: (0, _apiHelpersMjs.toAttributeType)(userAttributes)
    });
    return (0, _objectSpread._)({}, getConfirmedAttributes(userAttributes), getUnConfirmedAttributes(CodeDeliveryDetailsList));
};
function getConfirmedAttributes(attributes) {
    var _Object_keys;
    const confirmedAttributes = {};
    (_Object_keys = Object.keys(attributes)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.forEach((key)=>{
        confirmedAttributes[key] = {
            isUpdated: true,
            nextStep: {
                updateAttributeStep: 'DONE'
            }
        };
    });
    return confirmedAttributes;
}
function getUnConfirmedAttributes(codeDeliveryDetailsList) {
    const unConfirmedAttributes = {};
    codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.forEach((codeDeliveryDetails)=>{
        const { AttributeName, DeliveryMedium, Destination } = codeDeliveryDetails;
        if (AttributeName) unConfirmedAttributes[AttributeName] = {
            isUpdated: false,
            nextStep: {
                updateAttributeStep: 'CONFIRM_ATTRIBUTE_WITH_CODE',
                codeDeliveryDetails: {
                    attributeName: AttributeName,
                    deliveryMedium: DeliveryMedium,
                    destination: Destination
                }
            }
        };
    });
    return unConfirmedAttributes;
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/types.mjs":"4GeFs","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/apiHelpers.mjs":"8W5aY","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createUpdateUserAttributesClient.mjs":"72fyB","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"72fyB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUpdateUserAttributesClient", ()=>createUpdateUserAttributesClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createUpdateUserAttributesClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('UpdateUserAttributes'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aqmtL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateUserAttribute", ()=>updateUserAttribute);
var _updateUserAttributesMjs = require("./updateUserAttributes.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's attribute while authenticated.
 *
 * @param input - The UpdateUserAttributeInput object
 * @returns UpdateUserAttributeOutput
 * @throws - {@link UpdateUserAttributesException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const updateUserAttribute = async (input)=>{
    const { userAttribute: { attributeKey, value }, options } = input;
    const output = await (0, _updateUserAttributesMjs.updateUserAttributes)({
        userAttributes: {
            [attributeKey]: value
        },
        options
    });
    return Object.values(output)[0];
};

},{"./updateUserAttributes.mjs":"HYnWw","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fmKvE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "confirmUserAttribute", ()=>confirmUserAttribute);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _assertValidationErrorMjs = require("../../../errors/utils/assertValidationError.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createVerifyUserAttributeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createVerifyUserAttributeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a user attribute with the confirmation code.
 *
 * @param input -  The ConfirmUserAttributeInput object
 * @throws  -{@link AuthValidationErrorCode } -
 * Thrown when `confirmationCode` is not defined.
 * @throws  -{@link VerifyUserAttributeException } - Thrown due to an invalid confirmation code or attribute.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function confirmUserAttribute(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { confirmationCode, userAttributeKey } = input;
    (0, _assertValidationErrorMjs.assertValidationError)(!!confirmationCode, (0, _validationMjs.AuthValidationErrorCode).EmptyConfirmUserAttributeCode);
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const verifyUserAttribute = (0, _createVerifyUserAttributeClientMjs.createVerifyUserAttributeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await verifyUserAttribute({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ConfirmUserAttribute)
    }, {
        AccessToken: tokens.accessToken.toString(),
        AttributeName: userAttributeKey,
        Code: confirmationCode
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/types/validation.mjs":"frXJ6","../../../errors/utils/assertValidationError.mjs":"81Pnh","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createVerifyUserAttributeClient.mjs":"eaAdJ","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"eaAdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createVerifyUserAttributeClient", ()=>createVerifyUserAttributeClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createVerifyUserAttributeClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('VerifyUserAttribute'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5fLS2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInWithRedirect", ()=>signInWithRedirect);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _enableOAuthListenerMjs = require("../utils/oauth/enableOAuthListener.mjs");
var _modelsMjs = require("../types/models.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _openAuthSessionMjs = require("../../../utils/openAuthSession.mjs");
var _signInHelpersMjs = require("../utils/signInHelpers.mjs");
var _generateCodeVerifierMjs = require("../utils/oauth/generateCodeVerifier.mjs");
var _generateStateMjs = require("../utils/oauth/generateState.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _oAuthStoreMjs = require("../utils/oauth/oAuthStore.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _getRedirectUrlMjs = require("../utils/oauth/getRedirectUrl.mjs");
var _handleFailureMjs = require("../utils/oauth/handleFailure.mjs");
var _completeOAuthFlowMjs = require("../utils/oauth/completeOAuthFlow.mjs");
var _authMjs = require("../../../types/Auth.mjs");
var _createOAuthErrorMjs = require("../utils/oauth/createOAuthError.mjs");
var _cancelOAuthFlowMjs = require("../utils/oauth/cancelOAuthFlow.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs in a user with OAuth. Redirects the application to an Identity Provider.
 *
 * @param input - The SignInWithRedirectInput object, if empty it will redirect to Cognito HostedUI
 *
 * @throws AuthTokenConfigException - Thrown when the user pool config is invalid.
 * @throws OAuthNotConfigureException - Thrown when the oauth config is invalid.
 */ async function signInWithRedirect(input) {
    var _Amplify_getConfig_Auth, _input_options, _input_provider, _input_provider1, _input_options1, _input_options2, _input_options3, _input_options4, _input_options5, _input_options6;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    (0, _utils.assertOAuthConfig)(authConfig);
    (0, _oAuthStoreMjs.oAuthStore).setAuthConfig(authConfig);
    if (!(input === null || input === void 0 ? void 0 : (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.prompt)) await (0, _signInHelpersMjs.assertUserNotAuthenticated)();
    let provider = 'COGNITO'; // Default
    let idpIdentifier;
    if (typeof (input === null || input === void 0 ? void 0 : input.provider) === 'string') provider = (0, _modelsMjs.cognitoHostedUIIdentityProviderMap)[input.provider];
    else if (input === null || input === void 0 ? void 0 : (_input_provider = input.provider) === null || _input_provider === void 0 ? void 0 : _input_provider.custom) provider = input.provider.custom;
    else if (input === null || input === void 0 ? void 0 : (_input_provider1 = input.provider) === null || _input_provider1 === void 0 ? void 0 : _input_provider1.idpIdentifier) ({ idpIdentifier } = input.provider);
    return oauthSignIn({
        oauthConfig: authConfig.loginWith.oauth,
        clientId: authConfig.userPoolClientId,
        provider,
        idpIdentifier,
        customState: input === null || input === void 0 ? void 0 : input.customState,
        preferPrivateSession: input === null || input === void 0 ? void 0 : (_input_options1 = input.options) === null || _input_options1 === void 0 ? void 0 : _input_options1.preferPrivateSession,
        options: {
            loginHint: input === null || input === void 0 ? void 0 : (_input_options2 = input.options) === null || _input_options2 === void 0 ? void 0 : _input_options2.loginHint,
            lang: input === null || input === void 0 ? void 0 : (_input_options3 = input.options) === null || _input_options3 === void 0 ? void 0 : _input_options3.lang,
            nonce: input === null || input === void 0 ? void 0 : (_input_options4 = input.options) === null || _input_options4 === void 0 ? void 0 : _input_options4.nonce,
            prompt: input === null || input === void 0 ? void 0 : (_input_options5 = input.options) === null || _input_options5 === void 0 ? void 0 : _input_options5.prompt
        },
        authSessionOpener: input === null || input === void 0 ? void 0 : (_input_options6 = input.options) === null || _input_options6 === void 0 ? void 0 : _input_options6.authSessionOpener
    });
}
const oauthSignIn = async ({ oauthConfig, provider, idpIdentifier, clientId, customState, preferPrivateSession, options, authSessionOpener })=>{
    const { domain, redirectSignIn, responseType, scopes } = oauthConfig;
    const { loginHint, lang, nonce, prompt } = options !== null && options !== void 0 ? options : {};
    const randomState = (0, _generateStateMjs.generateState)();
    const openAuthSession$1 = authSessionOpener || (0, _openAuthSessionMjs.openAuthSession);
    /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
    single-encodes/decodes url on first sign in and double-encodes/decodes url
    when user already signed in. Using encodeURIComponent, Base32, Base64 add
    characters % or = which on further encoding becomes unsafe. '=' create issue
    for parsing query params.
    Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ const state = customState ? `${randomState}-${(0, _utils.urlSafeEncode)(customState)}` : randomState;
    const { value, method, toCodeChallenge } = (0, _generateCodeVerifierMjs.generateCodeVerifier)(128);
    const redirectUri = (0, _getRedirectUrlMjs.getRedirectUrl)(oauthConfig.redirectSignIn);
    if ((0, _utils.isBrowser)()) (0, _oAuthStoreMjs.oAuthStore).storeOAuthInFlight(true);
    (0, _oAuthStoreMjs.oAuthStore).storeOAuthState(state);
    (0, _oAuthStoreMjs.oAuthStore).storePKCE(value);
    const params = new URLSearchParams();
    params.append('redirect_uri', redirectUri);
    params.append('response_type', responseType);
    params.append('client_id', clientId);
    // Add either identity_provider or idp_identifier, but not both
    if (idpIdentifier) params.append('idp_identifier', idpIdentifier);
    else params.append('identity_provider', provider);
    params.append('scope', scopes.join(' '));
    loginHint && params.append('login_hint', loginHint);
    lang && params.append('lang', lang);
    nonce && params.append('nonce', nonce);
    prompt && params.append('prompt', prompt.toLowerCase());
    params.append('state', state);
    if (responseType === 'code') {
        params.append('code_challenge', toCodeChallenge());
        params.append('code_challenge_method', method);
    }
    // Using URL object is not supported in React Native as the `search` property is read-only
    // See: https://github.com/facebook/react-native/blob/main/packages/react-native/Libraries/Blob/URL.js
    const oAuthUrl = `https://${domain}/oauth2/authorize?${params.toString()}`;
    // this will only take effect in the following scenarios:
    // 1. the user cancels the OAuth flow on web via back button, and
    // 2. when bfcache is enabled
    (0, _cancelOAuthFlowMjs.listenForOAuthFlowCancellation)((0, _oAuthStoreMjs.oAuthStore));
    var _ref;
    // the following is effective only in react-native as openAuthSession resolves only in react-native
    const { type, error, url } = (_ref = await openAuthSession$1(oAuthUrl, redirectSignIn, preferPrivateSession)) !== null && _ref !== void 0 ? _ref : {};
    try {
        if (type === 'error') throw (0, _createOAuthErrorMjs.createOAuthError)(String(error));
        if (type === 'canceled') throw (0, _createOAuthErrorMjs.createOAuthError)(String(type));
        if (type === 'success' && url) await (0, _completeOAuthFlowMjs.completeOAuthFlow)({
            currentUrl: url,
            clientId,
            domain,
            redirectUri,
            responseType,
            userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignInWithRedirect),
            preferPrivateSession
        });
    } catch (err) {
        await (0, _handleFailureMjs.handleFailure)(err);
        // rethrow the error so it can be caught by `await signInWithRedirect()` in react-native
        throw err;
    }
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/oauth/enableOAuthListener.mjs":"aIFZQ","../types/models.mjs":"1nJ59","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../../../utils/openAuthSession.mjs":"8cAFr","../utils/signInHelpers.mjs":"2HTeV","../utils/oauth/generateCodeVerifier.mjs":"J2JSr","../utils/oauth/generateState.mjs":"3E3Ba","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/oauth/oAuthStore.mjs":"1uhgp","../tokenProvider/tokenProvider.mjs":"9mSqK","../utils/oauth/getRedirectUrl.mjs":"4iu6a","../utils/oauth/handleFailure.mjs":"jQJMg","../utils/oauth/completeOAuthFlow.mjs":"9cV65","../../../types/Auth.mjs":"lMA8M","../utils/oauth/createOAuthError.mjs":"12JH3","../utils/oauth/cancelOAuthFlow.mjs":"8Y92B","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"aIFZQ":[function(require,module,exports,__globalThis) {
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _attemptCompleteOAuthFlowMjs = require("./attemptCompleteOAuthFlow.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// attach the side effect for handling the completion of an inflight oauth flow
// this side effect works only on Web
(0, _utils.isBrowser)() && (()=>{
    // add the listener to the singleton for triggering
    (0, _core.Amplify)[0, _utils.ADD_OAUTH_LISTENER]((0, _attemptCompleteOAuthFlowMjs.attemptCompleteOAuthFlow));
})();

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","./attemptCompleteOAuthFlow.mjs":"3lEqH"}],"3lEqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attemptCompleteOAuthFlow", ()=>attemptCompleteOAuthFlow);
var _utils = require("@aws-amplify/core/internals/utils");
var _getAuthUserAgentValueMjs = require("../../../../utils/getAuthUserAgentValue.mjs");
var _oAuthStoreMjs = require("./oAuthStore.mjs");
var _completeOAuthFlowMjs = require("./completeOAuthFlow.mjs");
var _getRedirectUrlMjs = require("./getRedirectUrl.mjs");
var _handleFailureMjs = require("./handleFailure.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const attemptCompleteOAuthFlow = async (authConfig)=>{
    try {
        (0, _utils.assertTokenProviderConfig)(authConfig);
        (0, _utils.assertOAuthConfig)(authConfig);
        (0, _oAuthStoreMjs.oAuthStore).setAuthConfig(authConfig);
    } catch (_) {
        // no-op
        // This should not happen as Amplify singleton checks the oauth config key
        // unless the oauth config object doesn't contain required properties
        return;
    }
    // No inflight OAuth
    if (!await (0, _oAuthStoreMjs.oAuthStore).loadOAuthInFlight()) return;
    try {
        const currentUrl = window.location.href;
        const { loginWith, userPoolClientId } = authConfig;
        const { domain, redirectSignIn, responseType } = loginWith.oauth;
        const redirectUri = (0, _getRedirectUrlMjs.getRedirectUrl)(redirectSignIn);
        await (0, _completeOAuthFlowMjs.completeOAuthFlow)({
            currentUrl,
            clientId: userPoolClientId,
            domain,
            redirectUri,
            responseType,
            userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignInWithRedirect)
        });
    } catch (err) {
        await (0, _handleFailureMjs.handleFailure)(err);
    }
};

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../../utils/getAuthUserAgentValue.mjs":"6soVl","./oAuthStore.mjs":"1uhgp","./completeOAuthFlow.mjs":"9cV65","./getRedirectUrl.mjs":"4iu6a","./handleFailure.mjs":"jQJMg","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9cV65":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "completeOAuthFlow", ()=>completeOAuthFlow);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@aws-amplify/core/internals/utils");
var _core = require("@aws-amplify/core");
var _cacheTokensMjs = require("../../tokenProvider/cacheTokens.mjs");
var _dispatchSignedInHubEventMjs = require("../dispatchSignedInHubEvent.mjs");
var _refreshAuthTokensMjs = require("../refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../../tokenProvider/errorHelpers.mjs");
var _oAuthStoreMjs = require("./oAuthStore.mjs");
var _inflightPromiseMjs = require("./inflightPromise.mjs");
var _tokenProviderMjs = require("../../tokenProvider/tokenProvider.mjs");
var _createOAuthErrorMjs = require("./createOAuthError.mjs");
var _validateStateMjs = require("./validateState.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const completeOAuthFlow = async ({ currentUrl, userAgentValue, clientId, redirectUri, responseType, domain, preferPrivateSession })=>{
    const urlParams = new (0, _utils.AmplifyUrl)(currentUrl);
    const error = urlParams.searchParams.get('error');
    const errorMessage = urlParams.searchParams.get('error_description');
    if (error) throw (0, _createOAuthErrorMjs.createOAuthError)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : error);
    if (responseType === 'code') return handleCodeFlow({
        currentUrl,
        userAgentValue,
        clientId,
        redirectUri,
        domain,
        preferPrivateSession
    });
    return handleImplicitFlow({
        currentUrl,
        redirectUri,
        preferPrivateSession
    });
};
const handleCodeFlow = async ({ currentUrl, userAgentValue, clientId, redirectUri, domain, preferPrivateSession })=>{
    /* Convert URL into an object with parameters as keys
{ redirect_uri: 'http://localhost:3000/', response_type: 'code', ...} */ const url = new (0, _utils.AmplifyUrl)(currentUrl);
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');
    // if `code` or `state` is not presented in the redirect url, most likely
    // that the end user cancelled the inflight oauth flow by:
    // 1. clicking the back button of browser
    // 2. closing the provider hosted UI page and coming back to the app
    if (!code || !state) throw (0, _createOAuthErrorMjs.createOAuthError)('User cancelled OAuth flow.');
    // may throw error is being caught in attemptCompleteOAuthFlow.ts
    const validatedState = await (0, _validateStateMjs.validateState)(state);
    const oAuthTokenEndpoint = 'https://' + domain + '/oauth2/token';
    // TODO(v6): check hub events
    // dispatchAuthEvent(
    // 	'codeFlow',
    // 	{},
    // 	`Retrieving tokens from ${oAuthTokenEndpoint}`
    // );
    const codeVerifier = await (0, _oAuthStoreMjs.oAuthStore).loadPKCE();
    const oAuthTokenBody = (0, _objectSpread._)({
        grant_type: 'authorization_code',
        code,
        client_id: clientId,
        redirect_uri: redirectUri
    }, codeVerifier ? {
        code_verifier: codeVerifier
    } : {});
    const body = Object.entries(oAuthTokenBody).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    const { access_token, refresh_token: refreshToken, id_token, error, error_message: errorMessage, token_type, expires_in } = await (await fetch(oAuthTokenEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [(0, _utils.USER_AGENT_HEADER)]: userAgentValue
        },
        body
    })).json();
    if (error) // error is being caught in attemptCompleteOAuthFlow.ts
    throw (0, _createOAuthErrorMjs.createOAuthError)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : error);
    var _ref;
    const username = (_ref = access_token && (0, _core.decodeJWT)(access_token).payload.username) !== null && _ref !== void 0 ? _ref : 'username';
    await (0, _cacheTokensMjs.cacheCognitoTokens)({
        username,
        AccessToken: access_token,
        IdToken: id_token,
        RefreshToken: refreshToken
    });
    return completeFlow({
        redirectUri,
        state: validatedState,
        preferPrivateSession
    });
};
const handleImplicitFlow = async ({ currentUrl, redirectUri, preferPrivateSession })=>{
    // hash is `null` if `#` doesn't exist on URL
    const url = new (0, _utils.AmplifyUrl)(currentUrl);
    var _url_hash;
    const { id_token, access_token, state, token_type, expires_in, error_description, error } = ((_url_hash = url.hash) !== null && _url_hash !== void 0 ? _url_hash : '#').substring(1) // Remove # from returned code
    .split('&').map((pairings)=>pairings.split('=')).reduce((accum, [k, v])=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, accum), {
            [k]: v
        }), {
        id_token: undefined,
        access_token: undefined,
        state: undefined,
        token_type: undefined,
        expires_in: undefined,
        error_description: undefined,
        error: undefined
    });
    if (error) throw (0, _createOAuthErrorMjs.createOAuthError)(error_description !== null && error_description !== void 0 ? error_description : error);
    if (!access_token) // error is being caught in attemptCompleteOAuthFlow.ts
    throw (0, _createOAuthErrorMjs.createOAuthError)('No access token returned from OAuth flow.');
    const validatedState = await (0, _validateStateMjs.validateState)(state);
    var _ref;
    const username = (_ref = access_token && (0, _core.decodeJWT)(access_token).payload.username) !== null && _ref !== void 0 ? _ref : 'username';
    await (0, _cacheTokensMjs.cacheCognitoTokens)({
        username,
        AccessToken: access_token,
        IdToken: id_token
    });
    return completeFlow({
        redirectUri,
        state: validatedState,
        preferPrivateSession
    });
};
const completeFlow = async ({ redirectUri, state, preferPrivateSession })=>{
    await (0, _tokenProviderMjs.tokenOrchestrator).setOAuthMetadata({
        oauthSignIn: true
    });
    await (0, _oAuthStoreMjs.oAuthStore).clearOAuthData();
    await (0, _oAuthStoreMjs.oAuthStore).storeOAuthSignIn(true, preferPrivateSession);
    // this should be called before any call that involves `fetchAuthSession`
    // e.g. `getCurrentUser()` below, so it allows every inflight async calls to
    //  `fetchAuthSession` can be resolved
    (0, _inflightPromiseMjs.resolveAndClearInflightPromises)();
    // clear history before sending out final Hub events
    clearHistory(redirectUri);
    if (isCustomState(state)) (0, _core.Hub).dispatch('auth', {
        event: 'customOAuthState',
        data: (0, _utils.urlSafeDecode)(getCustomState(state))
    }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
    (0, _core.Hub).dispatch('auth', {
        event: 'signInWithRedirect'
    }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
    await (0, _dispatchSignedInHubEventMjs.dispatchSignedInHubEvent)();
};
const isCustomState = (state)=>{
    return /-/.test(state);
};
const getCustomState = (state)=>{
    return state.split('-').splice(1).join('-');
};
const clearHistory = (redirectUri)=>{
    if (typeof window !== 'undefined' && typeof window.history !== 'undefined') window.history.replaceState(window.history.state, '', redirectUri);
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core/internals/utils":"aiEf6","@aws-amplify/core":"94XF7","../../tokenProvider/cacheTokens.mjs":"bsRco","../dispatchSignedInHubEvent.mjs":"2RLlL","../refreshAuthTokens.mjs":"5xqj9","../../tokenProvider/errorHelpers.mjs":"5hyq8","./oAuthStore.mjs":"1uhgp","./inflightPromise.mjs":"6zbeu","../../tokenProvider/tokenProvider.mjs":"9mSqK","./createOAuthError.mjs":"12JH3","./validateState.mjs":"894c7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"12JH3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOAuthError", ()=>createOAuthError);
var _errorsMjs = require("../../../../Errors.mjs");
var _authErrorStringsMjs = require("../../../../common/AuthErrorStrings.mjs");
var _authErrorMjs = require("../../../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createOAuthError = (message, recoverySuggestion)=>new (0, _authErrorMjs.AuthError)({
        message: message !== null && message !== void 0 ? message : 'An error has occurred during the oauth process.',
        name: (0, _authErrorStringsMjs.AuthErrorCodes).OAuthSignInError,
        recoverySuggestion: recoverySuggestion !== null && recoverySuggestion !== void 0 ? recoverySuggestion : (0, _errorsMjs.authErrorMessages).oauthSignInError.log
    });

},{"../../../../Errors.mjs":"6EoGv","../../../../common/AuthErrorStrings.mjs":"eO30C","../../../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6EoGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>AuthError);
parcelHelpers.export(exports, "NoUserPoolError", ()=>NoUserPoolError);
parcelHelpers.export(exports, "authErrorMessages", ()=>authErrorMessages);
var _core = require("@aws-amplify/core");
var _authErrorStringsMjs = require("./common/AuthErrorStrings.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: delete this module when the Auth class is removed.
const logger = new (0, _core.ConsoleLogger)('AuthError');
class AuthError extends Error {
    constructor(type){
        const { message, log } = authErrorMessages[type];
        super(message);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = AuthError;
        Object.setPrototypeOf(this, AuthError.prototype);
        this.name = 'AuthError';
        this.log = log || message;
        logger.error(this.log);
    }
}
class NoUserPoolError extends AuthError {
    constructor(type){
        super(type);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = NoUserPoolError;
        Object.setPrototypeOf(this, NoUserPoolError.prototype);
        this.name = 'NoUserPoolError';
    }
}
const authErrorMessages = {
    oauthSignInError: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).OAUTH_ERROR,
        log: 'Make sure Cognito Hosted UI has been configured correctly'
    },
    noConfig: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
    },
    missingAuthConfig: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
    },
    emptyUsername: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).EMPTY_CODE
    },
    signUpError: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).NO_MFA
    },
    invalidMFA: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).DEVICE_CONFIG
    },
    networkError: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, _authErrorStringsMjs.AuthErrorStrings).DEFAULT_MSG
    }
};

},{"@aws-amplify/core":"94XF7","./common/AuthErrorStrings.mjs":"eO30C","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"894c7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flowCancelledMessage", ()=>flowCancelledMessage);
parcelHelpers.export(exports, "validateState", ()=>validateState);
parcelHelpers.export(exports, "validationFailedMessage", ()=>validationFailedMessage);
parcelHelpers.export(exports, "validationRecoverySuggestion", ()=>validationRecoverySuggestion);
var _authErrorMjs = require("../../../../errors/AuthError.mjs");
var _authMjs = require("../../../../types/Auth.mjs");
var _oAuthStoreMjs = require("./oAuthStore.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const flowCancelledMessage = '`signInWithRedirect` has been canceled.';
const validationFailedMessage = 'An error occurred while validating the state.';
const validationRecoverySuggestion = 'Try to initiate an OAuth flow from Amplify';
const validateState = async (state)=>{
    const savedState = await (0, _oAuthStoreMjs.oAuthStore).loadOAuthState();
    // This is because savedState only exists if the flow was initiated by Amplify
    const validatedState = state === savedState ? savedState : undefined;
    if (!validatedState) throw new (0, _authErrorMjs.AuthError)({
        name: (0, _authMjs.AuthErrorTypes).OAuthSignInError,
        message: state === null ? flowCancelledMessage : validationFailedMessage,
        recoverySuggestion: state === null ? undefined : validationRecoverySuggestion
    });
    return validatedState;
};

},{"../../../../errors/AuthError.mjs":"4RqZd","../../../../types/Auth.mjs":"lMA8M","./oAuthStore.mjs":"1uhgp","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lMA8M":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthErrorTypes", ()=>AuthErrorTypes);
var AuthErrorTypes;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
    AuthErrorTypes["OAuthSignInError"] = "oauthSignInError";
})(AuthErrorTypes || (AuthErrorTypes = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4iu6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRedirectUrl", ()=>getRedirectUrl);
var _constantsMjs = require("../../../../errors/constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function getRedirectUrl(redirects, preferredRedirectUrl) {
    if (preferredRedirectUrl) {
        const redirectUrl = redirects === null || redirects === void 0 ? void 0 : redirects.find((redirect)=>redirect === preferredRedirectUrl);
        if (!redirectUrl) throw 0, _constantsMjs.invalidPreferredRedirectUrlException;
        return redirectUrl;
    } else {
        var _redirects_find;
        const redirectUrlFromTheSameOrigin = (_redirects_find = redirects === null || redirects === void 0 ? void 0 : redirects.find(isSameOriginAndPathName)) !== null && _redirects_find !== void 0 ? _redirects_find : redirects === null || redirects === void 0 ? void 0 : redirects.find(isTheSameDomain);
        var _redirects_find1;
        const redirectUrlFromDifferentOrigin = (_redirects_find1 = redirects === null || redirects === void 0 ? void 0 : redirects.find(isHttps)) !== null && _redirects_find1 !== void 0 ? _redirects_find1 : redirects === null || redirects === void 0 ? void 0 : redirects.find(isHttp);
        if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
        else if (redirectUrlFromDifferentOrigin) throw 0, _constantsMjs.invalidOriginException;
        throw 0, _constantsMjs.invalidRedirectException;
    }
}
// origin + pathname => https://example.com/app
const isSameOriginAndPathName = (redirect)=>redirect.startsWith(String(window.location.origin + (window.location.pathname || '/')));
// domain => outlook.live.com, github.com
const isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const isHttp = (redirect)=>redirect.startsWith('http://');
const isHttps = (redirect)=>redirect.startsWith('https://');

},{"../../../../errors/constants.mjs":"8qcdh","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jQJMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleFailure", ()=>handleFailure);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _oAuthStoreMjs = require("./oAuthStore.mjs");
var _inflightPromiseMjs = require("./inflightPromise.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const handleFailure = async (error)=>{
    (0, _inflightPromiseMjs.resolveAndClearInflightPromises)();
    await (0, _oAuthStoreMjs.oAuthStore).clearOAuthInflightData();
    (0, _core.Hub).dispatch('auth', {
        event: 'signInWithRedirect_failure',
        data: {
            error
        }
    }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","./oAuthStore.mjs":"1uhgp","./inflightPromise.mjs":"6zbeu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1nJ59":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoHostedUIIdentityProviderMap", ()=>cognitoHostedUIIdentityProviderMap);
const cognitoHostedUIIdentityProviderMap = {
    Google: 'Google',
    Facebook: 'Facebook',
    Amazon: 'LoginWithAmazon',
    Apple: 'SignInWithApple'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8cAFr":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "openAuthSession", ()=>openAuthSession);
const openAuthSession = async (url)=>{
    var _window;
    if (!((_window = window) === null || _window === void 0 ? void 0 : _window.location)) return;
    // enforce HTTPS
    window.location.href = url.replace('http://', 'https://');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"J2JSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCodeVerifier", ()=>generateCodeVerifier);
var _sha256Js = require("@aws-crypto/sha256-js");
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const CODE_VERIFIER_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
/**
 *
 * @param length Desired length of the code verifier.
 *
 * **NOTE:** According to the [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 * A code verifier must be with a length >= 43 and <= 128.
 *
 * @returns An object that contains the generated `codeVerifier` and a method
 * `toCodeChallenge` to generate the code challenge from the `codeVerifier`
 * following the spec of [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2).
 */ const generateCodeVerifier = (length)=>{
    const randomBytes = new Uint8Array(length);
    (0, _utils.getCrypto)().getRandomValues(randomBytes);
    let value = '';
    let codeChallenge;
    for (const byte of randomBytes)value += CODE_VERIFIER_CHARSET.charAt(byte % CODE_VERIFIER_CHARSET.length);
    return {
        value,
        method: 'S256',
        toCodeChallenge () {
            if (codeChallenge) return codeChallenge;
            codeChallenge = generateCodeChallenge(value);
            return codeChallenge;
        }
    };
};
function generateCodeChallenge(codeVerifier) {
    const awsCryptoHash = new (0, _sha256Js.Sha256)();
    awsCryptoHash.update(codeVerifier);
    const codeChallenge = removePaddingChar((0, _utils.base64Encoder).convert(awsCryptoHash.digestSync(), {
        urlSafe: true
    }));
    return codeChallenge;
}
function removePaddingChar(base64Encoded) {
    return base64Encoded.replace(/=/g, '');
}

},{"@aws-crypto/sha256-js":"5A0J7","@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"3E3Ba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateState", ()=>generateState);
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const generateState = ()=>{
    return (0, _utils.generateRandomString)(32);
};

},{"@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8Y92B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listenForOAuthFlowCancellation", ()=>listenForOAuthFlowCancellation);
var _createOAuthErrorMjs = require("./createOAuthError.mjs");
var _handleFailureMjs = require("./handleFailure.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const listenForOAuthFlowCancellation = (store)=>{
    async function handleCancelOAuthFlow(event) {
        const isBfcache = event.persisted;
        if (isBfcache && await store.loadOAuthInFlight()) {
            const error = (0, _createOAuthErrorMjs.createOAuthError)('User cancelled OAuth flow.');
            await (0, _handleFailureMjs.handleFailure)(error);
        }
        window.removeEventListener('pageshow', handleCancelOAuthFlow);
    }
    window.addEventListener('pageshow', handleCancelOAuthFlow);
};

},{"./createOAuthError.mjs":"12JH3","./handleFailure.mjs":"jQJMg","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"Eu74O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchUserAttributes", ()=>fetchUserAttributes);
var _core = require("@aws-amplify/core");
var _fetchUserAttributesMjs = require("./internal/fetchUserAttributes.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const fetchUserAttributes = ()=>{
    return (0, _fetchUserAttributesMjs.fetchUserAttributes)((0, _core.Amplify));
};

},{"@aws-amplify/core":"94XF7","./internal/fetchUserAttributes.mjs":"gr0dP","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"gr0dP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchUserAttributes", ()=>fetchUserAttributes);
var _utils = require("@aws-amplify/core/internals/utils");
var _regionParsersMjs = require("../../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../../utils/types.mjs");
var _apiHelpersMjs = require("../../utils/apiHelpers.mjs");
var _getAuthUserAgentValueMjs = require("../../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../../errors/types/validation.mjs");
var _errorsMjs = require("../../types/errors.mjs");
var _createGetUserClientMjs = require("../../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetUserClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const fetchUserAttributes = async (amplify)=>{
    var _amplify_getConfig_Auth;
    const authConfig = (_amplify_getConfig_Auth = amplify.getConfig().Auth) === null || _amplify_getConfig_Auth === void 0 ? void 0 : _amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _utils.fetchAuthSession)(amplify, {
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const getUser = (0, _createGetUserClientMjs.createGetUserClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { UserAttributes } = await getUser({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, _apiHelpersMjs.toAuthUserAttribute)(UserAttributes);
};

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../utils/types.mjs":"4GeFs","../../utils/apiHelpers.mjs":"8W5aY","../../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../../common/AuthErrorStrings.mjs":"eO30C","../../../../errors/types/validation.mjs":"frXJ6","../../types/errors.mjs":"fLYtN","../../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetUserClient.mjs":"4asv5","../../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8tOG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signOut", ()=>signOut);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _signInWithRedirectStoreMjs = require("../utils/signInWithRedirectStore.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _sha256Js = require("@aws-crypto/sha256-js");
var _handleOAuthSignOutMjs = require("../utils/oauth/handleOAuthSignOut.mjs");
var _constantsMjs = require("../../../errors/constants.mjs");
var _errorsMjs = require("../../../Errors.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _authMjs = require("../../../types/Auth.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs1 = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _createRevokeTokenClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRevokeTokenClient.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs1 = require("../types/errors.mjs");
var _createGlobalSignOutClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGlobalSignOutClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _core.ConsoleLogger)('Auth');
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function signOut(input) {
    var _Amplify_getConfig_Auth;
    const cognitoConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(cognitoConfig);
    if (input === null || input === void 0 ? void 0 : input.global) await globalSignOut(cognitoConfig);
    else await clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, _utils.assertOAuthConfig)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        var _input_oauth;
        const oAuthStore = new (0, _signInWithRedirectStoreMjs.DefaultOAuthStore)((0, _core.defaultStorage));
        oAuthStore.setAuthConfig(cognitoConfig);
        var _ref;
        const { type } = (_ref = await (0, _handleOAuthSignOutMjs.handleOAuthSignOut)(cognitoConfig, oAuthStore, (0, _tokenProviderMjs.tokenOrchestrator), input === null || input === void 0 ? void 0 : (_input_oauth = input.oauth) === null || _input_oauth === void 0 ? void 0 : _input_oauth.redirectUrl)) !== null && _ref !== void 0 ? _ref : {};
        if (type === 'error') throw new (0, _authErrorMjs.AuthError)({
            name: (0, _constantsMjs.OAUTH_SIGNOUT_EXCEPTION),
            message: `An error occurred when attempting to log out from OAuth provider.`
        });
    } else {
        // complete sign out
        (0, _tokenProviderMjs.tokenOrchestrator).clearTokens();
        await (0, _core.clearCredentials)();
        (0, _core.Hub).dispatch('auth', {
            event: 'signedOut'
        }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
    }
}
async function clientSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint, userPoolId, userPoolClientId } = cognitoConfig;
        const authTokens = await (0, _tokenProviderMjs.tokenOrchestrator).getTokenStore().loadTokens();
        (0, _typesMjs.assertAuthTokensWithRefreshToken)(authTokens);
        if (isSessionRevocable(authTokens.accessToken)) {
            const revokeToken = (0, _createRevokeTokenClientMjs.createRevokeTokenClient)({
                endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                    endpointOverride: userPoolEndpoint
                })
            });
            await revokeToken({
                region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
                userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignOut)
            }, {
                ClientId: userPoolClientId,
                Token: authTokens.refreshToken
            });
        }
    } catch (err) {
        // this shouldn't throw
        logger.debug('Client signOut error caught but will proceed with token removal');
    }
}
async function globalSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint, userPoolId } = cognitoConfig;
        const authTokens = await (0, _tokenProviderMjs.tokenOrchestrator).getTokenStore().loadTokens();
        (0, _typesMjs.assertAuthTokens)(authTokens);
        const globalSignOutClient = (0, _createGlobalSignOutClientMjs.createGlobalSignOutClient)({
            endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
                endpointOverride: userPoolEndpoint
            })
        });
        await globalSignOutClient({
            region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
            userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        logger.debug('Global signOut error caught but will proceed with token removal');
    }
}
const isSessionRevocable = (token)=>{
    var _token_payload;
    return !!(token === null || token === void 0 ? void 0 : (_token_payload = token.payload) === null || _token_payload === void 0 ? void 0 : _token_payload.origin_jti);
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../utils/getAuthUserAgentValue.mjs":"6soVl","../utils/refreshAuthTokens.mjs":"5xqj9","../../../errors/AuthError.mjs":"4RqZd","../tokenProvider/errorHelpers.mjs":"5hyq8","../utils/signInWithRedirectStore.mjs":"4PmDB","../tokenProvider/tokenProvider.mjs":"9mSqK","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","@aws-crypto/sha256-js":"5A0J7","../utils/oauth/handleOAuthSignOut.mjs":"90QOw","../../../errors/constants.mjs":"8qcdh","../../../Errors.mjs":"6EoGv","../../../common/AuthErrorStrings.mjs":"eO30C","../../../types/Auth.mjs":"lMA8M","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createRevokeTokenClient.mjs":"2U0Sb","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGlobalSignOutClient.mjs":"hdkmR","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"90QOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleOAuthSignOut", ()=>handleOAuthSignOut);
var _completeOAuthSignOutMjs = require("./completeOAuthSignOut.mjs");
var _oAuthSignOutRedirectMjs = require("./oAuthSignOutRedirect.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const handleOAuthSignOut = async (cognitoConfig, store, tokenOrchestrator, redirectUrl)=>{
    const { isOAuthSignIn } = await store.loadOAuthSignIn();
    const oauthMetadata = await tokenOrchestrator.getOAuthMetadata();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, _completeOAuthSignOutMjs.completeOAuthSignOut)(store);
    // The isOAuthSignIn flag is propagated by the oAuthToken store which manages oauth keys in local storage only.
    // These keys are used to determine if a user is in an inflight or signedIn oauth states.
    // However, this behavior represents an issue when 2 apps share the same set of tokens in Cookie storage because the app that didn't
    // start the OAuth will not have access to the oauth keys.
    // A heuristic solution is to add oauth metadata to the tokenOrchestrator which will have access to the underlying
    // storage mechanism that is used by Amplify.
    if (isOAuthSignIn || (oauthMetadata === null || oauthMetadata === void 0 ? void 0 : oauthMetadata.oauthSignIn)) // On web, this will always end up being a void action
    return (0, _oAuthSignOutRedirectMjs.oAuthSignOutRedirect)(cognitoConfig, false, redirectUrl);
};

},{"./completeOAuthSignOut.mjs":"8mSTh","./oAuthSignOutRedirect.mjs":"biSHe","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8mSTh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "completeOAuthSignOut", ()=>completeOAuthSignOut);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _refreshAuthTokensMjs = require("../refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../../tokenProvider/errorHelpers.mjs");
var _typesMjs = require("../types.mjs");
var _tokenProviderMjs = require("../../tokenProvider/tokenProvider.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const completeOAuthSignOut = async (store)=>{
    await store.clearOAuthData();
    (0, _tokenProviderMjs.tokenOrchestrator).clearTokens();
    await (0, _core.clearCredentials)();
    (0, _core.Hub).dispatch('auth', {
        event: 'signedOut'
    }, 'Auth', (0, _utils.AMPLIFY_SYMBOL));
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../refreshAuthTokens.mjs":"5xqj9","../../tokenProvider/errorHelpers.mjs":"5hyq8","../types.mjs":"4GeFs","../../tokenProvider/tokenProvider.mjs":"9mSqK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"biSHe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "oAuthSignOutRedirect", ()=>oAuthSignOutRedirect);
var _utils = require("@aws-amplify/core/internals/utils");
var _openAuthSessionMjs = require("../../../../utils/openAuthSession.mjs");
var _getRedirectUrlMjs = require("./getRedirectUrl.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const oAuthSignOutRedirect = async (authConfig, preferPrivateSession = false, redirectUrl)=>{
    (0, _utils.assertOAuthConfig)(authConfig);
    const { loginWith, userPoolClientId } = authConfig;
    const { domain, redirectSignOut } = loginWith.oauth;
    const signoutUri = (0, _getRedirectUrlMjs.getRedirectUrl)(redirectSignOut, redirectUrl);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join('&')}`;
    return (0, _openAuthSessionMjs.openAuthSession)(oAuthLogoutEndpoint);
};

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../../utils/openAuthSession.mjs":"8cAFr","./getRedirectUrl.mjs":"4iu6a","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2U0Sb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRevokeTokenClient", ()=>createRevokeTokenClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createRevokeTokenClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('RevokeToken'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"hdkmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGlobalSignOutClient", ()=>createGlobalSignOutClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createGlobalSignOutClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('GlobalSignOut'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"28INX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendUserAttributeVerificationCode", ()=>sendUserAttributeVerificationCode);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../utils/types.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createGetUserAttributeVerificationCodeClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetUserAttributeVerificationCodeClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resends user's confirmation code when updating attributes while authenticated.
 *
 * @param input - The SendUserAttributeVerificationCodeInput object
 * @returns SendUserAttributeVerificationCodeOutput
 * @throws - {@link GetUserAttributeVerificationException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const sendUserAttributeVerificationCode = async (input)=>{
    var _Amplify_getConfig_Auth;
    const { userAttributeKey, options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const clientMetadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const getUserAttributeVerificationCode = (0, _createGetUserAttributeVerificationCodeClientMjs.createGetUserAttributeVerificationCodeClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetails } = await getUserAttributeVerificationCode({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).SendUserAttributeVerificationCode)
    }, {
        AccessToken: tokens.accessToken.toString(),
        ClientMetadata: clientMetadata,
        AttributeName: userAttributeKey
    });
    const { DeliveryMedium, AttributeName, Destination } = (0, _objectSpread._)({}, CodeDeliveryDetails);
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName
    };
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/types.mjs":"4GeFs","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createGetUserAttributeVerificationCodeClient.mjs":"dAOZZ","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dAOZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetUserAttributeVerificationCodeClient", ()=>createGetUserAttributeVerificationCodeClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createGetUserAttributeVerificationCodeClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('GetUserAttributeVerificationCode'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"kNiQK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteUserAttributes", ()=>deleteUserAttributes);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createDeleteUserAttributesClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createDeleteUserAttributesClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deletes user attributes.
 *
 * @param input -  The DeleteUserAttributesInput object
 * @throws  -{@link DeleteUserAttributesException } - Thrown due to invalid attribute.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function deleteUserAttributes(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userAttributeKeys } = input;
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)({
        forceRefresh: false
    });
    (0, _typesMjs.assertAuthTokens)(tokens);
    const deleteUserAttributesClient = (0, _createDeleteUserAttributesClientMjs.createDeleteUserAttributesClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await deleteUserAttributesClient({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).DeleteUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString(),
        UserAttributeNames: userAttributeKeys
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createDeleteUserAttributesClient.mjs":"70Dsq","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"70Dsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDeleteUserAttributesClient", ()=>createDeleteUserAttributesClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createDeleteUserAttributesClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('DeleteUserAttributes'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2DqRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteUser", ()=>deleteUser);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createDeleteUserClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createDeleteUserClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
var _signOutMjs = require("./signOut.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deletes a user from the user pool while authenticated.
 *
 * @throws - {@link DeleteUserException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function deleteUser() {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const serviceDeleteUser = (0, _createDeleteUserClientMjs.createDeleteUserClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await serviceDeleteUser({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).DeleteUser)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    await (0, _tokenProviderMjs.tokenOrchestrator).clearDeviceMetadata();
    await (0, _signOutMjs.signOut)();
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../tokenProvider/tokenProvider.mjs":"9mSqK","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createDeleteUserClient.mjs":"5K3aD","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","./signOut.mjs":"8tOG3","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5K3aD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDeleteUserClient", ()=>createDeleteUserClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _createEmptyResponseDeserializerMjs = require("./shared/serde/createEmptyResponseDeserializer.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createDeleteUserClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('DeleteUser'), (0, _createEmptyResponseDeserializerMjs.createEmptyResponseDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./shared/serde/createEmptyResponseDeserializer.mjs":"6krWT","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"6krWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEmptyResponseDeserializer", ()=>createEmptyResponseDeserializer);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _assertServiceErrorMjs = require("../../../../../../errors/utils/assertServiceError.mjs");
var _authErrorMjs = require("../../../../../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createEmptyResponseDeserializer = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, _awsClientUtils.parseJsonError)(response);
            (0, _assertServiceErrorMjs.assertServiceError)(error);
            throw new (0, _authErrorMjs.AuthError)({
                name: error.name,
                message: error.message
            });
        } else return undefined;
    };

},{"@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../../../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5PGM4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rememberDevice", ()=>rememberDevice);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../utils/types.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createUpdateDeviceStatusClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createUpdateDeviceStatusClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Marks device as remembered while authenticated.
 *
 * @throws - {@link UpdateDeviceStatusException} - Cognito service errors thrown when
 * setting device status to remembered using an invalid device key.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function rememberDevice() {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const deviceMetadata = await ((0, _tokenProviderMjs.tokenOrchestrator) === null || (0, _tokenProviderMjs.tokenOrchestrator) === void 0 ? void 0 : (0, _tokenProviderMjs.tokenOrchestrator).getDeviceMetadata());
    (0, _typesMjs.assertDeviceMetadata)(deviceMetadata);
    const updateDeviceStatus = (0, _createUpdateDeviceStatusClientMjs.createUpdateDeviceStatusClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await updateDeviceStatus({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).RememberDevice)
    }, {
        AccessToken: tokens.accessToken.toString(),
        DeviceKey: deviceMetadata.deviceKey,
        DeviceRememberedStatus: 'remembered'
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/types.mjs":"4GeFs","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../tokenProvider/tokenProvider.mjs":"9mSqK","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createUpdateDeviceStatusClient.mjs":"iCE6d","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iCE6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUpdateDeviceStatusClient", ()=>createUpdateDeviceStatusClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createUpdateDeviceStatusClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('UpdateDeviceStatus'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5U9Bh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forgetDevice", ()=>forgetDevice);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../utils/types.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _refreshAuthTokensMjs = require("../utils/refreshAuthTokens.mjs");
var _errorHelpersMjs = require("../tokenProvider/errorHelpers.mjs");
var _tokenProviderMjs = require("../tokenProvider/tokenProvider.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createForgetDeviceClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createForgetDeviceClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Forget a remembered device while authenticated.
 *
 * @param input - The ForgetDeviceInput object.
 * @throws - {@link ForgetDeviceException} - Cognito service errors thrown when
 * forgetting device with invalid device key
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function forgetDevice(input) {
    var _Amplify_getConfig_Auth;
    const { device: { id: externalDeviceKey } = {
        id: undefined
    } } = input !== null && input !== void 0 ? input : {};
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const deviceMetadata = await (0, _tokenProviderMjs.tokenOrchestrator).getDeviceMetadata();
    const currentDeviceKey = deviceMetadata === null || deviceMetadata === void 0 ? void 0 : deviceMetadata.deviceKey;
    if (!externalDeviceKey) (0, _typesMjs.assertDeviceMetadata)(deviceMetadata);
    const serviceForgetDevice = (0, _createForgetDeviceClientMjs.createForgetDeviceClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await serviceForgetDevice({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ForgetDevice)
    }, {
        AccessToken: tokens.accessToken.toString(),
        DeviceKey: externalDeviceKey !== null && externalDeviceKey !== void 0 ? externalDeviceKey : currentDeviceKey
    });
    if (!externalDeviceKey || externalDeviceKey === currentDeviceKey) await (0, _tokenProviderMjs.tokenOrchestrator).clearDeviceMetadata();
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/types.mjs":"4GeFs","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/refreshAuthTokens.mjs":"5xqj9","../tokenProvider/errorHelpers.mjs":"5hyq8","../tokenProvider/tokenProvider.mjs":"9mSqK","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createForgetDeviceClient.mjs":"27SP6","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"27SP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createForgetDeviceClient", ()=>createForgetDeviceClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _createEmptyResponseDeserializerMjs = require("./shared/serde/createEmptyResponseDeserializer.mjs");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createForgetDeviceClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ForgetDevice'), (0, _createEmptyResponseDeserializerMjs.createEmptyResponseDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./shared/serde/createEmptyResponseDeserializer.mjs":"6krWT","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"exXI6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchDevices", ()=>fetchDevices);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../utils/types.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../../errors/types/validation.mjs");
var _errorsMjs = require("../types/errors.mjs");
var _createListDevicesClientMjs = require("../../../foundation/factories/serviceClients/cognitoIdentityProvider/createListDevicesClient.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../factories/createCognitoUserPoolEndpointResolver.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Cognito Documentation for max device
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
const MAX_DEVICES = 60;
/**
 * Fetches devices that have been remembered using {@link rememberDevice}
 * for the currently authenticated user.
 *
 * @returns FetchDevicesOutput
 * @throws {@link ListDevicesException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function fetchDevices() {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const listDevices = (0, _createListDevicesClientMjs.createListDevicesClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await listDevices({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).FetchDevices)
    }, {
        AccessToken: tokens.accessToken.toString(),
        Limit: MAX_DEVICES
    });
    var _response_Devices;
    return parseDevicesResponse((_response_Devices = response.Devices) !== null && _response_Devices !== void 0 ? _response_Devices : []);
}
const parseDevicesResponse = async (devices)=>{
    return devices.map(({ DeviceKey: id = '', DeviceAttributes = [], DeviceCreateDate, DeviceLastModifiedDate, DeviceLastAuthenticatedDate })=>{
        let deviceName;
        const attributes = DeviceAttributes.reduce((attrs, { Name, Value })=>{
            if (Name && Value) {
                if (Name === 'device_name') deviceName = Value;
                attrs[Name] = Value;
            }
            return attrs;
        }, {});
        const result = {
            id,
            name: deviceName,
            attributes,
            createDate: DeviceCreateDate ? new Date(DeviceCreateDate * 1000) : undefined,
            lastModifiedDate: DeviceLastModifiedDate ? new Date(DeviceLastModifiedDate * 1000) : undefined,
            lastAuthenticatedDate: DeviceLastAuthenticatedDate ? new Date(DeviceLastAuthenticatedDate * 1000) : undefined
        };
        return result;
    });
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../utils/types.mjs":"4GeFs","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../../common/AuthErrorStrings.mjs":"eO30C","../../../errors/types/validation.mjs":"frXJ6","../types/errors.mjs":"fLYtN","../../../foundation/factories/serviceClients/cognitoIdentityProvider/createListDevicesClient.mjs":"1eh8N","../factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1eh8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createListDevicesClient", ()=>createListDevicesClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createListDevicesClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ListDevices'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"8kQMk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultIdentityIdStore", ()=>DefaultIdentityIdStore);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _tokenStoreMjs = require("../tokenProvider/TokenStore.mjs");
var _typesMjs = require("./types.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _core.ConsoleLogger)('DefaultIdentityIdStore');
class DefaultIdentityIdStore {
    setAuthConfig(authConfigParam) {
        (0, _utils.assertIdentityPoolIdConfig)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = createKeysForAuthStorage('Cognito', authConfigParam.Cognito.identityPoolId);
    }
    async loadIdentityId() {
        var _this_authConfig;
        (0, _utils.assertIdentityPoolIdConfig)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: 'primary'
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) {
                    this._hasGuestIdentityId = true;
                    return {
                        id: storedIdentityId,
                        type: 'guest'
                    };
                }
                return null;
            }
        } catch (err) {
            logger.log('Error getting stored IdentityId.', err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        var _this_authConfig;
        (0, _utils.assertIdentityPoolIdConfig)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        if (identity.type === 'guest') {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
            this._hasGuestIdentityId = true;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            if (this._hasGuestIdentityId) {
                this.keyValueStorage.removeItem(this._authKeys.identityId);
                this._hasGuestIdentityId = false;
            }
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this._hasGuestIdentityId = false;
        this.keyValueStorage = keyValueStorage;
    }
}
const createKeysForAuthStorage = (provider, identifier)=>{
    return (0, _tokenStoreMjs.getAuthStorageKeys)((0, _typesMjs.IdentityIdStorageKeys))(`com.amplify.${provider}`, identifier);
};

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../tokenProvider/TokenStore.mjs":"huiyc","./types.mjs":"5dGjH","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"5dGjH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdentityIdStorageKeys", ()=>IdentityIdStorageKeys);
const IdentityIdStorageKeys = {
    identityId: 'identityId'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"amlGl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CognitoAWSCredentialsAndIdentityIdProvider", ()=>CognitoAWSCredentialsAndIdentityIdProvider);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _typesMjs = require("../utils/types.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _createCognitoIdentityPoolEndpointResolverMjs = require("../factories/createCognitoIdentityPoolEndpointResolver.mjs");
var _identityIdProviderMjs = require("./IdentityIdProvider.mjs");
var _utilsMjs = require("./utils.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new (0, _core.ConsoleLogger)('CognitoCredentialsProvider');
const CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class CognitoAWSCredentialsAndIdentityIdProvider {
    async clearCredentialsAndIdentityId() {
        logger.debug('Clearing out credentials and identityId');
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        logger.debug('Clearing out in-memory credentials');
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens } = getCredentialsOptions;
        const { authConfig } = getCredentialsOptions;
        try {
            (0, _utils.assertIdentityPoolIdConfig)(authConfig === null || authConfig === void 0 ? void 0 : authConfig.Cognito);
        } catch (e) {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, _identityIdProviderMjs.cognitoIdentityIdProvider)({
            tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, _typesMjs.assertIdTokenInAuthTokens)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        var _clientResult_Credentials, _clientResult_Credentials1;
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            logger.info('returning stored credentials as they neither past TTL nor expired.');
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, _regionParsersMjs.getRegionFromIdentityPoolId)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, _core.createGetCredentialsForIdentityClient)({
            endpointResolver: (0, _createCognitoIdentityPoolEndpointResolverMjs.createCognitoIdentityPoolEndpointResolver)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region
            }, {
                IdentityId: identityId
            });
        } catch (e) {
            (0, _assertServiceErrorMjs.assertServiceError)(e);
            throw new (0, _authErrorMjs.AuthError)(e);
        }
        if ((clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials = clientResult.Credentials) === null || _clientResult_Credentials === void 0 ? void 0 : _clientResult_Credentials.AccessKeyId) && (clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials1 = clientResult.Credentials) === null || _clientResult_Credentials1 === void 0 ? void 0 : _clientResult_Credentials1.SecretKey)) {
            this._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: 'guest'
                });
            }
            this._credentialsAndIdentityId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, res), {
                isAuthenticatedCreds: false
            });
            return res;
        } else throw new (0, _authErrorMjs.AuthError)({
            name: 'CredentialsNotFoundException',
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        var _clientResult_Credentials, _clientResult_Credentials1;
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            logger.debug('returning stored credentials as they neither past TTL nor expired.');
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, _utilsMjs.formLoginsMap)(authTokens.idToken.toString()) : {};
        const region = (0, _regionParsersMjs.getRegionFromIdentityPoolId)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, _core.createGetCredentialsForIdentityClient)({
            endpointResolver: (0, _createCognitoIdentityPoolEndpointResolverMjs.createCognitoIdentityPoolEndpointResolver)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region
            }, {
                IdentityId: identityId,
                Logins: logins
            });
        } catch (e) {
            (0, _assertServiceErrorMjs.assertServiceError)(e);
            throw new (0, _authErrorMjs.AuthError)(e);
        }
        if ((clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials = clientResult.Credentials) === null || _clientResult_Credentials === void 0 ? void 0 : _clientResult_Credentials.AccessKeyId) && (clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials1 = clientResult.Credentials) === null || _clientResult_Credentials1 === void 0 ? void 0 : _clientResult_Credentials1.SecretKey)) {
            var _authTokens_idToken;
            this._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                // note: the following call removes guest identityId from the persistent store (localStorage)
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: 'primary'
                });
            }
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = (0, _objectSpreadProps._)((0, _objectSpread._)({}, res), {
                isAuthenticatedCreds: true,
                associatedIdToken: (_authTokens_idToken = authTokens.idToken) === null || _authTokens_idToken === void 0 ? void 0 : _authTokens_idToken.toString()
            });
            return res;
        } else throw new (0, _authErrorMjs.AuthError)({
            name: 'CredentialsException',
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        var _this__credentialsAndIdentityId, _tokens_idToken;
        return !!tokens && !!((_this__credentialsAndIdentityId = this._credentialsAndIdentityId) === null || _this__credentialsAndIdentityId === void 0 ? void 0 : _this__credentialsAndIdentityId.associatedIdToken) && ((_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.toString()) !== this._credentialsAndIdentityId.associatedIdToken;
    }
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
}

},{"@swc/helpers/_/_object_spread":"PGIdx","@swc/helpers/_/_object_spread_props":"31Fkl","@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../../errors/AuthError.mjs":"4RqZd","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../foundation/parsers/regionParsers.mjs":"9YQHb","../utils/types.mjs":"4GeFs","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../factories/createCognitoIdentityPoolEndpointResolver.mjs":"fmyNR","./IdentityIdProvider.mjs":"h1wZJ","./utils.mjs":"lhaIY","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fmyNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCognitoIdentityPoolEndpointResolver", ()=>createCognitoIdentityPoolEndpointResolver);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createCognitoIdentityPoolEndpointResolver = ({ endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, _utils.AmplifyUrl)(endpointOverride)
        };
        return (0, _core.cognitoIdentityPoolEndpointResolver)(input);
    };

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"h1wZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoIdentityIdProvider", ()=>cognitoIdentityIdProvider);
var _core = require("@aws-amplify/core");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
var _assertServiceErrorMjs = require("../../../errors/utils/assertServiceError.mjs");
var _regionParsersMjs = require("../../../foundation/parsers/regionParsers.mjs");
var _utils = require("@aws-amplify/core/internals/utils");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _createCognitoIdentityPoolEndpointResolverMjs = require("../factories/createCognitoIdentityPoolEndpointResolver.mjs");
var _utilsMjs = require("./utils.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function cognitoIdentityIdProvider({ tokens, authConfig, identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    const identityId = await identityIdStore.loadIdentityId();
    if (identityId) return identityId.id;
    const logins = (tokens === null || tokens === void 0 ? void 0 : tokens.idToken) ? (0, _utilsMjs.formLoginsMap)(tokens.idToken.toString()) : {};
    const generatedIdentityId = await generateIdentityId(logins, authConfig);
    // Store generated identityId
    identityIdStore.storeIdentityId({
        id: generatedIdentityId,
        type: tokens ? 'primary' : 'guest'
    });
    return generatedIdentityId;
}
async function generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig === null || authConfig === void 0 ? void 0 : authConfig.identityPoolId;
    const region = (0, _regionParsersMjs.getRegionFromIdentityPoolId)(identityPoolId);
    const getId = (0, _core.createGetIdClient)({
        endpointResolver: (0, _createCognitoIdentityPoolEndpointResolverMjs.createCognitoIdentityPoolEndpointResolver)({
            endpointOverride: authConfig.identityPoolEndpoint
        })
    });
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    let idResult;
    // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    try {
        idResult = (await getId({
            region
        }, {
            IdentityPoolId: identityPoolId,
            Logins: logins
        })).IdentityId;
    } catch (e) {
        (0, _assertServiceErrorMjs.assertServiceError)(e);
        throw new (0, _authErrorMjs.AuthError)(e);
    }
    if (!idResult) throw new (0, _authErrorMjs.AuthError)({
        name: 'GetIdResponseException',
        message: 'Received undefined response from getId operation',
        recoverySuggestion: 'Make sure to pass a valid identityPoolId in the configuration.'
    });
    return idResult;
}

},{"@aws-amplify/core":"94XF7","../../../errors/AuthError.mjs":"4RqZd","../../../errors/utils/assertServiceError.mjs":"e7Z2e","../../../foundation/parsers/regionParsers.mjs":"9YQHb","@aws-amplify/core/internals/utils":"aiEf6","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../factories/createCognitoIdentityPoolEndpointResolver.mjs":"fmyNR","./utils.mjs":"lhaIY","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lhaIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formLoginsMap", ()=>formLoginsMap);
var _utils = require("@aws-amplify/core/internals/utils");
var _authErrorMjs = require("../../../errors/AuthError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function formLoginsMap(idToken) {
    const issuer = (0, _utils.decodeJWT)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, _authErrorMjs.AuthError)({
        name: 'InvalidIdTokenException',
        message: 'Invalid Idtoken.'
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, '');
    res[domainName] = idToken;
    return res;
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../../../errors/AuthError.mjs":"4RqZd","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2HJzb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "associateWebAuthnCredential", ()=>associateWebAuthnCredential);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../../providers/cognito/utils/types.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _regionParsersMjs = require("../../foundation/parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../utils/getAuthUserAgentValue.mjs");
var _registerPasskeyMjs = require("../utils/passkey/registerPasskey.mjs");
var _passkeyErrorMjs = require("../utils/passkey/errors/passkeyError.mjs");
var _sharedMjs = require("../utils/passkey/types/shared.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../errors/types/validation.mjs");
var _errorsMjs = require("../../providers/cognito/types/errors.mjs");
var _createStartWebAuthnRegistrationClientMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/createStartWebAuthnRegistrationClient.mjs");
var _createCompleteWebAuthnRegistrationClientMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/createCompleteWebAuthnRegistrationClient.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Registers a new passkey for an authenticated user
 *
 * @returns Promise<void>
 * @throws - {@link PasskeyError}:
 * - Thrown when intermediate state is invalid
 * @throws - {@link AuthError}:
 * - Thrown when user is unauthenticated
 * @throws - {@link StartWebAuthnRegistrationException}
 * - Thrown due to a service error retrieving WebAuthn registration options
 * @throws - {@link CompleteWebAuthnRegistrationException}
 * - Thrown due to a service error when verifying WebAuthn registration result
 */ async function associateWebAuthnCredential() {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, _core.Amplify).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await (0, _core.fetchAuthSession)();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const startWebAuthnRegistration = (0, _createStartWebAuthnRegistrationClientMjs.createStartWebAuthnRegistrationClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CredentialCreationOptions: credentialCreationOptions } = await startWebAuthnRegistration({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).StartWebAuthnRegistration)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    (0, _sharedMjs.assertValidCredentialCreationOptions)(credentialCreationOptions);
    const cred = await (0, _registerPasskeyMjs.registerPasskey)(credentialCreationOptions);
    const completeWebAuthnRegistration = (0, _createCompleteWebAuthnRegistrationClientMjs.createCompleteWebAuthnRegistrationClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await completeWebAuthnRegistration({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).CompleteWebAuthnRegistration)
    }, {
        AccessToken: tokens.accessToken.toString(),
        Credential: cred
    });
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../providers/cognito/utils/types.mjs":"4GeFs","../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","../../foundation/parsers/regionParsers.mjs":"9YQHb","../../utils/getAuthUserAgentValue.mjs":"6soVl","../utils/passkey/registerPasskey.mjs":"4xiIj","../utils/passkey/errors/passkeyError.mjs":"bpX9I","../utils/passkey/types/shared.mjs":"5uOzs","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../common/AuthErrorStrings.mjs":"eO30C","../../errors/types/validation.mjs":"frXJ6","../../providers/cognito/types/errors.mjs":"fLYtN","../../foundation/factories/serviceClients/cognitoIdentityProvider/createStartWebAuthnRegistrationClient.mjs":"4UBLi","../../foundation/factories/serviceClients/cognitoIdentityProvider/createCompleteWebAuthnRegistrationClient.mjs":"fV2Yu","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4xiIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerPasskey", ()=>registerPasskey);
var _indexMjs = require("./types/index.mjs");
var _serdeMjs = require("./serde.mjs");
var _utils = require("@aws-amplify/core/internals/utils");
var _passkeyErrorMjs = require("./errors/passkeyError.mjs");
var _handlePasskeyRegistrationErrorMjs = require("./errors/handlePasskeyRegistrationError.mjs");
var _getIsPasskeySupportedMjs = require("./getIsPasskeySupported.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Registers a new passkey for user
 * @param input - PasskeyCreateOptionsJson
 * @returns serialized PasskeyCreateResult
 */ const registerPasskey = async (input)=>{
    try {
        const isPasskeySupported = (0, _getIsPasskeySupportedMjs.getIsPasskeySupported)();
        (0, _passkeyErrorMjs.assertPasskeyError)(isPasskeySupported, (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyNotSupported);
        const passkeyCreationOptions = (0, _serdeMjs.deserializeJsonToPkcCreationOptions)(input);
        const credential = await navigator.credentials.create({
            publicKey: passkeyCreationOptions
        });
        (0, _indexMjs.assertCredentialIsPkcWithAuthenticatorAttestationResponse)(credential);
        return (0, _serdeMjs.serializePkcWithAttestationToJson)(credential);
    } catch (err) {
        throw (0, _handlePasskeyRegistrationErrorMjs.handlePasskeyRegistrationError)(err);
    }
};

},{"./types/index.mjs":"53f0G","./serde.mjs":"aVrg6","@aws-amplify/core/internals/utils":"aiEf6","./errors/passkeyError.mjs":"bpX9I","./errors/handlePasskeyRegistrationError.mjs":"iltA8","./getIsPasskeySupported.mjs":"lIcwO","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"iltA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handlePasskeyRegistrationError", ()=>handlePasskeyRegistrationError);
var _handlePasskeyErrorMjs = require("./handlePasskeyError.mjs");
var _passkeyErrorMjs = require("./passkeyError.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handle Passkey Registration Errors
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const handlePasskeyRegistrationError = (err)=>{
    if (err instanceof (0, _passkeyErrorMjs.PasskeyError)) return err;
    if (err instanceof Error) {
        // Duplicate Passkey
        if (err.name === 'InvalidStateError') {
            const { message, recoverySuggestion } = (0, _passkeyErrorMjs.passkeyErrorMap)[(0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyAlreadyExists];
            return new (0, _passkeyErrorMjs.PasskeyError)({
                name: (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyAlreadyExists,
                message,
                recoverySuggestion,
                underlyingError: err
            });
        }
        // User Cancels Ceremony / Generic Catch All
        if (err.name === 'NotAllowedError') {
            const { message, recoverySuggestion } = (0, _passkeyErrorMjs.passkeyErrorMap)[(0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyRegistrationCanceled];
            return new (0, _passkeyErrorMjs.PasskeyError)({
                name: (0, _passkeyErrorMjs.PasskeyErrorCode).PasskeyRegistrationCanceled,
                message,
                recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return (0, _handlePasskeyErrorMjs.handlePasskeyError)(err);
};

},{"./handlePasskeyError.mjs":"3h25d","./passkeyError.mjs":"bpX9I","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"4UBLi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStartWebAuthnRegistrationClient", ()=>createStartWebAuthnRegistrationClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createStartWebAuthnRegistrationClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('StartWebAuthnRegistration'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fV2Yu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCompleteWebAuthnRegistrationClient", ()=>createCompleteWebAuthnRegistrationClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createCompleteWebAuthnRegistrationClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('CompleteWebAuthnRegistration'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dMbFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listWebAuthnCredentials", ()=>listWebAuthnCredentials);
var _core = require("@aws-amplify/core");
var _listWebAuthnCredentialsMjs = require("../../foundation/apis/listWebAuthnCredentials.mjs");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../../providers/cognito/utils/types.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../errors/types/validation.mjs");
var _errorsMjs = require("../../providers/cognito/types/errors.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Lists registered credentials for an authenticated user
 *
 * @param {ListWebAuthnCredentialsInput} input The list input parameters including page size and next token.
 * @returns Promise<ListWebAuthnCredentialsOutput>
 * @throws - {@link AuthError}:
 * - Thrown when user is unauthenticated
 * @throws - {@link ListWebAuthnCredentialsException}
 * - Thrown due to a service error when listing WebAuthn credentials
 */ async function listWebAuthnCredentials(input) {
    return (0, _listWebAuthnCredentialsMjs.listWebAuthnCredentials)((0, _core.Amplify), input);
}

},{"@aws-amplify/core":"94XF7","../../foundation/apis/listWebAuthnCredentials.mjs":"7bDGS","@aws-amplify/core/internals/utils":"aiEf6","../../providers/cognito/utils/types.mjs":"4GeFs","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../common/AuthErrorStrings.mjs":"eO30C","../../errors/types/validation.mjs":"frXJ6","../../providers/cognito/types/errors.mjs":"fLYtN","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"7bDGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listWebAuthnCredentials", ()=>listWebAuthnCredentials);
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../../providers/cognito/utils/types.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../errors/types/validation.mjs");
var _errorsMjs = require("../../providers/cognito/types/errors.mjs");
var _createListWebAuthnCredentialsClientMjs = require("../factories/serviceClients/cognitoIdentityProvider/createListWebAuthnCredentialsClient.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function listWebAuthnCredentials(amplify, input) {
    var _amplify_getConfig_Auth;
    const authConfig = (_amplify_getConfig_Auth = amplify.getConfig().Auth) === null || _amplify_getConfig_Auth === void 0 ? void 0 : _amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await amplify.Auth.fetchAuthSession();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const listWebAuthnCredentialsResult = (0, _createListWebAuthnCredentialsClientMjs.createListWebAuthnCredentialsClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Credentials: commandCredentials = [], NextToken: nextToken } = await listWebAuthnCredentialsResult({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).ListWebAuthnCredentials)
    }, {
        AccessToken: tokens.accessToken.toString(),
        MaxResults: input === null || input === void 0 ? void 0 : input.pageSize,
        NextToken: input === null || input === void 0 ? void 0 : input.nextToken
    });
    const credentials = commandCredentials.map((item)=>({
            credentialId: item.CredentialId,
            friendlyCredentialName: item.FriendlyCredentialName,
            relyingPartyId: item.RelyingPartyId,
            authenticatorAttachment: item.AuthenticatorAttachment,
            authenticatorTransports: item.AuthenticatorTransports,
            createdAt: item.CreatedAt ? new Date(item.CreatedAt * 1000) : undefined
        }));
    return {
        credentials,
        nextToken
    };
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../../providers/cognito/utils/types.mjs":"4GeFs","../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../parsers/regionParsers.mjs":"9YQHb","../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../common/AuthErrorStrings.mjs":"eO30C","../../errors/types/validation.mjs":"frXJ6","../../providers/cognito/types/errors.mjs":"fLYtN","../factories/serviceClients/cognitoIdentityProvider/createListWebAuthnCredentialsClient.mjs":"fGsnK","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"fGsnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createListWebAuthnCredentialsClient", ()=>createListWebAuthnCredentialsClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createListWebAuthnCredentialsClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('ListWebAuthnCredentials'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"2JRid":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteWebAuthnCredential", ()=>deleteWebAuthnCredential);
var _core = require("@aws-amplify/core");
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../../providers/cognito/utils/types.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../errors/types/validation.mjs");
var _errorsMjs = require("../../providers/cognito/types/errors.mjs");
var _deleteWebAuthnCredentialMjs = require("../../foundation/apis/deleteWebAuthnCredential.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Delete a registered credential for an authenticated user by credentialId
 * @param {DeleteWebAuthnCredentialInput} input The delete input parameters including the credentialId
 * @returns Promise<void>
 * @throws - {@link AuthError}:
 * - Thrown when user is unauthenticated
 * @throws - {@link DeleteWebAuthnCredentialException}
 * - Thrown due to a service error when deleting a WebAuthn credential
 */ async function deleteWebAuthnCredential(input) {
    return (0, _deleteWebAuthnCredentialMjs.deleteWebAuthnCredential)((0, _core.Amplify), input);
}

},{"@aws-amplify/core":"94XF7","@aws-amplify/core/internals/utils":"aiEf6","../../providers/cognito/utils/types.mjs":"4GeFs","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","../../foundation/factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../../foundation/factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../common/AuthErrorStrings.mjs":"eO30C","../../errors/types/validation.mjs":"frXJ6","../../providers/cognito/types/errors.mjs":"fLYtN","../../foundation/apis/deleteWebAuthnCredential.mjs":"dDqUW","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"dDqUW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteWebAuthnCredential", ()=>deleteWebAuthnCredential);
var _utils = require("@aws-amplify/core/internals/utils");
var _typesMjs = require("../../providers/cognito/utils/types.mjs");
var _createCognitoUserPoolEndpointResolverMjs = require("../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs");
var _core = require("@aws-amplify/core");
var _regionParsersMjs = require("../parsers/regionParsers.mjs");
var _getAuthUserAgentValueMjs = require("../../utils/getAuthUserAgentValue.mjs");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _cognitoUserPoolTransferHandlerMjs = require("../factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs");
var _constantsMjs = require("../factories/serviceClients/cognitoIdentityProvider/constants.mjs");
var _authErrorStringsMjs = require("../../common/AuthErrorStrings.mjs");
var _validationMjs = require("../../errors/types/validation.mjs");
var _errorsMjs = require("../../providers/cognito/types/errors.mjs");
var _createDeleteWebAuthnCredentialClientMjs = require("../factories/serviceClients/cognitoIdentityProvider/createDeleteWebAuthnCredentialClient.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function deleteWebAuthnCredential(amplify, input) {
    var _amplify_getConfig_Auth;
    const authConfig = (_amplify_getConfig_Auth = amplify.getConfig().Auth) === null || _amplify_getConfig_Auth === void 0 ? void 0 : _amplify_getConfig_Auth.Cognito;
    (0, _utils.assertTokenProviderConfig)(authConfig);
    const { userPoolEndpoint, userPoolId } = authConfig;
    const { tokens } = await amplify.Auth.fetchAuthSession();
    (0, _typesMjs.assertAuthTokens)(tokens);
    const deleteWebAuthnCredentialResult = (0, _createDeleteWebAuthnCredentialClientMjs.createDeleteWebAuthnCredentialClient)({
        endpointResolver: (0, _createCognitoUserPoolEndpointResolverMjs.createCognitoUserPoolEndpointResolver)({
            endpointOverride: userPoolEndpoint
        })
    });
    await deleteWebAuthnCredentialResult({
        region: (0, _regionParsersMjs.getRegionFromUserPoolId)(userPoolId),
        userAgentValue: (0, _getAuthUserAgentValueMjs.getAuthUserAgentValue)((0, _utils.AuthAction).DeleteWebAuthnCredential)
    }, {
        AccessToken: tokens.accessToken.toString(),
        CredentialId: input.credentialId
    });
}

},{"@aws-amplify/core/internals/utils":"aiEf6","../../providers/cognito/utils/types.mjs":"4GeFs","../../providers/cognito/factories/createCognitoUserPoolEndpointResolver.mjs":"l16n2","@aws-amplify/core":"94XF7","../parsers/regionParsers.mjs":"9YQHb","../../utils/getAuthUserAgentValue.mjs":"6soVl","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","@aws-amplify/core/internals/aws-client-utils":"gSPGh","../factories/serviceClients/cognitoIdentityProvider/shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","../factories/serviceClients/cognitoIdentityProvider/constants.mjs":"bHH4M","../../common/AuthErrorStrings.mjs":"eO30C","../../errors/types/validation.mjs":"frXJ6","../../providers/cognito/types/errors.mjs":"fLYtN","../factories/serviceClients/cognitoIdentityProvider/createDeleteWebAuthnCredentialClient.mjs":"jKha5","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"jKha5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDeleteWebAuthnCredentialClient", ()=>createDeleteWebAuthnCredentialClient);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _cognitoUserPoolTransferHandlerMjs = require("./shared/handler/cognitoUserPoolTransferHandler.mjs");
var _createUserPoolSerializerMjs = require("./shared/serde/createUserPoolSerializer.mjs");
var _createUserPoolDeserializerMjs = require("./shared/serde/createUserPoolDeserializer.mjs");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("@aws-amplify/core/internals/utils");
var _constantsMjs = require("./constants.mjs");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createDeleteWebAuthnCredentialClient = (config)=>(0, _composers.composeServiceApi)((0, _cognitoUserPoolTransferHandlerMjs.cognitoUserPoolTransferHandler), (0, _createUserPoolSerializerMjs.createUserPoolSerializer)('DeleteWebAuthnCredential'), (0, _createUserPoolDeserializerMjs.createUserPoolDeserializer)(), (0, _objectSpread._)({}, (0, _constantsMjs.DEFAULT_SERVICE_CLIENT_API_CONFIG), config));

},{"@swc/helpers/_/_object_spread":"PGIdx","@aws-amplify/core/internals/aws-client-utils/composers":"3t5JD","./shared/handler/cognitoUserPoolTransferHandler.mjs":"CUUvz","./shared/serde/createUserPoolSerializer.mjs":"c3JYT","./shared/serde/createUserPoolDeserializer.mjs":"bgSB4","@aws-amplify/core/internals/aws-client-utils":"gSPGh","@aws-amplify/core/internals/utils":"aiEf6","./constants.mjs":"bHH4M","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}]},[], null, "parcelRequire33b7", {})

//# sourceMappingURL=Privacy.e4e1627c.js.map
